// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { auditControllerGetEntityAudits, auditControllerGetInvestmentAudits, auditControllerGetPersonAudits, authControllerCancelChangeEmailRequest, authControllerCanChangeCredentials, authControllerChangeEmailRequest, authControllerDeleteChangeEmailRequest, authControllerRenewInvitation, authControllerStartHostedAuthKit, authControllerUpdateEmail, bankAccountControllerCreateMipBankAccount, bankAccountControllerDeleteMipBankAccount, bankAccountControllerGetMipBankAccount, bankAccountControllerUpdateMipBankAccount, bankAccountControllerValidateBankAccount, bankAccountFormatRuleControllerGetFormatRules, bankAccountFormatRuleControllerGetSupportedCountries, bankAccountLifecycleDebugControllerGetStateTransitions, bankAccountLifecycleDebugControllerGetVerificationLogs, capTableControllerDownloadExcel, capTableControllerExportDealHoldingsJson, capTableControllerGetCapDetails, capTableControllerGetCapTransactionsValidationDetails, capTableControllerPostCapTableData, capTableControllerPostGroupStructureData, capTableControllerPostGroupStructurePositions, capTableControllerPostSecuritiesForGroupStructureData, capTableControllerUpdateGroupStructurePositions, classifierControllerGetAllClassifiers, classifierControllerGetDealClassifiers, classifierControllerPostDealClassifiers, configProviderControllerGetConfig, contractControllerGetContractAndDocumentWorkflowFileNames, contractDraftControllerCreateContract, contractDraftControllerDeleteContract, contractDraftControllerGetContracts, contractDraftControllerUpdateContract, cspReportControllerCollectReport, customDetailControllerCreateSingleCustomDetail, customDetailControllerDeleteSingleCustomDetail, customDetailControllerGetAllMipCustomDetail, customDetailControllerGetKycWorkflowCustomDetails, customDetailControllerToggleArchived, customDetailControllerUpdateKycWorkflowCustomDetail, customDetailControllerUpdateSingleCustomDetail, dealControllerCreateDeal, dealControllerCreateDealClassifiers, dealControllerGetDeal, dealControllerGetDealBasicData, dealControllerGetDealClassifiers, dealControllerGetDealDetails, dealControllerGetList, dealControllerSetDealRestriction, dealControllerSoftDeleteDeal, dealControllerUpdateCompanyRepresentative, dealControllerUpdateDeal, dealControllerUpdateDealClassifiers, dealControllerUpdateProjectRepresentative, dealDocumentTemplatesControllerList, dealEmailTemplateControllerGetOne, dealEmailTemplateControllerList, dealEmailTemplateControllerPreview, dealEmailTemplateControllerReset, dealEmailTemplateControllerTestSend, dealEmailTemplateControllerUpdate, dealEventLogControllerExportDealEvents, dealEventLogControllerGetDealEventDailyCounts, dealEventLogControllerGetDealEventMessage, dealEventLogControllerGetDealEventRecipients, dealEventLogControllerGetDealEvents, dealEventLogControllerGetDealEventSenders, dealEventLogControllerGetDealEventSubjects, dealEventLogControllerGetUnread, dealEventLogControllerMarkViewed, dealUsersControllerDeleteUserFromDeal, dealUsersControllerGetDealUser, dealUsersControllerGetDealUsers, dealUsersControllerInviteUserToDeal, dealUsersControllerSyncUserInDealToAllProgrammes, documentControllerCreateDocuments, documentControllerCreateUploadPreSignedUrls, documentControllerFindRelatedDocuments, documentControllerFindRelatedFilesInDeal, documentControllerGetDocument, documentControllerGetDocuments, documentControllerRemoveDocument, documentControllerRemoveDocumentPersonLink, documentControllerRemoveDocumentTransactionLink, documentControllerUpdate, documentControllerUpdateRelatedDocuments, documentLibraryControllerAddPersonsToDocument, documentLibraryControllerAddPersonsToDocuments, documentLibraryControllerBulkClassifyDocuments, documentLibraryControllerBulkDeleteDocuments, documentLibraryControllerBulkDownloadDocumentFiles, documentLibraryControllerGetDealClassifiersByGroups, documentLibraryControllerGetDocumentDetails, documentLibraryControllerGetDocumentsWithFiltering, documentLibraryControllerGetPersonsInDeal, documentLibraryControllerRemovePersonsFromDocument, documentLibraryControllerRemovePersonsFromDocuments, documentLibraryControllerSetPersonDocumentVisibility, documentLibraryControllerUpdateDocument, documentParsingControllerGetBatchDocuments, documentParsingControllerGetBatchOverview, documentParsingControllerGetBatchPeople, documentParsingControllerGetBatchSecurities, documentParsingControllerGetBatchTransactions, documentParsingControllerGetDocumentTransactions, documentParsingControllerGetExtractionResult, documentParsingControllerGetExtractionStatus, documentParsingControllerListBatches, documentParsingControllerListDealBatches, documentParsingControllerMatchBatchPerson, documentParsingControllerMatchBatchSecurity, documentParsingControllerReextractBatch, documentParsingControllerSaveBatchExtractionOverrides, documentParsingControllerStartExtraction, documentParsingControllerUpdateBatchTitle, documentParsingControllerUploadExtractionDocument, documentTemplatesControllerCreate, documentTemplatesControllerGetAvailability, documentTemplatesControllerGetById, documentTemplatesControllerGetDocxFlowDocument, documentTemplatesControllerGetFieldBindingCatalogue, documentTemplatesControllerGetFieldBindings, documentTemplatesControllerList, documentTemplatesControllerPreviewFieldBindings, documentTemplatesControllerRenderDocxTemplate, documentTemplatesControllerSaveDocxFlowDocument, documentTemplatesControllerSetAvailability, documentTemplatesControllerSoftDelete, documentTemplatesControllerUpdate, documentTemplatesControllerUpdateFieldBindings, documentWorkflowBulkSigningControllerEidEasyBulkComplete, documentWorkflowBulkSigningControllerEidEasyBulkPrepare, documentWorkflowBulkSigningControllerEidEasyBulkSignComplete, documentWorkflowBulkSigningControllerEidEasyBulkSignInitiate, documentWorkflowBulkSigningControllerEidEasyBulkSignStatus, documentWorkflowControllerAddCounterparty, documentWorkflowControllerAddInvestors, documentWorkflowControllerApplyDateComplete, documentWorkflowControllerApplyDatePrepare, documentWorkflowControllerAssignUserToSigner, documentWorkflowControllerBulkAddCounterparty, documentWorkflowControllerBulkAddCounterpartyPreview, documentWorkflowControllerBulkAddCounterpartyStatus, documentWorkflowControllerBulkApplyDate, documentWorkflowControllerBulkApplyDateStatus, documentWorkflowControllerBulkAssignCounterpartiesPreview, documentWorkflowControllerBulkAssignCounterparty, documentWorkflowControllerBulkAssignCounterpartyStatus, documentWorkflowControllerBulkClaimGenerationStatus, documentWorkflowControllerBulkClaimOnBehalf, documentWorkflowControllerBulkClaimOnBehalfPreview, documentWorkflowControllerBulkDownloadFiles, documentWorkflowControllerBulkExportToExcel, documentWorkflowControllerBulkInviteAuthorisedSignatoriesPreview, documentWorkflowControllerBulkInviteAuthorisedSignatory, documentWorkflowControllerBulkReissueDocuments, documentWorkflowControllerBulkRemindSigners, documentWorkflowControllerBulkRemindSignersStatus, documentWorkflowControllerBulkRevokeSimpleDocuments, documentWorkflowControllerBulkSetSignerRequiresWitness, documentWorkflowControllerBulkSetSignerSecurityLevel, documentWorkflowControllerCancelAuthorisedSignatory, documentWorkflowControllerClaimSigner, documentWorkflowControllerCloseDocumentWithoutSignature, documentWorkflowControllerEidEasyComplete, documentWorkflowControllerEidEasyPrepare, documentWorkflowControllerFindDocumentWorkflowEvents, documentWorkflowControllerFindInvestmentProgrammeDocument, documentWorkflowControllerFindInvestmentProgrammeDocuments, documentWorkflowControllerFindInvestmentProgrammeSigningRoles, documentWorkflowControllerGetAddCounterpartyEligibility, documentWorkflowControllerGetAddInvestorEligibility, documentWorkflowControllerInviteAuthorisedSignatory, documentWorkflowControllerInviteRepresentative, documentWorkflowControllerInviteWitness, documentWorkflowControllerRemoveSigner, documentWorkflowControllerRemoveSubmittedForm, documentWorkflowControllerReplaceDocumentFile, documentWorkflowControllerResendInvitation, documentWorkflowControllerSetSignerRequiresWitness, documentWorkflowControllerSetSignerSecurityLevel, documentWorkflowControllerSignWetInkDocument, documentWorkflowControllerSignWetInkDocumentUpload, documentWorkflowControllerStreamProgrammeDocuments, documentWorkflowControllerSubmitForm, documentWorkflowControllerSubmitFormUpload, documentWorkflowControllerUnassignUserFromSigner, documentWorkflowDraftInvestmentControllerGetDraftTemplates, documentWorkflowKycFormControllerAttachForm, documentWorkflowKycFormControllerGetFormsForKycWorkflow, documentWorkflowKycFormControllerGetInvestorForms, documentWorkflowKycFormControllerRemoveForm, documentWorkflowKycFormControllerResetForm, documentWorkflowKycFormControllerReviewForm, documentWorkflowMasterDocumentsControllerBulkArchive, documentWorkflowMasterDocumentsControllerBulkDelete, documentWorkflowMasterDocumentsControllerCreate, documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplates, documentWorkflowMasterDocumentsControllerGetById, documentWorkflowMasterDocumentsControllerGetDocxFlowDocument, documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogue, documentWorkflowMasterDocumentsControllerGetFieldBindings, documentWorkflowMasterDocumentsControllerGetSignatureSlots, documentWorkflowMasterDocumentsControllerPreviewFieldBindings, documentWorkflowMasterDocumentsControllerRenderDocxTemplate, documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsView, documentWorkflowMasterDocumentsControllerSaveDocxFlowDocument, documentWorkflowMasterDocumentsControllerSoftDeleteMasterDocument, documentWorkflowMasterDocumentsControllerUpdateArchived, documentWorkflowMasterDocumentsControllerUpdateFieldBindings, documentWorkflowMasterDocumentsControllerUpdateMasterDocument, e2eControllerAcceptWorkOsInvitation, e2eControllerAuthenticateUser, e2eControllerChangeWorkOsUserEmail, e2eControllerCreateUser, e2eControllerCreateWorkOsUser, e2eControllerDisableMipKyc, e2eControllerGetChangeEmailVerificationCode, e2eControllerGetSentEmails, e2eControllerGetSsoFixture, e2eControllerGetWorkOsEmailVerificationCode, e2eControllerGetWorkOsMagicAuthCode, e2eControllerGetWorkOsPasswordResetLink, e2eControllerGetWorkOsUser, e2eControllerPollWorkOsEvents, e2eControllerResetSsoOrganization, e2eControllerWarmupPool, eidEasyMockControllerComplete, eidEasyMockControllerSignPage, eidEasyMockControllerVerifyOtp, eidEasyWebhookControllerCustomSignatureImage, eidEasyWebhookControllerDocumentSigned, emailChangeEligibilityControllerGetEmailChangeEligibility, emailSchedulerControllerCancel, emailSchedulerControllerCreateSchedule, emailSchedulerControllerListConfigs, emailSchedulerControllerListSchedules, emailSchedulerControllerReschedule, emailSchedulerControllerRestart, emailSchedulerControllerSendNow, emailSchedulerControllerSetEndDate, emailSchedulerControllerUpsertConfig, employmentEmployersControllerGetEmployers, employmentRecordControllerDeleteEmploymentRecord, employmentRecordControllerGetEmploymentRecord, employmentRecordControllerUpdateEmploymentRecord, fileControllerBulkDownloadFiles, fileControllerCreateFile, fileControllerCreateSignatureFile, fileControllerDownloadFile, fileControllerDownloadPreSignedUrl, fileControllerGetFileDownloadUrl, foreignExchangeControllerGetCurrenciesUsedInValuation, foreignExchangeControllerGetHistoricalAndCustomExchangeRate, foreignExchangeControllerGetLatestExchangeRate, foreignExchangeControllerPutCustomExchangeRate, fundControllerCreateFund, fundControllerGetAllFunds, fundControllerGetAvailableDealsForFund, fundControllerGetAvailableDealsForPersonFundLink, fundControllerGetFund, fundControllerGetFundByDeal, fundControllerGetFundLinkedDeals, fundControllerGetFundLinksForPerson, fundControllerLinkFundToDeal, fundControllerLinkPersonToFund, fundControllerUnlinkFundFromDeal, fundControllerUnlinkPersonFromFund, fundControllerUpdateFund, generatableDocumentsControllerAssignProjectToGeneratableDocumentTemplate, generatableDocumentsControllerCreateGdwtCustomDetailsDefinitions, generatableDocumentsControllerDeleteCustomDetailsDefinitions, generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByType, generatableDocumentsControllerGetAllGeneratableDocumentsTemplates, generatableDocumentsControllerGetGdwtCustomDetailsDefinitions, generatableDocumentsControllerGetGeneratableDocumentsTemplate, generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjects, generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFields, generatableDocumentsControllerUnassignProjectToGeneratableDocumentTemplate, generatableDocumentsControllerUpdateGdwtCustomDetailsDefinitions, generatableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFields, generatableDocumentsControllerUpdateGeneratableDocumentTemplate, godmodeControllerBulkCreateTsaForMip, godmodeControllerChangeDeal, godmodeControllerCreateCustomDetails, godmodeControllerDeleteUserSoft, godmodeControllerDownloadFile, godmodeControllerGetActiveMips, godmodeControllerGetAllInvestorData, godmodeControllerGetAllInvestors, godmodeControllerGetAllInvestorsForMip, godmodeControllerGetAllNotDeletedProjects, godmodeControllerGetDeal, godmodeControllerGetDealsList, godmodeControllerGetDealWithActiveMips, godmodeControllerGetFileInfo, godmodeControllerGetInvestmentWorkflows, godmodeControllerGetInvestorPersonalDetailsDataByUserId, godmodeControllerGetInvestorsFromMip, godmodeControllerGetMipCustomDetailsDataWithoutForms, godmodeControllerGetMipData, godmodeControllerGetMipListOfInvestments, godmodeControllerGetMipListOfLoans, godmodeControllerGetUserData, godmodeControllerIsAnyActiveInvestorInMip, godmodeControllerIsAnyInvitedInvestorInMip, godmodeControllerPostBulkEditMipInvestments, godmodeControllerPostBulkUpdateMipLoans, godmodeControllerPostReassignInvestor, godmodeControllerPostRemoveInvestor, godmodeControllerPostRevokeTsa, godmodeControllerPostSoftDeleteTsa, godmodeControllerRemoveInvestorPersonalDetails, godmodeControllerReplaceFile, godmodeControllerSoftDeleteKycFile, godmodeControllerSoftDeleteMip, godmodeControllerUnArchiveDealAndMips, godmodeControllerUpdateCustomDetailType, godmodeControllerUpdateDealMipsInvestorsDeleted, godmodeControllerUpdateInvestorPersonalDetails, godmodeControllerUpdateIsLocked, godmodeControllerUpdateMipKycOptional, godmodeControllerUpdateShareAssociations, godmodeControllerUpdateUserEmail, godmodeControllerUpdateUserName, godmodeControllerUploadPdfFile, healthControllerHealthCheck, helpBlogControllerGetArticles, helpBlogControllerGetAuthors, helpBlogControllerGetCategories, helpBlogControllerGetEntrypointArticles, helpBlogControllerGetSlugArticle, helpBlogControllerGetSlugAuthor, helpBlogControllerGetSlugCategory, holdingEventControllerCreateBulkHoldingEvents, holdingEventControllerCreateHoldingEvent, holdingEventControllerSoftDeleteHoldingEvent, holdingEventControllerUpdateHoldingEvent, holdingsControllerDownloadHoldingsExcel, holdingsControllerDownloadVestingEventsReport, holdingsControllerGenerateShareRegisterPdf, holdingsControllerGenerateShareRegisterPdfInline, holdingsControllerGetHoldingByPersonAndSecurity, holdingsControllerGetHoldingEventsListByPersonAndSecurity, holdingsControllerGetShareRegisterPdfTaskStatus, holdingsControllerPostHoldingsListForPerson, holdingsControllerPostRegularViewHoldingsCsv, holdingsControllerPostWideViewHoldingsCsv, holdingsControllerStartShareRegisterPdfGeneration, infoControllerDeploymentInfo, investmentControllerGetAllInvestmentValuations, investmentControllerGetInvestmentDetails, investmentControllerGetInvestmentPaymentInstruction, investmentControllerGetInvestmentsAndSdwDocuments, investmentControllerGetInvestmentV2, investmentControllerGetInvestmentValuations, investmentControllerGetSecurityVestingData, investmentControllerGetUserInvestmentsList, investmentControllerSetSelectedBankAccount, investorBankAccountControllerGetBankAccountDetail, investorBankAccountControllerGetBankAccountHistory, investorBankAccountControllerGetInvestorBankAccounts, investorBankAccountControllerReview, investorControllerDownloadInvestorsData, investorControllerGetInvestmentVehicleHoldings, investorControllerGetInvestmentVehicleQuickLinks, investorControllerGetInvestmentVehicleRelatedPeople, investorControllerGetInvestmentVehicleValuations, investorControllerGetInvestorHoldings, investorControllerGetInvestorHoldingTransactions, investorControllerGetInvestorInvestmentsAndTransactions, investorControllerGetInvestorInvestmentValuations, investorControllerGetInvestorJourneys, investorControllerGetInvestorQuickLinks, investorControllerGetMipDraftJoinerInvestorTemplate, investorControllerGetMipDraftLeaverInvestorTemplate, investorControllerGetMipInvestmentVehicleNamesForFiltering, investorControllerGetMipInvestorById, investorControllerGetMipInvestorDocumentWorkflowListById, investorControllerGetMipInvestorNamesForFiltering, investorControllerGetMipInvestorsDataForSendModal, investorControllerGetMipInvestorsIds, investorControllerGetMipInvestorsList, investorControllerGetMipInvestorsOrderedIds, investorControllerGetMipInvestorsSecuritiesListData, investorControllerGetMipSelectedInvestorsData, investorControllerGetSecurityVestingData, investorControllerPostBulkRevokeTsa, investorControllerPostMipDraftJLeaverInvestorTemplate, investorControllerPostMipDraftJoinerInvestorTemplate, investorControllerPostRemoveInvestor, investorControllerPostRevokeTsa, investorControllerPutInvestorCustomDetails, investorControllerRequestKyc, investorControllerSendInvites, investorControllerStartDownloadInvestorsDataWorkflow, investorDraftControllerGetMipInvestors, investorDraftControllerPostMipDraftInvestorData, investorDraftControllerPostMipDraftInvestorTemplate, investorInvestmentWorkflowControllerAddInvestmentAllocation, investorInvestmentWorkflowControllerAddInvestmentLoan, investorInvestmentWorkflowControllerApproveInvestment, investorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflow, investorInvestmentWorkflowControllerBulkUpdateExpectedTransactionType, investorInvestmentWorkflowControllerDownloadExcel, investorInvestmentWorkflowControllerGetInvestmentDetailsAllocations, investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformation, investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatus, investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocuments, investorInvestmentWorkflowControllerGetInvestmentDetailsOtherData, investorInvestmentWorkflowControllerGetInvestmentDetailsSummary, investorInvestmentWorkflowControllerGetInvestmentDetailsTaxCompliance, investorInvestmentWorkflowControllerGetInvestmentsForMip, investorInvestmentWorkflowControllerGetManageableLegalDocuments, investorInvestmentWorkflowControllerGetOrderedInvestmentIds, investorInvestmentWorkflowControllerGetReleaseWorkflowStatus, investorInvestmentWorkflowControllerMakeDraft, investorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflow, investorInvestmentWorkflowControllerRemoveInvestmentAllocation, investorInvestmentWorkflowControllerRemoveInvestmentLoan, investorInvestmentWorkflowControllerSetInvestmentDetailsBankAccount, investorInvestmentWorkflowControllerSetInvestmentDetailsPiv, investorInvestmentWorkflowControllerSetInvestmentDetailsTargetDates, investorInvestmentWorkflowControllerStartInvestment, investorInvestmentWorkflowControllerToggleLegalDocument, investorInvestmentWorkflowControllerUpdateInvestmentAllocation, investorInvestmentWorkflowControllerUpdateInvestmentLoan, investorInvestmentWorkflowControllerUpsertShareAssociations, investorMessageControllerGetMessageForInvestor, investorMessageControllerGetMessagesForInvestor, kycControllerDeleteKycFile, kycControllerDownloadInvestorsFiles, kycControllerGetInvestorsStatistics, kycControllerGetKycInvestorData, kycControllerGetKycInvestorsData, kycControllerGetKycWorkflowsData, kycControllerMorePivDocuments, kycControllerPutAssociateKycFile, kycControllerResendKycFileCertifierInvitation, kycControllerSetInvestorDeclarations, kycControllerUpdateDeclarationsStatus, kycControllerUpdateKycFile, kycControllerUpdateKycStatus, kycControllerWithdrawStandaloneKycWorkflow, kycFormTemplateControllerArchive, kycFormTemplateControllerCreate, kycFormTemplateControllerDelete, kycFormTemplateControllerDocxDocument, kycFormTemplateControllerFieldBindingCatalogue, kycFormTemplateControllerFieldBindings, kycFormTemplateControllerInstanceCount, kycFormTemplateControllerList, kycFormTemplateControllerListLibrary, kycFormTemplateControllerPreviewFieldBindings, kycFormTemplateControllerRenderDocx, kycFormTemplateControllerRenderDocxFields, kycFormTemplateControllerSaveDocxDocument, kycFormTemplateControllerSignatureSlots, kycFormTemplateControllerUpdate, kycFormTemplateControllerUpdateFieldBindings, kycFormTemplateControllerUpdateSignaturePlacement, kycSettingControllerGetByKycWorkflowId, kycSettingControllerGetMipRequirements, kycSettingControllerUpdateByKycWorkflowId, kycSettingControllerUpdateMipRequirements, loanDefinitionControllerCreateLoanDefinitions, loanDefinitionControllerDeleteLoanDefinition, loanDefinitionControllerGetLoansDefinitionByMipId, loanDefinitionControllerUpdateLoanDefinition, mipClassifierControllerAttachInvestors, mipClassifierControllerCreate, mipClassifierControllerDetachInvestors, mipClassifierControllerList, mipClassifierControllerListByInvestor, mipClassifierControllerUpdate, mipControllerAddMipProgrammeEntity, mipControllerDeleteMipProgrammeEntity, mipControllerGetEmailWorkflowStatus, mipControllerGetMipDetailsForJoiner, mipControllerGetMipDetailsForLeaver, mipControllerGetMipProgrammeEntities, mipControllerGetMipsForPerson, mipControllerGetPivDetailsForInvestors, mipControllerGetWorkflowSettings, mipControllerListProgrammes, mipControllerPostJoinerAdditionalAllocations, mipControllerPostLeaverNegativeAllocations, mipControllerUpdateMipData, mipControllerUpdateMipKycRequired, mipControllerUpdateWorkflowSettings, mipDraftControllerComplete, mipDraftControllerCreateActiveProgramme, mipDraftControllerCreateMip, mipDraftControllerGetDraftStepsStatuses, mipDraftControllerSoftDeleteMipDraft, mipDraftControllerUpdateDraftGeneralDealInputs, oneSchemaControllerCreateOneSchemaPersonsSession, oneSchemaControllerCreateOneSchemaTransactionsSession, oneSchemaControllerPrepareOneSchemaManagementLoansCache, oneSchemaControllerPrepareOneSchemaShareAssociationsCache, oneSchemaControllerValidateOneSchemaLegalPersonsRows, oneSchemaControllerValidateOneSchemaManagementLoansRows, oneSchemaControllerValidateOneSchemaNaturalPersonsRows, oneSchemaControllerValidateOneSchemaShareAssociationRows, oneSchemaControllerValidateOneSchemaTransactionRows, type Options, organizationControllerCreateOrganization, organizationControllerDeleteOrganization, organizationControllerGetAllOrganizations, organizationControllerGetOrganizationDetailsById, organizationControllerImportOrganization, organizationControllerLookupWorkOsOrganizations, organizationControllerUpdateOrganization, organizationControllerUpdateOrganizationType, organizationCustomFieldControllerCreateCustomField, organizationCustomFieldControllerDeleteCustomField, organizationCustomFieldControllerGetCustomFields, organizationCustomFieldControllerUpdateCustomField, organizationDealClassifierControllerListClassifiers, organizationDealClassifierControllerSetClassifiers, organizationDealEmailTemplateControllerGetOne, organizationDealEmailTemplateControllerList, organizationDealEmailTemplateControllerPreview, organizationDealEmailTemplateControllerReset, organizationDealEmailTemplateControllerUpdate, organizationDefaultMemberControllerAddMember, organizationDefaultMemberControllerListMembers, organizationDefaultMemberControllerRemoveMember, organizationDocumentTemplateControllerBulkArchive, organizationDocumentTemplateControllerBulkDelete, organizationDocumentTemplateControllerCreate, organizationDocumentTemplateControllerGetById, organizationDocumentTemplateControllerList, organizationDocumentTemplateControllerRemove, organizationDocumentTemplateControllerUpdate, organizationDocumentTemplateControllerUpdateArchived, organizationEmailScheduleControllerListConfigs, organizationEmailScheduleControllerUpsertConfig, organizationEmailTemplateControllerGetOne, organizationEmailTemplateControllerList, organizationEmailTemplateControllerPreview, organizationEmailTemplateControllerReset, organizationEmailTemplateControllerUpdate, organizationFileControllerDownloadPreSignedUrl, organizationKycFormTemplateControllerArchive, organizationKycFormTemplateControllerCreate, organizationKycFormTemplateControllerList, organizationKycFormTemplateControllerRemove, organizationKycFormTemplateControllerSignatureSlots, organizationKycFormTemplateControllerUpdate, organizationKycFormTemplateControllerUpdateSignaturePlacement, organizationKycSettingControllerGetRequirements, organizationKycSettingControllerUpdateRequirements, organizationUsersControllerDeleteUserFromOrganizations, organizationUsersControllerGetOrganizationUsers, organizationUsersControllerGetOrganizationUserWithPermissions, organizationUsersControllerInviteUserToOrganization, organizationVestingTermControllerCreateGraded, organizationVestingTermControllerCreateLeaverProvision, organizationVestingTermControllerCreateStraightLine, organizationVestingTermControllerCreateVestingTerm, organizationVestingTermControllerDeleteGraded, organizationVestingTermControllerDeleteLeaverProvision, organizationVestingTermControllerDeleteVestingTerm, organizationVestingTermControllerGetVestingTerms, organizationVestingTermControllerUpdateGraded, organizationVestingTermControllerUpdateLeaverProvision, organizationVestingTermControllerUpdateStraightLine, organizationVestingTermControllerUpdateVestingTerm, passwordControllerUpdatePassword, paymentControllerBulkUpdate, paymentControllerDownloadMipPayments, paymentControllerGetStatus, paymentControllerUpdate, permissionControllerAddResourcePermissionsForUser, permissionControllerRemoveResourcePermissionForUser, permissionControllerSetResourcePermissionsForUser, personBankAccountControllerCreatePersonBankAccount, personBankAccountControllerDeletePersonBankAccount, personBankAccountControllerGetPersonBankAccounts, personBankAccountControllerUpdatePersonBankAccount, personBankAccountControllerValidatePersonBankAccount, personControllerAddRelatedPersonByEmail, personControllerBulkCreateLegalPersons, personControllerBulkCreateNaturalPersons, personControllerCreateAddress, personControllerCreateLegalEntity, personControllerCreateNaturalEntity, personControllerCreateRelatedPeopleForPerson, personControllerDeleteAddress, personControllerDeleteEntities, personControllerDeletePersonRelatedPerson, personControllerGetAllEntities, personControllerGetAllLegalEntities, personControllerGetAvailableRelatedPeopleForPerson, personControllerGetEntityData, personControllerGetNaturalPersonsByPivId, personControllerGetPersonRelatedPeople, personControllerGetPersonsForCap, personControllerGetPersonTagsForDeal, personControllerIsPersonUserInvitedToPlatform, personControllerIsThereInvestmentWorkflow, personControllerLookupPersonByEmail, personControllerUpdateAddress, personControllerUpdateLegalPersonDetails, personControllerUpdateNaturalPersonDetails, personControllerUpdateNaturalPersonEmail, personControllerUpdateRelatedPersonRelation, personEmploymentControllerGetPersonEmployment, personEmploymentControllerUpsertPersonEmployment, personEmploymentRecordControllerCreateEmploymentRecord, personEmploymentRecordControllerListEmploymentRecords, personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMip, personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPerson, personInvestmentProgrammeControllerGetInvestmentProgrammesForPerson, personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMip, personInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequest, personInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequest, personTaxControllerCreatePersonTaxInformation, personTaxControllerDeletePersonTaxInformation, personTaxControllerGetPersonTaxInformation, personTaxControllerUpdatePersonTaxInformation, preFillableFormsControllerGetTemplatesForProject, preFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplate, preFillableFormTemplateControllerCreatePreFillableFormTemplate, preFillableFormTemplateControllerDeleteCustomDetailsDefinitions, preFillableFormTemplateControllerGetAllPreFillableFormTemplates, preFillableFormTemplateControllerGetOrganizationOptions, preFillableFormTemplateControllerGetPreFillableFormTemplate, preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitions, preFillableFormTemplateControllerSoftDeletePreFillableFormTemplate, preFillableFormTemplateControllerUpdateCustomDetailsDefinitions, preFillableFormTemplateControllerUpdatePreFillableFormTemplate, preFillableFormTemplateControllerUploadPreFillableFormTemplateFile, profileControllerUpdatePhone, programmeDefaultsSummaryControllerApply, programmeDefaultsSummaryControllerGetMySummary, programmeDefaultsSummaryControllerGetSummary, programmeDefaultsSummaryControllerGetSummaryForDeal, programmeEmailTemplateControllerGetOne, programmeEmailTemplateControllerList, programmeEmailTemplateControllerPreview, programmeEmailTemplateControllerReset, programmeEmailTemplateControllerTestSend, programmeEmailTemplateControllerUpdate, programmeSecurityAllocationsControllerCreateAllocation, programmeSecurityAllocationsControllerDeleteAllocation, programmeSecurityAllocationsControllerGetAllocationMipListBySecurityId, programmeSecurityAllocationsControllerGetAllocationsBySecurityId, programmeSecurityAllocationsControllerUpdateAllocation, programmeSettingControllerGetByMipId, programmeSettingControllerUpdateByMipId, programmeUsersControllerDeleteUserFromProgramme, programmeUsersControllerGetProgrammeUser, programmeUsersControllerGetProgrammeUsers, programmeUsersControllerInviteUserToProgramme, programmeUsersControllerUpdateUserAndUserProgramme, publicBulkSigningControllerBulkComplete, publicBulkSigningControllerBulkPrepare, publicBulkSigningControllerBulkSignComplete, publicBulkSigningControllerBulkSignInitiate, publicBulkSigningControllerBulkSignStatus, publicBulkSigningControllerGetProgrammeDocument, publicBulkSigningControllerGetProgrammeDocuments, publicBulkSigningControllerGetSignatureToken, publicCertificationControllerSaveCertifierDetails, publicCertificationControllerUpdateCertificationText, publicSigningControllerComplete, publicSigningControllerGetDocument, publicSigningControllerGetSigningInfo, publicSigningControllerInviteWitness, publicSigningControllerPrepare, publicSigningControllerSaveWitnessDetails, resendControllerEmailEvent, securityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRights, securityCatchUpRightsControllerSoftDeleteSecurityCatchUpRights, securityControllerBulkCreateSecurities, securityControllerBulkDeleteTrackedSecurities, securityControllerBulkSoftDeleteSecurities, securityControllerBulkUpdateSecurities, securityControllerBulkUpdateTrackedSecurities, securityControllerCreateSecurity, securityControllerDoesPersonHaveSecurities, securityControllerDownloadExcel, securityControllerGetLoanDefinitionsForDeal, securityControllerGetPersonSecurities, securityControllerGetPersonSecuritiesWithFeaturesAndRanks, securityControllerGetSecuritiesByDealId, securityControllerGetSecuritiesDataForMip, securityControllerGetSecurity, securityControllerGetSecurityNominalValue, securityControllerIsSecuritiesUsedInAnyMip, securityControllerSoftDeleteSecurity, securityControllerUpdateCurrencyForPersonSecurities, securityControllerUpdateSecurity, securityControllerUpdateSecurityAuthorisedCapital, securityControllerUpdateSecurityParticipationThreshold, securityEventControllerCreateSecurityEvent, securityEventControllerGetSecurityEvents, securityEventControllerSoftDeleteSecurityEvent, securityEventControllerUpdateSecurityEvent, securityExchangeRightsControllerCreateOrUpdateSecurityExchangeRights, securityExchangeRightsControllerSoftDeleteSecurityExchangeRights, securityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinition, securityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRights, securityInterestRedemptionControllerSoftDeleteSecurityInterestDefinition, securityInterestRedemptionControllerSoftDeleteSecurityRedemptionRights, securityLiquidationPreferenceControllerCreateOrUpdate, securityLiquidationPreferenceControllerGet, securityLiquidationPreferenceControllerSoftDelete, securityRankControllerDeleteSecurityIncomeRanks, securityRankControllerDeleteSecurityRank, securityRankControllerUpsertSecurityIncomeRanks, securityRankControllerUpsertSecurityRank, securityRankDefinitionControllerCreateRank, securityRankDefinitionControllerGetPersonRanks, securityRankDefinitionControllerSoftDeleteRank, securityRankDefinitionControllerUpdateRank, securityRatchetControllerDeleteSchedule, securityRatchetControllerGetSchedule, securityRatchetControllerUpsertSchedule, securityValueOverrideControllerCreateSecurityValueOverride, securityValueOverrideControllerDeleteSecurityValueOverride, securityValueOverrideControllerUpdateSecurityValueOverride, sessionManagementControllerGetSessionStatus, sessionManagementControllerKeepSessionAlive, sessionManagementControllerLogout, sessionManagementControllerRedirectCallbackFromWorkOs, sessionManagementControllerRefreshToken, sessionManagementControllerSendMagicAuthVerificationCode, sessionManagementControllerSignOut, sessionManagementControllerValidateMagicCode, shareholderBankAccountControllerConfirmBankAccount, shareholderBankAccountControllerDeleteBankAccount, shareholderBankAccountControllerGetUserBankAccount, shareholderBankAccountControllerRequestBankAccountCode, shareholderBankAccountControllerUpsertBankAccount, shareholderBankAccountControllerValidateBankAccount, shareholderContractControllerGeneratePrefillableFormFile, shareholderContractControllerGenerateSignableDocuments, shareholderContractControllerGetListOfActionableDocuments, shareholderContractControllerReviewDocument, shareholderContractControllerStreamSignableDocuments, shareholderCustomDetailControllerGetShareholderCustomDetailData, shareholderCustomDetailControllerUpdateShareholderInvestorData, shareholderInvestorControllerGetInvestmentTransactions, shareholderInvestorControllerGetInvestorDealDocuments, shareholderInvestorControllerGetInvestorDocuments, shareholderInvestorControllerGetInvestorRepresentative, shareholderInvestorControllerGetShareholderInvestorData, shareholderInvestorControllerGetShareholderInvestorDataByUserId, shareholderInvestorControllerUpdateShareholderInvestorCompletedStepsData, shareholderInvestorControllerUpdateShareholderInvestorData, shareholderInvestorControllerUpdateShareholderInvestorVehicleData, shareholderKycControllerAddFilledKycForm, shareholderKycControllerChangeKycFileCertification, shareholderKycControllerConfirmDeclaration, shareholderKycControllerConfirmInvestorForm, shareholderKycControllerConfirmKycFile, shareholderKycControllerDeleteKycFile, shareholderKycControllerDownloadPreFilledKycFormFile, shareholderKycControllerGetDeclarations, shareholderKycControllerGetInvestmentVehicleKycFiles, shareholderKycControllerGetInvestorKycForms, shareholderKycControllerGetProofOfAddress, shareholderKycControllerGetProofOfIdentity, shareholderKycControllerGetStandaloneKycMetadata, shareholderKycControllerPatchDeclarations, shareholderKycControllerPostInvestmentVehicle, shareholderKycControllerPreFillInvestorKycForm, shareholderKycControllerPutProofOfAddress, shareholderKycControllerPutProofOfIdentity, shareholderKycControllerRemoveInvestorForm, shareholderKycControllerResendKycFileCertifierInvitation, shareholderKycControllerResetInherited, shareholderKycControllerSetOffMorePivDocuments, simpleDocumentWorkflowControllerAddFileToMip, simpleDocumentWorkflowControllerCreateDocuments, simpleDocumentWorkflowControllerGetInvestorsFilteringData, simpleDocumentWorkflowControllerRemoveDocumentFile, simpleDocumentWorkflowControllerSendMasterDocuments, tagControllerAttachClassifiers, tagControllerCreate, tagControllerDetachClassifiers, tagControllerList, tagControllerRemove, tagControllerUpdate, taskControllerGet, transactionControllerAutoReorder, transactionControllerBulkDeleteTransactions, transactionControllerBulkRestore, transactionControllerBulkUpdate, transactionControllerBulkUpload, transactionControllerBulkUploadManagementLoans, transactionControllerCreateInseparableRedemption, transactionControllerCreatePairedIssue, transactionControllerCreateTransaction, transactionControllerDeleteTransaction, transactionControllerDownloadExcel, transactionControllerGetBulkUploadTaskStatus, transactionControllerGetInseparableRedemptionGroup, transactionControllerGetPairTransaction, transactionControllerGetTransactionDetails, transactionControllerGetTransactions, transactionControllerPairTransaction, transactionControllerPreviewInseparableRedemption, transactionControllerPreviewTransferCounterpart, transactionControllerRestore, transactionControllerSplitTransaction, transactionControllerSplitTransactionInterest, transactionControllerUpdate, transactionControllerUpdateInseparableRedemption, transactionControllerUpdateOrder, translationsControllerTranslations, twoFaControllerDeleteAuthFactor, twoFaControllerSetup2Fa, twoFaControllerVerifyChallenge2Fa, userControllerDeleteUserSignature, userControllerGetAllInvestors, userControllerGetCurrentUserData, userControllerGetUserOrganization, userControllerGetUserPersons, userControllerGetUserProfile, userControllerGetUserSignature, userControllerUpdatePersonalDetails, userControllerUpdateShareholderInvestorVehicleDataWithoutMip, userControllerUpdateUserLegalRepresentativeWithoutMip, userControllerUpdateUserSignature, validationControllerValidateTin, validationControllerVerifyBankIdentifiers, valuationControllerCreateValuation, valuationControllerDeleteValuation, valuationControllerDuplicateValuation, valuationControllerGetValuationsAndJoinWithClassifiers, valuationControllerUpdateValuationWithClassifiers, valuationControllerUpsertValuation, valuationInputControllerCreateValuationInputAdjustment, valuationInputControllerDeleteValuationInputAdjustment, valuationInputControllerGetValuationInputs, valuationInputControllerUpdateValuationInput, valuationInputControllerUpdateValuationInputAdjustment, valuationInputControllerUpsert, valuationPersonInputControllerCreateValuationPersonInput, valuationPersonInputControllerDeleteValuationPersonInput, valuationPersonInputControllerGetValuationPersonInputs, valuationPersonInputControllerUpdateValuationPersonInput, valuationPersonInputControllerUpsertValuationPersonInputs, valuationSummaryControllerDownloadExcel, valuationSummaryControllerDownloadInterestEventsExcel, valuationSummaryControllerGetValuationBreakpointSummary, valuationSummaryControllerGetValuationSummaryResult, valuationSummaryControllerStartCalculateValuation, valuationSummaryControllerStreamCalculateValuation, vestingControllerApplyVestingStartDateToInvestmentWorkflow, vestingControllerApplyVestingStartDateToTransaction, vestingControllerApplyVestingTermToInvestmentWorkflow, vestingControllerApplyVestingTermToTransaction, vestingControllerBulkUpdateInvestorsVesting, vestingControllerCreateVestingTerm, vestingControllerCreateVestingTermGraded, vestingControllerCreateVestingTermLeaverProvision, vestingControllerCreateVestingTermStraightLine, vestingControllerDeletePerformanceVesting, vestingControllerDeleteVestingTerm, vestingControllerDeleteVestingTermGraded, vestingControllerDeleteVestingTermLeaverProvision, vestingControllerDeleteVestingTermStraightLine, vestingControllerGetSimplifiedVestingTerms, vestingControllerGetVestingTerms, vestingControllerRemoveVestingTermFromInvestmentWorkflow, vestingControllerRemoveVestingTermFromTransaction, vestingControllerSaveTransactionVesting, vestingControllerUpdateVestingTerm, vestingControllerUpdateVestingTermGraded, vestingControllerUpdateVestingTermLeaverProvision, vestingControllerUpdateVestingTermStraightLine, vestingControllerUpsertPerformanceVesting, workOsEventsAdminControllerListWorkOsEvents, workOsEventsAdminControllerReplayWorkOsEvent, workOsWebhookControllerWebhook } from '../sdk.gen';
import type { AuditControllerGetEntityAuditsData, AuditControllerGetEntityAuditsResponse, AuditControllerGetInvestmentAuditsData, AuditControllerGetInvestmentAuditsResponse, AuditControllerGetPersonAuditsData, AuditControllerGetPersonAuditsResponse, AuthControllerCancelChangeEmailRequestData, AuthControllerCanChangeCredentialsData, AuthControllerCanChangeCredentialsResponse, AuthControllerChangeEmailRequestData, AuthControllerDeleteChangeEmailRequestData, AuthControllerRenewInvitationData, AuthControllerRenewInvitationResponse, AuthControllerStartHostedAuthKitData, AuthControllerUpdateEmailData, BankAccountControllerCreateMipBankAccountData, BankAccountControllerCreateMipBankAccountResponse, BankAccountControllerDeleteMipBankAccountData, BankAccountControllerGetMipBankAccountData, BankAccountControllerGetMipBankAccountResponse, BankAccountControllerUpdateMipBankAccountData, BankAccountControllerUpdateMipBankAccountResponse, BankAccountControllerValidateBankAccountData, BankAccountControllerValidateBankAccountResponse, BankAccountFormatRuleControllerGetFormatRulesData, BankAccountFormatRuleControllerGetFormatRulesResponse, BankAccountFormatRuleControllerGetSupportedCountriesData, BankAccountFormatRuleControllerGetSupportedCountriesResponse, BankAccountLifecycleDebugControllerGetStateTransitionsData, BankAccountLifecycleDebugControllerGetVerificationLogsData, CapTableControllerDownloadExcelData, CapTableControllerExportDealHoldingsJsonData, CapTableControllerExportDealHoldingsJsonResponse, CapTableControllerGetCapDetailsData, CapTableControllerGetCapDetailsResponse, CapTableControllerGetCapTransactionsValidationDetailsData, CapTableControllerGetCapTransactionsValidationDetailsResponse, CapTableControllerPostCapTableDataData, CapTableControllerPostCapTableDataResponse, CapTableControllerPostGroupStructureDataData, CapTableControllerPostGroupStructureDataResponse, CapTableControllerPostGroupStructurePositionsData, CapTableControllerPostGroupStructurePositionsResponse, CapTableControllerPostSecuritiesForGroupStructureDataData, CapTableControllerPostSecuritiesForGroupStructureDataResponse, CapTableControllerUpdateGroupStructurePositionsData, CapTableControllerUpdateGroupStructurePositionsResponse, ClassifierControllerGetAllClassifiersData, ClassifierControllerGetAllClassifiersResponse, ClassifierControllerGetDealClassifiersData, ClassifierControllerGetDealClassifiersResponse, ClassifierControllerPostDealClassifiersData, ClassifierControllerPostDealClassifiersResponse, ConfigProviderControllerGetConfigData, ContractControllerGetContractAndDocumentWorkflowFileNamesData, ContractControllerGetContractAndDocumentWorkflowFileNamesResponse, ContractDraftControllerCreateContractData, ContractDraftControllerCreateContractResponse, ContractDraftControllerDeleteContractData, ContractDraftControllerGetContractsData, ContractDraftControllerGetContractsResponse, ContractDraftControllerUpdateContractData, ContractDraftControllerUpdateContractResponse, CspReportControllerCollectReportData, CspReportControllerCollectReportResponse, CustomDetailControllerCreateSingleCustomDetailData, CustomDetailControllerDeleteSingleCustomDetailData, CustomDetailControllerGetAllMipCustomDetailData, CustomDetailControllerGetAllMipCustomDetailResponse, CustomDetailControllerGetKycWorkflowCustomDetailsData, CustomDetailControllerGetKycWorkflowCustomDetailsResponse, CustomDetailControllerToggleArchivedData, CustomDetailControllerUpdateKycWorkflowCustomDetailData, CustomDetailControllerUpdateSingleCustomDetailData, DealControllerCreateDealClassifiersData, DealControllerCreateDealClassifiersResponse, DealControllerCreateDealData, DealControllerCreateDealResponse, DealControllerGetDealBasicDataData, DealControllerGetDealBasicDataResponse, DealControllerGetDealClassifiersData, DealControllerGetDealClassifiersResponse, DealControllerGetDealData, DealControllerGetDealDetailsData, DealControllerGetDealDetailsResponse, DealControllerGetDealResponse, DealControllerGetListData, DealControllerGetListResponse, DealControllerSetDealRestrictionData, DealControllerSoftDeleteDealData, DealControllerUpdateCompanyRepresentativeData, DealControllerUpdateCompanyRepresentativeResponse, DealControllerUpdateDealClassifiersData, DealControllerUpdateDealClassifiersResponse, DealControllerUpdateDealData, DealControllerUpdateProjectRepresentativeData, DealDocumentTemplatesControllerListData, DealDocumentTemplatesControllerListResponse, DealEmailTemplateControllerGetOneData, DealEmailTemplateControllerGetOneResponse, DealEmailTemplateControllerListData, DealEmailTemplateControllerListResponse, DealEmailTemplateControllerPreviewData, DealEmailTemplateControllerPreviewResponse, DealEmailTemplateControllerResetData, DealEmailTemplateControllerResetResponse, DealEmailTemplateControllerTestSendData, DealEmailTemplateControllerTestSendResponse, DealEmailTemplateControllerUpdateData, DealEmailTemplateControllerUpdateResponse, DealEventLogControllerExportDealEventsData, DealEventLogControllerExportDealEventsResponse, DealEventLogControllerGetDealEventDailyCountsData, DealEventLogControllerGetDealEventDailyCountsResponse, DealEventLogControllerGetDealEventMessageData, DealEventLogControllerGetDealEventMessageResponse, DealEventLogControllerGetDealEventRecipientsData, DealEventLogControllerGetDealEventRecipientsResponse, DealEventLogControllerGetDealEventsData, DealEventLogControllerGetDealEventSendersData, DealEventLogControllerGetDealEventSendersResponse, DealEventLogControllerGetDealEventsResponse, DealEventLogControllerGetDealEventSubjectsData, DealEventLogControllerGetDealEventSubjectsResponse, DealEventLogControllerGetUnreadData, DealEventLogControllerGetUnreadResponse, DealEventLogControllerMarkViewedData, DealEventLogControllerMarkViewedResponse, DealUsersControllerDeleteUserFromDealData, DealUsersControllerGetDealUserData, DealUsersControllerGetDealUserResponse, DealUsersControllerGetDealUsersData, DealUsersControllerGetDealUsersResponse, DealUsersControllerInviteUserToDealData, DealUsersControllerSyncUserInDealToAllProgrammesData, DocumentControllerCreateDocumentsData, DocumentControllerCreateUploadPreSignedUrlsData, DocumentControllerFindRelatedDocumentsData, DocumentControllerFindRelatedDocumentsResponse, DocumentControllerFindRelatedFilesInDealData, DocumentControllerFindRelatedFilesInDealResponse, DocumentControllerGetDocumentData, DocumentControllerGetDocumentResponse, DocumentControllerGetDocumentsData, DocumentControllerGetDocumentsResponse, DocumentControllerRemoveDocumentData, DocumentControllerRemoveDocumentPersonLinkData, DocumentControllerRemoveDocumentTransactionLinkData, DocumentControllerUpdateData, DocumentControllerUpdateRelatedDocumentsData, DocumentLibraryControllerAddPersonsToDocumentData, DocumentLibraryControllerAddPersonsToDocumentsData, DocumentLibraryControllerBulkClassifyDocumentsData, DocumentLibraryControllerBulkDeleteDocumentsData, DocumentLibraryControllerBulkDeleteDocumentsResponse, DocumentLibraryControllerBulkDownloadDocumentFilesData, DocumentLibraryControllerBulkDownloadDocumentFilesResponse, DocumentLibraryControllerGetDealClassifiersByGroupsData, DocumentLibraryControllerGetDealClassifiersByGroupsResponse, DocumentLibraryControllerGetDocumentDetailsData, DocumentLibraryControllerGetDocumentDetailsResponse, DocumentLibraryControllerGetDocumentsWithFilteringData, DocumentLibraryControllerGetDocumentsWithFilteringResponse, DocumentLibraryControllerGetPersonsInDealData, DocumentLibraryControllerGetPersonsInDealResponse, DocumentLibraryControllerRemovePersonsFromDocumentData, DocumentLibraryControllerRemovePersonsFromDocumentsData, DocumentLibraryControllerSetPersonDocumentVisibilityData, DocumentLibraryControllerUpdateDocumentData, DocumentParsingControllerGetBatchDocumentsData, DocumentParsingControllerGetBatchDocumentsResponse, DocumentParsingControllerGetBatchOverviewData, DocumentParsingControllerGetBatchOverviewResponse, DocumentParsingControllerGetBatchPeopleData, DocumentParsingControllerGetBatchPeopleResponse, DocumentParsingControllerGetBatchSecuritiesData, DocumentParsingControllerGetBatchSecuritiesResponse, DocumentParsingControllerGetBatchTransactionsData, DocumentParsingControllerGetBatchTransactionsResponse, DocumentParsingControllerGetDocumentTransactionsData, DocumentParsingControllerGetExtractionResultData, DocumentParsingControllerGetExtractionResultResponse, DocumentParsingControllerGetExtractionStatusData, DocumentParsingControllerGetExtractionStatusResponse, DocumentParsingControllerListBatchesData, DocumentParsingControllerListBatchesResponse, DocumentParsingControllerListDealBatchesData, DocumentParsingControllerListDealBatchesResponse, DocumentParsingControllerMatchBatchPersonData, DocumentParsingControllerMatchBatchSecurityData, DocumentParsingControllerReextractBatchData, DocumentParsingControllerSaveBatchExtractionOverridesData, DocumentParsingControllerSaveBatchExtractionOverridesResponse, DocumentParsingControllerStartExtractionData, DocumentParsingControllerStartExtractionResponse, DocumentParsingControllerUpdateBatchTitleData, DocumentParsingControllerUploadExtractionDocumentData, DocumentParsingControllerUploadExtractionDocumentResponse, DocumentTemplatesControllerCreateData, DocumentTemplatesControllerCreateResponse, DocumentTemplatesControllerGetAvailabilityData, DocumentTemplatesControllerGetAvailabilityResponse, DocumentTemplatesControllerGetByIdData, DocumentTemplatesControllerGetByIdResponse, DocumentTemplatesControllerGetDocxFlowDocumentData, DocumentTemplatesControllerGetDocxFlowDocumentResponse, DocumentTemplatesControllerGetFieldBindingCatalogueData, DocumentTemplatesControllerGetFieldBindingCatalogueResponse, DocumentTemplatesControllerGetFieldBindingsData, DocumentTemplatesControllerGetFieldBindingsResponse, DocumentTemplatesControllerListData, DocumentTemplatesControllerListResponse, DocumentTemplatesControllerPreviewFieldBindingsData, DocumentTemplatesControllerPreviewFieldBindingsResponse, DocumentTemplatesControllerRenderDocxTemplateData, DocumentTemplatesControllerRenderDocxTemplateResponse, DocumentTemplatesControllerSaveDocxFlowDocumentData, DocumentTemplatesControllerSaveDocxFlowDocumentResponse, DocumentTemplatesControllerSetAvailabilityData, DocumentTemplatesControllerSetAvailabilityResponse, DocumentTemplatesControllerSoftDeleteData, DocumentTemplatesControllerUpdateData, DocumentTemplatesControllerUpdateFieldBindingsData, DocumentTemplatesControllerUpdateResponse, DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData, DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData, DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponse, DocumentWorkflowControllerAddCounterpartyData, DocumentWorkflowControllerAddCounterpartyResponse, DocumentWorkflowControllerAddInvestorsData, DocumentWorkflowControllerApplyDateCompleteData, DocumentWorkflowControllerApplyDatePrepareData, DocumentWorkflowControllerAssignUserToSignerData, DocumentWorkflowControllerAssignUserToSignerResponse, DocumentWorkflowControllerBulkAddCounterpartyData, DocumentWorkflowControllerBulkAddCounterpartyPreviewData, DocumentWorkflowControllerBulkAddCounterpartyPreviewResponse, DocumentWorkflowControllerBulkAddCounterpartyResponse, DocumentWorkflowControllerBulkAddCounterpartyStatusData, DocumentWorkflowControllerBulkAddCounterpartyStatusResponse, DocumentWorkflowControllerBulkApplyDateData, DocumentWorkflowControllerBulkApplyDateResponse, DocumentWorkflowControllerBulkApplyDateStatusData, DocumentWorkflowControllerBulkApplyDateStatusResponse, DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData, DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponse, DocumentWorkflowControllerBulkAssignCounterpartyData, DocumentWorkflowControllerBulkAssignCounterpartyResponse, DocumentWorkflowControllerBulkAssignCounterpartyStatusData, DocumentWorkflowControllerBulkAssignCounterpartyStatusResponse, DocumentWorkflowControllerBulkClaimGenerationStatusData, DocumentWorkflowControllerBulkClaimGenerationStatusResponse, DocumentWorkflowControllerBulkClaimOnBehalfData, DocumentWorkflowControllerBulkClaimOnBehalfPreviewData, DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponse, DocumentWorkflowControllerBulkClaimOnBehalfResponse, DocumentWorkflowControllerBulkDownloadFilesData, DocumentWorkflowControllerBulkDownloadFilesResponse, DocumentWorkflowControllerBulkExportToExcelData, DocumentWorkflowControllerBulkExportToExcelResponse, DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData, DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponse, DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData, DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponse, DocumentWorkflowControllerBulkReissueDocumentsData, DocumentWorkflowControllerBulkRemindSignersData, DocumentWorkflowControllerBulkRemindSignersResponse, DocumentWorkflowControllerBulkRemindSignersStatusData, DocumentWorkflowControllerBulkRemindSignersStatusResponse, DocumentWorkflowControllerBulkRevokeSimpleDocumentsData, DocumentWorkflowControllerBulkSetSignerRequiresWitnessData, DocumentWorkflowControllerBulkSetSignerSecurityLevelData, DocumentWorkflowControllerCancelAuthorisedSignatoryData, DocumentWorkflowControllerClaimSignerData, DocumentWorkflowControllerCloseDocumentWithoutSignatureData, DocumentWorkflowControllerCloseDocumentWithoutSignatureResponse, DocumentWorkflowControllerEidEasyCompleteData, DocumentWorkflowControllerEidEasyCompleteResponse, DocumentWorkflowControllerEidEasyPrepareData, DocumentWorkflowControllerFindDocumentWorkflowEventsData, DocumentWorkflowControllerFindDocumentWorkflowEventsResponse, DocumentWorkflowControllerFindInvestmentProgrammeDocumentData, DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponse, DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData, DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponse, DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData, DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponse, DocumentWorkflowControllerGetAddCounterpartyEligibilityData, DocumentWorkflowControllerGetAddCounterpartyEligibilityResponse, DocumentWorkflowControllerGetAddInvestorEligibilityData, DocumentWorkflowControllerGetAddInvestorEligibilityResponse, DocumentWorkflowControllerInviteAuthorisedSignatoryData, DocumentWorkflowControllerInviteRepresentativeData, DocumentWorkflowControllerInviteWitnessData, DocumentWorkflowControllerRemoveSignerData, DocumentWorkflowControllerRemoveSignerResponse, DocumentWorkflowControllerRemoveSubmittedFormData, DocumentWorkflowControllerReplaceDocumentFileData, DocumentWorkflowControllerReplaceDocumentFileResponse, DocumentWorkflowControllerResendInvitationData, DocumentWorkflowControllerSetSignerRequiresWitnessData, DocumentWorkflowControllerSetSignerSecurityLevelData, DocumentWorkflowControllerSignWetInkDocumentData, DocumentWorkflowControllerSignWetInkDocumentUploadData, DocumentWorkflowControllerSignWetInkDocumentUploadResponse, DocumentWorkflowControllerStreamProgrammeDocumentsData, DocumentWorkflowControllerSubmitFormData, DocumentWorkflowControllerSubmitFormUploadData, DocumentWorkflowControllerSubmitFormUploadResponse, DocumentWorkflowControllerUnassignUserFromSignerData, DocumentWorkflowControllerUnassignUserFromSignerResponse, DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData, DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponse, DocumentWorkflowKycFormControllerAttachFormData, DocumentWorkflowKycFormControllerAttachFormResponse, DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData, DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponse, DocumentWorkflowKycFormControllerGetInvestorFormsData, DocumentWorkflowKycFormControllerGetInvestorFormsResponse, DocumentWorkflowKycFormControllerRemoveFormData, DocumentWorkflowKycFormControllerRemoveFormResponse, DocumentWorkflowKycFormControllerResetFormData, DocumentWorkflowKycFormControllerResetFormResponse, DocumentWorkflowKycFormControllerReviewFormData, DocumentWorkflowKycFormControllerReviewFormResponse, DocumentWorkflowMasterDocumentsControllerBulkArchiveData, DocumentWorkflowMasterDocumentsControllerBulkArchiveResponse, DocumentWorkflowMasterDocumentsControllerBulkDeleteData, DocumentWorkflowMasterDocumentsControllerBulkDeleteResponse, DocumentWorkflowMasterDocumentsControllerCreateData, DocumentWorkflowMasterDocumentsControllerCreateResponse, DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData, DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponse, DocumentWorkflowMasterDocumentsControllerGetByIdData, DocumentWorkflowMasterDocumentsControllerGetByIdResponse, DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData, DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponse, DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData, DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponse, DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData, DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponse, DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData, DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponse, DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData, DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponse, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponse, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponse, DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData, DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponse, DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData, DocumentWorkflowMasterDocumentsControllerUpdateArchivedData, DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData, DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData, E2eControllerAcceptWorkOsInvitationData, E2eControllerAcceptWorkOsInvitationResponse, E2eControllerAuthenticateUserData, E2eControllerAuthenticateUserResponse, E2eControllerChangeWorkOsUserEmailData, E2eControllerChangeWorkOsUserEmailResponse, E2eControllerCreateUserData, E2eControllerCreateUserResponse, E2eControllerCreateWorkOsUserData, E2eControllerCreateWorkOsUserResponse, E2eControllerDisableMipKycData, E2eControllerGetChangeEmailVerificationCodeData, E2eControllerGetChangeEmailVerificationCodeResponse, E2eControllerGetSentEmailsData, E2eControllerGetSentEmailsResponse, E2eControllerGetSsoFixtureData, E2eControllerGetSsoFixtureResponse, E2eControllerGetWorkOsEmailVerificationCodeData, E2eControllerGetWorkOsEmailVerificationCodeResponse, E2eControllerGetWorkOsMagicAuthCodeData, E2eControllerGetWorkOsMagicAuthCodeResponse, E2eControllerGetWorkOsPasswordResetLinkData, E2eControllerGetWorkOsPasswordResetLinkResponse, E2eControllerGetWorkOsUserData, E2eControllerGetWorkOsUserResponse, E2eControllerPollWorkOsEventsData, E2eControllerPollWorkOsEventsResponse, E2eControllerResetSsoOrganizationData, E2eControllerResetSsoOrganizationResponse, E2eControllerWarmupPoolData, EidEasyMockControllerCompleteData, EidEasyMockControllerSignPageData, EidEasyMockControllerVerifyOtpData, EidEasyWebhookControllerCustomSignatureImageData, EidEasyWebhookControllerDocumentSignedData, EmailChangeEligibilityControllerGetEmailChangeEligibilityData, EmailChangeEligibilityControllerGetEmailChangeEligibilityResponse, EmailSchedulerControllerCancelData, EmailSchedulerControllerCreateScheduleData, EmailSchedulerControllerCreateScheduleResponse, EmailSchedulerControllerListConfigsData, EmailSchedulerControllerListConfigsResponse, EmailSchedulerControllerListSchedulesData, EmailSchedulerControllerListSchedulesResponse, EmailSchedulerControllerRescheduleData, EmailSchedulerControllerRestartData, EmailSchedulerControllerSendNowData, EmailSchedulerControllerSetEndDateData, EmailSchedulerControllerUpsertConfigData, EmploymentEmployersControllerGetEmployersData, EmploymentEmployersControllerGetEmployersResponse, EmploymentRecordControllerDeleteEmploymentRecordData, EmploymentRecordControllerDeleteEmploymentRecordResponse, EmploymentRecordControllerGetEmploymentRecordData, EmploymentRecordControllerGetEmploymentRecordResponse, EmploymentRecordControllerUpdateEmploymentRecordData, EmploymentRecordControllerUpdateEmploymentRecordResponse, FileControllerBulkDownloadFilesData, FileControllerCreateFileData, FileControllerCreateFileResponse, FileControllerCreateSignatureFileData, FileControllerCreateSignatureFileResponse, FileControllerDownloadFileData, FileControllerDownloadPreSignedUrlData, FileControllerGetFileDownloadUrlData, ForeignExchangeControllerGetCurrenciesUsedInValuationData, ForeignExchangeControllerGetCurrenciesUsedInValuationResponse, ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData, ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponse, ForeignExchangeControllerGetLatestExchangeRateData, ForeignExchangeControllerGetLatestExchangeRateResponse, ForeignExchangeControllerPutCustomExchangeRateData, ForeignExchangeControllerPutCustomExchangeRateResponse, FundControllerCreateFundData, FundControllerCreateFundResponse, FundControllerGetAllFundsData, FundControllerGetAllFundsResponse, FundControllerGetAvailableDealsForFundData, FundControllerGetAvailableDealsForFundResponse, FundControllerGetAvailableDealsForPersonFundLinkData, FundControllerGetAvailableDealsForPersonFundLinkResponse, FundControllerGetFundByDealData, FundControllerGetFundByDealResponse, FundControllerGetFundData, FundControllerGetFundLinkedDealsData, FundControllerGetFundLinkedDealsResponse, FundControllerGetFundLinksForPersonData, FundControllerGetFundLinksForPersonResponse, FundControllerGetFundResponse, FundControllerLinkFundToDealData, FundControllerLinkFundToDealResponse, FundControllerLinkPersonToFundData, FundControllerLinkPersonToFundResponse, FundControllerUnlinkFundFromDealData, FundControllerUnlinkPersonFromFundData, FundControllerUpdateFundData, FundControllerUpdateFundResponse, GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData, GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData, GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData, GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData, GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponse, GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponse, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponse, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponse, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponse, GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData, GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData, GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData, GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData, GodmodeControllerBulkCreateTsaForMipData, GodmodeControllerChangeDealData, GodmodeControllerCreateCustomDetailsData, GodmodeControllerDeleteUserSoftData, GodmodeControllerDownloadFileData, GodmodeControllerGetActiveMipsData, GodmodeControllerGetActiveMipsResponse, GodmodeControllerGetAllInvestorDataData, GodmodeControllerGetAllInvestorDataResponse, GodmodeControllerGetAllInvestorsData, GodmodeControllerGetAllInvestorsForMipData, GodmodeControllerGetAllInvestorsForMipResponse, GodmodeControllerGetAllNotDeletedProjectsData, GodmodeControllerGetAllNotDeletedProjectsResponse, GodmodeControllerGetDealData, GodmodeControllerGetDealResponse, GodmodeControllerGetDealsListData, GodmodeControllerGetDealsListResponse, GodmodeControllerGetDealWithActiveMipsData, GodmodeControllerGetDealWithActiveMipsResponse, GodmodeControllerGetFileInfoData, GodmodeControllerGetInvestmentWorkflowsData, GodmodeControllerGetInvestmentWorkflowsResponse, GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData, GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponse, GodmodeControllerGetInvestorsFromMipData, GodmodeControllerGetInvestorsFromMipResponse, GodmodeControllerGetMipCustomDetailsDataWithoutFormsData, GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponse, GodmodeControllerGetMipDataData, GodmodeControllerGetMipDataResponse, GodmodeControllerGetMipListOfInvestmentsData, GodmodeControllerGetMipListOfLoansData, GodmodeControllerGetMipListOfLoansResponse, GodmodeControllerGetUserDataData, GodmodeControllerGetUserDataResponse, GodmodeControllerIsAnyActiveInvestorInMipData, GodmodeControllerIsAnyActiveInvestorInMipResponse, GodmodeControllerIsAnyInvitedInvestorInMipData, GodmodeControllerIsAnyInvitedInvestorInMipResponse, GodmodeControllerPostBulkEditMipInvestmentsData, GodmodeControllerPostBulkEditMipInvestmentsResponse, GodmodeControllerPostBulkUpdateMipLoansData, GodmodeControllerPostReassignInvestorData, GodmodeControllerPostRemoveInvestorData, GodmodeControllerPostRevokeTsaData, GodmodeControllerPostSoftDeleteTsaData, GodmodeControllerRemoveInvestorPersonalDetailsData, GodmodeControllerReplaceFileData, GodmodeControllerSoftDeleteKycFileData, GodmodeControllerSoftDeleteMipData, GodmodeControllerUnArchiveDealAndMipsData, GodmodeControllerUpdateCustomDetailTypeData, GodmodeControllerUpdateDealMipsInvestorsDeletedData, GodmodeControllerUpdateInvestorPersonalDetailsData, GodmodeControllerUpdateIsLockedData, GodmodeControllerUpdateMipKycOptionalData, GodmodeControllerUpdateShareAssociationsData, GodmodeControllerUpdateUserEmailData, GodmodeControllerUpdateUserNameData, GodmodeControllerUploadPdfFileData, GodmodeControllerUploadPdfFileResponse, HealthControllerHealthCheckData, HealthControllerHealthCheckError, HealthControllerHealthCheckResponse, HelpBlogControllerGetArticlesData, HelpBlogControllerGetArticlesResponse, HelpBlogControllerGetAuthorsData, HelpBlogControllerGetAuthorsResponse, HelpBlogControllerGetCategoriesData, HelpBlogControllerGetCategoriesResponse, HelpBlogControllerGetEntrypointArticlesData, HelpBlogControllerGetEntrypointArticlesResponse, HelpBlogControllerGetSlugArticleData, HelpBlogControllerGetSlugArticleResponse, HelpBlogControllerGetSlugAuthorData, HelpBlogControllerGetSlugAuthorResponse, HelpBlogControllerGetSlugCategoryData, HelpBlogControllerGetSlugCategoryResponse, HoldingEventControllerCreateBulkHoldingEventsData, HoldingEventControllerCreateBulkHoldingEventsResponse, HoldingEventControllerCreateHoldingEventData, HoldingEventControllerCreateHoldingEventResponse, HoldingEventControllerSoftDeleteHoldingEventData, HoldingEventControllerSoftDeleteHoldingEventResponse, HoldingEventControllerUpdateHoldingEventData, HoldingEventControllerUpdateHoldingEventResponse, HoldingsControllerDownloadHoldingsExcelData, HoldingsControllerDownloadVestingEventsReportData, HoldingsControllerGenerateShareRegisterPdfData, HoldingsControllerGenerateShareRegisterPdfInlineData, HoldingsControllerGenerateShareRegisterPdfInlineResponse, HoldingsControllerGenerateShareRegisterPdfResponse, HoldingsControllerGetHoldingByPersonAndSecurityData, HoldingsControllerGetHoldingByPersonAndSecurityResponse, HoldingsControllerGetHoldingEventsListByPersonAndSecurityData, HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponse, HoldingsControllerGetShareRegisterPdfTaskStatusData, HoldingsControllerGetShareRegisterPdfTaskStatusResponse, HoldingsControllerPostHoldingsListForPersonData, HoldingsControllerPostHoldingsListForPersonResponse, HoldingsControllerPostRegularViewHoldingsCsvData, HoldingsControllerPostWideViewHoldingsCsvData, HoldingsControllerStartShareRegisterPdfGenerationData, HoldingsControllerStartShareRegisterPdfGenerationResponse, InfoControllerDeploymentInfoData, InfoControllerDeploymentInfoResponse, InvestmentControllerGetAllInvestmentValuationsData, InvestmentControllerGetAllInvestmentValuationsResponse, InvestmentControllerGetInvestmentDetailsData, InvestmentControllerGetInvestmentDetailsResponse, InvestmentControllerGetInvestmentPaymentInstructionData, InvestmentControllerGetInvestmentsAndSdwDocumentsData, InvestmentControllerGetInvestmentsAndSdwDocumentsResponse, InvestmentControllerGetInvestmentV2Data, InvestmentControllerGetInvestmentV2Response, InvestmentControllerGetInvestmentValuationsData, InvestmentControllerGetInvestmentValuationsResponse, InvestmentControllerGetSecurityVestingDataData, InvestmentControllerGetSecurityVestingDataResponse, InvestmentControllerGetUserInvestmentsListData, InvestmentControllerGetUserInvestmentsListResponse, InvestmentControllerSetSelectedBankAccountData, InvestorBankAccountControllerGetBankAccountDetailData, InvestorBankAccountControllerGetBankAccountDetailResponse, InvestorBankAccountControllerGetBankAccountHistoryData, InvestorBankAccountControllerGetBankAccountHistoryResponse, InvestorBankAccountControllerGetInvestorBankAccountsData, InvestorBankAccountControllerGetInvestorBankAccountsResponse, InvestorBankAccountControllerReviewData, InvestorBankAccountControllerReviewResponse, InvestorControllerDownloadInvestorsDataData, InvestorControllerGetInvestmentVehicleHoldingsData, InvestorControllerGetInvestmentVehicleHoldingsResponse, InvestorControllerGetInvestmentVehicleQuickLinksData, InvestorControllerGetInvestmentVehicleQuickLinksResponse, InvestorControllerGetInvestmentVehicleRelatedPeopleData, InvestorControllerGetInvestmentVehicleRelatedPeopleResponse, InvestorControllerGetInvestmentVehicleValuationsData, InvestorControllerGetInvestmentVehicleValuationsResponse, InvestorControllerGetInvestorHoldingsData, InvestorControllerGetInvestorHoldingsResponse, InvestorControllerGetInvestorHoldingTransactionsData, InvestorControllerGetInvestorHoldingTransactionsResponse, InvestorControllerGetInvestorInvestmentsAndTransactionsData, InvestorControllerGetInvestorInvestmentsAndTransactionsResponse, InvestorControllerGetInvestorInvestmentValuationsData, InvestorControllerGetInvestorInvestmentValuationsResponse, InvestorControllerGetInvestorJourneysData, InvestorControllerGetInvestorJourneysResponse, InvestorControllerGetInvestorQuickLinksData, InvestorControllerGetInvestorQuickLinksResponse, InvestorControllerGetMipDraftJoinerInvestorTemplateData, InvestorControllerGetMipDraftLeaverInvestorTemplateData, InvestorControllerGetMipInvestmentVehicleNamesForFilteringData, InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse, InvestorControllerGetMipInvestorByIdData, InvestorControllerGetMipInvestorByIdResponse, InvestorControllerGetMipInvestorDocumentWorkflowListByIdData, InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponse, InvestorControllerGetMipInvestorNamesForFilteringData, InvestorControllerGetMipInvestorNamesForFilteringResponse, InvestorControllerGetMipInvestorsDataForSendModalData, InvestorControllerGetMipInvestorsDataForSendModalResponse, InvestorControllerGetMipInvestorsIdsData, InvestorControllerGetMipInvestorsIdsResponse, InvestorControllerGetMipInvestorsListData, InvestorControllerGetMipInvestorsListResponse, InvestorControllerGetMipInvestorsOrderedIdsData, InvestorControllerGetMipInvestorsOrderedIdsResponse, InvestorControllerGetMipInvestorsSecuritiesListDataData, InvestorControllerGetMipInvestorsSecuritiesListDataResponse, InvestorControllerGetMipSelectedInvestorsDataData, InvestorControllerGetMipSelectedInvestorsDataResponse, InvestorControllerGetSecurityVestingDataData, InvestorControllerGetSecurityVestingDataResponse, InvestorControllerPostBulkRevokeTsaData, InvestorControllerPostMipDraftJLeaverInvestorTemplateData, InvestorControllerPostMipDraftJLeaverInvestorTemplateResponse, InvestorControllerPostMipDraftJoinerInvestorTemplateData, InvestorControllerPostMipDraftJoinerInvestorTemplateResponse, InvestorControllerPostRemoveInvestorData, InvestorControllerPostRevokeTsaData, InvestorControllerPutInvestorCustomDetailsData, InvestorControllerRequestKycData, InvestorControllerSendInvitesData, InvestorControllerSendInvitesResponse, InvestorControllerStartDownloadInvestorsDataWorkflowData, InvestorDraftControllerGetMipInvestorsData, InvestorDraftControllerGetMipInvestorsResponse, InvestorDraftControllerPostMipDraftInvestorDataData, InvestorDraftControllerPostMipDraftInvestorTemplateData, InvestorDraftControllerPostMipDraftInvestorTemplateResponse, InvestorInvestmentWorkflowControllerAddInvestmentAllocationData, InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponse, InvestorInvestmentWorkflowControllerAddInvestmentLoanData, InvestorInvestmentWorkflowControllerAddInvestmentLoanResponse, InvestorInvestmentWorkflowControllerApproveInvestmentData, InvestorInvestmentWorkflowControllerApproveInvestmentResponse, InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData, InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponse, InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData, InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponse, InvestorInvestmentWorkflowControllerDownloadExcelData, InvestorInvestmentWorkflowControllerDownloadExcelResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponse, InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData, InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponse, InvestorInvestmentWorkflowControllerGetInvestmentsForMipData, InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponse, InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData, InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponse, InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData, InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponse, InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData, InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponse, InvestorInvestmentWorkflowControllerMakeDraftData, InvestorInvestmentWorkflowControllerMakeDraftResponse, InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData, InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData, InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponse, InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponse, InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData, InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponse, InvestorInvestmentWorkflowControllerStartInvestmentData, InvestorInvestmentWorkflowControllerStartInvestmentResponse, InvestorInvestmentWorkflowControllerToggleLegalDocumentData, InvestorInvestmentWorkflowControllerToggleLegalDocumentResponse, InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData, InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponse, InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData, InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponse, InvestorInvestmentWorkflowControllerUpsertShareAssociationsData, InvestorMessageControllerGetMessageForInvestorData, InvestorMessageControllerGetMessageForInvestorResponse, InvestorMessageControllerGetMessagesForInvestorData, InvestorMessageControllerGetMessagesForInvestorResponse, KycControllerDeleteKycFileData, KycControllerDownloadInvestorsFilesData, KycControllerGetInvestorsStatisticsData, KycControllerGetInvestorsStatisticsResponse, KycControllerGetKycInvestorDataData, KycControllerGetKycInvestorDataResponse, KycControllerGetKycInvestorsDataData, KycControllerGetKycInvestorsDataResponse, KycControllerGetKycWorkflowsDataData, KycControllerGetKycWorkflowsDataResponse, KycControllerMorePivDocumentsData, KycControllerPutAssociateKycFileData, KycControllerResendKycFileCertifierInvitationData, KycControllerResendKycFileCertifierInvitationResponse, KycControllerSetInvestorDeclarationsData, KycControllerUpdateDeclarationsStatusData, KycControllerUpdateKycFileData, KycControllerUpdateKycStatusData, KycControllerWithdrawStandaloneKycWorkflowData, KycFormTemplateControllerArchiveData, KycFormTemplateControllerArchiveResponse, KycFormTemplateControllerCreateData, KycFormTemplateControllerCreateResponse, KycFormTemplateControllerDeleteData, KycFormTemplateControllerDeleteResponse, KycFormTemplateControllerDocxDocumentData, KycFormTemplateControllerDocxDocumentResponse, KycFormTemplateControllerFieldBindingCatalogueData, KycFormTemplateControllerFieldBindingCatalogueResponse, KycFormTemplateControllerFieldBindingsData, KycFormTemplateControllerFieldBindingsResponse, KycFormTemplateControllerInstanceCountData, KycFormTemplateControllerInstanceCountResponse, KycFormTemplateControllerListData, KycFormTemplateControllerListLibraryData, KycFormTemplateControllerListLibraryResponse, KycFormTemplateControllerListResponse, KycFormTemplateControllerPreviewFieldBindingsData, KycFormTemplateControllerPreviewFieldBindingsResponse, KycFormTemplateControllerRenderDocxData, KycFormTemplateControllerRenderDocxFieldsData, KycFormTemplateControllerRenderDocxFieldsResponse, KycFormTemplateControllerRenderDocxResponse, KycFormTemplateControllerSaveDocxDocumentData, KycFormTemplateControllerSaveDocxDocumentResponse, KycFormTemplateControllerSignatureSlotsData, KycFormTemplateControllerSignatureSlotsResponse, KycFormTemplateControllerUpdateData, KycFormTemplateControllerUpdateFieldBindingsData, KycFormTemplateControllerUpdateFieldBindingsResponse, KycFormTemplateControllerUpdateResponse, KycFormTemplateControllerUpdateSignaturePlacementData, KycFormTemplateControllerUpdateSignaturePlacementResponse, KycSettingControllerGetByKycWorkflowIdData, KycSettingControllerGetByKycWorkflowIdResponse, KycSettingControllerGetMipRequirementsData, KycSettingControllerGetMipRequirementsResponse, KycSettingControllerUpdateByKycWorkflowIdData, KycSettingControllerUpdateMipRequirementsData, LoanDefinitionControllerCreateLoanDefinitionsData, LoanDefinitionControllerCreateLoanDefinitionsResponse, LoanDefinitionControllerDeleteLoanDefinitionData, LoanDefinitionControllerGetLoansDefinitionByMipIdData, LoanDefinitionControllerGetLoansDefinitionByMipIdResponse, LoanDefinitionControllerUpdateLoanDefinitionData, MipClassifierControllerAttachInvestorsData, MipClassifierControllerAttachInvestorsResponse, MipClassifierControllerCreateData, MipClassifierControllerCreateResponse, MipClassifierControllerDetachInvestorsData, MipClassifierControllerDetachInvestorsResponse, MipClassifierControllerListByInvestorData, MipClassifierControllerListByInvestorResponse, MipClassifierControllerListData, MipClassifierControllerListResponse, MipClassifierControllerUpdateData, MipClassifierControllerUpdateResponse, MipControllerAddMipProgrammeEntityData, MipControllerDeleteMipProgrammeEntityData, MipControllerGetEmailWorkflowStatusData, MipControllerGetEmailWorkflowStatusResponse, MipControllerGetMipDetailsForJoinerData, MipControllerGetMipDetailsForJoinerResponse, MipControllerGetMipDetailsForLeaverData, MipControllerGetMipDetailsForLeaverResponse, MipControllerGetMipProgrammeEntitiesData, MipControllerGetMipProgrammeEntitiesResponse, MipControllerGetMipsForPersonData, MipControllerGetMipsForPersonResponse, MipControllerGetPivDetailsForInvestorsData, MipControllerGetPivDetailsForInvestorsResponse, MipControllerGetWorkflowSettingsData, MipControllerGetWorkflowSettingsResponse, MipControllerListProgrammesData, MipControllerListProgrammesResponse, MipControllerPostJoinerAdditionalAllocationsData, MipControllerPostJoinerAdditionalAllocationsResponse, MipControllerPostLeaverNegativeAllocationsData, MipControllerPostLeaverNegativeAllocationsResponse, MipControllerUpdateMipDataData, MipControllerUpdateMipKycRequiredData, MipControllerUpdateWorkflowSettingsData, MipDraftControllerCompleteData, MipDraftControllerCreateActiveProgrammeData, MipDraftControllerCreateActiveProgrammeResponse, MipDraftControllerCreateMipData, MipDraftControllerCreateMipResponse, MipDraftControllerGetDraftStepsStatusesData, MipDraftControllerGetDraftStepsStatusesResponse, MipDraftControllerSoftDeleteMipDraftData, MipDraftControllerSoftDeleteMipDraftResponse, MipDraftControllerUpdateDraftGeneralDealInputsData, MipDraftControllerUpdateDraftGeneralDealInputsResponse, OneSchemaControllerCreateOneSchemaPersonsSessionData, OneSchemaControllerCreateOneSchemaPersonsSessionResponse, OneSchemaControllerCreateOneSchemaTransactionsSessionData, OneSchemaControllerCreateOneSchemaTransactionsSessionResponse, OneSchemaControllerPrepareOneSchemaManagementLoansCacheData, OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData, OneSchemaControllerValidateOneSchemaLegalPersonsRowsData, OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponse, OneSchemaControllerValidateOneSchemaManagementLoansRowsData, OneSchemaControllerValidateOneSchemaManagementLoansRowsResponse, OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData, OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponse, OneSchemaControllerValidateOneSchemaShareAssociationRowsData, OneSchemaControllerValidateOneSchemaShareAssociationRowsResponse, OneSchemaControllerValidateOneSchemaTransactionRowsData, OneSchemaControllerValidateOneSchemaTransactionRowsResponse, OrganizationControllerCreateOrganizationData, OrganizationControllerDeleteOrganizationData, OrganizationControllerGetAllOrganizationsData, OrganizationControllerGetAllOrganizationsResponse, OrganizationControllerGetOrganizationDetailsByIdData, OrganizationControllerGetOrganizationDetailsByIdResponse, OrganizationControllerImportOrganizationData, OrganizationControllerImportOrganizationResponse, OrganizationControllerLookupWorkOsOrganizationsData, OrganizationControllerLookupWorkOsOrganizationsResponse, OrganizationControllerUpdateOrganizationData, OrganizationControllerUpdateOrganizationResponse, OrganizationControllerUpdateOrganizationTypeData, OrganizationControllerUpdateOrganizationTypeResponse, OrganizationCustomFieldControllerCreateCustomFieldData, OrganizationCustomFieldControllerCreateCustomFieldResponse, OrganizationCustomFieldControllerDeleteCustomFieldData, OrganizationCustomFieldControllerGetCustomFieldsData, OrganizationCustomFieldControllerGetCustomFieldsResponse, OrganizationCustomFieldControllerUpdateCustomFieldData, OrganizationCustomFieldControllerUpdateCustomFieldResponse, OrganizationDealClassifierControllerListClassifiersData, OrganizationDealClassifierControllerListClassifiersResponse, OrganizationDealClassifierControllerSetClassifiersData, OrganizationDealEmailTemplateControllerGetOneData, OrganizationDealEmailTemplateControllerGetOneResponse, OrganizationDealEmailTemplateControllerListData, OrganizationDealEmailTemplateControllerListResponse, OrganizationDealEmailTemplateControllerPreviewData, OrganizationDealEmailTemplateControllerPreviewResponse, OrganizationDealEmailTemplateControllerResetData, OrganizationDealEmailTemplateControllerResetResponse, OrganizationDealEmailTemplateControllerUpdateData, OrganizationDealEmailTemplateControllerUpdateResponse, OrganizationDefaultMemberControllerAddMemberData, OrganizationDefaultMemberControllerListMembersData, OrganizationDefaultMemberControllerListMembersResponse, OrganizationDefaultMemberControllerRemoveMemberData, OrganizationDocumentTemplateControllerBulkArchiveData, OrganizationDocumentTemplateControllerBulkDeleteData, OrganizationDocumentTemplateControllerCreateData, OrganizationDocumentTemplateControllerCreateResponse, OrganizationDocumentTemplateControllerGetByIdData, OrganizationDocumentTemplateControllerGetByIdResponse, OrganizationDocumentTemplateControllerListData, OrganizationDocumentTemplateControllerListResponse, OrganizationDocumentTemplateControllerRemoveData, OrganizationDocumentTemplateControllerUpdateArchivedData, OrganizationDocumentTemplateControllerUpdateData, OrganizationEmailScheduleControllerListConfigsData, OrganizationEmailScheduleControllerListConfigsResponse, OrganizationEmailScheduleControllerUpsertConfigData, OrganizationEmailTemplateControllerGetOneData, OrganizationEmailTemplateControllerGetOneResponse, OrganizationEmailTemplateControllerListData, OrganizationEmailTemplateControllerListResponse, OrganizationEmailTemplateControllerPreviewData, OrganizationEmailTemplateControllerPreviewResponse, OrganizationEmailTemplateControllerResetData, OrganizationEmailTemplateControllerResetResponse, OrganizationEmailTemplateControllerUpdateData, OrganizationEmailTemplateControllerUpdateResponse, OrganizationFileControllerDownloadPreSignedUrlData, OrganizationFileControllerDownloadPreSignedUrlResponse, OrganizationKycFormTemplateControllerArchiveData, OrganizationKycFormTemplateControllerArchiveResponse, OrganizationKycFormTemplateControllerCreateData, OrganizationKycFormTemplateControllerCreateResponse, OrganizationKycFormTemplateControllerListData, OrganizationKycFormTemplateControllerListResponse, OrganizationKycFormTemplateControllerRemoveData, OrganizationKycFormTemplateControllerRemoveResponse, OrganizationKycFormTemplateControllerSignatureSlotsData, OrganizationKycFormTemplateControllerSignatureSlotsResponse, OrganizationKycFormTemplateControllerUpdateData, OrganizationKycFormTemplateControllerUpdateResponse, OrganizationKycFormTemplateControllerUpdateSignaturePlacementData, OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponse, OrganizationKycSettingControllerGetRequirementsData, OrganizationKycSettingControllerGetRequirementsResponse, OrganizationKycSettingControllerUpdateRequirementsData, OrganizationKycSettingControllerUpdateRequirementsResponse, OrganizationUsersControllerDeleteUserFromOrganizationsData, OrganizationUsersControllerDeleteUserFromOrganizationsResponse, OrganizationUsersControllerGetOrganizationUsersData, OrganizationUsersControllerGetOrganizationUsersResponse, OrganizationUsersControllerGetOrganizationUserWithPermissionsData, OrganizationUsersControllerGetOrganizationUserWithPermissionsResponse, OrganizationUsersControllerInviteUserToOrganizationData, OrganizationVestingTermControllerCreateGradedData, OrganizationVestingTermControllerCreateGradedResponse, OrganizationVestingTermControllerCreateLeaverProvisionData, OrganizationVestingTermControllerCreateLeaverProvisionResponse, OrganizationVestingTermControllerCreateStraightLineData, OrganizationVestingTermControllerCreateStraightLineResponse, OrganizationVestingTermControllerCreateVestingTermData, OrganizationVestingTermControllerCreateVestingTermResponse, OrganizationVestingTermControllerDeleteGradedData, OrganizationVestingTermControllerDeleteLeaverProvisionData, OrganizationVestingTermControllerDeleteVestingTermData, OrganizationVestingTermControllerGetVestingTermsData, OrganizationVestingTermControllerGetVestingTermsResponse, OrganizationVestingTermControllerUpdateGradedData, OrganizationVestingTermControllerUpdateGradedResponse, OrganizationVestingTermControllerUpdateLeaverProvisionData, OrganizationVestingTermControllerUpdateLeaverProvisionResponse, OrganizationVestingTermControllerUpdateStraightLineData, OrganizationVestingTermControllerUpdateStraightLineResponse, OrganizationVestingTermControllerUpdateVestingTermData, OrganizationVestingTermControllerUpdateVestingTermResponse, PasswordControllerUpdatePasswordData, PaymentControllerBulkUpdateData, PaymentControllerBulkUpdateResponse, PaymentControllerDownloadMipPaymentsData, PaymentControllerGetStatusData, PaymentControllerGetStatusResponse, PaymentControllerUpdateData, PermissionControllerAddResourcePermissionsForUserData, PermissionControllerRemoveResourcePermissionForUserData, PermissionControllerSetResourcePermissionsForUserData, PersonBankAccountControllerCreatePersonBankAccountData, PersonBankAccountControllerCreatePersonBankAccountResponse, PersonBankAccountControllerDeletePersonBankAccountData, PersonBankAccountControllerDeletePersonBankAccountResponse, PersonBankAccountControllerGetPersonBankAccountsData, PersonBankAccountControllerGetPersonBankAccountsResponse, PersonBankAccountControllerUpdatePersonBankAccountData, PersonBankAccountControllerUpdatePersonBankAccountResponse, PersonBankAccountControllerValidatePersonBankAccountData, PersonBankAccountControllerValidatePersonBankAccountResponse, PersonControllerAddRelatedPersonByEmailData, PersonControllerBulkCreateLegalPersonsData, PersonControllerBulkCreateNaturalPersonsData, PersonControllerCreateAddressData, PersonControllerCreateAddressResponse, PersonControllerCreateLegalEntityData, PersonControllerCreateLegalEntityResponse, PersonControllerCreateNaturalEntityData, PersonControllerCreateNaturalEntityResponse, PersonControllerCreateRelatedPeopleForPersonData, PersonControllerDeleteAddressData, PersonControllerDeleteEntitiesData, PersonControllerDeletePersonRelatedPersonData, PersonControllerDeletePersonRelatedPersonResponse, PersonControllerGetAllEntitiesData, PersonControllerGetAllLegalEntitiesData, PersonControllerGetAllLegalEntitiesResponse, PersonControllerGetAvailableRelatedPeopleForPersonData, PersonControllerGetAvailableRelatedPeopleForPersonResponse, PersonControllerGetEntityDataData, PersonControllerGetEntityDataResponse, PersonControllerGetNaturalPersonsByPivIdData, PersonControllerGetNaturalPersonsByPivIdResponse, PersonControllerGetPersonRelatedPeopleData, PersonControllerGetPersonRelatedPeopleResponse, PersonControllerGetPersonsForCapData, PersonControllerGetPersonsForCapResponse, PersonControllerGetPersonTagsForDealData, PersonControllerGetPersonTagsForDealResponse, PersonControllerIsPersonUserInvitedToPlatformData, PersonControllerIsPersonUserInvitedToPlatformResponse, PersonControllerIsThereInvestmentWorkflowData, PersonControllerIsThereInvestmentWorkflowResponse, PersonControllerLookupPersonByEmailData, PersonControllerLookupPersonByEmailResponse, PersonControllerUpdateAddressData, PersonControllerUpdateAddressResponse, PersonControllerUpdateLegalPersonDetailsData, PersonControllerUpdateNaturalPersonDetailsData, PersonControllerUpdateNaturalPersonEmailData, PersonControllerUpdateRelatedPersonRelationData, PersonEmploymentControllerGetPersonEmploymentData, PersonEmploymentControllerGetPersonEmploymentResponse, PersonEmploymentControllerUpsertPersonEmploymentData, PersonEmploymentControllerUpsertPersonEmploymentResponse, PersonEmploymentRecordControllerCreateEmploymentRecordData, PersonEmploymentRecordControllerCreateEmploymentRecordResponse, PersonEmploymentRecordControllerListEmploymentRecordsData, PersonEmploymentRecordControllerListEmploymentRecordsResponse, PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData, PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponse, PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData, PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponse, PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData, PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponse, PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData, PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponse, PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData, PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponse, PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData, PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponse, PersonTaxControllerCreatePersonTaxInformationData, PersonTaxControllerCreatePersonTaxInformationResponse, PersonTaxControllerDeletePersonTaxInformationData, PersonTaxControllerDeletePersonTaxInformationResponse, PersonTaxControllerGetPersonTaxInformationData, PersonTaxControllerGetPersonTaxInformationResponse, PersonTaxControllerUpdatePersonTaxInformationData, PersonTaxControllerUpdatePersonTaxInformationResponse, PreFillableFormsControllerGetTemplatesForProjectData, PreFillableFormsControllerGetTemplatesForProjectResponse, PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData, PreFillableFormTemplateControllerCreatePreFillableFormTemplateData, PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData, PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData, PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponse, PreFillableFormTemplateControllerGetOrganizationOptionsData, PreFillableFormTemplateControllerGetOrganizationOptionsResponse, PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData, PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponse, PreFillableFormTemplateControllerGetPreFillableFormTemplateData, PreFillableFormTemplateControllerGetPreFillableFormTemplateResponse, PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData, PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData, PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData, PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData, PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponse, ProfileControllerUpdatePhoneData, ProgrammeDefaultsSummaryControllerApplyData, ProgrammeDefaultsSummaryControllerApplyResponse, ProgrammeDefaultsSummaryControllerGetMySummaryData, ProgrammeDefaultsSummaryControllerGetMySummaryResponse, ProgrammeDefaultsSummaryControllerGetSummaryData, ProgrammeDefaultsSummaryControllerGetSummaryForDealData, ProgrammeDefaultsSummaryControllerGetSummaryForDealResponse, ProgrammeDefaultsSummaryControllerGetSummaryResponse, ProgrammeEmailTemplateControllerGetOneData, ProgrammeEmailTemplateControllerGetOneResponse, ProgrammeEmailTemplateControllerListData, ProgrammeEmailTemplateControllerListResponse, ProgrammeEmailTemplateControllerPreviewData, ProgrammeEmailTemplateControllerPreviewResponse, ProgrammeEmailTemplateControllerResetData, ProgrammeEmailTemplateControllerResetResponse, ProgrammeEmailTemplateControllerTestSendData, ProgrammeEmailTemplateControllerTestSendResponse, ProgrammeEmailTemplateControllerUpdateData, ProgrammeEmailTemplateControllerUpdateResponse, ProgrammeSecurityAllocationsControllerCreateAllocationData, ProgrammeSecurityAllocationsControllerCreateAllocationResponse, ProgrammeSecurityAllocationsControllerDeleteAllocationData, ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData, ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponse, ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData, ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponse, ProgrammeSecurityAllocationsControllerUpdateAllocationData, ProgrammeSecurityAllocationsControllerUpdateAllocationResponse, ProgrammeSettingControllerGetByMipIdData, ProgrammeSettingControllerGetByMipIdResponse, ProgrammeSettingControllerUpdateByMipIdData, ProgrammeUsersControllerDeleteUserFromProgrammeData, ProgrammeUsersControllerGetProgrammeUserData, ProgrammeUsersControllerGetProgrammeUserResponse, ProgrammeUsersControllerGetProgrammeUsersData, ProgrammeUsersControllerGetProgrammeUsersResponse, ProgrammeUsersControllerInviteUserToProgrammeData, ProgrammeUsersControllerUpdateUserAndUserProgrammeData, ProgrammeUsersControllerUpdateUserAndUserProgrammeResponse, PublicBulkSigningControllerBulkCompleteData, PublicBulkSigningControllerBulkPrepareData, PublicBulkSigningControllerBulkSignCompleteData, PublicBulkSigningControllerBulkSignInitiateData, PublicBulkSigningControllerBulkSignStatusData, PublicBulkSigningControllerBulkSignStatusResponse, PublicBulkSigningControllerGetProgrammeDocumentData, PublicBulkSigningControllerGetProgrammeDocumentsData, PublicBulkSigningControllerGetSignatureTokenData, PublicCertificationControllerSaveCertifierDetailsData, PublicCertificationControllerSaveCertifierDetailsResponse, PublicCertificationControllerUpdateCertificationTextData, PublicCertificationControllerUpdateCertificationTextResponse, PublicSigningControllerCompleteData, PublicSigningControllerGetDocumentData, PublicSigningControllerGetSigningInfoData, PublicSigningControllerInviteWitnessData, PublicSigningControllerPrepareData, PublicSigningControllerSaveWitnessDetailsData, ResendControllerEmailEventData, SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData, SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponse, SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData, SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponse, SecurityControllerBulkCreateSecuritiesData, SecurityControllerBulkCreateSecuritiesResponse, SecurityControllerBulkDeleteTrackedSecuritiesData, SecurityControllerBulkDeleteTrackedSecuritiesResponse, SecurityControllerBulkSoftDeleteSecuritiesData, SecurityControllerBulkSoftDeleteSecuritiesResponse, SecurityControllerBulkUpdateSecuritiesData, SecurityControllerBulkUpdateSecuritiesResponse, SecurityControllerBulkUpdateTrackedSecuritiesData, SecurityControllerBulkUpdateTrackedSecuritiesResponse, SecurityControllerCreateSecurityData, SecurityControllerCreateSecurityResponse, SecurityControllerDoesPersonHaveSecuritiesData, SecurityControllerDoesPersonHaveSecuritiesResponse, SecurityControllerDownloadExcelData, SecurityControllerDownloadExcelResponse, SecurityControllerGetLoanDefinitionsForDealData, SecurityControllerGetLoanDefinitionsForDealResponse, SecurityControllerGetPersonSecuritiesData, SecurityControllerGetPersonSecuritiesResponse, SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData, SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponse, SecurityControllerGetSecuritiesByDealIdData, SecurityControllerGetSecuritiesByDealIdResponse, SecurityControllerGetSecuritiesDataForMipData, SecurityControllerGetSecuritiesDataForMipResponse, SecurityControllerGetSecurityData, SecurityControllerGetSecurityNominalValueData, SecurityControllerGetSecurityNominalValueResponse, SecurityControllerGetSecurityResponse, SecurityControllerIsSecuritiesUsedInAnyMipData, SecurityControllerIsSecuritiesUsedInAnyMipResponse, SecurityControllerSoftDeleteSecurityData, SecurityControllerUpdateCurrencyForPersonSecuritiesData, SecurityControllerUpdateCurrencyForPersonSecuritiesResponse, SecurityControllerUpdateSecurityAuthorisedCapitalData, SecurityControllerUpdateSecurityAuthorisedCapitalResponse, SecurityControllerUpdateSecurityData, SecurityControllerUpdateSecurityParticipationThresholdData, SecurityControllerUpdateSecurityParticipationThresholdResponse, SecurityControllerUpdateSecurityResponse, SecurityEventControllerCreateSecurityEventData, SecurityEventControllerCreateSecurityEventResponse, SecurityEventControllerGetSecurityEventsData, SecurityEventControllerGetSecurityEventsResponse, SecurityEventControllerSoftDeleteSecurityEventData, SecurityEventControllerSoftDeleteSecurityEventResponse, SecurityEventControllerUpdateSecurityEventData, SecurityEventControllerUpdateSecurityEventResponse, SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData, SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponse, SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData, SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponse, SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData, SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponse, SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData, SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponse, SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData, SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponse, SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData, SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponse, SecurityLiquidationPreferenceControllerCreateOrUpdateData, SecurityLiquidationPreferenceControllerCreateOrUpdateResponse, SecurityLiquidationPreferenceControllerGetData, SecurityLiquidationPreferenceControllerGetResponse, SecurityLiquidationPreferenceControllerSoftDeleteData, SecurityLiquidationPreferenceControllerSoftDeleteResponse, SecurityRankControllerDeleteSecurityIncomeRanksData, SecurityRankControllerDeleteSecurityRankData, SecurityRankControllerUpsertSecurityIncomeRanksData, SecurityRankControllerUpsertSecurityIncomeRanksResponse, SecurityRankControllerUpsertSecurityRankData, SecurityRankControllerUpsertSecurityRankResponse, SecurityRankDefinitionControllerCreateRankData, SecurityRankDefinitionControllerCreateRankResponse, SecurityRankDefinitionControllerGetPersonRanksData, SecurityRankDefinitionControllerGetPersonRanksResponse, SecurityRankDefinitionControllerSoftDeleteRankData, SecurityRankDefinitionControllerSoftDeleteRankResponse, SecurityRankDefinitionControllerUpdateRankData, SecurityRankDefinitionControllerUpdateRankResponse, SecurityRatchetControllerDeleteScheduleData, SecurityRatchetControllerGetScheduleData, SecurityRatchetControllerUpsertScheduleData, SecurityValueOverrideControllerCreateSecurityValueOverrideData, SecurityValueOverrideControllerCreateSecurityValueOverrideResponse, SecurityValueOverrideControllerDeleteSecurityValueOverrideData, SecurityValueOverrideControllerDeleteSecurityValueOverrideResponse, SecurityValueOverrideControllerUpdateSecurityValueOverrideData, SecurityValueOverrideControllerUpdateSecurityValueOverrideResponse, SessionManagementControllerGetSessionStatusData, SessionManagementControllerGetSessionStatusResponse, SessionManagementControllerKeepSessionAliveData, SessionManagementControllerKeepSessionAliveResponse, SessionManagementControllerLogoutData, SessionManagementControllerRedirectCallbackFromWorkOsData, SessionManagementControllerRefreshTokenData, SessionManagementControllerSendMagicAuthVerificationCodeData, SessionManagementControllerSignOutData, SessionManagementControllerValidateMagicCodeData, SessionManagementControllerValidateMagicCodeResponse, ShareholderBankAccountControllerConfirmBankAccountData, ShareholderBankAccountControllerConfirmBankAccountResponse, ShareholderBankAccountControllerDeleteBankAccountData, ShareholderBankAccountControllerDeleteBankAccountResponse, ShareholderBankAccountControllerGetUserBankAccountData, ShareholderBankAccountControllerGetUserBankAccountResponse, ShareholderBankAccountControllerRequestBankAccountCodeData, ShareholderBankAccountControllerUpsertBankAccountData, ShareholderBankAccountControllerUpsertBankAccountResponse, ShareholderBankAccountControllerValidateBankAccountData, ShareholderBankAccountControllerValidateBankAccountResponse, ShareholderContractControllerGeneratePrefillableFormFileData, ShareholderContractControllerGenerateSignableDocumentsData, ShareholderContractControllerGetListOfActionableDocumentsData, ShareholderContractControllerGetListOfActionableDocumentsResponse, ShareholderContractControllerReviewDocumentData, ShareholderContractControllerStreamSignableDocumentsData, ShareholderCustomDetailControllerGetShareholderCustomDetailDataData, ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponse, ShareholderCustomDetailControllerUpdateShareholderInvestorDataData, ShareholderInvestorControllerGetInvestmentTransactionsData, ShareholderInvestorControllerGetInvestmentTransactionsResponse, ShareholderInvestorControllerGetInvestorDealDocumentsData, ShareholderInvestorControllerGetInvestorDealDocumentsResponse, ShareholderInvestorControllerGetInvestorDocumentsData, ShareholderInvestorControllerGetInvestorDocumentsResponse, ShareholderInvestorControllerGetInvestorRepresentativeData, ShareholderInvestorControllerGetInvestorRepresentativeResponse, ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData, ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponse, ShareholderInvestorControllerGetShareholderInvestorDataData, ShareholderInvestorControllerGetShareholderInvestorDataResponse, ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData, ShareholderInvestorControllerUpdateShareholderInvestorDataData, ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData, ShareholderKycControllerAddFilledKycFormData, ShareholderKycControllerChangeKycFileCertificationData, ShareholderKycControllerChangeKycFileCertificationResponse, ShareholderKycControllerConfirmDeclarationData, ShareholderKycControllerConfirmInvestorFormData, ShareholderKycControllerConfirmKycFileData, ShareholderKycControllerDeleteKycFileData, ShareholderKycControllerDownloadPreFilledKycFormFileData, ShareholderKycControllerGetDeclarationsData, ShareholderKycControllerGetDeclarationsResponse, ShareholderKycControllerGetInvestmentVehicleKycFilesData, ShareholderKycControllerGetInvestorKycFormsData, ShareholderKycControllerGetInvestorKycFormsResponse, ShareholderKycControllerGetProofOfAddressData, ShareholderKycControllerGetProofOfIdentityData, ShareholderKycControllerGetProofOfIdentityResponse, ShareholderKycControllerGetStandaloneKycMetadataData, ShareholderKycControllerGetStandaloneKycMetadataResponse, ShareholderKycControllerPatchDeclarationsData, ShareholderKycControllerPostInvestmentVehicleData, ShareholderKycControllerPreFillInvestorKycFormData, ShareholderKycControllerPreFillInvestorKycFormResponse, ShareholderKycControllerPutProofOfAddressData, ShareholderKycControllerPutProofOfIdentityData, ShareholderKycControllerRemoveInvestorFormData, ShareholderKycControllerResendKycFileCertifierInvitationData, ShareholderKycControllerResendKycFileCertifierInvitationResponse, ShareholderKycControllerResetInheritedData, ShareholderKycControllerSetOffMorePivDocumentsData, SimpleDocumentWorkflowControllerAddFileToMipData, SimpleDocumentWorkflowControllerAddFileToMipResponse, SimpleDocumentWorkflowControllerCreateDocumentsData, SimpleDocumentWorkflowControllerCreateDocumentsResponse, SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData, SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse, SimpleDocumentWorkflowControllerRemoveDocumentFileData, SimpleDocumentWorkflowControllerSendMasterDocumentsData, SimpleDocumentWorkflowControllerSendMasterDocumentsResponse, TagControllerAttachClassifiersData, TagControllerAttachClassifiersResponse, TagControllerCreateData, TagControllerCreateResponse, TagControllerDetachClassifiersData, TagControllerDetachClassifiersResponse, TagControllerListData, TagControllerListResponse, TagControllerRemoveData, TagControllerRemoveResponse, TagControllerUpdateData, TagControllerUpdateResponse, TaskControllerGetData, TaskControllerGetResponse, TransactionControllerAutoReorderData, TransactionControllerAutoReorderResponse, TransactionControllerBulkDeleteTransactionsData, TransactionControllerBulkDeleteTransactionsResponse, TransactionControllerBulkRestoreData, TransactionControllerBulkRestoreResponse, TransactionControllerBulkUpdateData, TransactionControllerBulkUpdateResponse, TransactionControllerBulkUploadData, TransactionControllerBulkUploadManagementLoansData, TransactionControllerCreateInseparableRedemptionData, TransactionControllerCreateInseparableRedemptionResponse, TransactionControllerCreatePairedIssueData, TransactionControllerCreatePairedIssueResponse, TransactionControllerCreateTransactionData, TransactionControllerCreateTransactionResponse, TransactionControllerDeleteTransactionData, TransactionControllerDownloadExcelData, TransactionControllerDownloadExcelResponse, TransactionControllerGetBulkUploadTaskStatusData, TransactionControllerGetBulkUploadTaskStatusResponse, TransactionControllerGetInseparableRedemptionGroupData, TransactionControllerGetInseparableRedemptionGroupResponse, TransactionControllerGetPairTransactionData, TransactionControllerGetPairTransactionResponse, TransactionControllerGetTransactionDetailsData, TransactionControllerGetTransactionDetailsResponse, TransactionControllerGetTransactionsData, TransactionControllerGetTransactionsResponse, TransactionControllerPairTransactionData, TransactionControllerPairTransactionResponse, TransactionControllerPreviewInseparableRedemptionData, TransactionControllerPreviewInseparableRedemptionResponse, TransactionControllerPreviewTransferCounterpartData, TransactionControllerPreviewTransferCounterpartResponse, TransactionControllerRestoreData, TransactionControllerRestoreResponse, TransactionControllerSplitTransactionData, TransactionControllerSplitTransactionInterestData, TransactionControllerSplitTransactionInterestResponse, TransactionControllerSplitTransactionResponse, TransactionControllerUpdateData, TransactionControllerUpdateInseparableRedemptionData, TransactionControllerUpdateInseparableRedemptionResponse, TransactionControllerUpdateOrderData, TransactionControllerUpdateOrderResponse, TransactionControllerUpdateResponse, TranslationsControllerTranslationsData, TwoFaControllerDeleteAuthFactorData, TwoFaControllerSetup2FaData, TwoFaControllerSetup2FaResponse, TwoFaControllerVerifyChallenge2FaData, TwoFaControllerVerifyChallenge2FaResponse, UserControllerDeleteUserSignatureData, UserControllerDeleteUserSignatureResponse, UserControllerGetAllInvestorsData, UserControllerGetAllInvestorsResponse, UserControllerGetCurrentUserDataData, UserControllerGetCurrentUserDataResponse, UserControllerGetUserOrganizationData, UserControllerGetUserOrganizationResponse, UserControllerGetUserPersonsData, UserControllerGetUserPersonsResponse, UserControllerGetUserProfileData, UserControllerGetUserProfileResponse, UserControllerGetUserSignatureData, UserControllerGetUserSignatureResponse, UserControllerUpdatePersonalDetailsData, UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData, UserControllerUpdateUserLegalRepresentativeWithoutMipData, UserControllerUpdateUserSignatureData, ValidationControllerValidateTinData, ValidationControllerValidateTinResponse, ValidationControllerVerifyBankIdentifiersData, ValidationControllerVerifyBankIdentifiersResponse, ValuationControllerCreateValuationData, ValuationControllerCreateValuationResponse, ValuationControllerDeleteValuationData, ValuationControllerDuplicateValuationData, ValuationControllerDuplicateValuationResponse, ValuationControllerGetValuationsAndJoinWithClassifiersData, ValuationControllerGetValuationsAndJoinWithClassifiersResponse, ValuationControllerUpdateValuationWithClassifiersData, ValuationControllerUpdateValuationWithClassifiersResponse, ValuationControllerUpsertValuationData, ValuationControllerUpsertValuationResponse, ValuationInputControllerCreateValuationInputAdjustmentData, ValuationInputControllerCreateValuationInputAdjustmentResponse, ValuationInputControllerDeleteValuationInputAdjustmentData, ValuationInputControllerGetValuationInputsData, ValuationInputControllerGetValuationInputsResponse, ValuationInputControllerUpdateValuationInputAdjustmentData, ValuationInputControllerUpdateValuationInputAdjustmentResponse, ValuationInputControllerUpdateValuationInputData, ValuationInputControllerUpdateValuationInputResponse, ValuationInputControllerUpsertData, ValuationInputControllerUpsertResponse, ValuationPersonInputControllerCreateValuationPersonInputData, ValuationPersonInputControllerCreateValuationPersonInputResponse, ValuationPersonInputControllerDeleteValuationPersonInputData, ValuationPersonInputControllerDeleteValuationPersonInputResponse, ValuationPersonInputControllerGetValuationPersonInputsData, ValuationPersonInputControllerGetValuationPersonInputsResponse, ValuationPersonInputControllerUpdateValuationPersonInputData, ValuationPersonInputControllerUpdateValuationPersonInputResponse, ValuationPersonInputControllerUpsertValuationPersonInputsData, ValuationPersonInputControllerUpsertValuationPersonInputsResponse, ValuationSummaryControllerDownloadExcelData, ValuationSummaryControllerDownloadExcelResponse, ValuationSummaryControllerDownloadInterestEventsExcelData, ValuationSummaryControllerDownloadInterestEventsExcelResponse, ValuationSummaryControllerGetValuationBreakpointSummaryData, ValuationSummaryControllerGetValuationBreakpointSummaryResponse, ValuationSummaryControllerGetValuationSummaryResultData, ValuationSummaryControllerGetValuationSummaryResultResponse, ValuationSummaryControllerStartCalculateValuationData, ValuationSummaryControllerStartCalculateValuationResponse, ValuationSummaryControllerStreamCalculateValuationData, VestingControllerApplyVestingStartDateToInvestmentWorkflowData, VestingControllerApplyVestingStartDateToTransactionData, VestingControllerApplyVestingTermToInvestmentWorkflowData, VestingControllerApplyVestingTermToTransactionData, VestingControllerBulkUpdateInvestorsVestingData, VestingControllerCreateVestingTermData, VestingControllerCreateVestingTermGradedData, VestingControllerCreateVestingTermGradedResponse, VestingControllerCreateVestingTermLeaverProvisionData, VestingControllerCreateVestingTermLeaverProvisionResponse, VestingControllerCreateVestingTermResponse, VestingControllerCreateVestingTermStraightLineData, VestingControllerCreateVestingTermStraightLineResponse, VestingControllerDeletePerformanceVestingData, VestingControllerDeleteVestingTermData, VestingControllerDeleteVestingTermGradedData, VestingControllerDeleteVestingTermLeaverProvisionData, VestingControllerDeleteVestingTermStraightLineData, VestingControllerGetSimplifiedVestingTermsData, VestingControllerGetSimplifiedVestingTermsResponse, VestingControllerGetVestingTermsData, VestingControllerGetVestingTermsResponse, VestingControllerRemoveVestingTermFromInvestmentWorkflowData, VestingControllerRemoveVestingTermFromTransactionData, VestingControllerSaveTransactionVestingData, VestingControllerUpdateVestingTermData, VestingControllerUpdateVestingTermGradedData, VestingControllerUpdateVestingTermGradedResponse, VestingControllerUpdateVestingTermLeaverProvisionData, VestingControllerUpdateVestingTermLeaverProvisionResponse, VestingControllerUpdateVestingTermResponse, VestingControllerUpdateVestingTermStraightLineData, VestingControllerUpdateVestingTermStraightLineResponse, VestingControllerUpsertPerformanceVestingData, VestingControllerUpsertPerformanceVestingResponse, WorkOsEventsAdminControllerListWorkOsEventsData, WorkOsEventsAdminControllerListWorkOsEventsResponse, WorkOsEventsAdminControllerReplayWorkOsEventData, WorkOsEventsAdminControllerReplayWorkOsEventResponse, WorkOsWebhookControllerWebhookData } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const userControllerGetCurrentUserDataQueryKey = (options?: Options<UserControllerGetCurrentUserDataData>) => createQueryKey('userControllerGetCurrentUserData', options);

/**
 * Fetch current user data
 */
export const userControllerGetCurrentUserDataOptions = (options?: Options<UserControllerGetCurrentUserDataData>) => queryOptions<UserControllerGetCurrentUserDataResponse, DefaultError, UserControllerGetCurrentUserDataResponse, ReturnType<typeof userControllerGetCurrentUserDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetCurrentUserData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetCurrentUserDataQueryKey(options)
});

export const userControllerGetUserOrganizationQueryKey = (options?: Options<UserControllerGetUserOrganizationData>) => createQueryKey('userControllerGetUserOrganization', options);

/**
 * Fetch the id of the organization the current user belongs to
 */
export const userControllerGetUserOrganizationOptions = (options?: Options<UserControllerGetUserOrganizationData>) => queryOptions<UserControllerGetUserOrganizationResponse, DefaultError, UserControllerGetUserOrganizationResponse, ReturnType<typeof userControllerGetUserOrganizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetUserOrganization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetUserOrganizationQueryKey(options)
});

export const userControllerGetUserProfileQueryKey = (options?: Options<UserControllerGetUserProfileData>) => createQueryKey('userControllerGetUserProfile', options);

/**
 * Fetch user profile
 */
export const userControllerGetUserProfileOptions = (options?: Options<UserControllerGetUserProfileData>) => queryOptions<UserControllerGetUserProfileResponse, DefaultError, UserControllerGetUserProfileResponse, ReturnType<typeof userControllerGetUserProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetUserProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetUserProfileQueryKey(options)
});

export const userControllerGetUserPersonsQueryKey = (options?: Options<UserControllerGetUserPersonsData>) => createQueryKey('userControllerGetUserPersons', options);

/**
 * Fetch user persons data
 */
export const userControllerGetUserPersonsOptions = (options?: Options<UserControllerGetUserPersonsData>) => queryOptions<UserControllerGetUserPersonsResponse, DefaultError, UserControllerGetUserPersonsResponse, ReturnType<typeof userControllerGetUserPersonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetUserPersons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetUserPersonsQueryKey(options)
});

/**
 * Update user personal details
 */
export const userControllerUpdatePersonalDetailsMutation = (options?: Partial<Options<UserControllerUpdatePersonalDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdatePersonalDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdatePersonalDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userControllerUpdatePersonalDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft-delete the current user signature (idempotent)
 */
export const userControllerDeleteUserSignatureMutation = (options?: Partial<Options<UserControllerDeleteUserSignatureData>>): UseMutationOptions<UserControllerDeleteUserSignatureResponse, DefaultError, Options<UserControllerDeleteUserSignatureData>> => {
    const mutationOptions: UseMutationOptions<UserControllerDeleteUserSignatureResponse, DefaultError, Options<UserControllerDeleteUserSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userControllerDeleteUserSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userControllerGetUserSignatureQueryKey = (options?: Options<UserControllerGetUserSignatureData>) => createQueryKey('userControllerGetUserSignature', options);

/**
 * Get the current user signature image (signed URL) or null
 */
export const userControllerGetUserSignatureOptions = (options?: Options<UserControllerGetUserSignatureData>) => queryOptions<UserControllerGetUserSignatureResponse, DefaultError, UserControllerGetUserSignatureResponse, ReturnType<typeof userControllerGetUserSignatureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetUserSignature({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetUserSignatureQueryKey(options)
});

/**
 * Set or replace the current user signature image
 */
export const userControllerUpdateUserSignatureMutation = (options?: Partial<Options<UserControllerUpdateUserSignatureData>>): UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateUserSignatureData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateUserSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userControllerUpdateUserSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update user vehicle data without mipId
 */
export const userControllerUpdateShareholderInvestorVehicleDataWithoutMipMutation = (options?: Partial<Options<UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData>>): UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userControllerUpdateShareholderInvestorVehicleDataWithoutMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update user legal representative without mipId
 */
export const userControllerUpdateUserLegalRepresentativeWithoutMipMutation = (options?: Partial<Options<UserControllerUpdateUserLegalRepresentativeWithoutMipData>>): UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateUserLegalRepresentativeWithoutMipData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UserControllerUpdateUserLegalRepresentativeWithoutMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userControllerUpdateUserLegalRepresentativeWithoutMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userControllerGetAllInvestorsQueryKey = (options: Options<UserControllerGetAllInvestorsData>) => createQueryKey('userControllerGetAllInvestors', options);

/**
 * Get all users
 */
export const userControllerGetAllInvestorsOptions = (options: Options<UserControllerGetAllInvestorsData>) => queryOptions<UserControllerGetAllInvestorsResponse, DefaultError, UserControllerGetAllInvestorsResponse, ReturnType<typeof userControllerGetAllInvestorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userControllerGetAllInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userControllerGetAllInvestorsQueryKey(options)
});

export const shareholderInvestorControllerGetShareholderInvestorDataQueryKey = (options: Options<ShareholderInvestorControllerGetShareholderInvestorDataData>) => createQueryKey('shareholderInvestorControllerGetShareholderInvestorData', options);

/**
 * Get Shareholder investor data
 */
export const shareholderInvestorControllerGetShareholderInvestorDataOptions = (options: Options<ShareholderInvestorControllerGetShareholderInvestorDataData>) => queryOptions<ShareholderInvestorControllerGetShareholderInvestorDataResponse, DefaultError, ShareholderInvestorControllerGetShareholderInvestorDataResponse, ReturnType<typeof shareholderInvestorControllerGetShareholderInvestorDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetShareholderInvestorData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetShareholderInvestorDataQueryKey(options)
});

/**
 * Update investor data during first step of investment flow
 */
export const shareholderInvestorControllerUpdateShareholderInvestorDataMutation = (options?: Partial<Options<ShareholderInvestorControllerUpdateShareholderInvestorDataData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderInvestorControllerUpdateShareholderInvestorData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderInvestorControllerGetShareholderInvestorDataByUserIdQueryKey = (options?: Options<ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData>) => createQueryKey('shareholderInvestorControllerGetShareholderInvestorDataByUserId', options);

/**
 * Get Shareholder investor data by user id
 */
export const shareholderInvestorControllerGetShareholderInvestorDataByUserIdOptions = (options?: Options<ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData>) => queryOptions<ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponse, DefaultError, ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponse, ReturnType<typeof shareholderInvestorControllerGetShareholderInvestorDataByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetShareholderInvestorDataByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetShareholderInvestorDataByUserIdQueryKey(options)
});

export const shareholderInvestorControllerGetInvestorDocumentsQueryKey = (options?: Options<ShareholderInvestorControllerGetInvestorDocumentsData>) => createQueryKey('shareholderInvestorControllerGetInvestorDocuments', options);

/**
 * documents for all users investments, or a single MIP investment when investorId is provided
 */
export const shareholderInvestorControllerGetInvestorDocumentsOptions = (options?: Options<ShareholderInvestorControllerGetInvestorDocumentsData>) => queryOptions<ShareholderInvestorControllerGetInvestorDocumentsResponse, DefaultError, ShareholderInvestorControllerGetInvestorDocumentsResponse, ReturnType<typeof shareholderInvestorControllerGetInvestorDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetInvestorDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetInvestorDocumentsQueryKey(options)
});

export const shareholderInvestorControllerGetInvestorDealDocumentsQueryKey = (options?: Options<ShareholderInvestorControllerGetInvestorDealDocumentsData>) => createQueryKey('shareholderInvestorControllerGetInvestorDealDocuments', options);

/**
 * Deal library documents shared with this investor
 *
 * DC-494. Documents from the deal document library that a deal admin has opted in to the investor portal for the caller, or for an investment vehicle the caller holds through. Scoped entirely off the authenticated user — no caller-supplied id is trusted.
 */
export const shareholderInvestorControllerGetInvestorDealDocumentsOptions = (options?: Options<ShareholderInvestorControllerGetInvestorDealDocumentsData>) => queryOptions<ShareholderInvestorControllerGetInvestorDealDocumentsResponse, DefaultError, ShareholderInvestorControllerGetInvestorDealDocumentsResponse, ReturnType<typeof shareholderInvestorControllerGetInvestorDealDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetInvestorDealDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetInvestorDealDocumentsQueryKey(options)
});

/**
 * Update investor vehicle data
 */
export const shareholderInvestorControllerUpdateShareholderInvestorVehicleDataMutation = (options?: Partial<Options<ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderInvestorControllerUpdateShareholderInvestorVehicleData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update data on which completion step are investor for given MIP
 */
export const shareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataMutation = (options?: Partial<Options<ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderInvestorControllerUpdateShareholderInvestorCompletedStepsData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderInvestorControllerGetInvestorRepresentativeQueryKey = (options: Options<ShareholderInvestorControllerGetInvestorRepresentativeData>) => createQueryKey('shareholderInvestorControllerGetInvestorRepresentative', options);

/**
 * Get Shareholder investor data
 */
export const shareholderInvestorControllerGetInvestorRepresentativeOptions = (options: Options<ShareholderInvestorControllerGetInvestorRepresentativeData>) => queryOptions<ShareholderInvestorControllerGetInvestorRepresentativeResponse, DefaultError, ShareholderInvestorControllerGetInvestorRepresentativeResponse, ReturnType<typeof shareholderInvestorControllerGetInvestorRepresentativeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetInvestorRepresentative({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetInvestorRepresentativeQueryKey(options)
});

export const shareholderInvestorControllerGetInvestmentTransactionsQueryKey = (options: Options<ShareholderInvestorControllerGetInvestmentTransactionsData>) => createQueryKey('shareholderInvestorControllerGetInvestmentTransactions', options);

/**
 * Get shareholder investor transactions
 */
export const shareholderInvestorControllerGetInvestmentTransactionsOptions = (options: Options<ShareholderInvestorControllerGetInvestmentTransactionsData>) => queryOptions<ShareholderInvestorControllerGetInvestmentTransactionsResponse, DefaultError, ShareholderInvestorControllerGetInvestmentTransactionsResponse, ReturnType<typeof shareholderInvestorControllerGetInvestmentTransactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderInvestorControllerGetInvestmentTransactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderInvestorControllerGetInvestmentTransactionsQueryKey(options)
});

/**
 * Create natural person entity
 */
export const personControllerCreateNaturalEntityMutation = (options?: Partial<Options<PersonControllerCreateNaturalEntityData>>): UseMutationOptions<PersonControllerCreateNaturalEntityResponse, DefaultError, Options<PersonControllerCreateNaturalEntityData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerCreateNaturalEntityResponse, DefaultError, Options<PersonControllerCreateNaturalEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerCreateNaturalEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create legal person entity
 */
export const personControllerCreateLegalEntityMutation = (options?: Partial<Options<PersonControllerCreateLegalEntityData>>): UseMutationOptions<PersonControllerCreateLegalEntityResponse, DefaultError, Options<PersonControllerCreateLegalEntityData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerCreateLegalEntityResponse, DefaultError, Options<PersonControllerCreateLegalEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerCreateLegalEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update legal person details
 */
export const personControllerUpdateLegalPersonDetailsMutation = (options?: Partial<Options<PersonControllerUpdateLegalPersonDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateLegalPersonDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateLegalPersonDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerUpdateLegalPersonDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update natural person details
 */
export const personControllerUpdateNaturalPersonDetailsMutation = (options?: Partial<Options<PersonControllerUpdateNaturalPersonDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateNaturalPersonDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateNaturalPersonDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerUpdateNaturalPersonDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update natural person email
 */
export const personControllerUpdateNaturalPersonEmailMutation = (options?: Partial<Options<PersonControllerUpdateNaturalPersonEmailData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateNaturalPersonEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateNaturalPersonEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerUpdateNaturalPersonEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personControllerLookupPersonByEmailQueryKey = (options: Options<PersonControllerLookupPersonByEmailData>) => createQueryKey('personControllerLookupPersonByEmail', options);

/**
 * Look up a person by email in the deal directory (prefill)
 */
export const personControllerLookupPersonByEmailOptions = (options: Options<PersonControllerLookupPersonByEmailData>) => queryOptions<PersonControllerLookupPersonByEmailResponse, DefaultError, PersonControllerLookupPersonByEmailResponse, ReturnType<typeof personControllerLookupPersonByEmailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerLookupPersonByEmail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerLookupPersonByEmailQueryKey(options)
});

export const personControllerGetEntityDataQueryKey = (options: Options<PersonControllerGetEntityDataData>) => createQueryKey('personControllerGetEntityData', options);

/**
 * Get person data
 */
export const personControllerGetEntityDataOptions = (options: Options<PersonControllerGetEntityDataData>) => queryOptions<PersonControllerGetEntityDataResponse, DefaultError, PersonControllerGetEntityDataResponse, ReturnType<typeof personControllerGetEntityDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetEntityData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetEntityDataQueryKey(options)
});

/**
 * Delete related person
 */
export const personControllerDeletePersonRelatedPersonMutation = (options?: Partial<Options<PersonControllerDeletePersonRelatedPersonData>>): UseMutationOptions<PersonControllerDeletePersonRelatedPersonResponse, DefaultError, Options<PersonControllerDeletePersonRelatedPersonData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerDeletePersonRelatedPersonResponse, DefaultError, Options<PersonControllerDeletePersonRelatedPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerDeletePersonRelatedPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personControllerGetPersonRelatedPeopleQueryKey = (options: Options<PersonControllerGetPersonRelatedPeopleData>) => createQueryKey('personControllerGetPersonRelatedPeople', options);

/**
 * Get related people for person
 */
export const personControllerGetPersonRelatedPeopleOptions = (options: Options<PersonControllerGetPersonRelatedPeopleData>) => queryOptions<PersonControllerGetPersonRelatedPeopleResponse, DefaultError, PersonControllerGetPersonRelatedPeopleResponse, ReturnType<typeof personControllerGetPersonRelatedPeopleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetPersonRelatedPeople({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetPersonRelatedPeopleQueryKey(options)
});

/**
 * Create related people for person
 */
export const personControllerCreateRelatedPeopleForPersonMutation = (options?: Partial<Options<PersonControllerCreateRelatedPeopleForPersonData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerCreateRelatedPeopleForPersonData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerCreateRelatedPeopleForPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerCreateRelatedPeopleForPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personControllerGetAvailableRelatedPeopleForPersonQueryKey = (options: Options<PersonControllerGetAvailableRelatedPeopleForPersonData>) => createQueryKey('personControllerGetAvailableRelatedPeopleForPerson', options);

/**
 * Get available people to relate to person
 */
export const personControllerGetAvailableRelatedPeopleForPersonOptions = (options: Options<PersonControllerGetAvailableRelatedPeopleForPersonData>) => queryOptions<PersonControllerGetAvailableRelatedPeopleForPersonResponse, DefaultError, PersonControllerGetAvailableRelatedPeopleForPersonResponse, ReturnType<typeof personControllerGetAvailableRelatedPeopleForPersonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetAvailableRelatedPeopleForPerson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetAvailableRelatedPeopleForPersonQueryKey(options)
});

/**
 * Add a related person to a legal person by email (find-or-create + link)
 */
export const personControllerAddRelatedPersonByEmailMutation = (options?: Partial<Options<PersonControllerAddRelatedPersonByEmailData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerAddRelatedPersonByEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerAddRelatedPersonByEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerAddRelatedPersonByEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update related person relation
 */
export const personControllerUpdateRelatedPersonRelationMutation = (options?: Partial<Options<PersonControllerUpdateRelatedPersonRelationData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateRelatedPersonRelationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerUpdateRelatedPersonRelationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerUpdateRelatedPersonRelation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personControllerGetAllEntitiesQueryKey = (options: Options<PersonControllerGetAllEntitiesData>) => createQueryKey('personControllerGetAllEntities', options);

/**
 * Get all person entities
 */
export const personControllerGetAllEntitiesOptions = (options: Options<PersonControllerGetAllEntitiesData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof personControllerGetAllEntitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetAllEntities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetAllEntitiesQueryKey(options)
});

export const personControllerGetAllLegalEntitiesQueryKey = (options: Options<PersonControllerGetAllLegalEntitiesData>) => createQueryKey('personControllerGetAllLegalEntities', options);

/**
 * Get all legal person entities
 */
export const personControllerGetAllLegalEntitiesOptions = (options: Options<PersonControllerGetAllLegalEntitiesData>) => queryOptions<PersonControllerGetAllLegalEntitiesResponse, DefaultError, PersonControllerGetAllLegalEntitiesResponse, ReturnType<typeof personControllerGetAllLegalEntitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetAllLegalEntities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetAllLegalEntitiesQueryKey(options)
});

export const personControllerGetPersonsForCapQueryKey = (options: Options<PersonControllerGetPersonsForCapData>) => createQueryKey('personControllerGetPersonsForCap', options);

/**
 * Get persons for CAP manage page
 */
export const personControllerGetPersonsForCapOptions = (options: Options<PersonControllerGetPersonsForCapData>) => queryOptions<PersonControllerGetPersonsForCapResponse, DefaultError, PersonControllerGetPersonsForCapResponse, ReturnType<typeof personControllerGetPersonsForCapQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetPersonsForCap({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetPersonsForCapQueryKey(options)
});

export const personControllerGetPersonTagsForDealQueryKey = (options: Options<PersonControllerGetPersonTagsForDealData>) => createQueryKey('personControllerGetPersonTagsForDeal', options);

/**
 * Get all deal person tags with counts
 */
export const personControllerGetPersonTagsForDealOptions = (options: Options<PersonControllerGetPersonTagsForDealData>) => queryOptions<PersonControllerGetPersonTagsForDealResponse, DefaultError, PersonControllerGetPersonTagsForDealResponse, ReturnType<typeof personControllerGetPersonTagsForDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetPersonTagsForDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetPersonTagsForDealQueryKey(options)
});

/**
 * Delete person entities
 */
export const personControllerDeleteEntitiesMutation = (options?: Partial<Options<PersonControllerDeleteEntitiesData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerDeleteEntitiesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerDeleteEntitiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerDeleteEntities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * check if person have InvestmentWorkflow attached
 */
export const personControllerIsThereInvestmentWorkflowMutation = (options?: Partial<Options<PersonControllerIsThereInvestmentWorkflowData>>): UseMutationOptions<PersonControllerIsThereInvestmentWorkflowResponse, DefaultError, Options<PersonControllerIsThereInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerIsThereInvestmentWorkflowResponse, DefaultError, Options<PersonControllerIsThereInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerIsThereInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create legal persons
 */
export const personControllerBulkCreateLegalPersonsMutation = (options?: Partial<Options<PersonControllerBulkCreateLegalPersonsData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerBulkCreateLegalPersonsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerBulkCreateLegalPersonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerBulkCreateLegalPersons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create natural persons
 */
export const personControllerBulkCreateNaturalPersonsMutation = (options?: Partial<Options<PersonControllerBulkCreateNaturalPersonsData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerBulkCreateNaturalPersonsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerBulkCreateNaturalPersonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerBulkCreateNaturalPersons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create person address
 */
export const personControllerCreateAddressMutation = (options?: Partial<Options<PersonControllerCreateAddressData>>): UseMutationOptions<PersonControllerCreateAddressResponse, DefaultError, Options<PersonControllerCreateAddressData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerCreateAddressResponse, DefaultError, Options<PersonControllerCreateAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerCreateAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update person address
 */
export const personControllerUpdateAddressMutation = (options?: Partial<Options<PersonControllerUpdateAddressData>>): UseMutationOptions<PersonControllerUpdateAddressResponse, DefaultError, Options<PersonControllerUpdateAddressData>> => {
    const mutationOptions: UseMutationOptions<PersonControllerUpdateAddressResponse, DefaultError, Options<PersonControllerUpdateAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerUpdateAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete person address
 */
export const personControllerDeleteAddressMutation = (options?: Partial<Options<PersonControllerDeleteAddressData>>): UseMutationOptions<unknown, DefaultError, Options<PersonControllerDeleteAddressData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PersonControllerDeleteAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personControllerDeleteAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personControllerGetNaturalPersonsByPivIdQueryKey = (options: Options<PersonControllerGetNaturalPersonsByPivIdData>) => createQueryKey('personControllerGetNaturalPersonsByPivId', options);

/**
 * Get natural persons investing through a PIV
 */
export const personControllerGetNaturalPersonsByPivIdOptions = (options: Options<PersonControllerGetNaturalPersonsByPivIdData>) => queryOptions<PersonControllerGetNaturalPersonsByPivIdResponse, DefaultError, PersonControllerGetNaturalPersonsByPivIdResponse, ReturnType<typeof personControllerGetNaturalPersonsByPivIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerGetNaturalPersonsByPivId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerGetNaturalPersonsByPivIdQueryKey(options)
});

export const personControllerIsPersonUserInvitedToPlatformQueryKey = (options: Options<PersonControllerIsPersonUserInvitedToPlatformData>) => createQueryKey('personControllerIsPersonUserInvitedToPlatform', options);

/**
 * Check if person email can be updated, based on whether user is invited to the platform
 */
export const personControllerIsPersonUserInvitedToPlatformOptions = (options: Options<PersonControllerIsPersonUserInvitedToPlatformData>) => queryOptions<PersonControllerIsPersonUserInvitedToPlatformResponse, DefaultError, PersonControllerIsPersonUserInvitedToPlatformResponse, ReturnType<typeof personControllerIsPersonUserInvitedToPlatformQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personControllerIsPersonUserInvitedToPlatform({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personControllerIsPersonUserInvitedToPlatformQueryKey(options)
});

export const personBankAccountControllerGetPersonBankAccountsQueryKey = (options: Options<PersonBankAccountControllerGetPersonBankAccountsData>) => createQueryKey('personBankAccountControllerGetPersonBankAccounts', options);

/**
 * Get person bank accounts
 */
export const personBankAccountControllerGetPersonBankAccountsOptions = (options: Options<PersonBankAccountControllerGetPersonBankAccountsData>) => queryOptions<PersonBankAccountControllerGetPersonBankAccountsResponse, DefaultError, PersonBankAccountControllerGetPersonBankAccountsResponse, ReturnType<typeof personBankAccountControllerGetPersonBankAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personBankAccountControllerGetPersonBankAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personBankAccountControllerGetPersonBankAccountsQueryKey(options)
});

/**
 * Add person bank account
 */
export const personBankAccountControllerCreatePersonBankAccountMutation = (options?: Partial<Options<PersonBankAccountControllerCreatePersonBankAccountData>>): UseMutationOptions<PersonBankAccountControllerCreatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerCreatePersonBankAccountData>> => {
    const mutationOptions: UseMutationOptions<PersonBankAccountControllerCreatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerCreatePersonBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personBankAccountControllerCreatePersonBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete person bank account
 */
export const personBankAccountControllerDeletePersonBankAccountMutation = (options?: Partial<Options<PersonBankAccountControllerDeletePersonBankAccountData>>): UseMutationOptions<PersonBankAccountControllerDeletePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerDeletePersonBankAccountData>> => {
    const mutationOptions: UseMutationOptions<PersonBankAccountControllerDeletePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerDeletePersonBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personBankAccountControllerDeletePersonBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update person bank account
 */
export const personBankAccountControllerUpdatePersonBankAccountMutation = (options?: Partial<Options<PersonBankAccountControllerUpdatePersonBankAccountData>>): UseMutationOptions<PersonBankAccountControllerUpdatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerUpdatePersonBankAccountData>> => {
    const mutationOptions: UseMutationOptions<PersonBankAccountControllerUpdatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerUpdatePersonBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personBankAccountControllerUpdatePersonBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify a person bank account's identifiers per format rule and log the lookup
 */
export const personBankAccountControllerValidatePersonBankAccountMutation = (options?: Partial<Options<PersonBankAccountControllerValidatePersonBankAccountData>>): UseMutationOptions<PersonBankAccountControllerValidatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerValidatePersonBankAccountData>> => {
    const mutationOptions: UseMutationOptions<PersonBankAccountControllerValidatePersonBankAccountResponse, DefaultError, Options<PersonBankAccountControllerValidatePersonBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personBankAccountControllerValidatePersonBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personTaxControllerGetPersonTaxInformationQueryKey = (options: Options<PersonTaxControllerGetPersonTaxInformationData>) => createQueryKey('personTaxControllerGetPersonTaxInformation', options);

/**
 * Get person tax information
 */
export const personTaxControllerGetPersonTaxInformationOptions = (options: Options<PersonTaxControllerGetPersonTaxInformationData>) => queryOptions<PersonTaxControllerGetPersonTaxInformationResponse, DefaultError, PersonTaxControllerGetPersonTaxInformationResponse, ReturnType<typeof personTaxControllerGetPersonTaxInformationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personTaxControllerGetPersonTaxInformation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personTaxControllerGetPersonTaxInformationQueryKey(options)
});

/**
 * Add person tax information
 */
export const personTaxControllerCreatePersonTaxInformationMutation = (options?: Partial<Options<PersonTaxControllerCreatePersonTaxInformationData>>): UseMutationOptions<PersonTaxControllerCreatePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerCreatePersonTaxInformationData>> => {
    const mutationOptions: UseMutationOptions<PersonTaxControllerCreatePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerCreatePersonTaxInformationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personTaxControllerCreatePersonTaxInformation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete person tax information
 */
export const personTaxControllerDeletePersonTaxInformationMutation = (options?: Partial<Options<PersonTaxControllerDeletePersonTaxInformationData>>): UseMutationOptions<PersonTaxControllerDeletePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerDeletePersonTaxInformationData>> => {
    const mutationOptions: UseMutationOptions<PersonTaxControllerDeletePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerDeletePersonTaxInformationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personTaxControllerDeletePersonTaxInformation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update person tax information
 */
export const personTaxControllerUpdatePersonTaxInformationMutation = (options?: Partial<Options<PersonTaxControllerUpdatePersonTaxInformationData>>): UseMutationOptions<PersonTaxControllerUpdatePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerUpdatePersonTaxInformationData>> => {
    const mutationOptions: UseMutationOptions<PersonTaxControllerUpdatePersonTaxInformationResponse, DefaultError, Options<PersonTaxControllerUpdatePersonTaxInformationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personTaxControllerUpdatePersonTaxInformation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personInvestmentProgrammeControllerGetInvestmentProgrammesForPersonQueryKey = (options: Options<PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData>) => createQueryKey('personInvestmentProgrammeControllerGetInvestmentProgrammesForPerson', options);

/**
 * Get investment programmes for person
 */
export const personInvestmentProgrammeControllerGetInvestmentProgrammesForPersonOptions = (options: Options<PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData>) => queryOptions<PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponse, DefaultError, PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponse, ReturnType<typeof personInvestmentProgrammeControllerGetInvestmentProgrammesForPersonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personInvestmentProgrammeControllerGetInvestmentProgrammesForPerson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personInvestmentProgrammeControllerGetInvestmentProgrammesForPersonQueryKey(options)
});

export const personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonQueryKey = (options: Options<PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData>) => createQueryKey('personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPerson', options);

/**
 * Get available investment programmes for person
 */
export const personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonOptions = (options: Options<PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData>) => queryOptions<PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponse, DefaultError, PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponse, ReturnType<typeof personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPerson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonQueryKey(options)
});

export const personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipQueryKey = (options: Options<PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData>) => createQueryKey('personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMip', options);

/**
 * Check available transactions for person for mip
 */
export const personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipOptions = (options: Options<PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData>) => queryOptions<PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponse, DefaultError, PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponse, ReturnType<typeof personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipQueryKey(options)
});

export const personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipQueryKey = (options: Options<PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData>) => createQueryKey('personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMip', options);

/**
 * Get open TSA warning for person in MIP
 */
export const personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipOptions = (options: Options<PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData>) => queryOptions<PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponse, DefaultError, PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponse, ReturnType<typeof personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipQueryKey(options)
});

/**
 * Link person to MIP
 */
export const personInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestMutation = (options?: Partial<Options<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData>>): UseMutationOptions<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponse, DefaultError, Options<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData>> => {
    const mutationOptions: UseMutationOptions<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponse, DefaultError, Options<PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink person from MIP
 */
export const personInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestMutation = (options?: Partial<Options<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData>>): UseMutationOptions<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponse, DefaultError, Options<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData>> => {
    const mutationOptions: UseMutationOptions<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponse, DefaultError, Options<PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personEmploymentRecordControllerListEmploymentRecordsQueryKey = (options: Options<PersonEmploymentRecordControllerListEmploymentRecordsData>) => createQueryKey('personEmploymentRecordControllerListEmploymentRecords', options);

/**
 * List employment records for a person (as employee or employer)
 */
export const personEmploymentRecordControllerListEmploymentRecordsOptions = (options: Options<PersonEmploymentRecordControllerListEmploymentRecordsData>) => queryOptions<PersonEmploymentRecordControllerListEmploymentRecordsResponse, DefaultError, PersonEmploymentRecordControllerListEmploymentRecordsResponse, ReturnType<typeof personEmploymentRecordControllerListEmploymentRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personEmploymentRecordControllerListEmploymentRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personEmploymentRecordControllerListEmploymentRecordsQueryKey(options)
});

/**
 * Create an employment record for a person
 */
export const personEmploymentRecordControllerCreateEmploymentRecordMutation = (options?: Partial<Options<PersonEmploymentRecordControllerCreateEmploymentRecordData>>): UseMutationOptions<PersonEmploymentRecordControllerCreateEmploymentRecordResponse, DefaultError, Options<PersonEmploymentRecordControllerCreateEmploymentRecordData>> => {
    const mutationOptions: UseMutationOptions<PersonEmploymentRecordControllerCreateEmploymentRecordResponse, DefaultError, Options<PersonEmploymentRecordControllerCreateEmploymentRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personEmploymentRecordControllerCreateEmploymentRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const personEmploymentControllerGetPersonEmploymentQueryKey = (options: Options<PersonEmploymentControllerGetPersonEmploymentData>) => createQueryKey('personEmploymentControllerGetPersonEmployment', options);

/**
 * Get employment records where the person is the employee
 */
export const personEmploymentControllerGetPersonEmploymentOptions = (options: Options<PersonEmploymentControllerGetPersonEmploymentData>) => queryOptions<PersonEmploymentControllerGetPersonEmploymentResponse, DefaultError, PersonEmploymentControllerGetPersonEmploymentResponse, ReturnType<typeof personEmploymentControllerGetPersonEmploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await personEmploymentControllerGetPersonEmployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: personEmploymentControllerGetPersonEmploymentQueryKey(options)
});

/**
 * Upsert an employment record by employer name
 */
export const personEmploymentControllerUpsertPersonEmploymentMutation = (options?: Partial<Options<PersonEmploymentControllerUpsertPersonEmploymentData>>): UseMutationOptions<PersonEmploymentControllerUpsertPersonEmploymentResponse, DefaultError, Options<PersonEmploymentControllerUpsertPersonEmploymentData>> => {
    const mutationOptions: UseMutationOptions<PersonEmploymentControllerUpsertPersonEmploymentResponse, DefaultError, Options<PersonEmploymentControllerUpsertPersonEmploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personEmploymentControllerUpsertPersonEmployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const employmentEmployersControllerGetEmployersQueryKey = (options?: Options<EmploymentEmployersControllerGetEmployersData>) => createQueryKey('employmentEmployersControllerGetEmployers', options);

/**
 * List employer persons referenced by employment records in the deal
 */
export const employmentEmployersControllerGetEmployersOptions = (options?: Options<EmploymentEmployersControllerGetEmployersData>) => queryOptions<EmploymentEmployersControllerGetEmployersResponse, DefaultError, EmploymentEmployersControllerGetEmployersResponse, ReturnType<typeof employmentEmployersControllerGetEmployersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employmentEmployersControllerGetEmployers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employmentEmployersControllerGetEmployersQueryKey(options)
});

/**
 * Delete an employment record
 */
export const employmentRecordControllerDeleteEmploymentRecordMutation = (options?: Partial<Options<EmploymentRecordControllerDeleteEmploymentRecordData>>): UseMutationOptions<EmploymentRecordControllerDeleteEmploymentRecordResponse, DefaultError, Options<EmploymentRecordControllerDeleteEmploymentRecordData>> => {
    const mutationOptions: UseMutationOptions<EmploymentRecordControllerDeleteEmploymentRecordResponse, DefaultError, Options<EmploymentRecordControllerDeleteEmploymentRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await employmentRecordControllerDeleteEmploymentRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const employmentRecordControllerGetEmploymentRecordQueryKey = (options: Options<EmploymentRecordControllerGetEmploymentRecordData>) => createQueryKey('employmentRecordControllerGetEmploymentRecord', options);

/**
 * Get a single employment record
 */
export const employmentRecordControllerGetEmploymentRecordOptions = (options: Options<EmploymentRecordControllerGetEmploymentRecordData>) => queryOptions<EmploymentRecordControllerGetEmploymentRecordResponse, DefaultError, EmploymentRecordControllerGetEmploymentRecordResponse, ReturnType<typeof employmentRecordControllerGetEmploymentRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employmentRecordControllerGetEmploymentRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employmentRecordControllerGetEmploymentRecordQueryKey(options)
});

/**
 * Update an employment record
 */
export const employmentRecordControllerUpdateEmploymentRecordMutation = (options?: Partial<Options<EmploymentRecordControllerUpdateEmploymentRecordData>>): UseMutationOptions<EmploymentRecordControllerUpdateEmploymentRecordResponse, DefaultError, Options<EmploymentRecordControllerUpdateEmploymentRecordData>> => {
    const mutationOptions: UseMutationOptions<EmploymentRecordControllerUpdateEmploymentRecordResponse, DefaultError, Options<EmploymentRecordControllerUpdateEmploymentRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await employmentRecordControllerUpdateEmploymentRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bankAccountLifecycleDebugControllerGetVerificationLogsQueryKey = (options: Options<BankAccountLifecycleDebugControllerGetVerificationLogsData>) => createQueryKey('bankAccountLifecycleDebugControllerGetVerificationLogs', options);

/**
 * Debug: all verification log rows for a bank account
 */
export const bankAccountLifecycleDebugControllerGetVerificationLogsOptions = (options: Options<BankAccountLifecycleDebugControllerGetVerificationLogsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof bankAccountLifecycleDebugControllerGetVerificationLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankAccountLifecycleDebugControllerGetVerificationLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankAccountLifecycleDebugControllerGetVerificationLogsQueryKey(options)
});

export const bankAccountLifecycleDebugControllerGetStateTransitionsQueryKey = (options: Options<BankAccountLifecycleDebugControllerGetStateTransitionsData>) => createQueryKey('bankAccountLifecycleDebugControllerGetStateTransitions', options);

/**
 * Debug: all state transition rows for a bank account
 */
export const bankAccountLifecycleDebugControllerGetStateTransitionsOptions = (options: Options<BankAccountLifecycleDebugControllerGetStateTransitionsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof bankAccountLifecycleDebugControllerGetStateTransitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankAccountLifecycleDebugControllerGetStateTransitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankAccountLifecycleDebugControllerGetStateTransitionsQueryKey(options)
});

/**
 * Verify bank identifiers against the format rule (or as IBAN when no rule is given)
 */
export const validationControllerVerifyBankIdentifiersMutation = (options?: Partial<Options<ValidationControllerVerifyBankIdentifiersData>>): UseMutationOptions<ValidationControllerVerifyBankIdentifiersResponse, DefaultError, Options<ValidationControllerVerifyBankIdentifiersData>> => {
    const mutationOptions: UseMutationOptions<ValidationControllerVerifyBankIdentifiersResponse, DefaultError, Options<ValidationControllerVerifyBankIdentifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validationControllerVerifyBankIdentifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate TIN
 */
export const validationControllerValidateTinMutation = (options?: Partial<Options<ValidationControllerValidateTinData>>): UseMutationOptions<ValidationControllerValidateTinResponse, DefaultError, Options<ValidationControllerValidateTinData>> => {
    const mutationOptions: UseMutationOptions<ValidationControllerValidateTinResponse, DefaultError, Options<ValidationControllerValidateTinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validationControllerValidateTin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const vestingControllerGetVestingTermsQueryKey = (options?: Options<VestingControllerGetVestingTermsData>) => createQueryKey('vestingControllerGetVestingTerms', options);

/**
 * Get all vesting terms and their nested entities
 */
export const vestingControllerGetVestingTermsOptions = (options?: Options<VestingControllerGetVestingTermsData>) => queryOptions<VestingControllerGetVestingTermsResponse, DefaultError, VestingControllerGetVestingTermsResponse, ReturnType<typeof vestingControllerGetVestingTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vestingControllerGetVestingTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vestingControllerGetVestingTermsQueryKey(options)
});

/**
 * Create vesting term
 */
export const vestingControllerCreateVestingTermMutation = (options?: Partial<Options<VestingControllerCreateVestingTermData>>): UseMutationOptions<VestingControllerCreateVestingTermResponse, DefaultError, Options<VestingControllerCreateVestingTermData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerCreateVestingTermResponse, DefaultError, Options<VestingControllerCreateVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerCreateVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const vestingControllerGetSimplifiedVestingTermsQueryKey = (options?: Options<VestingControllerGetSimplifiedVestingTermsData>) => createQueryKey('vestingControllerGetSimplifiedVestingTerms', options);

/**
 * Get all vesting terms (basic data)
 */
export const vestingControllerGetSimplifiedVestingTermsOptions = (options?: Options<VestingControllerGetSimplifiedVestingTermsData>) => queryOptions<VestingControllerGetSimplifiedVestingTermsResponse, DefaultError, VestingControllerGetSimplifiedVestingTermsResponse, ReturnType<typeof vestingControllerGetSimplifiedVestingTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vestingControllerGetSimplifiedVestingTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vestingControllerGetSimplifiedVestingTermsQueryKey(options)
});

/**
 * Apply vesting start date to InvestmentWorkflow
 */
export const vestingControllerApplyVestingStartDateToInvestmentWorkflowMutation = (options?: Partial<Options<VestingControllerApplyVestingStartDateToInvestmentWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingStartDateToInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingStartDateToInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerApplyVestingStartDateToInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply vesting start date to transaction
 */
export const vestingControllerApplyVestingStartDateToTransactionMutation = (options?: Partial<Options<VestingControllerApplyVestingStartDateToTransactionData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingStartDateToTransactionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingStartDateToTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerApplyVestingStartDateToTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply a vesting term and start date to a transaction in one step
 */
export const vestingControllerSaveTransactionVestingMutation = (options?: Partial<Options<VestingControllerSaveTransactionVestingData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerSaveTransactionVestingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerSaveTransactionVestingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerSaveTransactionVesting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply vesting term to investmentWorkflow
 */
export const vestingControllerApplyVestingTermToInvestmentWorkflowMutation = (options?: Partial<Options<VestingControllerApplyVestingTermToInvestmentWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingTermToInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingTermToInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerApplyVestingTermToInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply vesting term to transaction
 */
export const vestingControllerApplyVestingTermToTransactionMutation = (options?: Partial<Options<VestingControllerApplyVestingTermToTransactionData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingTermToTransactionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerApplyVestingTermToTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerApplyVestingTermToTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove vesting term from investmentWorkflow
 */
export const vestingControllerRemoveVestingTermFromInvestmentWorkflowMutation = (options?: Partial<Options<VestingControllerRemoveVestingTermFromInvestmentWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerRemoveVestingTermFromInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerRemoveVestingTermFromInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerRemoveVestingTermFromInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove vesting term from transaction
 */
export const vestingControllerRemoveVestingTermFromTransactionMutation = (options?: Partial<Options<VestingControllerRemoveVestingTermFromTransactionData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerRemoveVestingTermFromTransactionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerRemoveVestingTermFromTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerRemoveVestingTermFromTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update vesting for investors
 */
export const vestingControllerBulkUpdateInvestorsVestingMutation = (options?: Partial<Options<VestingControllerBulkUpdateInvestorsVestingData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerBulkUpdateInvestorsVestingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerBulkUpdateInvestorsVestingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerBulkUpdateInvestorsVesting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete vesting term
 */
export const vestingControllerDeleteVestingTermMutation = (options?: Partial<Options<VestingControllerDeleteVestingTermData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerDeleteVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update vesting term
 */
export const vestingControllerUpdateVestingTermMutation = (options?: Partial<Options<VestingControllerUpdateVestingTermData>>): UseMutationOptions<VestingControllerUpdateVestingTermResponse, DefaultError, Options<VestingControllerUpdateVestingTermData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerUpdateVestingTermResponse, DefaultError, Options<VestingControllerUpdateVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerUpdateVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create vesting term graded
 */
export const vestingControllerCreateVestingTermGradedMutation = (options?: Partial<Options<VestingControllerCreateVestingTermGradedData>>): UseMutationOptions<VestingControllerCreateVestingTermGradedResponse, DefaultError, Options<VestingControllerCreateVestingTermGradedData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerCreateVestingTermGradedResponse, DefaultError, Options<VestingControllerCreateVestingTermGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerCreateVestingTermGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete vesting term graded
 */
export const vestingControllerDeleteVestingTermGradedMutation = (options?: Partial<Options<VestingControllerDeleteVestingTermGradedData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermGradedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerDeleteVestingTermGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update vesting term graded
 */
export const vestingControllerUpdateVestingTermGradedMutation = (options?: Partial<Options<VestingControllerUpdateVestingTermGradedData>>): UseMutationOptions<VestingControllerUpdateVestingTermGradedResponse, DefaultError, Options<VestingControllerUpdateVestingTermGradedData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerUpdateVestingTermGradedResponse, DefaultError, Options<VestingControllerUpdateVestingTermGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerUpdateVestingTermGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create vesting term straight line
 */
export const vestingControllerCreateVestingTermStraightLineMutation = (options?: Partial<Options<VestingControllerCreateVestingTermStraightLineData>>): UseMutationOptions<VestingControllerCreateVestingTermStraightLineResponse, DefaultError, Options<VestingControllerCreateVestingTermStraightLineData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerCreateVestingTermStraightLineResponse, DefaultError, Options<VestingControllerCreateVestingTermStraightLineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerCreateVestingTermStraightLine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete vesting term straight line
 */
export const vestingControllerDeleteVestingTermStraightLineMutation = (options?: Partial<Options<VestingControllerDeleteVestingTermStraightLineData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermStraightLineData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermStraightLineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerDeleteVestingTermStraightLine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update vesting term straight line
 */
export const vestingControllerUpdateVestingTermStraightLineMutation = (options?: Partial<Options<VestingControllerUpdateVestingTermStraightLineData>>): UseMutationOptions<VestingControllerUpdateVestingTermStraightLineResponse, DefaultError, Options<VestingControllerUpdateVestingTermStraightLineData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerUpdateVestingTermStraightLineResponse, DefaultError, Options<VestingControllerUpdateVestingTermStraightLineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerUpdateVestingTermStraightLine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create vesting term leaver provision
 */
export const vestingControllerCreateVestingTermLeaverProvisionMutation = (options?: Partial<Options<VestingControllerCreateVestingTermLeaverProvisionData>>): UseMutationOptions<VestingControllerCreateVestingTermLeaverProvisionResponse, DefaultError, Options<VestingControllerCreateVestingTermLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerCreateVestingTermLeaverProvisionResponse, DefaultError, Options<VestingControllerCreateVestingTermLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerCreateVestingTermLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete vesting term leaver provision
 */
export const vestingControllerDeleteVestingTermLeaverProvisionMutation = (options?: Partial<Options<VestingControllerDeleteVestingTermLeaverProvisionData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeleteVestingTermLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerDeleteVestingTermLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update vesting term leaver provision
 */
export const vestingControllerUpdateVestingTermLeaverProvisionMutation = (options?: Partial<Options<VestingControllerUpdateVestingTermLeaverProvisionData>>): UseMutationOptions<VestingControllerUpdateVestingTermLeaverProvisionResponse, DefaultError, Options<VestingControllerUpdateVestingTermLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerUpdateVestingTermLeaverProvisionResponse, DefaultError, Options<VestingControllerUpdateVestingTermLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerUpdateVestingTermLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update performance vesting for a vesting term
 */
export const vestingControllerUpsertPerformanceVestingMutation = (options?: Partial<Options<VestingControllerUpsertPerformanceVestingData>>): UseMutationOptions<VestingControllerUpsertPerformanceVestingResponse, DefaultError, Options<VestingControllerUpsertPerformanceVestingData>> => {
    const mutationOptions: UseMutationOptions<VestingControllerUpsertPerformanceVestingResponse, DefaultError, Options<VestingControllerUpsertPerformanceVestingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerUpsertPerformanceVesting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete performance vesting for a vesting term
 */
export const vestingControllerDeletePerformanceVestingMutation = (options?: Partial<Options<VestingControllerDeletePerformanceVestingData>>): UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeletePerformanceVestingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<VestingControllerDeletePerformanceVestingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vestingControllerDeletePerformanceVesting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bankAccountFormatRuleControllerGetSupportedCountriesQueryKey = (options?: Options<BankAccountFormatRuleControllerGetSupportedCountriesData>) => createQueryKey('bankAccountFormatRuleControllerGetSupportedCountries', options);

/**
 * List countries with an active bank account format rule
 */
export const bankAccountFormatRuleControllerGetSupportedCountriesOptions = (options?: Options<BankAccountFormatRuleControllerGetSupportedCountriesData>) => queryOptions<BankAccountFormatRuleControllerGetSupportedCountriesResponse, DefaultError, BankAccountFormatRuleControllerGetSupportedCountriesResponse, ReturnType<typeof bankAccountFormatRuleControllerGetSupportedCountriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankAccountFormatRuleControllerGetSupportedCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankAccountFormatRuleControllerGetSupportedCountriesQueryKey(options)
});

export const bankAccountFormatRuleControllerGetFormatRulesQueryKey = (options: Options<BankAccountFormatRuleControllerGetFormatRulesData>) => createQueryKey('bankAccountFormatRuleControllerGetFormatRules', options);

/**
 * Active bank account format rules for a country, ordered for display
 */
export const bankAccountFormatRuleControllerGetFormatRulesOptions = (options: Options<BankAccountFormatRuleControllerGetFormatRulesData>) => queryOptions<BankAccountFormatRuleControllerGetFormatRulesResponse, DefaultError, BankAccountFormatRuleControllerGetFormatRulesResponse, ReturnType<typeof bankAccountFormatRuleControllerGetFormatRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankAccountFormatRuleControllerGetFormatRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankAccountFormatRuleControllerGetFormatRulesQueryKey(options)
});

/**
 * Create one schema session for transactions upload
 */
export const oneSchemaControllerCreateOneSchemaTransactionsSessionMutation = (options?: Partial<Options<OneSchemaControllerCreateOneSchemaTransactionsSessionData>>): UseMutationOptions<OneSchemaControllerCreateOneSchemaTransactionsSessionResponse, DefaultError, Options<OneSchemaControllerCreateOneSchemaTransactionsSessionData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerCreateOneSchemaTransactionsSessionResponse, DefaultError, Options<OneSchemaControllerCreateOneSchemaTransactionsSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerCreateOneSchemaTransactionsSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webhook: Validate transactions for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaTransactionRowsMutation = (options?: Partial<Options<OneSchemaControllerValidateOneSchemaTransactionRowsData>>): UseMutationOptions<OneSchemaControllerValidateOneSchemaTransactionRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaTransactionRowsData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerValidateOneSchemaTransactionRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaTransactionRowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerValidateOneSchemaTransactionRows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create one schema session for persons upload
 */
export const oneSchemaControllerCreateOneSchemaPersonsSessionMutation = (options?: Partial<Options<OneSchemaControllerCreateOneSchemaPersonsSessionData>>): UseMutationOptions<OneSchemaControllerCreateOneSchemaPersonsSessionResponse, DefaultError, Options<OneSchemaControllerCreateOneSchemaPersonsSessionData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerCreateOneSchemaPersonsSessionResponse, DefaultError, Options<OneSchemaControllerCreateOneSchemaPersonsSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerCreateOneSchemaPersonsSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webhook: Validate legal persons for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaLegalPersonsRowsMutation = (options?: Partial<Options<OneSchemaControllerValidateOneSchemaLegalPersonsRowsData>>): UseMutationOptions<OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaLegalPersonsRowsData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaLegalPersonsRowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerValidateOneSchemaLegalPersonsRows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webhook: Validate natural persons for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaNaturalPersonsRowsMutation = (options?: Partial<Options<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData>>): UseMutationOptions<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerValidateOneSchemaNaturalPersonsRows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prepare one schema cache for management loans upload
 */
export const oneSchemaControllerPrepareOneSchemaManagementLoansCacheMutation = (options?: Partial<Options<OneSchemaControllerPrepareOneSchemaManagementLoansCacheData>>): UseMutationOptions<unknown, DefaultError, Options<OneSchemaControllerPrepareOneSchemaManagementLoansCacheData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OneSchemaControllerPrepareOneSchemaManagementLoansCacheData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerPrepareOneSchemaManagementLoansCache({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webhook: Validate management loans for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaManagementLoansRowsMutation = (options?: Partial<Options<OneSchemaControllerValidateOneSchemaManagementLoansRowsData>>): UseMutationOptions<OneSchemaControllerValidateOneSchemaManagementLoansRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaManagementLoansRowsData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerValidateOneSchemaManagementLoansRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaManagementLoansRowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerValidateOneSchemaManagementLoansRows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prepare one schema cache for share associations upload
 */
export const oneSchemaControllerPrepareOneSchemaShareAssociationsCacheMutation = (options?: Partial<Options<OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData>>): UseMutationOptions<unknown, DefaultError, Options<OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerPrepareOneSchemaShareAssociationsCache({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webhook: Validate share associations for bulk upload
 */
export const oneSchemaControllerValidateOneSchemaShareAssociationRowsMutation = (options?: Partial<Options<OneSchemaControllerValidateOneSchemaShareAssociationRowsData>>): UseMutationOptions<OneSchemaControllerValidateOneSchemaShareAssociationRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaShareAssociationRowsData>> => {
    const mutationOptions: UseMutationOptions<OneSchemaControllerValidateOneSchemaShareAssociationRowsResponse, DefaultError, Options<OneSchemaControllerValidateOneSchemaShareAssociationRowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await oneSchemaControllerValidateOneSchemaShareAssociationRows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload file
 */
export const fileControllerCreateFileMutation = (options?: Partial<Options<FileControllerCreateFileData>>): UseMutationOptions<FileControllerCreateFileResponse, DefaultError, Options<FileControllerCreateFileData>> => {
    const mutationOptions: UseMutationOptions<FileControllerCreateFileResponse, DefaultError, Options<FileControllerCreateFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileControllerCreateFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fileControllerDownloadFileQueryKey = (options: Options<FileControllerDownloadFileData>) => createQueryKey('fileControllerDownloadFile', options);

/**
 * Download file
 */
export const fileControllerDownloadFileOptions = (options: Options<FileControllerDownloadFileData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof fileControllerDownloadFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fileControllerDownloadFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fileControllerDownloadFileQueryKey(options)
});

/**
 * Download file url
 */
export const fileControllerDownloadPreSignedUrlMutation = (options?: Partial<Options<FileControllerDownloadPreSignedUrlData>>): UseMutationOptions<unknown, DefaultError, Options<FileControllerDownloadPreSignedUrlData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<FileControllerDownloadPreSignedUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileControllerDownloadPreSignedUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download files in zip archive
 */
export const fileControllerBulkDownloadFilesMutation = (options?: Partial<Options<FileControllerBulkDownloadFilesData>>): UseMutationOptions<unknown, DefaultError, Options<FileControllerBulkDownloadFilesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<FileControllerBulkDownloadFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileControllerBulkDownloadFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fileControllerGetFileDownloadUrlQueryKey = (options: Options<FileControllerGetFileDownloadUrlData>) => createQueryKey('fileControllerGetFileDownloadUrl', options);

export const fileControllerGetFileDownloadUrlOptions = (options: Options<FileControllerGetFileDownloadUrlData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof fileControllerGetFileDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fileControllerGetFileDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fileControllerGetFileDownloadUrlQueryKey(options)
});

/**
 * Upload signature image file
 */
export const fileControllerCreateSignatureFileMutation = (options?: Partial<Options<FileControllerCreateSignatureFileData>>): UseMutationOptions<FileControllerCreateSignatureFileResponse, DefaultError, Options<FileControllerCreateSignatureFileData>> => {
    const mutationOptions: UseMutationOptions<FileControllerCreateSignatureFileResponse, DefaultError, Options<FileControllerCreateSignatureFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileControllerCreateSignatureFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke InvestmentWorkflow
 */
export const godmodeControllerPostReassignInvestorMutation = (options?: Partial<Options<GodmodeControllerPostReassignInvestorData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostReassignInvestorData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostReassignInvestorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostReassignInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetAllInvestorsQueryKey = (options: Options<GodmodeControllerGetAllInvestorsData>) => createQueryKey('godmodeControllerGetAllInvestors', options);

/**
 * Fetch all users data
 */
export const godmodeControllerGetAllInvestorsOptions = (options: Options<GodmodeControllerGetAllInvestorsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof godmodeControllerGetAllInvestorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetAllInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetAllInvestorsQueryKey(options)
});

/**
 * Fetch active MIPs data
 */
export const godmodeControllerGetActiveMipsMutation = (options?: Partial<Options<GodmodeControllerGetActiveMipsData>>): UseMutationOptions<GodmodeControllerGetActiveMipsResponse, DefaultError, Options<GodmodeControllerGetActiveMipsData>> => {
    const mutationOptions: UseMutationOptions<GodmodeControllerGetActiveMipsResponse, DefaultError, Options<GodmodeControllerGetActiveMipsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerGetActiveMips({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerDownloadFileQueryKey = (options: Options<GodmodeControllerDownloadFileData>) => createQueryKey('godmodeControllerDownloadFile', options);

/**
 * Download file
 */
export const godmodeControllerDownloadFileOptions = (options: Options<GodmodeControllerDownloadFileData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof godmodeControllerDownloadFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerDownloadFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerDownloadFileQueryKey(options)
});

/**
 * Revoke InvestmentWorkflow
 */
export const godmodeControllerPostRevokeTsaMutation = (options?: Partial<Options<GodmodeControllerPostRevokeTsaData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostRevokeTsaData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostRevokeTsaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostRevokeTsa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete InvestmentWorkflow
 */
export const godmodeControllerPostSoftDeleteTsaMutation = (options?: Partial<Options<GodmodeControllerPostSoftDeleteTsaData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostSoftDeleteTsaData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostSoftDeleteTsaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostSoftDeleteTsa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove investor
 */
export const godmodeControllerPostRemoveInvestorMutation = (options?: Partial<Options<GodmodeControllerPostRemoveInvestorData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostRemoveInvestorData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostRemoveInvestorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostRemoveInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete user
 */
export const godmodeControllerDeleteUserSoftMutation = (options?: Partial<Options<GodmodeControllerDeleteUserSoftData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerDeleteUserSoftData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerDeleteUserSoftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerDeleteUserSoft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace file
 */
export const godmodeControllerReplaceFileMutation = (options?: Partial<Options<GodmodeControllerReplaceFileData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerReplaceFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerReplaceFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerReplaceFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerIsAnyActiveInvestorInMipQueryKey = (options: Options<GodmodeControllerIsAnyActiveInvestorInMipData>) => createQueryKey('godmodeControllerIsAnyActiveInvestorInMip', options);

/**
 * Is any investor on state COLLECT_AND_APPROVE
 */
export const godmodeControllerIsAnyActiveInvestorInMipOptions = (options: Options<GodmodeControllerIsAnyActiveInvestorInMipData>) => queryOptions<GodmodeControllerIsAnyActiveInvestorInMipResponse, DefaultError, GodmodeControllerIsAnyActiveInvestorInMipResponse, ReturnType<typeof godmodeControllerIsAnyActiveInvestorInMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerIsAnyActiveInvestorInMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerIsAnyActiveInvestorInMipQueryKey(options)
});

export const godmodeControllerIsAnyInvitedInvestorInMipQueryKey = (options: Options<GodmodeControllerIsAnyInvitedInvestorInMipData>) => createQueryKey('godmodeControllerIsAnyInvitedInvestorInMip', options);

/**
 * Is any investor invited to Programme
 */
export const godmodeControllerIsAnyInvitedInvestorInMipOptions = (options: Options<GodmodeControllerIsAnyInvitedInvestorInMipData>) => queryOptions<GodmodeControllerIsAnyInvitedInvestorInMipResponse, DefaultError, GodmodeControllerIsAnyInvitedInvestorInMipResponse, ReturnType<typeof godmodeControllerIsAnyInvitedInvestorInMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerIsAnyInvitedInvestorInMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerIsAnyInvitedInvestorInMipQueryKey(options)
});

export const godmodeControllerGetFileInfoQueryKey = (options: Options<GodmodeControllerGetFileInfoData>) => createQueryKey('godmodeControllerGetFileInfo', options);

/**
 * Get file info
 */
export const godmodeControllerGetFileInfoOptions = (options: Options<GodmodeControllerGetFileInfoData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof godmodeControllerGetFileInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetFileInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetFileInfoQueryKey(options)
});

export const godmodeControllerGetAllInvestorDataQueryKey = (options: Options<GodmodeControllerGetAllInvestorDataData>) => createQueryKey('godmodeControllerGetAllInvestorData', options);

/**
 * Fetch all investor data
 */
export const godmodeControllerGetAllInvestorDataOptions = (options: Options<GodmodeControllerGetAllInvestorDataData>) => queryOptions<GodmodeControllerGetAllInvestorDataResponse, DefaultError, GodmodeControllerGetAllInvestorDataResponse, ReturnType<typeof godmodeControllerGetAllInvestorDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetAllInvestorData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetAllInvestorDataQueryKey(options)
});

/**
 * Update Investor Personal Details
 */
export const godmodeControllerUpdateInvestorPersonalDetailsMutation = (options?: Partial<Options<GodmodeControllerUpdateInvestorPersonalDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateInvestorPersonalDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateInvestorPersonalDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateInvestorPersonalDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetAllInvestorsForMipQueryKey = (options: Options<GodmodeControllerGetAllInvestorsForMipData>) => createQueryKey('godmodeControllerGetAllInvestorsForMip', options);

/**
 * Fetch all investors data for specified mipId
 */
export const godmodeControllerGetAllInvestorsForMipOptions = (options: Options<GodmodeControllerGetAllInvestorsForMipData>) => queryOptions<GodmodeControllerGetAllInvestorsForMipResponse, DefaultError, GodmodeControllerGetAllInvestorsForMipResponse, ReturnType<typeof godmodeControllerGetAllInvestorsForMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetAllInvestorsForMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetAllInvestorsForMipQueryKey(options)
});

export const godmodeControllerGetUserDataQueryKey = (options: Options<GodmodeControllerGetUserDataData>) => createQueryKey('godmodeControllerGetUserData', options);

/**
 * Fetch user by id data
 */
export const godmodeControllerGetUserDataOptions = (options: Options<GodmodeControllerGetUserDataData>) => queryOptions<GodmodeControllerGetUserDataResponse, DefaultError, GodmodeControllerGetUserDataResponse, ReturnType<typeof godmodeControllerGetUserDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetUserData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetUserDataQueryKey(options)
});

export const godmodeControllerGetMipDataQueryKey = (options: Options<GodmodeControllerGetMipDataData>) => createQueryKey('godmodeControllerGetMipData', options);

/**
 * Fetch all mip data
 */
export const godmodeControllerGetMipDataOptions = (options: Options<GodmodeControllerGetMipDataData>) => queryOptions<GodmodeControllerGetMipDataResponse, DefaultError, GodmodeControllerGetMipDataResponse, ReturnType<typeof godmodeControllerGetMipDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetMipData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetMipDataQueryKey(options)
});

export const godmodeControllerGetInvestorsFromMipQueryKey = (options: Options<GodmodeControllerGetInvestorsFromMipData>) => createQueryKey('godmodeControllerGetInvestorsFromMip', options);

/**
 * Fetch all investors with InvestmentWorkflow from MIP
 */
export const godmodeControllerGetInvestorsFromMipOptions = (options: Options<GodmodeControllerGetInvestorsFromMipData>) => queryOptions<GodmodeControllerGetInvestorsFromMipResponse, DefaultError, GodmodeControllerGetInvestorsFromMipResponse, ReturnType<typeof godmodeControllerGetInvestorsFromMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetInvestorsFromMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetInvestorsFromMipQueryKey(options)
});

export const godmodeControllerGetMipCustomDetailsDataWithoutFormsQueryKey = (options: Options<GodmodeControllerGetMipCustomDetailsDataWithoutFormsData>) => createQueryKey('godmodeControllerGetMipCustomDetailsDataWithoutForms', options);

/**
 * Fetch mip with custom details data without forms
 */
export const godmodeControllerGetMipCustomDetailsDataWithoutFormsOptions = (options: Options<GodmodeControllerGetMipCustomDetailsDataWithoutFormsData>) => queryOptions<GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponse, DefaultError, GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponse, ReturnType<typeof godmodeControllerGetMipCustomDetailsDataWithoutFormsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetMipCustomDetailsDataWithoutForms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetMipCustomDetailsDataWithoutFormsQueryKey(options)
});

export const godmodeControllerGetInvestorPersonalDetailsDataByUserIdQueryKey = (options: Options<GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData>) => createQueryKey('godmodeControllerGetInvestorPersonalDetailsDataByUserId', options);

/**
 * Fetch investor personal details by userId
 */
export const godmodeControllerGetInvestorPersonalDetailsDataByUserIdOptions = (options: Options<GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData>) => queryOptions<GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponse, DefaultError, GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponse, ReturnType<typeof godmodeControllerGetInvestorPersonalDetailsDataByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetInvestorPersonalDetailsDataByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetInvestorPersonalDetailsDataByUserIdQueryKey(options)
});

/**
 * Remove investors personal details
 */
export const godmodeControllerRemoveInvestorPersonalDetailsMutation = (options?: Partial<Options<GodmodeControllerRemoveInvestorPersonalDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerRemoveInvestorPersonalDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerRemoveInvestorPersonalDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerRemoveInvestorPersonalDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update custom detail type
 */
export const godmodeControllerUpdateCustomDetailTypeMutation = (options?: Partial<Options<GodmodeControllerUpdateCustomDetailTypeData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateCustomDetailTypeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateCustomDetailTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateCustomDetailType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetAllNotDeletedProjectsQueryKey = (options?: Options<GodmodeControllerGetAllNotDeletedProjectsData>) => createQueryKey('godmodeControllerGetAllNotDeletedProjects', options);

/**
 * Get list of all not deleted projects
 */
export const godmodeControllerGetAllNotDeletedProjectsOptions = (options?: Options<GodmodeControllerGetAllNotDeletedProjectsData>) => queryOptions<GodmodeControllerGetAllNotDeletedProjectsResponse, DefaultError, GodmodeControllerGetAllNotDeletedProjectsResponse, ReturnType<typeof godmodeControllerGetAllNotDeletedProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetAllNotDeletedProjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetAllNotDeletedProjectsQueryKey(options)
});

export const godmodeControllerGetDealsListQueryKey = (options?: Options<GodmodeControllerGetDealsListData>) => createQueryKey('godmodeControllerGetDealsList', options);

/**
 * Get list of deals
 */
export const godmodeControllerGetDealsListOptions = (options?: Options<GodmodeControllerGetDealsListData>) => queryOptions<GodmodeControllerGetDealsListResponse, DefaultError, GodmodeControllerGetDealsListResponse, ReturnType<typeof godmodeControllerGetDealsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetDealsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetDealsListQueryKey(options)
});

export const godmodeControllerGetDealQueryKey = (options: Options<GodmodeControllerGetDealData>) => createQueryKey('godmodeControllerGetDeal', options);

/**
 * Get deal by MIP id
 */
export const godmodeControllerGetDealOptions = (options: Options<GodmodeControllerGetDealData>) => queryOptions<GodmodeControllerGetDealResponse, DefaultError, GodmodeControllerGetDealResponse, ReturnType<typeof godmodeControllerGetDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetDealQueryKey(options)
});

/**
 * Update deal for MIP
 */
export const godmodeControllerChangeDealMutation = (options?: Partial<Options<GodmodeControllerChangeDealData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerChangeDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerChangeDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerChangeDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update user first and last name
 */
export const godmodeControllerUpdateUserNameMutation = (options?: Partial<Options<GodmodeControllerUpdateUserNameData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateUserNameData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateUserNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateUserName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update user email
 */
export const godmodeControllerUpdateUserEmailMutation = (options?: Partial<Options<GodmodeControllerUpdateUserEmailData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateUserEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateUserEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateUserEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Un archive deal and programmes and sets them in draft. All OpenFGA relations and resources need to be re-added in OpenFGA to activate the permission system
 */
export const godmodeControllerUnArchiveDealAndMipsMutation = (options?: Partial<Options<GodmodeControllerUnArchiveDealAndMipsData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUnArchiveDealAndMipsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUnArchiveDealAndMipsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUnArchiveDealAndMips({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete programme and investors. Removes all OpenFGA relations and resources from FGA
 */
export const godmodeControllerSoftDeleteMipMutation = (options?: Partial<Options<GodmodeControllerSoftDeleteMipData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerSoftDeleteMipData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerSoftDeleteMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerSoftDeleteMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update isKycRequired status
 */
export const godmodeControllerUpdateMipKycOptionalMutation = (options?: Partial<Options<GodmodeControllerUpdateMipKycOptionalData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateMipKycOptionalData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateMipKycOptionalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateMipKycOptional({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update isLocked flag
 */
export const godmodeControllerUpdateIsLockedMutation = (options?: Partial<Options<GodmodeControllerUpdateIsLockedData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateIsLockedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateIsLockedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateIsLocked({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetMipListOfInvestmentsQueryKey = (options: Options<GodmodeControllerGetMipListOfInvestmentsData>) => createQueryKey('godmodeControllerGetMipListOfInvestments', options);

/**
 * Get list of Investments under MIP
 */
export const godmodeControllerGetMipListOfInvestmentsOptions = (options: Options<GodmodeControllerGetMipListOfInvestmentsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof godmodeControllerGetMipListOfInvestmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetMipListOfInvestments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetMipListOfInvestmentsQueryKey(options)
});

/**
 * Upload Bulk Edit MIP Investments file
 */
export const godmodeControllerPostBulkEditMipInvestmentsMutation = (options?: Partial<Options<GodmodeControllerPostBulkEditMipInvestmentsData>>): UseMutationOptions<GodmodeControllerPostBulkEditMipInvestmentsResponse, DefaultError, Options<GodmodeControllerPostBulkEditMipInvestmentsData>> => {
    const mutationOptions: UseMutationOptions<GodmodeControllerPostBulkEditMipInvestmentsResponse, DefaultError, Options<GodmodeControllerPostBulkEditMipInvestmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostBulkEditMipInvestments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete Deal, MIPs and investors
 */
export const godmodeControllerUpdateDealMipsInvestorsDeletedMutation = (options?: Partial<Options<GodmodeControllerUpdateDealMipsInvestorsDeletedData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateDealMipsInvestorsDeletedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateDealMipsInvestorsDeletedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateDealMipsInvestorsDeleted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetDealWithActiveMipsQueryKey = (options: Options<GodmodeControllerGetDealWithActiveMipsData>) => createQueryKey('godmodeControllerGetDealWithActiveMips', options);

/**
 * Get deal data with active MIPs inside it
 */
export const godmodeControllerGetDealWithActiveMipsOptions = (options: Options<GodmodeControllerGetDealWithActiveMipsData>) => queryOptions<GodmodeControllerGetDealWithActiveMipsResponse, DefaultError, GodmodeControllerGetDealWithActiveMipsResponse, ReturnType<typeof godmodeControllerGetDealWithActiveMipsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetDealWithActiveMips({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetDealWithActiveMipsQueryKey(options)
});

export const godmodeControllerGetInvestmentWorkflowsQueryKey = (options: Options<GodmodeControllerGetInvestmentWorkflowsData>) => createQueryKey('godmodeControllerGetInvestmentWorkflows', options);

/**
 * Fetch investor transaction share association
 */
export const godmodeControllerGetInvestmentWorkflowsOptions = (options: Options<GodmodeControllerGetInvestmentWorkflowsData>) => queryOptions<GodmodeControllerGetInvestmentWorkflowsResponse, DefaultError, GodmodeControllerGetInvestmentWorkflowsResponse, ReturnType<typeof godmodeControllerGetInvestmentWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetInvestmentWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetInvestmentWorkflowsQueryKey(options)
});

/**
 * Update share associations
 */
export const godmodeControllerUpdateShareAssociationsMutation = (options?: Partial<Options<GodmodeControllerUpdateShareAssociationsData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateShareAssociationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerUpdateShareAssociationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUpdateShareAssociations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload file
 */
export const godmodeControllerUploadPdfFileMutation = (options?: Partial<Options<GodmodeControllerUploadPdfFileData>>): UseMutationOptions<GodmodeControllerUploadPdfFileResponse, DefaultError, Options<GodmodeControllerUploadPdfFileData>> => {
    const mutationOptions: UseMutationOptions<GodmodeControllerUploadPdfFileResponse, DefaultError, Options<GodmodeControllerUploadPdfFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerUploadPdfFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const godmodeControllerGetMipListOfLoansQueryKey = (options: Options<GodmodeControllerGetMipListOfLoansData>) => createQueryKey('godmodeControllerGetMipListOfLoans', options);

/**
 * Get list of Loans under MIP
 */
export const godmodeControllerGetMipListOfLoansOptions = (options: Options<GodmodeControllerGetMipListOfLoansData>) => queryOptions<GodmodeControllerGetMipListOfLoansResponse, DefaultError, GodmodeControllerGetMipListOfLoansResponse, ReturnType<typeof godmodeControllerGetMipListOfLoansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await godmodeControllerGetMipListOfLoans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: godmodeControllerGetMipListOfLoansQueryKey(options)
});

/**
 * Upload Bulk Update MIP Loans file
 */
export const godmodeControllerPostBulkUpdateMipLoansMutation = (options?: Partial<Options<GodmodeControllerPostBulkUpdateMipLoansData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostBulkUpdateMipLoansData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerPostBulkUpdateMipLoansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerPostBulkUpdateMipLoans({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create InvestmentWorkflow
 */
export const godmodeControllerBulkCreateTsaForMipMutation = (options?: Partial<Options<GodmodeControllerBulkCreateTsaForMipData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerBulkCreateTsaForMipData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerBulkCreateTsaForMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerBulkCreateTsaForMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add custom details and attach them to investors
 */
export const godmodeControllerCreateCustomDetailsMutation = (options?: Partial<Options<GodmodeControllerCreateCustomDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerCreateCustomDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerCreateCustomDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerCreateCustomDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete kyc file
 */
export const godmodeControllerSoftDeleteKycFileMutation = (options?: Partial<Options<GodmodeControllerSoftDeleteKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerSoftDeleteKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GodmodeControllerSoftDeleteKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await godmodeControllerSoftDeleteKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const workOsEventsAdminControllerListWorkOsEventsQueryKey = (options?: Options<WorkOsEventsAdminControllerListWorkOsEventsData>) => createQueryKey('workOsEventsAdminControllerListWorkOsEvents', options);

/**
 * List ingested WorkOS events, newest first
 *
 * Payloads are returned verbatim and may contain PII (email, IP) - super admin only.
 */
export const workOsEventsAdminControllerListWorkOsEventsOptions = (options?: Options<WorkOsEventsAdminControllerListWorkOsEventsData>) => queryOptions<WorkOsEventsAdminControllerListWorkOsEventsResponse, DefaultError, WorkOsEventsAdminControllerListWorkOsEventsResponse, ReturnType<typeof workOsEventsAdminControllerListWorkOsEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await workOsEventsAdminControllerListWorkOsEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: workOsEventsAdminControllerListWorkOsEventsQueryKey(options)
});

/**
 * Requeue a WorkOS event for another pass (FAILED -> PENDING, attempts reset)
 */
export const workOsEventsAdminControllerReplayWorkOsEventMutation = (options?: Partial<Options<WorkOsEventsAdminControllerReplayWorkOsEventData>>): UseMutationOptions<WorkOsEventsAdminControllerReplayWorkOsEventResponse, DefaultError, Options<WorkOsEventsAdminControllerReplayWorkOsEventData>> => {
    const mutationOptions: UseMutationOptions<WorkOsEventsAdminControllerReplayWorkOsEventResponse, DefaultError, Options<WorkOsEventsAdminControllerReplayWorkOsEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workOsEventsAdminControllerReplayWorkOsEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailChangeEligibilityControllerGetEmailChangeEligibilityQueryKey = (options: Options<EmailChangeEligibilityControllerGetEmailChangeEligibilityData>) => createQueryKey('emailChangeEligibilityControllerGetEmailChangeEligibility', options);

/**
 * Whether the platform may change the email address of this user
 *
 * Local read of the WorkOS organization-domain projection. Pass targetEmail to also check the destination domain and a DealStack address collision. The write path re-checks authoritatively against WorkOS before it changes anything.
 */
export const emailChangeEligibilityControllerGetEmailChangeEligibilityOptions = (options: Options<EmailChangeEligibilityControllerGetEmailChangeEligibilityData>) => queryOptions<EmailChangeEligibilityControllerGetEmailChangeEligibilityResponse, DefaultError, EmailChangeEligibilityControllerGetEmailChangeEligibilityResponse, ReturnType<typeof emailChangeEligibilityControllerGetEmailChangeEligibilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await emailChangeEligibilityControllerGetEmailChangeEligibility({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: emailChangeEligibilityControllerGetEmailChangeEligibilityQueryKey(options)
});

export const contractControllerGetContractAndDocumentWorkflowFileNamesQueryKey = (options?: Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>) => createQueryKey('contractControllerGetContractAndDocumentWorkflowFileNames', options);

/**
 * Get a list of contractFile and documentWorkflowFile names to filter on
 */
export const contractControllerGetContractAndDocumentWorkflowFileNamesOptions = (options?: Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>) => queryOptions<ContractControllerGetContractAndDocumentWorkflowFileNamesResponse, DefaultError, ContractControllerGetContractAndDocumentWorkflowFileNamesResponse, ReturnType<typeof contractControllerGetContractAndDocumentWorkflowFileNamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contractControllerGetContractAndDocumentWorkflowFileNames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contractControllerGetContractAndDocumentWorkflowFileNamesQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const contractControllerGetContractAndDocumentWorkflowFileNamesInfiniteQueryKey = (options?: Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>): QueryKey<Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>> => createQueryKey('contractControllerGetContractAndDocumentWorkflowFileNames', options, true);

/**
 * Get a list of contractFile and documentWorkflowFile names to filter on
 */
export const contractControllerGetContractAndDocumentWorkflowFileNamesInfiniteOptions = (options?: Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>) => infiniteQueryOptions<ContractControllerGetContractAndDocumentWorkflowFileNamesResponse, DefaultError, InfiniteData<ContractControllerGetContractAndDocumentWorkflowFileNamesResponse>, QueryKey<Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>>, string | Pick<QueryKey<Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ContractControllerGetContractAndDocumentWorkflowFileNamesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await contractControllerGetContractAndDocumentWorkflowFileNames({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contractControllerGetContractAndDocumentWorkflowFileNamesInfiniteQueryKey(options)
});

export const contractDraftControllerGetContractsQueryKey = (options?: Options<ContractDraftControllerGetContractsData>) => createQueryKey('contractDraftControllerGetContracts', options);

/**
 * Get contracts for requested mipId
 */
export const contractDraftControllerGetContractsOptions = (options?: Options<ContractDraftControllerGetContractsData>) => queryOptions<ContractDraftControllerGetContractsResponse, DefaultError, ContractDraftControllerGetContractsResponse, ReturnType<typeof contractDraftControllerGetContractsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contractDraftControllerGetContracts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contractDraftControllerGetContractsQueryKey(options)
});

/**
 * Create contract
 */
export const contractDraftControllerCreateContractMutation = (options?: Partial<Options<ContractDraftControllerCreateContractData>>): UseMutationOptions<ContractDraftControllerCreateContractResponse, DefaultError, Options<ContractDraftControllerCreateContractData>> => {
    const mutationOptions: UseMutationOptions<ContractDraftControllerCreateContractResponse, DefaultError, Options<ContractDraftControllerCreateContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contractDraftControllerCreateContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete contract by its id
 */
export const contractDraftControllerDeleteContractMutation = (options?: Partial<Options<ContractDraftControllerDeleteContractData>>): UseMutationOptions<unknown, DefaultError, Options<ContractDraftControllerDeleteContractData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ContractDraftControllerDeleteContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contractDraftControllerDeleteContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update contract by its id
 */
export const contractDraftControllerUpdateContractMutation = (options?: Partial<Options<ContractDraftControllerUpdateContractData>>): UseMutationOptions<ContractDraftControllerUpdateContractResponse, DefaultError, Options<ContractDraftControllerUpdateContractData>> => {
    const mutationOptions: UseMutationOptions<ContractDraftControllerUpdateContractResponse, DefaultError, Options<ContractDraftControllerUpdateContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contractDraftControllerUpdateContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowDraftInvestmentControllerGetDraftTemplatesQueryKey = (options: Options<DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData>) => createQueryKey('documentWorkflowDraftInvestmentControllerGetDraftTemplates', options);

/**
 * Get document workflow draft templates for the programme (new workflow)
 */
export const documentWorkflowDraftInvestmentControllerGetDraftTemplatesOptions = (options: Options<DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData>) => queryOptions<DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponse, DefaultError, DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponse, ReturnType<typeof documentWorkflowDraftInvestmentControllerGetDraftTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowDraftInvestmentControllerGetDraftTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowDraftInvestmentControllerGetDraftTemplatesQueryKey(options)
});

export const documentWorkflowControllerStreamProgrammeDocumentsQueryKey = (options: Options<DocumentWorkflowControllerStreamProgrammeDocumentsData>) => createQueryKey('documentWorkflowControllerStreamProgrammeDocuments', options);

/**
 * Stream document-change signals for a programme
 */
export const documentWorkflowControllerStreamProgrammeDocumentsOptions = (options: Options<DocumentWorkflowControllerStreamProgrammeDocumentsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof documentWorkflowControllerStreamProgrammeDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerStreamProgrammeDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerStreamProgrammeDocumentsQueryKey(options)
});

export const documentWorkflowControllerFindInvestmentProgrammeDocumentsQueryKey = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData>) => createQueryKey('documentWorkflowControllerFindInvestmentProgrammeDocuments', options);

/**
 * get investment programme documents
 */
export const documentWorkflowControllerFindInvestmentProgrammeDocumentsOptions = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData>) => queryOptions<DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponse, DefaultError, DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponse, ReturnType<typeof documentWorkflowControllerFindInvestmentProgrammeDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerFindInvestmentProgrammeDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerFindInvestmentProgrammeDocumentsQueryKey(options)
});

export const documentWorkflowControllerFindInvestmentProgrammeSigningRolesQueryKey = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData>) => createQueryKey('documentWorkflowControllerFindInvestmentProgrammeSigningRoles', options);

/**
 * Get signing roles for investment programme documents
 */
export const documentWorkflowControllerFindInvestmentProgrammeSigningRolesOptions = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData>) => queryOptions<DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponse, DefaultError, DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponse, ReturnType<typeof documentWorkflowControllerFindInvestmentProgrammeSigningRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerFindInvestmentProgrammeSigningRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerFindInvestmentProgrammeSigningRolesQueryKey(options)
});

/**
 * bulk export excel
 */
export const documentWorkflowControllerBulkExportToExcelMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkExportToExcelData>>): UseMutationOptions<DocumentWorkflowControllerBulkExportToExcelResponse, DefaultError, Options<DocumentWorkflowControllerBulkExportToExcelData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkExportToExcelResponse, DefaultError, Options<DocumentWorkflowControllerBulkExportToExcelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkExportToExcel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerFindInvestmentProgrammeDocumentQueryKey = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentData>) => createQueryKey('documentWorkflowControllerFindInvestmentProgrammeDocument', options);

/**
 * Get a single investment programme document by instance ID
 */
export const documentWorkflowControllerFindInvestmentProgrammeDocumentOptions = (options: Options<DocumentWorkflowControllerFindInvestmentProgrammeDocumentData>) => queryOptions<DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponse, DefaultError, DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponse, ReturnType<typeof documentWorkflowControllerFindInvestmentProgrammeDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerFindInvestmentProgrammeDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerFindInvestmentProgrammeDocumentQueryKey(options)
});

export const documentWorkflowControllerFindDocumentWorkflowEventsQueryKey = (options: Options<DocumentWorkflowControllerFindDocumentWorkflowEventsData>) => createQueryKey('documentWorkflowControllerFindDocumentWorkflowEvents', options);

/**
 * Get document workflow event logs for a document instance
 */
export const documentWorkflowControllerFindDocumentWorkflowEventsOptions = (options: Options<DocumentWorkflowControllerFindDocumentWorkflowEventsData>) => queryOptions<DocumentWorkflowControllerFindDocumentWorkflowEventsResponse, DefaultError, DocumentWorkflowControllerFindDocumentWorkflowEventsResponse, ReturnType<typeof documentWorkflowControllerFindDocumentWorkflowEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerFindDocumentWorkflowEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerFindDocumentWorkflowEventsQueryKey(options)
});

/**
 * Replace the file on a completed document workflow instance (DealStack Support only)
 */
export const documentWorkflowControllerReplaceDocumentFileMutation = (options?: Partial<Options<DocumentWorkflowControllerReplaceDocumentFileData>>): UseMutationOptions<DocumentWorkflowControllerReplaceDocumentFileResponse, DefaultError, Options<DocumentWorkflowControllerReplaceDocumentFileData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerReplaceDocumentFileResponse, DefaultError, Options<DocumentWorkflowControllerReplaceDocumentFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerReplaceDocumentFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close a document the investor will not sign, recording the reason
 */
export const documentWorkflowControllerCloseDocumentWithoutSignatureMutation = (options?: Partial<Options<DocumentWorkflowControllerCloseDocumentWithoutSignatureData>>): UseMutationOptions<DocumentWorkflowControllerCloseDocumentWithoutSignatureResponse, DefaultError, Options<DocumentWorkflowControllerCloseDocumentWithoutSignatureData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerCloseDocumentWithoutSignatureResponse, DefaultError, Options<DocumentWorkflowControllerCloseDocumentWithoutSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerCloseDocumentWithoutSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign a user as a signer to a document workflow instance
 */
export const documentWorkflowControllerAssignUserToSignerMutation = (options?: Partial<Options<DocumentWorkflowControllerAssignUserToSignerData>>): UseMutationOptions<DocumentWorkflowControllerAssignUserToSignerResponse, DefaultError, Options<DocumentWorkflowControllerAssignUserToSignerData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerAssignUserToSignerResponse, DefaultError, Options<DocumentWorkflowControllerAssignUserToSignerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerAssignUserToSigner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign a user as a signer from a document workflow instance
 */
export const documentWorkflowControllerUnassignUserFromSignerMutation = (options?: Partial<Options<DocumentWorkflowControllerUnassignUserFromSignerData>>): UseMutationOptions<DocumentWorkflowControllerUnassignUserFromSignerResponse, DefaultError, Options<DocumentWorkflowControllerUnassignUserFromSignerData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerUnassignUserFromSignerResponse, DefaultError, Options<DocumentWorkflowControllerUnassignUserFromSignerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerUnassignUserFromSigner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerGetAddInvestorEligibilityQueryKey = (options: Options<DocumentWorkflowControllerGetAddInvestorEligibilityData>) => createQueryKey('documentWorkflowControllerGetAddInvestorEligibility', options);

/**
 * Whether an investor can be added to this in-flight document
 */
export const documentWorkflowControllerGetAddInvestorEligibilityOptions = (options: Options<DocumentWorkflowControllerGetAddInvestorEligibilityData>) => queryOptions<DocumentWorkflowControllerGetAddInvestorEligibilityResponse, DefaultError, DocumentWorkflowControllerGetAddInvestorEligibilityResponse, ReturnType<typeof documentWorkflowControllerGetAddInvestorEligibilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerGetAddInvestorEligibility({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerGetAddInvestorEligibilityQueryKey(options)
});

/**
 * Add investors to a multi-sign document already out for signature
 */
export const documentWorkflowControllerAddInvestorsMutation = (options?: Partial<Options<DocumentWorkflowControllerAddInvestorsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerAddInvestorsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerAddInvestorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerAddInvestors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerGetAddCounterpartyEligibilityQueryKey = (options: Options<DocumentWorkflowControllerGetAddCounterpartyEligibilityData>) => createQueryKey('documentWorkflowControllerGetAddCounterpartyEligibility', options);

/**
 * Whether a counterparty can be added to this in-flight document
 */
export const documentWorkflowControllerGetAddCounterpartyEligibilityOptions = (options: Options<DocumentWorkflowControllerGetAddCounterpartyEligibilityData>) => queryOptions<DocumentWorkflowControllerGetAddCounterpartyEligibilityResponse, DefaultError, DocumentWorkflowControllerGetAddCounterpartyEligibilityResponse, ReturnType<typeof documentWorkflowControllerGetAddCounterpartyEligibilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerGetAddCounterpartyEligibility({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerGetAddCounterpartyEligibilityQueryKey(options)
});

/**
 * Add a counterparty to a document already out for signature
 */
export const documentWorkflowControllerAddCounterpartyMutation = (options?: Partial<Options<DocumentWorkflowControllerAddCounterpartyData>>): UseMutationOptions<DocumentWorkflowControllerAddCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerAddCounterpartyData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerAddCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerAddCounterpartyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerAddCounterparty({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an outstanding, unsigned signature requirement from a document
 */
export const documentWorkflowControllerRemoveSignerMutation = (options?: Partial<Options<DocumentWorkflowControllerRemoveSignerData>>): UseMutationOptions<DocumentWorkflowControllerRemoveSignerResponse, DefaultError, Options<DocumentWorkflowControllerRemoveSignerData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerRemoveSignerResponse, DefaultError, Options<DocumentWorkflowControllerRemoveSignerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerRemoveSigner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get a presigned upload URL to sign a wet ink document
 */
export const documentWorkflowControllerSignWetInkDocumentUploadMutation = (options?: Partial<Options<DocumentWorkflowControllerSignWetInkDocumentUploadData>>): UseMutationOptions<DocumentWorkflowControllerSignWetInkDocumentUploadResponse, DefaultError, Options<DocumentWorkflowControllerSignWetInkDocumentUploadData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerSignWetInkDocumentUploadResponse, DefaultError, Options<DocumentWorkflowControllerSignWetInkDocumentUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSignWetInkDocumentUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign document (wet ink upload)
 */
export const documentWorkflowControllerSignWetInkDocumentMutation = (options?: Partial<Options<DocumentWorkflowControllerSignWetInkDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSignWetInkDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSignWetInkDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSignWetInkDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim an investor signature to sign on their behalf (Power of Attorney)
 */
export const documentWorkflowControllerClaimSignerMutation = (options?: Partial<Options<DocumentWorkflowControllerClaimSignerData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerClaimSignerData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerClaimSignerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerClaimSigner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get a presigned upload URL for a signable form submission
 */
export const documentWorkflowControllerSubmitFormUploadMutation = (options?: Partial<Options<DocumentWorkflowControllerSubmitFormUploadData>>): UseMutationOptions<DocumentWorkflowControllerSubmitFormUploadResponse, DefaultError, Options<DocumentWorkflowControllerSubmitFormUploadData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerSubmitFormUploadResponse, DefaultError, Options<DocumentWorkflowControllerSubmitFormUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSubmitFormUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit the filled signable form
 */
export const documentWorkflowControllerSubmitFormMutation = (options?: Partial<Options<DocumentWorkflowControllerSubmitFormData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSubmitFormData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSubmitFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSubmitForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw a signable form the investor uploaded but has not signed
 */
export const documentWorkflowControllerRemoveSubmittedFormMutation = (options?: Partial<Options<DocumentWorkflowControllerRemoveSubmittedFormData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerRemoveSubmittedFormData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerRemoveSubmittedFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerRemoveSubmittedForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * bulk download files
 */
export const documentWorkflowControllerBulkDownloadFilesMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkDownloadFilesData>>): UseMutationOptions<DocumentWorkflowControllerBulkDownloadFilesResponse, DefaultError, Options<DocumentWorkflowControllerBulkDownloadFilesData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkDownloadFilesResponse, DefaultError, Options<DocumentWorkflowControllerBulkDownloadFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkDownloadFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * bulk revoke simple document workflow documents
 */
export const documentWorkflowControllerBulkRevokeSimpleDocumentsMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkRevokeSimpleDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkRevokeSimpleDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkRevokeSimpleDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkRevokeSimpleDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk reissue documents
 */
export const documentWorkflowControllerBulkReissueDocumentsMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkReissueDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkReissueDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkReissueDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkReissueDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get aggregated counterparty role state across selected documents
 */
export const documentWorkflowControllerBulkAssignCounterpartiesPreviewMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData>>): UseMutationOptions<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkAssignCounterpartiesPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start an async bulk assign/unassign counterparty job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkAssignCounterpartyMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkAssignCounterpartyData>>): UseMutationOptions<DocumentWorkflowControllerBulkAssignCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerBulkAssignCounterpartyData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkAssignCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerBulkAssignCounterpartyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkAssignCounterparty({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerBulkAssignCounterpartyStatusQueryKey = (options: Options<DocumentWorkflowControllerBulkAssignCounterpartyStatusData>) => createQueryKey('documentWorkflowControllerBulkAssignCounterpartyStatus', options);

/**
 * Get bulk-assign-counterparty job status for polling
 */
export const documentWorkflowControllerBulkAssignCounterpartyStatusOptions = (options: Options<DocumentWorkflowControllerBulkAssignCounterpartyStatusData>) => queryOptions<DocumentWorkflowControllerBulkAssignCounterpartyStatusResponse, DefaultError, DocumentWorkflowControllerBulkAssignCounterpartyStatusResponse, ReturnType<typeof documentWorkflowControllerBulkAssignCounterpartyStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerBulkAssignCounterpartyStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerBulkAssignCounterpartyStatusQueryKey(options)
});

/**
 * Preview a bulk add-counterparty: eligible count and skip reasons breakdown
 */
export const documentWorkflowControllerBulkAddCounterpartyPreviewMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkAddCounterpartyPreviewData>>): UseMutationOptions<DocumentWorkflowControllerBulkAddCounterpartyPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkAddCounterpartyPreviewData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkAddCounterpartyPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkAddCounterpartyPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkAddCounterpartyPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start an async bulk add-counterparty job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkAddCounterpartyMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkAddCounterpartyData>>): UseMutationOptions<DocumentWorkflowControllerBulkAddCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerBulkAddCounterpartyData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkAddCounterpartyResponse, DefaultError, Options<DocumentWorkflowControllerBulkAddCounterpartyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkAddCounterparty({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerBulkAddCounterpartyStatusQueryKey = (options: Options<DocumentWorkflowControllerBulkAddCounterpartyStatusData>) => createQueryKey('documentWorkflowControllerBulkAddCounterpartyStatus', options);

/**
 * Get bulk-add-counterparty job status for polling
 */
export const documentWorkflowControllerBulkAddCounterpartyStatusOptions = (options: Options<DocumentWorkflowControllerBulkAddCounterpartyStatusData>) => queryOptions<DocumentWorkflowControllerBulkAddCounterpartyStatusResponse, DefaultError, DocumentWorkflowControllerBulkAddCounterpartyStatusResponse, ReturnType<typeof documentWorkflowControllerBulkAddCounterpartyStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerBulkAddCounterpartyStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerBulkAddCounterpartyStatusQueryKey(options)
});

/**
 * Aggregate open counterparty roles across selected documents for authorised-signatory invite
 */
export const documentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData>>): UseMutationOptions<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkInviteAuthorisedSignatoriesPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invite an authorised signatory to open counterparty slots across selected documents
 */
export const documentWorkflowControllerBulkInviteAuthorisedSignatoryMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData>>): UseMutationOptions<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponse, DefaultError, Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponse, DefaultError, Options<DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkInviteAuthorisedSignatory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start an async bulk remind-signers job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkRemindSignersMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkRemindSignersData>>): UseMutationOptions<DocumentWorkflowControllerBulkRemindSignersResponse, DefaultError, Options<DocumentWorkflowControllerBulkRemindSignersData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkRemindSignersResponse, DefaultError, Options<DocumentWorkflowControllerBulkRemindSignersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkRemindSigners({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerBulkRemindSignersStatusQueryKey = (options: Options<DocumentWorkflowControllerBulkRemindSignersStatusData>) => createQueryKey('documentWorkflowControllerBulkRemindSignersStatus', options);

/**
 * Get bulk-remind-signers job status for polling
 */
export const documentWorkflowControllerBulkRemindSignersStatusOptions = (options: Options<DocumentWorkflowControllerBulkRemindSignersStatusData>) => queryOptions<DocumentWorkflowControllerBulkRemindSignersStatusResponse, DefaultError, DocumentWorkflowControllerBulkRemindSignersStatusResponse, ReturnType<typeof documentWorkflowControllerBulkRemindSignersStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerBulkRemindSignersStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerBulkRemindSignersStatusQueryKey(options)
});

/**
 * Start an async bulk apply-date job — returns jobId for status polling
 */
export const documentWorkflowControllerBulkApplyDateMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkApplyDateData>>): UseMutationOptions<DocumentWorkflowControllerBulkApplyDateResponse, DefaultError, Options<DocumentWorkflowControllerBulkApplyDateData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkApplyDateResponse, DefaultError, Options<DocumentWorkflowControllerBulkApplyDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkApplyDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerBulkApplyDateStatusQueryKey = (options: Options<DocumentWorkflowControllerBulkApplyDateStatusData>) => createQueryKey('documentWorkflowControllerBulkApplyDateStatus', options);

/**
 * Get bulk-apply-date job status for polling
 */
export const documentWorkflowControllerBulkApplyDateStatusOptions = (options: Options<DocumentWorkflowControllerBulkApplyDateStatusData>) => queryOptions<DocumentWorkflowControllerBulkApplyDateStatusResponse, DefaultError, DocumentWorkflowControllerBulkApplyDateStatusResponse, ReturnType<typeof documentWorkflowControllerBulkApplyDateStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerBulkApplyDateStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerBulkApplyDateStatusQueryKey(options)
});

/**
 * Preview claimable investor signers across selected documents, grouped by role
 */
export const documentWorkflowControllerBulkClaimOnBehalfPreviewMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkClaimOnBehalfPreviewData>>): UseMutationOptions<DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkClaimOnBehalfPreviewData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponse, DefaultError, Options<DocumentWorkflowControllerBulkClaimOnBehalfPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkClaimOnBehalfPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim investor signer slots on behalf across selected documents
 */
export const documentWorkflowControllerBulkClaimOnBehalfMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkClaimOnBehalfData>>): UseMutationOptions<DocumentWorkflowControllerBulkClaimOnBehalfResponse, DefaultError, Options<DocumentWorkflowControllerBulkClaimOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerBulkClaimOnBehalfResponse, DefaultError, Options<DocumentWorkflowControllerBulkClaimOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkClaimOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowControllerBulkClaimGenerationStatusQueryKey = (options: Options<DocumentWorkflowControllerBulkClaimGenerationStatusData>) => createQueryKey('documentWorkflowControllerBulkClaimGenerationStatus', options);

/**
 * Get bulk-claim-generation job status for polling
 */
export const documentWorkflowControllerBulkClaimGenerationStatusOptions = (options: Options<DocumentWorkflowControllerBulkClaimGenerationStatusData>) => queryOptions<DocumentWorkflowControllerBulkClaimGenerationStatusResponse, DefaultError, DocumentWorkflowControllerBulkClaimGenerationStatusResponse, ReturnType<typeof documentWorkflowControllerBulkClaimGenerationStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowControllerBulkClaimGenerationStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowControllerBulkClaimGenerationStatusQueryKey(options)
});

/**
 * Prepare document for eID Easy signing (PAdES hash flow)
 */
export const documentWorkflowControllerEidEasyPrepareMutation = (options?: Partial<Options<DocumentWorkflowControllerEidEasyPrepareData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerEidEasyPrepareData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerEidEasyPrepareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerEidEasyPrepare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete eID Easy signing and save signed document
 */
export const documentWorkflowControllerEidEasyCompleteMutation = (options?: Partial<Options<DocumentWorkflowControllerEidEasyCompleteData>>): UseMutationOptions<DocumentWorkflowControllerEidEasyCompleteResponse, DefaultError, Options<DocumentWorkflowControllerEidEasyCompleteData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowControllerEidEasyCompleteResponse, DefaultError, Options<DocumentWorkflowControllerEidEasyCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerEidEasyComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Open an eID Easy session for the next unapplied date placement
 */
export const documentWorkflowControllerApplyDatePrepareMutation = (options?: Partial<Options<DocumentWorkflowControllerApplyDatePrepareData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerApplyDatePrepareData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerApplyDatePrepareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerApplyDatePrepare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save the dated PDF produced by an apply-date session
 */
export const documentWorkflowControllerApplyDateCompleteMutation = (options?: Partial<Options<DocumentWorkflowControllerApplyDateCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerApplyDateCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerApplyDateCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerApplyDateComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-set requiresWitness on every signer of a role within an instance.
 */
export const documentWorkflowControllerBulkSetSignerRequiresWitnessMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkSetSignerRequiresWitnessData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkSetSignerRequiresWitnessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkSetSignerRequiresWitnessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkSetSignerRequiresWitness({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-set securityLevel override on every signer of a role within an instance. BASIC enables simple sign (DRAW); ADVANCED disables it; null clears the override. DealStack Support only.
 */
export const documentWorkflowControllerBulkSetSignerSecurityLevelMutation = (options?: Partial<Options<DocumentWorkflowControllerBulkSetSignerSecurityLevelData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkSetSignerSecurityLevelData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerBulkSetSignerSecurityLevelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerBulkSetSignerSecurityLevel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set requiresWitness on a single signer within an instance.
 */
export const documentWorkflowControllerSetSignerRequiresWitnessMutation = (options?: Partial<Options<DocumentWorkflowControllerSetSignerRequiresWitnessData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSetSignerRequiresWitnessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSetSignerRequiresWitnessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSetSignerRequiresWitness({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set securityLevel override on a single signer within an instance. BASIC enables simple sign (DRAW); ADVANCED disables it; null clears the override. DealStack Support only.
 */
export const documentWorkflowControllerSetSignerSecurityLevelMutation = (options?: Partial<Options<DocumentWorkflowControllerSetSignerSecurityLevelData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSetSignerSecurityLevelData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerSetSignerSecurityLevelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerSetSignerSecurityLevel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invite a witness to sign via email
 */
export const documentWorkflowControllerInviteWitnessMutation = (options?: Partial<Options<DocumentWorkflowControllerInviteWitnessData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteWitnessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteWitnessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerInviteWitness({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invite a representative to sign via email
 */
export const documentWorkflowControllerInviteRepresentativeMutation = (options?: Partial<Options<DocumentWorkflowControllerInviteRepresentativeData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteRepresentativeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteRepresentativeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerInviteRepresentative({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invite an authorised signatory to sign via email
 */
export const documentWorkflowControllerInviteAuthorisedSignatoryMutation = (options?: Partial<Options<DocumentWorkflowControllerInviteAuthorisedSignatoryData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteAuthorisedSignatoryData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerInviteAuthorisedSignatoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerInviteAuthorisedSignatory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel an invited authorised signatory, resetting the slot to unassigned
 */
export const documentWorkflowControllerCancelAuthorisedSignatoryMutation = (options?: Partial<Options<DocumentWorkflowControllerCancelAuthorisedSignatoryData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerCancelAuthorisedSignatoryData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerCancelAuthorisedSignatoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerCancelAuthorisedSignatory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend signing invitation email
 */
export const documentWorkflowControllerResendInvitationMutation = (options?: Partial<Options<DocumentWorkflowControllerResendInvitationData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerResendInvitationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowControllerResendInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowControllerResendInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prepare multiple documents for eID Easy bulk signing
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkPrepareMutation = (options?: Partial<Options<DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowBulkSigningControllerEidEasyBulkPrepare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete eID Easy bulk signing and save all signed documents
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkCompleteMutation = (options?: Partial<Options<DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowBulkSigningControllerEidEasyBulkComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Initiate async bulk signing job (returns jobId for polling)
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignInitiateMutation = (options?: Partial<Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowBulkSigningControllerEidEasyBulkSignInitiate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowBulkSigningControllerEidEasyBulkSignStatusQueryKey = (options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData>) => createQueryKey('documentWorkflowBulkSigningControllerEidEasyBulkSignStatus', options);

/**
 * Get async bulk signing job status (for polling)
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignStatusOptions = (options: Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData>) => queryOptions<DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponse, DefaultError, DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponse, ReturnType<typeof documentWorkflowBulkSigningControllerEidEasyBulkSignStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowBulkSigningControllerEidEasyBulkSignStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowBulkSigningControllerEidEasyBulkSignStatusQueryKey(options)
});

/**
 * Signal FTN signing complete — triggers async complete phase
 */
export const documentWorkflowBulkSigningControllerEidEasyBulkSignCompleteMutation = (options?: Partial<Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowBulkSigningControllerEidEasyBulkSignComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowKycFormControllerGetFormsForKycWorkflowQueryKey = (options: Options<DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData>) => createQueryKey('documentWorkflowKycFormControllerGetFormsForKycWorkflow', options);

/**
 * MIP KYC forms + which are attached to a KYC workflow (per-investment toggle state)
 */
export const documentWorkflowKycFormControllerGetFormsForKycWorkflowOptions = (options: Options<DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData>) => queryOptions<DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponse, DefaultError, DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponse, ReturnType<typeof documentWorkflowKycFormControllerGetFormsForKycWorkflowQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowKycFormControllerGetFormsForKycWorkflow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowKycFormControllerGetFormsForKycWorkflowQueryKey(options)
});

/**
 * Attach a KYC form to a KYC workflow (per-workflow override)
 */
export const documentWorkflowKycFormControllerAttachFormMutation = (options?: Partial<Options<DocumentWorkflowKycFormControllerAttachFormData>>): UseMutationOptions<DocumentWorkflowKycFormControllerAttachFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerAttachFormData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowKycFormControllerAttachFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerAttachFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowKycFormControllerAttachForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a KYC form from a single investment (per-investment override)
 */
export const documentWorkflowKycFormControllerRemoveFormMutation = (options?: Partial<Options<DocumentWorkflowKycFormControllerRemoveFormData>>): UseMutationOptions<DocumentWorkflowKycFormControllerRemoveFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerRemoveFormData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowKycFormControllerRemoveFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerRemoveFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowKycFormControllerRemoveForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Review a submitted KYC form
 */
export const documentWorkflowKycFormControllerReviewFormMutation = (options?: Partial<Options<DocumentWorkflowKycFormControllerReviewFormData>>): UseMutationOptions<DocumentWorkflowKycFormControllerReviewFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerReviewFormData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowKycFormControllerReviewFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerReviewFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowKycFormControllerReviewForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset (clear) a submitted KYC form back to unsubmitted
 */
export const documentWorkflowKycFormControllerResetFormMutation = (options?: Partial<Options<DocumentWorkflowKycFormControllerResetFormData>>): UseMutationOptions<DocumentWorkflowKycFormControllerResetFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerResetFormData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowKycFormControllerResetFormResponse, DefaultError, Options<DocumentWorkflowKycFormControllerResetFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowKycFormControllerResetForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowKycFormControllerGetInvestorFormsQueryKey = (options: Options<DocumentWorkflowKycFormControllerGetInvestorFormsData>) => createQueryKey('documentWorkflowKycFormControllerGetInvestorForms', options);

/**
 * Attached KYC forms + submission state for a KYC workflow
 */
export const documentWorkflowKycFormControllerGetInvestorFormsOptions = (options: Options<DocumentWorkflowKycFormControllerGetInvestorFormsData>) => queryOptions<DocumentWorkflowKycFormControllerGetInvestorFormsResponse, DefaultError, DocumentWorkflowKycFormControllerGetInvestorFormsResponse, ReturnType<typeof documentWorkflowKycFormControllerGetInvestorFormsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowKycFormControllerGetInvestorForms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowKycFormControllerGetInvestorFormsQueryKey(options)
});

/**
 * Delete KYC form templates (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerDeleteMutation = (options?: Partial<Options<KycFormTemplateControllerDeleteData>>): UseMutationOptions<KycFormTemplateControllerDeleteResponse, DefaultError, Options<KycFormTemplateControllerDeleteData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerDeleteResponse, DefaultError, Options<KycFormTemplateControllerDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerListQueryKey = (options: Options<KycFormTemplateControllerListData>) => createQueryKey('kycFormTemplateControllerList', options);

/**
 * List a MIP's active KYC form templates (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerListOptions = (options: Options<KycFormTemplateControllerListData>) => queryOptions<KycFormTemplateControllerListResponse, DefaultError, KycFormTemplateControllerListResponse, ReturnType<typeof kycFormTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerListQueryKey(options)
});

/**
 * Create a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerCreateMutation = (options?: Partial<Options<KycFormTemplateControllerCreateData>>): UseMutationOptions<KycFormTemplateControllerCreateResponse, DefaultError, Options<KycFormTemplateControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerCreateResponse, DefaultError, Options<KycFormTemplateControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerListLibraryQueryKey = (options: Options<KycFormTemplateControllerListLibraryData>) => createQueryKey('kycFormTemplateControllerListLibrary', options);

/**
 * Published library templates tagged for one section of Tax & Compliance
 */
export const kycFormTemplateControllerListLibraryOptions = (options: Options<KycFormTemplateControllerListLibraryData>) => queryOptions<KycFormTemplateControllerListLibraryResponse, DefaultError, KycFormTemplateControllerListLibraryResponse, ReturnType<typeof kycFormTemplateControllerListLibraryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerListLibrary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerListLibraryQueryKey(options)
});

/**
 * Update a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerUpdateMutation = (options?: Partial<Options<KycFormTemplateControllerUpdateData>>): UseMutationOptions<KycFormTemplateControllerUpdateResponse, DefaultError, Options<KycFormTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerUpdateResponse, DefaultError, Options<KycFormTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerSignatureSlotsQueryKey = (options: Options<KycFormTemplateControllerSignatureSlotsData>) => createQueryKey('kycFormTemplateControllerSignatureSlots', options);

/**
 * The signature box an admin must place on a KYC form (always exactly one)
 */
export const kycFormTemplateControllerSignatureSlotsOptions = (options: Options<KycFormTemplateControllerSignatureSlotsData>) => queryOptions<KycFormTemplateControllerSignatureSlotsResponse, DefaultError, KycFormTemplateControllerSignatureSlotsResponse, ReturnType<typeof kycFormTemplateControllerSignatureSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerSignatureSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerSignatureSlotsQueryKey(options)
});

/**
 * Save the manual signature placement for a KYC form template
 */
export const kycFormTemplateControllerUpdateSignaturePlacementMutation = (options?: Partial<Options<KycFormTemplateControllerUpdateSignaturePlacementData>>): UseMutationOptions<KycFormTemplateControllerUpdateSignaturePlacementResponse, DefaultError, Options<KycFormTemplateControllerUpdateSignaturePlacementData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerUpdateSignaturePlacementResponse, DefaultError, Options<KycFormTemplateControllerUpdateSignaturePlacementData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerUpdateSignaturePlacement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerFieldBindingsQueryKey = (options: Options<KycFormTemplateControllerFieldBindingsData>) => createQueryKey('kycFormTemplateControllerFieldBindings', options);

/**
 * Get the coordinate field bindings of a PDF KYC form
 */
export const kycFormTemplateControllerFieldBindingsOptions = (options: Options<KycFormTemplateControllerFieldBindingsData>) => queryOptions<KycFormTemplateControllerFieldBindingsResponse, DefaultError, KycFormTemplateControllerFieldBindingsResponse, ReturnType<typeof kycFormTemplateControllerFieldBindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerFieldBindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerFieldBindingsQueryKey(options)
});

/**
 * Replace the coordinate field bindings of a PDF KYC form
 */
export const kycFormTemplateControllerUpdateFieldBindingsMutation = (options?: Partial<Options<KycFormTemplateControllerUpdateFieldBindingsData>>): UseMutationOptions<KycFormTemplateControllerUpdateFieldBindingsResponse, DefaultError, Options<KycFormTemplateControllerUpdateFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerUpdateFieldBindingsResponse, DefaultError, Options<KycFormTemplateControllerUpdateFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerUpdateFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerFieldBindingCatalogueQueryKey = (options?: Options<KycFormTemplateControllerFieldBindingCatalogueData>) => createQueryKey('kycFormTemplateControllerFieldBindingCatalogue', options);

/**
 * Get the field-binding catalogue with resolved sample values
 */
export const kycFormTemplateControllerFieldBindingCatalogueOptions = (options?: Options<KycFormTemplateControllerFieldBindingCatalogueData>) => queryOptions<KycFormTemplateControllerFieldBindingCatalogueResponse, DefaultError, KycFormTemplateControllerFieldBindingCatalogueResponse, ReturnType<typeof kycFormTemplateControllerFieldBindingCatalogueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerFieldBindingCatalogue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerFieldBindingCatalogueQueryKey(options)
});

/**
 * Render a KYC form with one investor’s values in place
 */
export const kycFormTemplateControllerPreviewFieldBindingsMutation = (options?: Partial<Options<KycFormTemplateControllerPreviewFieldBindingsData>>): UseMutationOptions<KycFormTemplateControllerPreviewFieldBindingsResponse, DefaultError, Options<KycFormTemplateControllerPreviewFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerPreviewFieldBindingsResponse, DefaultError, Options<KycFormTemplateControllerPreviewFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerPreviewFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerDocxDocumentQueryKey = (options: Options<KycFormTemplateControllerDocxDocumentData>) => createQueryKey('kycFormTemplateControllerDocxDocument', options);

/**
 * Get the editable document for a Word KYC form
 */
export const kycFormTemplateControllerDocxDocumentOptions = (options: Options<KycFormTemplateControllerDocxDocumentData>) => queryOptions<KycFormTemplateControllerDocxDocumentResponse, DefaultError, KycFormTemplateControllerDocxDocumentResponse, ReturnType<typeof kycFormTemplateControllerDocxDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerDocxDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerDocxDocumentQueryKey(options)
});

/**
 * Save an edited Word KYC form
 */
export const kycFormTemplateControllerSaveDocxDocumentMutation = (options?: Partial<Options<KycFormTemplateControllerSaveDocxDocumentData>>): UseMutationOptions<KycFormTemplateControllerSaveDocxDocumentResponse, DefaultError, Options<KycFormTemplateControllerSaveDocxDocumentData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerSaveDocxDocumentResponse, DefaultError, Options<KycFormTemplateControllerSaveDocxDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerSaveDocxDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerRenderDocxFieldsQueryKey = (options: Options<KycFormTemplateControllerRenderDocxFieldsData>) => createQueryKey('kycFormTemplateControllerRenderDocxFields', options);

/**
 * Render a Word KYC form with its field names in place
 */
export const kycFormTemplateControllerRenderDocxFieldsOptions = (options: Options<KycFormTemplateControllerRenderDocxFieldsData>) => queryOptions<KycFormTemplateControllerRenderDocxFieldsResponse, DefaultError, KycFormTemplateControllerRenderDocxFieldsResponse, ReturnType<typeof kycFormTemplateControllerRenderDocxFieldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerRenderDocxFields({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerRenderDocxFieldsQueryKey(options)
});

/**
 * Render a Word KYC form — field names, or an investor’s values
 */
export const kycFormTemplateControllerRenderDocxMutation = (options?: Partial<Options<KycFormTemplateControllerRenderDocxData>>): UseMutationOptions<KycFormTemplateControllerRenderDocxResponse, DefaultError, Options<KycFormTemplateControllerRenderDocxData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerRenderDocxResponse, DefaultError, Options<KycFormTemplateControllerRenderDocxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerRenderDocx({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive a KYC form template (DocumentWorkflow-native)
 */
export const kycFormTemplateControllerArchiveMutation = (options?: Partial<Options<KycFormTemplateControllerArchiveData>>): UseMutationOptions<KycFormTemplateControllerArchiveResponse, DefaultError, Options<KycFormTemplateControllerArchiveData>> => {
    const mutationOptions: UseMutationOptions<KycFormTemplateControllerArchiveResponse, DefaultError, Options<KycFormTemplateControllerArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycFormTemplateControllerArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycFormTemplateControllerInstanceCountQueryKey = (options: Options<KycFormTemplateControllerInstanceCountData>) => createQueryKey('kycFormTemplateControllerInstanceCount', options);

/**
 * How many KYC workflows hold an instance of a KYC form template
 */
export const kycFormTemplateControllerInstanceCountOptions = (options: Options<KycFormTemplateControllerInstanceCountData>) => queryOptions<KycFormTemplateControllerInstanceCountResponse, DefaultError, KycFormTemplateControllerInstanceCountResponse, ReturnType<typeof kycFormTemplateControllerInstanceCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycFormTemplateControllerInstanceCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycFormTemplateControllerInstanceCountQueryKey(options)
});

export const publicSigningControllerGetSigningInfoQueryKey = (options?: Options<PublicSigningControllerGetSigningInfoData>) => createQueryKey('publicSigningControllerGetSigningInfo', options);

export const publicSigningControllerGetSigningInfoOptions = (options?: Options<PublicSigningControllerGetSigningInfoData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof publicSigningControllerGetSigningInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await publicSigningControllerGetSigningInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: publicSigningControllerGetSigningInfoQueryKey(options)
});

export const publicSigningControllerGetDocumentQueryKey = (options?: Options<PublicSigningControllerGetDocumentData>) => createQueryKey('publicSigningControllerGetDocument', options);

export const publicSigningControllerGetDocumentOptions = (options?: Options<PublicSigningControllerGetDocumentData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof publicSigningControllerGetDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await publicSigningControllerGetDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: publicSigningControllerGetDocumentQueryKey(options)
});

export const publicSigningControllerSaveWitnessDetailsMutation = (options?: Partial<Options<PublicSigningControllerSaveWitnessDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerSaveWitnessDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerSaveWitnessDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicSigningControllerSaveWitnessDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicSigningControllerInviteWitnessMutation = (options?: Partial<Options<PublicSigningControllerInviteWitnessData>>): UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerInviteWitnessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerInviteWitnessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicSigningControllerInviteWitness({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicSigningControllerPrepareMutation = (options?: Partial<Options<PublicSigningControllerPrepareData>>): UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerPrepareData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerPrepareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicSigningControllerPrepare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicSigningControllerCompleteMutation = (options?: Partial<Options<PublicSigningControllerCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicSigningControllerCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicSigningControllerComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicBulkSigningControllerGetProgrammeDocumentsQueryKey = (options?: Options<PublicBulkSigningControllerGetProgrammeDocumentsData>) => createQueryKey('publicBulkSigningControllerGetProgrammeDocuments', options);

export const publicBulkSigningControllerGetProgrammeDocumentsOptions = (options?: Options<PublicBulkSigningControllerGetProgrammeDocumentsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof publicBulkSigningControllerGetProgrammeDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await publicBulkSigningControllerGetProgrammeDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: publicBulkSigningControllerGetProgrammeDocumentsQueryKey(options)
});

export const publicBulkSigningControllerGetProgrammeDocumentQueryKey = (options: Options<PublicBulkSigningControllerGetProgrammeDocumentData>) => createQueryKey('publicBulkSigningControllerGetProgrammeDocument', options);

export const publicBulkSigningControllerGetProgrammeDocumentOptions = (options: Options<PublicBulkSigningControllerGetProgrammeDocumentData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof publicBulkSigningControllerGetProgrammeDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await publicBulkSigningControllerGetProgrammeDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: publicBulkSigningControllerGetProgrammeDocumentQueryKey(options)
});

export const publicBulkSigningControllerGetSignatureTokenMutation = (options?: Partial<Options<PublicBulkSigningControllerGetSignatureTokenData>>): UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerGetSignatureTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerGetSignatureTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicBulkSigningControllerGetSignatureToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicBulkSigningControllerBulkPrepareMutation = (options?: Partial<Options<PublicBulkSigningControllerBulkPrepareData>>): UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkPrepareData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkPrepareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicBulkSigningControllerBulkPrepare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicBulkSigningControllerBulkCompleteMutation = (options?: Partial<Options<PublicBulkSigningControllerBulkCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicBulkSigningControllerBulkComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicBulkSigningControllerBulkSignInitiateMutation = (options?: Partial<Options<PublicBulkSigningControllerBulkSignInitiateData>>): UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkSignInitiateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkSignInitiateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicBulkSigningControllerBulkSignInitiate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicBulkSigningControllerBulkSignStatusQueryKey = (options: Options<PublicBulkSigningControllerBulkSignStatusData>) => createQueryKey('publicBulkSigningControllerBulkSignStatus', options);

export const publicBulkSigningControllerBulkSignStatusOptions = (options: Options<PublicBulkSigningControllerBulkSignStatusData>) => queryOptions<PublicBulkSigningControllerBulkSignStatusResponse, DefaultError, PublicBulkSigningControllerBulkSignStatusResponse, ReturnType<typeof publicBulkSigningControllerBulkSignStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await publicBulkSigningControllerBulkSignStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: publicBulkSigningControllerBulkSignStatusQueryKey(options)
});

export const publicBulkSigningControllerBulkSignCompleteMutation = (options?: Partial<Options<PublicBulkSigningControllerBulkSignCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkSignCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PublicBulkSigningControllerBulkSignCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicBulkSigningControllerBulkSignComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save a KYC certifier's name, address and professional capacity
 */
export const publicCertificationControllerSaveCertifierDetailsMutation = (options?: Partial<Options<PublicCertificationControllerSaveCertifierDetailsData>>): UseMutationOptions<PublicCertificationControllerSaveCertifierDetailsResponse, DefaultError, Options<PublicCertificationControllerSaveCertifierDetailsData>> => {
    const mutationOptions: UseMutationOptions<PublicCertificationControllerSaveCertifierDetailsResponse, DefaultError, Options<PublicCertificationControllerSaveCertifierDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicCertificationControllerSaveCertifierDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-stamp a KYC certification with the certifier’s amended wording
 */
export const publicCertificationControllerUpdateCertificationTextMutation = (options?: Partial<Options<PublicCertificationControllerUpdateCertificationTextData>>): UseMutationOptions<PublicCertificationControllerUpdateCertificationTextResponse, DefaultError, Options<PublicCertificationControllerUpdateCertificationTextData>> => {
    const mutationOptions: UseMutationOptions<PublicCertificationControllerUpdateCertificationTextResponse, DefaultError, Options<PublicCertificationControllerUpdateCertificationTextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publicCertificationControllerUpdateCertificationText({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerListQueryKey = (options?: Options<DocumentTemplatesControllerListData>) => createQueryKey('documentTemplatesControllerList', options);

/**
 * List all global document templates
 */
export const documentTemplatesControllerListOptions = (options?: Options<DocumentTemplatesControllerListData>) => queryOptions<DocumentTemplatesControllerListResponse, DefaultError, DocumentTemplatesControllerListResponse, ReturnType<typeof documentTemplatesControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerListQueryKey(options)
});

/**
 * Create a global document template
 */
export const documentTemplatesControllerCreateMutation = (options?: Partial<Options<DocumentTemplatesControllerCreateData>>): UseMutationOptions<DocumentTemplatesControllerCreateResponse, DefaultError, Options<DocumentTemplatesControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerCreateResponse, DefaultError, Options<DocumentTemplatesControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft-delete a global document template
 */
export const documentTemplatesControllerSoftDeleteMutation = (options?: Partial<Options<DocumentTemplatesControllerSoftDeleteData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentTemplatesControllerSoftDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentTemplatesControllerSoftDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerSoftDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerGetByIdQueryKey = (options: Options<DocumentTemplatesControllerGetByIdData>) => createQueryKey('documentTemplatesControllerGetById', options);

/**
 * Get a global document template by id
 */
export const documentTemplatesControllerGetByIdOptions = (options: Options<DocumentTemplatesControllerGetByIdData>) => queryOptions<DocumentTemplatesControllerGetByIdResponse, DefaultError, DocumentTemplatesControllerGetByIdResponse, ReturnType<typeof documentTemplatesControllerGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerGetByIdQueryKey(options)
});

/**
 * Update a global document template
 */
export const documentTemplatesControllerUpdateMutation = (options?: Partial<Options<DocumentTemplatesControllerUpdateData>>): UseMutationOptions<DocumentTemplatesControllerUpdateResponse, DefaultError, Options<DocumentTemplatesControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerUpdateResponse, DefaultError, Options<DocumentTemplatesControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerGetAvailabilityQueryKey = (options: Options<DocumentTemplatesControllerGetAvailabilityData>) => createQueryKey('documentTemplatesControllerGetAvailability', options);

/**
 * Get which deals a global document template is available to
 */
export const documentTemplatesControllerGetAvailabilityOptions = (options: Options<DocumentTemplatesControllerGetAvailabilityData>) => queryOptions<DocumentTemplatesControllerGetAvailabilityResponse, DefaultError, DocumentTemplatesControllerGetAvailabilityResponse, ReturnType<typeof documentTemplatesControllerGetAvailabilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerGetAvailability({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerGetAvailabilityQueryKey(options)
});

/**
 * Replace which deals a global document template is available to
 */
export const documentTemplatesControllerSetAvailabilityMutation = (options?: Partial<Options<DocumentTemplatesControllerSetAvailabilityData>>): UseMutationOptions<DocumentTemplatesControllerSetAvailabilityResponse, DefaultError, Options<DocumentTemplatesControllerSetAvailabilityData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerSetAvailabilityResponse, DefaultError, Options<DocumentTemplatesControllerSetAvailabilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerSetAvailability({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerGetFieldBindingsQueryKey = (options: Options<DocumentTemplatesControllerGetFieldBindingsData>) => createQueryKey('documentTemplatesControllerGetFieldBindings', options);

/**
 * List field bindings for a global document template
 */
export const documentTemplatesControllerGetFieldBindingsOptions = (options: Options<DocumentTemplatesControllerGetFieldBindingsData>) => queryOptions<DocumentTemplatesControllerGetFieldBindingsResponse, DefaultError, DocumentTemplatesControllerGetFieldBindingsResponse, ReturnType<typeof documentTemplatesControllerGetFieldBindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerGetFieldBindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerGetFieldBindingsQueryKey(options)
});

/**
 * Replace field bindings for a global document template
 */
export const documentTemplatesControllerUpdateFieldBindingsMutation = (options?: Partial<Options<DocumentTemplatesControllerUpdateFieldBindingsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentTemplatesControllerUpdateFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentTemplatesControllerUpdateFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerUpdateFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerGetFieldBindingCatalogueQueryKey = (options?: Options<DocumentTemplatesControllerGetFieldBindingCatalogueData>) => createQueryKey('documentTemplatesControllerGetFieldBindingCatalogue', options);

/**
 * List bindable data points with sample values
 */
export const documentTemplatesControllerGetFieldBindingCatalogueOptions = (options?: Options<DocumentTemplatesControllerGetFieldBindingCatalogueData>) => queryOptions<DocumentTemplatesControllerGetFieldBindingCatalogueResponse, DefaultError, DocumentTemplatesControllerGetFieldBindingCatalogueResponse, ReturnType<typeof documentTemplatesControllerGetFieldBindingCatalogueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerGetFieldBindingCatalogue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerGetFieldBindingCatalogueQueryKey(options)
});

/**
 * Render a template with sample values filled in
 */
export const documentTemplatesControllerPreviewFieldBindingsMutation = (options?: Partial<Options<DocumentTemplatesControllerPreviewFieldBindingsData>>): UseMutationOptions<DocumentTemplatesControllerPreviewFieldBindingsResponse, DefaultError, Options<DocumentTemplatesControllerPreviewFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerPreviewFieldBindingsResponse, DefaultError, Options<DocumentTemplatesControllerPreviewFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerPreviewFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentTemplatesControllerGetDocxFlowDocumentQueryKey = (options: Options<DocumentTemplatesControllerGetDocxFlowDocumentData>) => createQueryKey('documentTemplatesControllerGetDocxFlowDocument', options);

/**
 * Get the editable document for a Word document template
 */
export const documentTemplatesControllerGetDocxFlowDocumentOptions = (options: Options<DocumentTemplatesControllerGetDocxFlowDocumentData>) => queryOptions<DocumentTemplatesControllerGetDocxFlowDocumentResponse, DefaultError, DocumentTemplatesControllerGetDocxFlowDocumentResponse, ReturnType<typeof documentTemplatesControllerGetDocxFlowDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentTemplatesControllerGetDocxFlowDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentTemplatesControllerGetDocxFlowDocumentQueryKey(options)
});

/**
 * Save an edited Word document template
 */
export const documentTemplatesControllerSaveDocxFlowDocumentMutation = (options?: Partial<Options<DocumentTemplatesControllerSaveDocxFlowDocumentData>>): UseMutationOptions<DocumentTemplatesControllerSaveDocxFlowDocumentResponse, DefaultError, Options<DocumentTemplatesControllerSaveDocxFlowDocumentData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerSaveDocxFlowDocumentResponse, DefaultError, Options<DocumentTemplatesControllerSaveDocxFlowDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerSaveDocxFlowDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Render a Word document template against sample data
 */
export const documentTemplatesControllerRenderDocxTemplateMutation = (options?: Partial<Options<DocumentTemplatesControllerRenderDocxTemplateData>>): UseMutationOptions<DocumentTemplatesControllerRenderDocxTemplateResponse, DefaultError, Options<DocumentTemplatesControllerRenderDocxTemplateData>> => {
    const mutationOptions: UseMutationOptions<DocumentTemplatesControllerRenderDocxTemplateResponse, DefaultError, Options<DocumentTemplatesControllerRenderDocxTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentTemplatesControllerRenderDocxTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealDocumentTemplatesControllerListQueryKey = (options: Options<DealDocumentTemplatesControllerListData>) => createQueryKey('dealDocumentTemplatesControllerList', options);

/**
 * List published document templates available to this deal
 */
export const dealDocumentTemplatesControllerListOptions = (options: Options<DealDocumentTemplatesControllerListData>) => queryOptions<DealDocumentTemplatesControllerListResponse, DefaultError, DealDocumentTemplatesControllerListResponse, ReturnType<typeof dealDocumentTemplatesControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealDocumentTemplatesControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealDocumentTemplatesControllerListQueryKey(options)
});

export const preFillableFormsControllerGetTemplatesForProjectQueryKey = (options?: Options<PreFillableFormsControllerGetTemplatesForProjectData>) => createQueryKey('preFillableFormsControllerGetTemplatesForProject', options);

/**
 * Get pdf forms assigned to project
 */
export const preFillableFormsControllerGetTemplatesForProjectOptions = (options?: Options<PreFillableFormsControllerGetTemplatesForProjectData>) => queryOptions<PreFillableFormsControllerGetTemplatesForProjectResponse, DefaultError, PreFillableFormsControllerGetTemplatesForProjectResponse, ReturnType<typeof preFillableFormsControllerGetTemplatesForProjectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await preFillableFormsControllerGetTemplatesForProject({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: preFillableFormsControllerGetTemplatesForProjectQueryKey(options)
});

export const generatableDocumentsControllerGetAllGeneratableDocumentsTemplatesQueryKey = (options?: Options<GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData>) => createQueryKey('generatableDocumentsControllerGetAllGeneratableDocumentsTemplates', options);

/**
 * Get generatable document templates
 */
export const generatableDocumentsControllerGetAllGeneratableDocumentsTemplatesOptions = (options?: Options<GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData>) => queryOptions<GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponse, DefaultError, GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponse, ReturnType<typeof generatableDocumentsControllerGetAllGeneratableDocumentsTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerGetAllGeneratableDocumentsTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerGetAllGeneratableDocumentsTemplatesQueryKey(options)
});

export const generatableDocumentsControllerGetGeneratableDocumentsTemplateQueryKey = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData>) => createQueryKey('generatableDocumentsControllerGetGeneratableDocumentsTemplate', options);

/**
 * Get generatable document template details
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplateOptions = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData>) => queryOptions<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponse, DefaultError, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponse, ReturnType<typeof generatableDocumentsControllerGetGeneratableDocumentsTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerGetGeneratableDocumentsTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerGetGeneratableDocumentsTemplateQueryKey(options)
});

/**
 * Update generatable document template
 */
export const generatableDocumentsControllerUpdateGeneratableDocumentTemplateMutation = (options?: Partial<Options<GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerUpdateGeneratableDocumentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsQueryKey = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData>) => createQueryKey('generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjects', options);

/**
 * Get generatable document template assigned projects
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsOptions = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData>) => queryOptions<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponse, DefaultError, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponse, ReturnType<typeof generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsQueryKey(options)
});

export const generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsQueryKey = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData>) => createQueryKey('generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFields', options);

/**
 * Get generatable document template smart fields
 */
export const generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsOptions = (options: Options<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData>) => queryOptions<GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponse, DefaultError, GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponse, ReturnType<typeof generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFields({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsQueryKey(options)
});

/**
 * Update generatable document template smart fields
 */
export const generatableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsMutation = (options?: Partial<Options<GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFields({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign project to generatable document template
 */
export const generatableDocumentsControllerAssignProjectToGeneratableDocumentTemplateMutation = (options?: Partial<Options<GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerAssignProjectToGeneratableDocumentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign project from generatable document template
 */
export const generatableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateMutation = (options?: Partial<Options<GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerUnassignProjectToGeneratableDocumentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeQueryKey = (options?: Options<GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData>) => createQueryKey('generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByType', options);

export const generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeOptions = (options?: Options<GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeQueryKey(options)
});

export const generatableDocumentsControllerGetGdwtCustomDetailsDefinitionsQueryKey = (options: Options<GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData>) => createQueryKey('generatableDocumentsControllerGetGdwtCustomDetailsDefinitions', options);

/**
 * Get GeneratableDocumentsTemplate custom details definitions
 */
export const generatableDocumentsControllerGetGdwtCustomDetailsDefinitionsOptions = (options: Options<GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData>) => queryOptions<GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponse, DefaultError, GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponse, ReturnType<typeof generatableDocumentsControllerGetGdwtCustomDetailsDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatableDocumentsControllerGetGdwtCustomDetailsDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatableDocumentsControllerGetGdwtCustomDetailsDefinitionsQueryKey(options)
});

/**
 * Delete custom details definitions
 */
export const generatableDocumentsControllerDeleteCustomDetailsDefinitionsMutation = (options?: Partial<Options<GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerDeleteCustomDetailsDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create custom detail definition for GeneratableDocumentsTemplate
 */
export const generatableDocumentsControllerCreateGdwtCustomDetailsDefinitionsMutation = (options?: Partial<Options<GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerCreateGdwtCustomDetailsDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update custom details definitions for GeneratableDocumentsTemplate
 */
export const generatableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsMutation = (options?: Partial<Options<GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData>>): UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatableDocumentsControllerUpdateGdwtCustomDetailsDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const preFillableFormTemplateControllerGetAllPreFillableFormTemplatesQueryKey = (options?: Options<PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData>) => createQueryKey('preFillableFormTemplateControllerGetAllPreFillableFormTemplates', options);

/**
 * Get all pre-fillable form templates
 */
export const preFillableFormTemplateControllerGetAllPreFillableFormTemplatesOptions = (options?: Options<PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData>) => queryOptions<PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponse, DefaultError, PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponse, ReturnType<typeof preFillableFormTemplateControllerGetAllPreFillableFormTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await preFillableFormTemplateControllerGetAllPreFillableFormTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: preFillableFormTemplateControllerGetAllPreFillableFormTemplatesQueryKey(options)
});

export const preFillableFormTemplateControllerGetOrganizationOptionsQueryKey = (options?: Options<PreFillableFormTemplateControllerGetOrganizationOptionsData>) => createQueryKey('preFillableFormTemplateControllerGetOrganizationOptions', options);

/**
 * List the organisations a pre-fillable form can be assigned to
 */
export const preFillableFormTemplateControllerGetOrganizationOptionsOptions = (options?: Options<PreFillableFormTemplateControllerGetOrganizationOptionsData>) => queryOptions<PreFillableFormTemplateControllerGetOrganizationOptionsResponse, DefaultError, PreFillableFormTemplateControllerGetOrganizationOptionsResponse, ReturnType<typeof preFillableFormTemplateControllerGetOrganizationOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await preFillableFormTemplateControllerGetOrganizationOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: preFillableFormTemplateControllerGetOrganizationOptionsQueryKey(options)
});

/**
 * Upload pre-fillable form template file
 */
export const preFillableFormTemplateControllerUploadPreFillableFormTemplateFileMutation = (options?: Partial<Options<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData>>): UseMutationOptions<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponse, DefaultError, Options<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData>> => {
    const mutationOptions: UseMutationOptions<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponse, DefaultError, Options<PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerUploadPreFillableFormTemplateFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create pre-fillable form template
 */
export const preFillableFormTemplateControllerCreatePreFillableFormTemplateMutation = (options?: Partial<Options<PreFillableFormTemplateControllerCreatePreFillableFormTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerCreatePreFillableFormTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerCreatePreFillableFormTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerCreatePreFillableFormTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete custom details definitions
 */
export const preFillableFormTemplateControllerDeleteCustomDetailsDefinitionsMutation = (options?: Partial<Options<PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerDeleteCustomDetailsDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create custom detail definition for pre-fillable form template
 */
export const preFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateMutation = (options?: Partial<Options<PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update custom details definitions
 */
export const preFillableFormTemplateControllerUpdateCustomDetailsDefinitionsMutation = (options?: Partial<Options<PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerUpdateCustomDetailsDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update pre-fillable form template
 */
export const preFillableFormTemplateControllerUpdatePreFillableFormTemplateMutation = (options?: Partial<Options<PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerUpdatePreFillableFormTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete pre-fillable form template with related data
 */
export const preFillableFormTemplateControllerSoftDeletePreFillableFormTemplateMutation = (options?: Partial<Options<PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preFillableFormTemplateControllerSoftDeletePreFillableFormTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const preFillableFormTemplateControllerGetPreFillableFormTemplateQueryKey = (options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateData>) => createQueryKey('preFillableFormTemplateControllerGetPreFillableFormTemplate', options);

/**
 * Get pre-fillable form template data by id
 */
export const preFillableFormTemplateControllerGetPreFillableFormTemplateOptions = (options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateData>) => queryOptions<PreFillableFormTemplateControllerGetPreFillableFormTemplateResponse, DefaultError, PreFillableFormTemplateControllerGetPreFillableFormTemplateResponse, ReturnType<typeof preFillableFormTemplateControllerGetPreFillableFormTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await preFillableFormTemplateControllerGetPreFillableFormTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: preFillableFormTemplateControllerGetPreFillableFormTemplateQueryKey(options)
});

export const preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsQueryKey = (options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData>) => createQueryKey('preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitions', options);

/**
 * Get pre-fillable form template custom details definitions
 */
export const preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsOptions = (options: Options<PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData>) => queryOptions<PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponse, DefaultError, PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponse, ReturnType<typeof preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: preFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsQueryKey(options)
});

export const securityControllerGetLoanDefinitionsForDealQueryKey = (options?: Options<SecurityControllerGetLoanDefinitionsForDealData>) => createQueryKey('securityControllerGetLoanDefinitionsForDeal', options);

/**
 * Get loans definitions for all mips in deal
 */
export const securityControllerGetLoanDefinitionsForDealOptions = (options?: Options<SecurityControllerGetLoanDefinitionsForDealData>) => queryOptions<SecurityControllerGetLoanDefinitionsForDealResponse, DefaultError, SecurityControllerGetLoanDefinitionsForDealResponse, ReturnType<typeof securityControllerGetLoanDefinitionsForDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetLoanDefinitionsForDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetLoanDefinitionsForDealQueryKey(options)
});

export const securityControllerGetSecuritiesByDealIdQueryKey = (options?: Options<SecurityControllerGetSecuritiesByDealIdData>) => createQueryKey('securityControllerGetSecuritiesByDealId', options);

/**
 * Get all securities for deal
 */
export const securityControllerGetSecuritiesByDealIdOptions = (options?: Options<SecurityControllerGetSecuritiesByDealIdData>) => queryOptions<SecurityControllerGetSecuritiesByDealIdResponse, DefaultError, SecurityControllerGetSecuritiesByDealIdResponse, ReturnType<typeof securityControllerGetSecuritiesByDealIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetSecuritiesByDealId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetSecuritiesByDealIdQueryKey(options)
});

export const securityControllerGetSecurityQueryKey = (options: Options<SecurityControllerGetSecurityData>) => createQueryKey('securityControllerGetSecurity', options);

/**
 * Get security by id
 */
export const securityControllerGetSecurityOptions = (options: Options<SecurityControllerGetSecurityData>) => queryOptions<SecurityControllerGetSecurityResponse, DefaultError, SecurityControllerGetSecurityResponse, ReturnType<typeof securityControllerGetSecurityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetSecurity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetSecurityQueryKey(options)
});

export const securityControllerGetSecuritiesDataForMipQueryKey = (options: Options<SecurityControllerGetSecuritiesDataForMipData>) => createQueryKey('securityControllerGetSecuritiesDataForMip', options);

/**
 * Get securities data for mip
 */
export const securityControllerGetSecuritiesDataForMipOptions = (options: Options<SecurityControllerGetSecuritiesDataForMipData>) => queryOptions<SecurityControllerGetSecuritiesDataForMipResponse, DefaultError, SecurityControllerGetSecuritiesDataForMipResponse, ReturnType<typeof securityControllerGetSecuritiesDataForMipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetSecuritiesDataForMip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetSecuritiesDataForMipQueryKey(options)
});

/**
 * Get securities for person id
 */
export const securityControllerGetPersonSecuritiesMutation = (options?: Partial<Options<SecurityControllerGetPersonSecuritiesData>>): UseMutationOptions<SecurityControllerGetPersonSecuritiesResponse, DefaultError, Options<SecurityControllerGetPersonSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerGetPersonSecuritiesResponse, DefaultError, Options<SecurityControllerGetPersonSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerGetPersonSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const securityControllerDoesPersonHaveSecuritiesQueryKey = (options: Options<SecurityControllerDoesPersonHaveSecuritiesData>) => createQueryKey('securityControllerDoesPersonHaveSecurities', options);

/**
 * Does person have any securities
 */
export const securityControllerDoesPersonHaveSecuritiesOptions = (options: Options<SecurityControllerDoesPersonHaveSecuritiesData>) => queryOptions<SecurityControllerDoesPersonHaveSecuritiesResponse, DefaultError, SecurityControllerDoesPersonHaveSecuritiesResponse, ReturnType<typeof securityControllerDoesPersonHaveSecuritiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerDoesPersonHaveSecurities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerDoesPersonHaveSecuritiesQueryKey(options)
});

export const securityControllerGetPersonSecuritiesWithFeaturesAndRanksQueryKey = (options: Options<SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData>) => createQueryKey('securityControllerGetPersonSecuritiesWithFeaturesAndRanks', options);

/**
 * Securities with features and ranks for person
 */
export const securityControllerGetPersonSecuritiesWithFeaturesAndRanksOptions = (options: Options<SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData>) => queryOptions<SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponse, DefaultError, SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponse, ReturnType<typeof securityControllerGetPersonSecuritiesWithFeaturesAndRanksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetPersonSecuritiesWithFeaturesAndRanks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetPersonSecuritiesWithFeaturesAndRanksQueryKey(options)
});

/**
 * Check if we have InvestmentWorkflow and how many
 */
export const securityControllerIsSecuritiesUsedInAnyMipMutation = (options?: Partial<Options<SecurityControllerIsSecuritiesUsedInAnyMipData>>): UseMutationOptions<SecurityControllerIsSecuritiesUsedInAnyMipResponse, DefaultError, Options<SecurityControllerIsSecuritiesUsedInAnyMipData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerIsSecuritiesUsedInAnyMipResponse, DefaultError, Options<SecurityControllerIsSecuritiesUsedInAnyMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerIsSecuritiesUsedInAnyMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create security
 */
export const securityControllerCreateSecurityMutation = (options?: Partial<Options<SecurityControllerCreateSecurityData>>): UseMutationOptions<SecurityControllerCreateSecurityResponse, DefaultError, Options<SecurityControllerCreateSecurityData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerCreateSecurityResponse, DefaultError, Options<SecurityControllerCreateSecurityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerCreateSecurity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update security
 */
export const securityControllerUpdateSecurityMutation = (options?: Partial<Options<SecurityControllerUpdateSecurityData>>): UseMutationOptions<SecurityControllerUpdateSecurityResponse, DefaultError, Options<SecurityControllerUpdateSecurityData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerUpdateSecurityResponse, DefaultError, Options<SecurityControllerUpdateSecurityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerUpdateSecurity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create securities
 */
export const securityControllerBulkCreateSecuritiesMutation = (options?: Partial<Options<SecurityControllerBulkCreateSecuritiesData>>): UseMutationOptions<SecurityControllerBulkCreateSecuritiesResponse, DefaultError, Options<SecurityControllerBulkCreateSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerBulkCreateSecuritiesResponse, DefaultError, Options<SecurityControllerBulkCreateSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerBulkCreateSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update securities
 */
export const securityControllerBulkUpdateSecuritiesMutation = (options?: Partial<Options<SecurityControllerBulkUpdateSecuritiesData>>): UseMutationOptions<SecurityControllerBulkUpdateSecuritiesResponse, DefaultError, Options<SecurityControllerBulkUpdateSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerBulkUpdateSecuritiesResponse, DefaultError, Options<SecurityControllerBulkUpdateSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerBulkUpdateSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update tracked securities
 */
export const securityControllerBulkUpdateTrackedSecuritiesMutation = (options?: Partial<Options<SecurityControllerBulkUpdateTrackedSecuritiesData>>): UseMutationOptions<SecurityControllerBulkUpdateTrackedSecuritiesResponse, DefaultError, Options<SecurityControllerBulkUpdateTrackedSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerBulkUpdateTrackedSecuritiesResponse, DefaultError, Options<SecurityControllerBulkUpdateTrackedSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerBulkUpdateTrackedSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk delete tracked securities
 */
export const securityControllerBulkDeleteTrackedSecuritiesMutation = (options?: Partial<Options<SecurityControllerBulkDeleteTrackedSecuritiesData>>): UseMutationOptions<SecurityControllerBulkDeleteTrackedSecuritiesResponse, DefaultError, Options<SecurityControllerBulkDeleteTrackedSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerBulkDeleteTrackedSecuritiesResponse, DefaultError, Options<SecurityControllerBulkDeleteTrackedSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerBulkDeleteTrackedSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update currency for all securities issued by person
 */
export const securityControllerUpdateCurrencyForPersonSecuritiesMutation = (options?: Partial<Options<SecurityControllerUpdateCurrencyForPersonSecuritiesData>>): UseMutationOptions<SecurityControllerUpdateCurrencyForPersonSecuritiesResponse, DefaultError, Options<SecurityControllerUpdateCurrencyForPersonSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerUpdateCurrencyForPersonSecuritiesResponse, DefaultError, Options<SecurityControllerUpdateCurrencyForPersonSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerUpdateCurrencyForPersonSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete security
 */
export const securityControllerSoftDeleteSecurityMutation = (options?: Partial<Options<SecurityControllerSoftDeleteSecurityData>>): UseMutationOptions<unknown, DefaultError, Options<SecurityControllerSoftDeleteSecurityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SecurityControllerSoftDeleteSecurityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerSoftDeleteSecurity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk delete securities
 */
export const securityControllerBulkSoftDeleteSecuritiesMutation = (options?: Partial<Options<SecurityControllerBulkSoftDeleteSecuritiesData>>): UseMutationOptions<SecurityControllerBulkSoftDeleteSecuritiesResponse, DefaultError, Options<SecurityControllerBulkSoftDeleteSecuritiesData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerBulkSoftDeleteSecuritiesResponse, DefaultError, Options<SecurityControllerBulkSoftDeleteSecuritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerBulkSoftDeleteSecurities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download excel file with securities
 */
export const securityControllerDownloadExcelMutation = (options?: Partial<Options<SecurityControllerDownloadExcelData>>): UseMutationOptions<SecurityControllerDownloadExcelResponse, DefaultError, Options<SecurityControllerDownloadExcelData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerDownloadExcelResponse, DefaultError, Options<SecurityControllerDownloadExcelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerDownloadExcel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update authorised capital on security
 */
export const securityControllerUpdateSecurityAuthorisedCapitalMutation = (options?: Partial<Options<SecurityControllerUpdateSecurityAuthorisedCapitalData>>): UseMutationOptions<SecurityControllerUpdateSecurityAuthorisedCapitalResponse, DefaultError, Options<SecurityControllerUpdateSecurityAuthorisedCapitalData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerUpdateSecurityAuthorisedCapitalResponse, DefaultError, Options<SecurityControllerUpdateSecurityAuthorisedCapitalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerUpdateSecurityAuthorisedCapital({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update participation threshold on security
 */
export const securityControllerUpdateSecurityParticipationThresholdMutation = (options?: Partial<Options<SecurityControllerUpdateSecurityParticipationThresholdData>>): UseMutationOptions<SecurityControllerUpdateSecurityParticipationThresholdResponse, DefaultError, Options<SecurityControllerUpdateSecurityParticipationThresholdData>> => {
    const mutationOptions: UseMutationOptions<SecurityControllerUpdateSecurityParticipationThresholdResponse, DefaultError, Options<SecurityControllerUpdateSecurityParticipationThresholdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityControllerUpdateSecurityParticipationThreshold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const securityControllerGetSecurityNominalValueQueryKey = (options: Options<SecurityControllerGetSecurityNominalValueData>) => createQueryKey('securityControllerGetSecurityNominalValue', options);

/**
 * Get nominal value for security
 */
export const securityControllerGetSecurityNominalValueOptions = (options: Options<SecurityControllerGetSecurityNominalValueData>) => queryOptions<SecurityControllerGetSecurityNominalValueResponse, DefaultError, SecurityControllerGetSecurityNominalValueResponse, ReturnType<typeof securityControllerGetSecurityNominalValueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityControllerGetSecurityNominalValue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityControllerGetSecurityNominalValueQueryKey(options)
});

/**
 * Delete exchange rights for security
 */
export const securityExchangeRightsControllerSoftDeleteSecurityExchangeRightsMutation = (options?: Partial<Options<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData>>): UseMutationOptions<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponse, DefaultError, Options<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponse, DefaultError, Options<SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityExchangeRightsControllerSoftDeleteSecurityExchangeRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update exchange rights for security
 */
export const securityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsMutation = (options?: Partial<Options<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData>>): UseMutationOptions<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponse, DefaultError, Options<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponse, DefaultError, Options<SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityExchangeRightsControllerCreateOrUpdateSecurityExchangeRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete interest definition for security
 */
export const securityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionMutation = (options?: Partial<Options<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData>>): UseMutationOptions<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponse, DefaultError, Options<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData>> => {
    const mutationOptions: UseMutationOptions<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponse, DefaultError, Options<SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityInterestRedemptionControllerSoftDeleteSecurityInterestDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update interest definition for security
 */
export const securityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionMutation = (options?: Partial<Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData>>): UseMutationOptions<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponse, DefaultError, Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData>> => {
    const mutationOptions: UseMutationOptions<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponse, DefaultError, Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete redemption rights for security
 */
export const securityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsMutation = (options?: Partial<Options<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData>>): UseMutationOptions<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponse, DefaultError, Options<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponse, DefaultError, Options<SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityInterestRedemptionControllerSoftDeleteSecurityRedemptionRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update redemption rights for security
 */
export const securityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsMutation = (options?: Partial<Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData>>): UseMutationOptions<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponse, DefaultError, Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponse, DefaultError, Options<SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete catch up rights for security
 */
export const securityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsMutation = (options?: Partial<Options<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData>>): UseMutationOptions<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponse, DefaultError, Options<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponse, DefaultError, Options<SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityCatchUpRightsControllerSoftDeleteSecurityCatchUpRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update catch up rights for security
 */
export const securityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsMutation = (options?: Partial<Options<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData>>): UseMutationOptions<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponse, DefaultError, Options<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData>> => {
    const mutationOptions: UseMutationOptions<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponse, DefaultError, Options<SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerSoftDeleteMutation = (options?: Partial<Options<SecurityLiquidationPreferenceControllerSoftDeleteData>>): UseMutationOptions<SecurityLiquidationPreferenceControllerSoftDeleteResponse, DefaultError, Options<SecurityLiquidationPreferenceControllerSoftDeleteData>> => {
    const mutationOptions: UseMutationOptions<SecurityLiquidationPreferenceControllerSoftDeleteResponse, DefaultError, Options<SecurityLiquidationPreferenceControllerSoftDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityLiquidationPreferenceControllerSoftDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const securityLiquidationPreferenceControllerGetQueryKey = (options: Options<SecurityLiquidationPreferenceControllerGetData>) => createQueryKey('securityLiquidationPreferenceControllerGet', options);

/**
 * Get the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerGetOptions = (options: Options<SecurityLiquidationPreferenceControllerGetData>) => queryOptions<SecurityLiquidationPreferenceControllerGetResponse, DefaultError, SecurityLiquidationPreferenceControllerGetResponse, ReturnType<typeof securityLiquidationPreferenceControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityLiquidationPreferenceControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityLiquidationPreferenceControllerGetQueryKey(options)
});

/**
 * Create or update the liquidation preference for a security
 */
export const securityLiquidationPreferenceControllerCreateOrUpdateMutation = (options?: Partial<Options<SecurityLiquidationPreferenceControllerCreateOrUpdateData>>): UseMutationOptions<SecurityLiquidationPreferenceControllerCreateOrUpdateResponse, DefaultError, Options<SecurityLiquidationPreferenceControllerCreateOrUpdateData>> => {
    const mutationOptions: UseMutationOptions<SecurityLiquidationPreferenceControllerCreateOrUpdateResponse, DefaultError, Options<SecurityLiquidationPreferenceControllerCreateOrUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityLiquidationPreferenceControllerCreateOrUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorInvestmentWorkflowControllerGetReleaseWorkflowStatusQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData>) => createQueryKey('investorInvestmentWorkflowControllerGetReleaseWorkflowStatus', options);

/**
 * Release workflow progress updates
 */
export const investorInvestmentWorkflowControllerGetReleaseWorkflowStatusOptions = (options: Options<InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData>) => queryOptions<InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponse, DefaultError, InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetReleaseWorkflowStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetReleaseWorkflowStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetReleaseWorkflowStatusQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetInvestmentDetailsSummaryQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsSummary', options);

/**
 * Investment details — summary (header + sidebar)
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsSummaryOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsSummaryQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsAllocations', options);

/**
 * Investment details — allocations
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsAllocations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsQueryKey(options)
});

/**
 * Investment details — add single allocation
 */
export const investorInvestmentWorkflowControllerAddInvestmentAllocationMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerAddInvestmentAllocationData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerAddInvestmentAllocationData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerAddInvestmentAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerAddInvestmentAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocuments', options);

/**
 * Investment details — legal documents
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetManageableLegalDocumentsQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData>) => createQueryKey('investorInvestmentWorkflowControllerGetManageableLegalDocuments', options);

/**
 * Investment details — manageable master documents
 */
export const investorInvestmentWorkflowControllerGetManageableLegalDocumentsOptions = (options: Options<InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData>) => queryOptions<InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponse, DefaultError, InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetManageableLegalDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetManageableLegalDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetManageableLegalDocumentsQueryKey(options)
});

/**
 * Investment details — toggle a master legal document on/off
 */
export const investorInvestmentWorkflowControllerToggleLegalDocumentMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerToggleLegalDocumentData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerToggleLegalDocumentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerToggleLegalDocumentData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerToggleLegalDocumentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerToggleLegalDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerToggleLegalDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformation', options);

/**
 * Investment details — bank information
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsOtherData', options);

/**
 * Investment details — other data
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsOtherData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsTaxCompliance', options);

/**
 * Investment details — tax compliance
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsTaxCompliance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceQueryKey(options)
});

export const investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusQueryKey = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData>) => createQueryKey('investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatus', options);

/**
 * Investment details — KYC status
 */
export const investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusOptions = (options: Options<InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData>) => queryOptions<InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponse, DefaultError, InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponse, ReturnType<typeof investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusQueryKey(options)
});

/**
 * Investment details — start the investment workflow
 */
export const investorInvestmentWorkflowControllerStartInvestmentMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerStartInvestmentData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerStartInvestmentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerStartInvestmentData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerStartInvestmentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerStartInvestmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerStartInvestment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — approve the investment (Open → Definition Complete)
 */
export const investorInvestmentWorkflowControllerApproveInvestmentMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerApproveInvestmentData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerApproveInvestmentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerApproveInvestmentData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerApproveInvestmentResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerApproveInvestmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerApproveInvestment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — move the investment back to Open
 */
export const investorInvestmentWorkflowControllerMakeDraftMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerMakeDraftData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerMakeDraftResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerMakeDraftData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerMakeDraftResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerMakeDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerMakeDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — set target start / completion dates
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerSetInvestmentDetailsTargetDates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — set investment vehicle (PIV)
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsPivMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerSetInvestmentDetailsPiv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — set selected bank account
 */
export const investorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerSetInvestmentDetailsBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk release InvestmentWorkflow
 */
export const investorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release single InvestmentWorkflow
 */
export const investorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP investments
 */
export const investorInvestmentWorkflowControllerGetInvestmentsForMipMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerGetInvestmentsForMipData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerGetInvestmentsForMipData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerGetInvestmentsForMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerGetInvestmentsForMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get the ids of every investment the list matches, in list order, ignoring paging
 */
export const investorInvestmentWorkflowControllerGetOrderedInvestmentIdsMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerGetOrderedInvestmentIds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update the expected transaction type on investment allocations
 */
export const investorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerBulkUpdateExpectedTransactionType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download investments excel
 */
export const investorInvestmentWorkflowControllerDownloadExcelMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerDownloadExcelData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerDownloadExcelResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerDownloadExcelData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerDownloadExcelResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerDownloadExcelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerDownloadExcel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — remove single allocation
 */
export const investorInvestmentWorkflowControllerRemoveInvestmentAllocationMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerRemoveInvestmentAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — update single allocation
 */
export const investorInvestmentWorkflowControllerUpdateInvestmentAllocationMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerUpdateInvestmentAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — add a single loan
 */
export const investorInvestmentWorkflowControllerAddInvestmentLoanMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerAddInvestmentLoanData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerAddInvestmentLoanResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerAddInvestmentLoanData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerAddInvestmentLoanResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerAddInvestmentLoanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerAddInvestmentLoan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — remove single loan (soft-delete)
 */
export const investorInvestmentWorkflowControllerRemoveInvestmentLoanMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerRemoveInvestmentLoan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Investment details — update single loan
 */
export const investorInvestmentWorkflowControllerUpdateInvestmentLoanMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData>>): UseMutationOptions<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData>> => {
    const mutationOptions: UseMutationOptions<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponse, DefaultError, Options<InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerUpdateInvestmentLoan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk upsert share associations
 */
export const investorInvestmentWorkflowControllerUpsertShareAssociationsMutation = (options?: Partial<Options<InvestorInvestmentWorkflowControllerUpsertShareAssociationsData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerUpsertShareAssociationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorInvestmentWorkflowControllerUpsertShareAssociationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorInvestmentWorkflowControllerUpsertShareAssociations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP investors data list
 */
export const investorControllerGetMipInvestorsListMutation = (options?: Partial<Options<InvestorControllerGetMipInvestorsListData>>): UseMutationOptions<InvestorControllerGetMipInvestorsListResponse, DefaultError, Options<InvestorControllerGetMipInvestorsListData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipInvestorsListResponse, DefaultError, Options<InvestorControllerGetMipInvestorsListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipInvestorsList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get the ids of every investor the list matches, in list order, ignoring paging
 */
export const investorControllerGetMipInvestorsOrderedIdsMutation = (options?: Partial<Options<InvestorControllerGetMipInvestorsOrderedIdsData>>): UseMutationOptions<InvestorControllerGetMipInvestorsOrderedIdsResponse, DefaultError, Options<InvestorControllerGetMipInvestorsOrderedIdsData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipInvestorsOrderedIdsResponse, DefaultError, Options<InvestorControllerGetMipInvestorsOrderedIdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipInvestorsOrderedIds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP investors data for send modal
 */
export const investorControllerGetMipInvestorsDataForSendModalMutation = (options?: Partial<Options<InvestorControllerGetMipInvestorsDataForSendModalData>>): UseMutationOptions<InvestorControllerGetMipInvestorsDataForSendModalResponse, DefaultError, Options<InvestorControllerGetMipInvestorsDataForSendModalData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipInvestorsDataForSendModalResponse, DefaultError, Options<InvestorControllerGetMipInvestorsDataForSendModalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipInvestorsDataForSendModal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP selected investors data
 */
export const investorControllerGetMipSelectedInvestorsDataMutation = (options?: Partial<Options<InvestorControllerGetMipSelectedInvestorsDataData>>): UseMutationOptions<InvestorControllerGetMipSelectedInvestorsDataResponse, DefaultError, Options<InvestorControllerGetMipSelectedInvestorsDataData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipSelectedInvestorsDataResponse, DefaultError, Options<InvestorControllerGetMipSelectedInvestorsDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipSelectedInvestorsData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP investors ids
 */
export const investorControllerGetMipInvestorsIdsMutation = (options?: Partial<Options<InvestorControllerGetMipInvestorsIdsData>>): UseMutationOptions<InvestorControllerGetMipInvestorsIdsResponse, DefaultError, Options<InvestorControllerGetMipInvestorsIdsData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipInvestorsIdsResponse, DefaultError, Options<InvestorControllerGetMipInvestorsIdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipInvestorsIds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorControllerGetMipInvestorByIdQueryKey = (options: Options<InvestorControllerGetMipInvestorByIdData>) => createQueryKey('investorControllerGetMipInvestorById', options);

/**
 * Get MIP investor by id
 */
export const investorControllerGetMipInvestorByIdOptions = (options: Options<InvestorControllerGetMipInvestorByIdData>) => queryOptions<InvestorControllerGetMipInvestorByIdResponse, DefaultError, InvestorControllerGetMipInvestorByIdResponse, ReturnType<typeof investorControllerGetMipInvestorByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetMipInvestorById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestorByIdQueryKey(options)
});

export const investorControllerGetInvestorInvestmentsAndTransactionsQueryKey = (options: Options<InvestorControllerGetInvestorInvestmentsAndTransactionsData>) => createQueryKey('investorControllerGetInvestorInvestmentsAndTransactions', options);

/**
 * Get investor investments and transactions by investor id
 */
export const investorControllerGetInvestorInvestmentsAndTransactionsOptions = (options: Options<InvestorControllerGetInvestorInvestmentsAndTransactionsData>) => queryOptions<InvestorControllerGetInvestorInvestmentsAndTransactionsResponse, DefaultError, InvestorControllerGetInvestorInvestmentsAndTransactionsResponse, ReturnType<typeof investorControllerGetInvestorInvestmentsAndTransactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorInvestmentsAndTransactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorInvestmentsAndTransactionsQueryKey(options)
});

export const investorControllerGetMipInvestorDocumentWorkflowListByIdQueryKey = (options: Options<InvestorControllerGetMipInvestorDocumentWorkflowListByIdData>) => createQueryKey('investorControllerGetMipInvestorDocumentWorkflowListById', options);

/**
 * Get MIP investor document workflow list by investor id
 */
export const investorControllerGetMipInvestorDocumentWorkflowListByIdOptions = (options: Options<InvestorControllerGetMipInvestorDocumentWorkflowListByIdData>) => queryOptions<InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponse, DefaultError, InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponse, ReturnType<typeof investorControllerGetMipInvestorDocumentWorkflowListByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetMipInvestorDocumentWorkflowListById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestorDocumentWorkflowListByIdQueryKey(options)
});

/**
 * Send investor invites
 */
export const investorControllerSendInvitesMutation = (options?: Partial<Options<InvestorControllerSendInvitesData>>): UseMutationOptions<InvestorControllerSendInvitesResponse, DefaultError, Options<InvestorControllerSendInvitesData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerSendInvitesResponse, DefaultError, Options<InvestorControllerSendInvitesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerSendInvites({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP investors securities list
 */
export const investorControllerGetMipInvestorsSecuritiesListDataMutation = (options?: Partial<Options<InvestorControllerGetMipInvestorsSecuritiesListDataData>>): UseMutationOptions<InvestorControllerGetMipInvestorsSecuritiesListDataResponse, DefaultError, Options<InvestorControllerGetMipInvestorsSecuritiesListDataData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerGetMipInvestorsSecuritiesListDataResponse, DefaultError, Options<InvestorControllerGetMipInvestorsSecuritiesListDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipInvestorsSecuritiesListData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP Joiner Investors template xlsx
 */
export const investorControllerGetMipDraftJoinerInvestorTemplateMutation = (options?: Partial<Options<InvestorControllerGetMipDraftJoinerInvestorTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerGetMipDraftJoinerInvestorTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerGetMipDraftJoinerInvestorTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipDraftJoinerInvestorTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post file with investors and securities
 */
export const investorControllerPostMipDraftJoinerInvestorTemplateMutation = (options?: Partial<Options<InvestorControllerPostMipDraftJoinerInvestorTemplateData>>): UseMutationOptions<InvestorControllerPostMipDraftJoinerInvestorTemplateResponse, DefaultError, Options<InvestorControllerPostMipDraftJoinerInvestorTemplateData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerPostMipDraftJoinerInvestorTemplateResponse, DefaultError, Options<InvestorControllerPostMipDraftJoinerInvestorTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPostMipDraftJoinerInvestorTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIP Leaver Investors template xlsx
 */
export const investorControllerGetMipDraftLeaverInvestorTemplateMutation = (options?: Partial<Options<InvestorControllerGetMipDraftLeaverInvestorTemplateData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerGetMipDraftLeaverInvestorTemplateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerGetMipDraftLeaverInvestorTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerGetMipDraftLeaverInvestorTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post file with investors, securities & loans
 */
export const investorControllerPostMipDraftJLeaverInvestorTemplateMutation = (options?: Partial<Options<InvestorControllerPostMipDraftJLeaverInvestorTemplateData>>): UseMutationOptions<InvestorControllerPostMipDraftJLeaverInvestorTemplateResponse, DefaultError, Options<InvestorControllerPostMipDraftJLeaverInvestorTemplateData>> => {
    const mutationOptions: UseMutationOptions<InvestorControllerPostMipDraftJLeaverInvestorTemplateResponse, DefaultError, Options<InvestorControllerPostMipDraftJLeaverInvestorTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPostMipDraftJLeaverInvestorTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download xlsx with data for provided investors
 */
export const investorControllerDownloadInvestorsDataMutation = (options?: Partial<Options<InvestorControllerDownloadInvestorsDataData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerDownloadInvestorsDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerDownloadInvestorsDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerDownloadInvestorsData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate excel file for all provided investors and upload it to S3
 */
export const investorControllerStartDownloadInvestorsDataWorkflowMutation = (options?: Partial<Options<InvestorControllerStartDownloadInvestorsDataWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerStartDownloadInvestorsDataWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerStartDownloadInvestorsDataWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerStartDownloadInvestorsDataWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke InvestmentWorkflow
 */
export const investorControllerPostRevokeTsaMutation = (options?: Partial<Options<InvestorControllerPostRevokeTsaData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostRevokeTsaData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostRevokeTsaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPostRevokeTsa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk revoke InvestmentWorkflows
 */
export const investorControllerPostBulkRevokeTsaMutation = (options?: Partial<Options<InvestorControllerPostBulkRevokeTsaData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostBulkRevokeTsaData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostBulkRevokeTsaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPostBulkRevokeTsa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove investor
 */
export const investorControllerPostRemoveInvestorMutation = (options?: Partial<Options<InvestorControllerPostRemoveInvestorData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostRemoveInvestorData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPostRemoveInvestorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPostRemoveInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the investor's custom field values
 */
export const investorControllerPutInvestorCustomDetailsMutation = (options?: Partial<Options<InvestorControllerPutInvestorCustomDetailsData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPutInvestorCustomDetailsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerPutInvestorCustomDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerPutInvestorCustomDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorControllerGetSecurityVestingDataQueryKey = (options: Options<InvestorControllerGetSecurityVestingDataData>) => createQueryKey('investorControllerGetSecurityVestingData', options);

/**
 * Get vesting data for a specific security of an investor
 */
export const investorControllerGetSecurityVestingDataOptions = (options: Options<InvestorControllerGetSecurityVestingDataData>) => queryOptions<InvestorControllerGetSecurityVestingDataResponse, DefaultError, InvestorControllerGetSecurityVestingDataResponse, ReturnType<typeof investorControllerGetSecurityVestingDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetSecurityVestingData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetSecurityVestingDataQueryKey(options)
});

export const investorControllerGetInvestorInvestmentValuationsQueryKey = (options: Options<InvestorControllerGetInvestorInvestmentValuationsData>) => createQueryKey('investorControllerGetInvestorInvestmentValuations', options);

/**
 * Get list of investor valuations
 */
export const investorControllerGetInvestorInvestmentValuationsOptions = (options: Options<InvestorControllerGetInvestorInvestmentValuationsData>) => queryOptions<InvestorControllerGetInvestorInvestmentValuationsResponse, DefaultError, InvestorControllerGetInvestorInvestmentValuationsResponse, ReturnType<typeof investorControllerGetInvestorInvestmentValuationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorInvestmentValuations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorInvestmentValuationsQueryKey(options)
});

export const investorControllerGetInvestmentVehicleValuationsQueryKey = (options: Options<InvestorControllerGetInvestmentVehicleValuationsData>) => createQueryKey('investorControllerGetInvestmentVehicleValuations', options);

/**
 * Get an investment vehicle's aggregated holdings and loans
 */
export const investorControllerGetInvestmentVehicleValuationsOptions = (options: Options<InvestorControllerGetInvestmentVehicleValuationsData>) => queryOptions<InvestorControllerGetInvestmentVehicleValuationsResponse, DefaultError, InvestorControllerGetInvestmentVehicleValuationsResponse, ReturnType<typeof investorControllerGetInvestmentVehicleValuationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestmentVehicleValuations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestmentVehicleValuationsQueryKey(options)
});

export const investorControllerGetInvestmentVehicleRelatedPeopleQueryKey = (options: Options<InvestorControllerGetInvestmentVehicleRelatedPeopleData>) => createQueryKey('investorControllerGetInvestmentVehicleRelatedPeople', options);

/**
 * Get the people related to an investment vehicle
 */
export const investorControllerGetInvestmentVehicleRelatedPeopleOptions = (options: Options<InvestorControllerGetInvestmentVehicleRelatedPeopleData>) => queryOptions<InvestorControllerGetInvestmentVehicleRelatedPeopleResponse, DefaultError, InvestorControllerGetInvestmentVehicleRelatedPeopleResponse, ReturnType<typeof investorControllerGetInvestmentVehicleRelatedPeopleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestmentVehicleRelatedPeople({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestmentVehicleRelatedPeopleQueryKey(options)
});

export const investorControllerGetInvestmentVehicleHoldingsQueryKey = (options: Options<InvestorControllerGetInvestmentVehicleHoldingsData>) => createQueryKey('investorControllerGetInvestmentVehicleHoldings', options);

/**
 * An investment vehicle's holdings, one row per security per investor held for
 */
export const investorControllerGetInvestmentVehicleHoldingsOptions = (options: Options<InvestorControllerGetInvestmentVehicleHoldingsData>) => queryOptions<InvestorControllerGetInvestmentVehicleHoldingsResponse, DefaultError, InvestorControllerGetInvestmentVehicleHoldingsResponse, ReturnType<typeof investorControllerGetInvestmentVehicleHoldingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestmentVehicleHoldings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestmentVehicleHoldingsQueryKey(options)
});

export const investorControllerGetInvestmentVehicleQuickLinksQueryKey = (options: Options<InvestorControllerGetInvestmentVehicleQuickLinksData>) => createQueryKey('investorControllerGetInvestmentVehicleQuickLinks', options);

/**
 * Quick link counts for an investment vehicle, across its investors
 */
export const investorControllerGetInvestmentVehicleQuickLinksOptions = (options: Options<InvestorControllerGetInvestmentVehicleQuickLinksData>) => queryOptions<InvestorControllerGetInvestmentVehicleQuickLinksResponse, DefaultError, InvestorControllerGetInvestmentVehicleQuickLinksResponse, ReturnType<typeof investorControllerGetInvestmentVehicleQuickLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestmentVehicleQuickLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestmentVehicleQuickLinksQueryKey(options)
});

export const investorControllerGetInvestorQuickLinksQueryKey = (options: Options<InvestorControllerGetInvestorQuickLinksData>) => createQueryKey('investorControllerGetInvestorQuickLinks', options);

/**
 * Get active and total counts behind the investor quick links
 */
export const investorControllerGetInvestorQuickLinksOptions = (options: Options<InvestorControllerGetInvestorQuickLinksData>) => queryOptions<InvestorControllerGetInvestorQuickLinksResponse, DefaultError, InvestorControllerGetInvestorQuickLinksResponse, ReturnType<typeof investorControllerGetInvestorQuickLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorQuickLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorQuickLinksQueryKey(options)
});

export const investorControllerGetInvestorJourneysQueryKey = (options: Options<InvestorControllerGetInvestorJourneysData>) => createQueryKey('investorControllerGetInvestorJourneys', options);

/**
 * Get the investor open journeys, deduplicated
 */
export const investorControllerGetInvestorJourneysOptions = (options: Options<InvestorControllerGetInvestorJourneysData>) => queryOptions<InvestorControllerGetInvestorJourneysResponse, DefaultError, InvestorControllerGetInvestorJourneysResponse, ReturnType<typeof investorControllerGetInvestorJourneysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorJourneys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorJourneysQueryKey(options)
});

export const investorControllerGetInvestorHoldingsQueryKey = (options: Options<InvestorControllerGetInvestorHoldingsData>) => createQueryKey('investorControllerGetInvestorHoldings', options);

/**
 * Get holdings by or for an investor, including via vehicles
 */
export const investorControllerGetInvestorHoldingsOptions = (options: Options<InvestorControllerGetInvestorHoldingsData>) => queryOptions<InvestorControllerGetInvestorHoldingsResponse, DefaultError, InvestorControllerGetInvestorHoldingsResponse, ReturnType<typeof investorControllerGetInvestorHoldingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorHoldings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorHoldingsQueryKey(options)
});

export const investorControllerGetInvestorHoldingTransactionsQueryKey = (options: Options<InvestorControllerGetInvestorHoldingTransactionsData>) => createQueryKey('investorControllerGetInvestorHoldingTransactions', options);

/**
 * The acquisitions and disposals behind one of an investor's holdings
 */
export const investorControllerGetInvestorHoldingTransactionsOptions = (options: Options<InvestorControllerGetInvestorHoldingTransactionsData>) => queryOptions<InvestorControllerGetInvestorHoldingTransactionsResponse, DefaultError, InvestorControllerGetInvestorHoldingTransactionsResponse, ReturnType<typeof investorControllerGetInvestorHoldingTransactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetInvestorHoldingTransactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetInvestorHoldingTransactionsQueryKey(options)
});

export const investorControllerGetMipInvestorNamesForFilteringQueryKey = (options?: Options<InvestorControllerGetMipInvestorNamesForFilteringData>) => createQueryKey('investorControllerGetMipInvestorNamesForFiltering', options);

/**
 * Get MIP Investor names for filtering
 */
export const investorControllerGetMipInvestorNamesForFilteringOptions = (options?: Options<InvestorControllerGetMipInvestorNamesForFilteringData>) => queryOptions<InvestorControllerGetMipInvestorNamesForFilteringResponse, DefaultError, InvestorControllerGetMipInvestorNamesForFilteringResponse, ReturnType<typeof investorControllerGetMipInvestorNamesForFilteringQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetMipInvestorNamesForFiltering({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestorNamesForFilteringQueryKey(options)
});

export const investorControllerGetMipInvestorNamesForFilteringInfiniteQueryKey = (options?: Options<InvestorControllerGetMipInvestorNamesForFilteringData>): QueryKey<Options<InvestorControllerGetMipInvestorNamesForFilteringData>> => createQueryKey('investorControllerGetMipInvestorNamesForFiltering', options, true);

/**
 * Get MIP Investor names for filtering
 */
export const investorControllerGetMipInvestorNamesForFilteringInfiniteOptions = (options?: Options<InvestorControllerGetMipInvestorNamesForFilteringData>) => infiniteQueryOptions<InvestorControllerGetMipInvestorNamesForFilteringResponse, DefaultError, InfiniteData<InvestorControllerGetMipInvestorNamesForFilteringResponse>, QueryKey<Options<InvestorControllerGetMipInvestorNamesForFilteringData>>, string | Pick<QueryKey<Options<InvestorControllerGetMipInvestorNamesForFilteringData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InvestorControllerGetMipInvestorNamesForFilteringData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await investorControllerGetMipInvestorNamesForFiltering({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestorNamesForFilteringInfiniteQueryKey(options)
});

export const investorControllerGetMipInvestmentVehicleNamesForFilteringQueryKey = (options?: Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>) => createQueryKey('investorControllerGetMipInvestmentVehicleNamesForFiltering', options);

/**
 * Get MIP investment vehicle names for filtering
 */
export const investorControllerGetMipInvestmentVehicleNamesForFilteringOptions = (options?: Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>) => queryOptions<InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse, DefaultError, InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse, ReturnType<typeof investorControllerGetMipInvestmentVehicleNamesForFilteringQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorControllerGetMipInvestmentVehicleNamesForFiltering({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestmentVehicleNamesForFilteringQueryKey(options)
});

export const investorControllerGetMipInvestmentVehicleNamesForFilteringInfiniteQueryKey = (options?: Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>): QueryKey<Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>> => createQueryKey('investorControllerGetMipInvestmentVehicleNamesForFiltering', options, true);

/**
 * Get MIP investment vehicle names for filtering
 */
export const investorControllerGetMipInvestmentVehicleNamesForFilteringInfiniteOptions = (options?: Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>) => infiniteQueryOptions<InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse, DefaultError, InfiniteData<InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse>, QueryKey<Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>>, string | Pick<QueryKey<Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<InvestorControllerGetMipInvestmentVehicleNamesForFilteringData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await investorControllerGetMipInvestmentVehicleNamesForFiltering({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorControllerGetMipInvestmentVehicleNamesForFilteringInfiniteQueryKey(options)
});

/**
 * Request KYC for selected investors
 */
export const investorControllerRequestKycMutation = (options?: Partial<Options<InvestorControllerRequestKycData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorControllerRequestKycData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorControllerRequestKycData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorControllerRequestKyc({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post file with investors and securities
 */
export const investorDraftControllerPostMipDraftInvestorTemplateMutation = (options?: Partial<Options<InvestorDraftControllerPostMipDraftInvestorTemplateData>>): UseMutationOptions<InvestorDraftControllerPostMipDraftInvestorTemplateResponse, DefaultError, Options<InvestorDraftControllerPostMipDraftInvestorTemplateData>> => {
    const mutationOptions: UseMutationOptions<InvestorDraftControllerPostMipDraftInvestorTemplateResponse, DefaultError, Options<InvestorDraftControllerPostMipDraftInvestorTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorDraftControllerPostMipDraftInvestorTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorDraftControllerGetMipInvestorsQueryKey = (options?: Options<InvestorDraftControllerGetMipInvestorsData>) => createQueryKey('investorDraftControllerGetMipInvestors', options);

/**
 * Get MIP Draft Investors data from DB
 */
export const investorDraftControllerGetMipInvestorsOptions = (options?: Options<InvestorDraftControllerGetMipInvestorsData>) => queryOptions<InvestorDraftControllerGetMipInvestorsResponse, DefaultError, InvestorDraftControllerGetMipInvestorsResponse, ReturnType<typeof investorDraftControllerGetMipInvestorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorDraftControllerGetMipInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorDraftControllerGetMipInvestorsQueryKey(options)
});

/**
 * Update MIP Draft Investors DB, removes all previous data
 */
export const investorDraftControllerPostMipDraftInvestorDataMutation = (options?: Partial<Options<InvestorDraftControllerPostMipDraftInvestorDataData>>): UseMutationOptions<unknown, DefaultError, Options<InvestorDraftControllerPostMipDraftInvestorDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestorDraftControllerPostMipDraftInvestorDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorDraftControllerPostMipDraftInvestorData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const paymentControllerGetStatusQueryKey = (options?: Options<PaymentControllerGetStatusData>) => createQueryKey('paymentControllerGetStatus', options);

/**
 * Get MIP payments
 */
export const paymentControllerGetStatusOptions = (options?: Options<PaymentControllerGetStatusData>) => queryOptions<PaymentControllerGetStatusResponse, DefaultError, PaymentControllerGetStatusResponse, ReturnType<typeof paymentControllerGetStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentControllerGetStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentControllerGetStatusQueryKey(options)
});

/**
 * Bulk update MIP Payment status
 */
export const paymentControllerBulkUpdateMutation = (options?: Partial<Options<PaymentControllerBulkUpdateData>>): UseMutationOptions<PaymentControllerBulkUpdateResponse, DefaultError, Options<PaymentControllerBulkUpdateData>> => {
    const mutationOptions: UseMutationOptions<PaymentControllerBulkUpdateResponse, DefaultError, Options<PaymentControllerBulkUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentControllerBulkUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP Payment status
 */
export const paymentControllerUpdateMutation = (options?: Partial<Options<PaymentControllerUpdateData>>): UseMutationOptions<unknown, DefaultError, Options<PaymentControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PaymentControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const paymentControllerDownloadMipPaymentsQueryKey = (options?: Options<PaymentControllerDownloadMipPaymentsData>) => createQueryKey('paymentControllerDownloadMipPayments', options);

/**
 * Download xlsx with mip payments
 */
export const paymentControllerDownloadMipPaymentsOptions = (options?: Options<PaymentControllerDownloadMipPaymentsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof paymentControllerDownloadMipPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentControllerDownloadMipPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentControllerDownloadMipPaymentsQueryKey(options)
});

export const loanDefinitionControllerGetLoansDefinitionByMipIdQueryKey = (options?: Options<LoanDefinitionControllerGetLoansDefinitionByMipIdData>) => createQueryKey('loanDefinitionControllerGetLoansDefinitionByMipId', options);

/**
 * Get MIP Loans Definition
 */
export const loanDefinitionControllerGetLoansDefinitionByMipIdOptions = (options?: Options<LoanDefinitionControllerGetLoansDefinitionByMipIdData>) => queryOptions<LoanDefinitionControllerGetLoansDefinitionByMipIdResponse, DefaultError, LoanDefinitionControllerGetLoansDefinitionByMipIdResponse, ReturnType<typeof loanDefinitionControllerGetLoansDefinitionByMipIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await loanDefinitionControllerGetLoansDefinitionByMipId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: loanDefinitionControllerGetLoansDefinitionByMipIdQueryKey(options)
});

/**
 * Create MIP Loans Definition
 */
export const loanDefinitionControllerCreateLoanDefinitionsMutation = (options?: Partial<Options<LoanDefinitionControllerCreateLoanDefinitionsData>>): UseMutationOptions<LoanDefinitionControllerCreateLoanDefinitionsResponse, DefaultError, Options<LoanDefinitionControllerCreateLoanDefinitionsData>> => {
    const mutationOptions: UseMutationOptions<LoanDefinitionControllerCreateLoanDefinitionsResponse, DefaultError, Options<LoanDefinitionControllerCreateLoanDefinitionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loanDefinitionControllerCreateLoanDefinitions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete MIP Loan Definition
 */
export const loanDefinitionControllerDeleteLoanDefinitionMutation = (options?: Partial<Options<LoanDefinitionControllerDeleteLoanDefinitionData>>): UseMutationOptions<unknown, DefaultError, Options<LoanDefinitionControllerDeleteLoanDefinitionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<LoanDefinitionControllerDeleteLoanDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loanDefinitionControllerDeleteLoanDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP Loan Definition
 */
export const loanDefinitionControllerUpdateLoanDefinitionMutation = (options?: Partial<Options<LoanDefinitionControllerUpdateLoanDefinitionData>>): UseMutationOptions<unknown, DefaultError, Options<LoanDefinitionControllerUpdateLoanDefinitionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<LoanDefinitionControllerUpdateLoanDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loanDefinitionControllerUpdateLoanDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive a custom detail
 */
export const customDetailControllerToggleArchivedMutation = (options?: Partial<Options<CustomDetailControllerToggleArchivedData>>): UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerToggleArchivedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerToggleArchivedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customDetailControllerToggleArchived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const customDetailControllerGetAllMipCustomDetailQueryKey = (options?: Options<CustomDetailControllerGetAllMipCustomDetailData>) => createQueryKey('customDetailControllerGetAllMipCustomDetail', options);

/**
 * Get MIP CustomDetails
 */
export const customDetailControllerGetAllMipCustomDetailOptions = (options?: Options<CustomDetailControllerGetAllMipCustomDetailData>) => queryOptions<CustomDetailControllerGetAllMipCustomDetailResponse, DefaultError, CustomDetailControllerGetAllMipCustomDetailResponse, ReturnType<typeof customDetailControllerGetAllMipCustomDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await customDetailControllerGetAllMipCustomDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: customDetailControllerGetAllMipCustomDetailQueryKey(options)
});

/**
 * Create MIP Custom Detail
 */
export const customDetailControllerCreateSingleCustomDetailMutation = (options?: Partial<Options<CustomDetailControllerCreateSingleCustomDetailData>>): UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerCreateSingleCustomDetailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerCreateSingleCustomDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customDetailControllerCreateSingleCustomDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete MIP CustomDetails
 */
export const customDetailControllerDeleteSingleCustomDetailMutation = (options?: Partial<Options<CustomDetailControllerDeleteSingleCustomDetailData>>): UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerDeleteSingleCustomDetailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerDeleteSingleCustomDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customDetailControllerDeleteSingleCustomDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP CustomDetails
 */
export const customDetailControllerUpdateSingleCustomDetailMutation = (options?: Partial<Options<CustomDetailControllerUpdateSingleCustomDetailData>>): UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerUpdateSingleCustomDetailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerUpdateSingleCustomDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customDetailControllerUpdateSingleCustomDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const customDetailControllerGetKycWorkflowCustomDetailsQueryKey = (options: Options<CustomDetailControllerGetKycWorkflowCustomDetailsData>) => createQueryKey('customDetailControllerGetKycWorkflowCustomDetails', options);

/**
 * Get per-investment custom field requirements
 */
export const customDetailControllerGetKycWorkflowCustomDetailsOptions = (options: Options<CustomDetailControllerGetKycWorkflowCustomDetailsData>) => queryOptions<CustomDetailControllerGetKycWorkflowCustomDetailsResponse, DefaultError, CustomDetailControllerGetKycWorkflowCustomDetailsResponse, ReturnType<typeof customDetailControllerGetKycWorkflowCustomDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await customDetailControllerGetKycWorkflowCustomDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: customDetailControllerGetKycWorkflowCustomDetailsQueryKey(options)
});

/**
 * Toggle a custom field requirement for a single investment
 */
export const customDetailControllerUpdateKycWorkflowCustomDetailMutation = (options?: Partial<Options<CustomDetailControllerUpdateKycWorkflowCustomDetailData>>): UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerUpdateKycWorkflowCustomDetailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CustomDetailControllerUpdateKycWorkflowCustomDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customDetailControllerUpdateKycWorkflowCustomDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationControllerGetAllOrganizationsQueryKey = (options?: Options<OrganizationControllerGetAllOrganizationsData>) => createQueryKey('organizationControllerGetAllOrganizations', options);

/**
 * list organizations (DealStack support only)
 */
export const organizationControllerGetAllOrganizationsOptions = (options?: Options<OrganizationControllerGetAllOrganizationsData>) => queryOptions<OrganizationControllerGetAllOrganizationsResponse, DefaultError, OrganizationControllerGetAllOrganizationsResponse, ReturnType<typeof organizationControllerGetAllOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationControllerGetAllOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationControllerGetAllOrganizationsQueryKey(options)
});

export const organizationControllerGetAllOrganizationsInfiniteQueryKey = (options?: Options<OrganizationControllerGetAllOrganizationsData>): QueryKey<Options<OrganizationControllerGetAllOrganizationsData>> => createQueryKey('organizationControllerGetAllOrganizations', options, true);

/**
 * list organizations (DealStack support only)
 */
export const organizationControllerGetAllOrganizationsInfiniteOptions = (options?: Options<OrganizationControllerGetAllOrganizationsData>) => infiniteQueryOptions<OrganizationControllerGetAllOrganizationsResponse, DefaultError, InfiniteData<OrganizationControllerGetAllOrganizationsResponse>, QueryKey<Options<OrganizationControllerGetAllOrganizationsData>>, number | Pick<QueryKey<Options<OrganizationControllerGetAllOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<OrganizationControllerGetAllOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await organizationControllerGetAllOrganizations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationControllerGetAllOrganizationsInfiniteQueryKey(options)
});

/**
 * create organization
 */
export const organizationControllerCreateOrganizationMutation = (options?: Partial<Options<OrganizationControllerCreateOrganizationData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationControllerCreateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationControllerCreateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationControllerCreateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationControllerLookupWorkOsOrganizationsQueryKey = (options: Options<OrganizationControllerLookupWorkOsOrganizationsData>) => createQueryKey('organizationControllerLookupWorkOsOrganizations', options);

/**
 * look up WorkOs organizations by email domain (import flow)
 */
export const organizationControllerLookupWorkOsOrganizationsOptions = (options: Options<OrganizationControllerLookupWorkOsOrganizationsData>) => queryOptions<OrganizationControllerLookupWorkOsOrganizationsResponse, DefaultError, OrganizationControllerLookupWorkOsOrganizationsResponse, ReturnType<typeof organizationControllerLookupWorkOsOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationControllerLookupWorkOsOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationControllerLookupWorkOsOrganizationsQueryKey(options)
});

/**
 * delete organization
 */
export const organizationControllerDeleteOrganizationMutation = (options?: Partial<Options<OrganizationControllerDeleteOrganizationData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationControllerDeleteOrganizationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationControllerDeleteOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationControllerDeleteOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationControllerGetOrganizationDetailsByIdQueryKey = (options: Options<OrganizationControllerGetOrganizationDetailsByIdData>) => createQueryKey('organizationControllerGetOrganizationDetailsById', options);

/**
 * get organization details by id
 */
export const organizationControllerGetOrganizationDetailsByIdOptions = (options: Options<OrganizationControllerGetOrganizationDetailsByIdData>) => queryOptions<OrganizationControllerGetOrganizationDetailsByIdResponse, DefaultError, OrganizationControllerGetOrganizationDetailsByIdResponse, ReturnType<typeof organizationControllerGetOrganizationDetailsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationControllerGetOrganizationDetailsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationControllerGetOrganizationDetailsByIdQueryKey(options)
});

/**
 * update organization by id
 */
export const organizationControllerUpdateOrganizationMutation = (options?: Partial<Options<OrganizationControllerUpdateOrganizationData>>): UseMutationOptions<OrganizationControllerUpdateOrganizationResponse, DefaultError, Options<OrganizationControllerUpdateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<OrganizationControllerUpdateOrganizationResponse, DefaultError, Options<OrganizationControllerUpdateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationControllerUpdateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set organization type (DealStack support only)
 */
export const organizationControllerUpdateOrganizationTypeMutation = (options?: Partial<Options<OrganizationControllerUpdateOrganizationTypeData>>): UseMutationOptions<OrganizationControllerUpdateOrganizationTypeResponse, DefaultError, Options<OrganizationControllerUpdateOrganizationTypeData>> => {
    const mutationOptions: UseMutationOptions<OrganizationControllerUpdateOrganizationTypeResponse, DefaultError, Options<OrganizationControllerUpdateOrganizationTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationControllerUpdateOrganizationType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * import an existing WorkOs organization into the DB (for orgs created outside the app)
 */
export const organizationControllerImportOrganizationMutation = (options?: Partial<Options<OrganizationControllerImportOrganizationData>>): UseMutationOptions<OrganizationControllerImportOrganizationResponse, DefaultError, Options<OrganizationControllerImportOrganizationData>> => {
    const mutationOptions: UseMutationOptions<OrganizationControllerImportOrganizationResponse, DefaultError, Options<OrganizationControllerImportOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationControllerImportOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycSettingControllerGetMipRequirementsQueryKey = (options?: Options<KycSettingControllerGetMipRequirementsData>) => createQueryKey('kycSettingControllerGetMipRequirements', options);

/**
 * Get MIP-level KYC settings
 */
export const kycSettingControllerGetMipRequirementsOptions = (options?: Options<KycSettingControllerGetMipRequirementsData>) => queryOptions<KycSettingControllerGetMipRequirementsResponse, DefaultError, KycSettingControllerGetMipRequirementsResponse, ReturnType<typeof kycSettingControllerGetMipRequirementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycSettingControllerGetMipRequirements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycSettingControllerGetMipRequirementsQueryKey(options)
});

/**
 * Update MIP-level KYC settings
 */
export const kycSettingControllerUpdateMipRequirementsMutation = (options?: Partial<Options<KycSettingControllerUpdateMipRequirementsData>>): UseMutationOptions<unknown, DefaultError, Options<KycSettingControllerUpdateMipRequirementsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycSettingControllerUpdateMipRequirementsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycSettingControllerUpdateMipRequirements({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycSettingControllerGetByKycWorkflowIdQueryKey = (options: Options<KycSettingControllerGetByKycWorkflowIdData>) => createQueryKey('kycSettingControllerGetByKycWorkflowId', options);

/**
 * Get KYC settings for a specific KYC workflow
 */
export const kycSettingControllerGetByKycWorkflowIdOptions = (options: Options<KycSettingControllerGetByKycWorkflowIdData>) => queryOptions<KycSettingControllerGetByKycWorkflowIdResponse, DefaultError, KycSettingControllerGetByKycWorkflowIdResponse, ReturnType<typeof kycSettingControllerGetByKycWorkflowIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycSettingControllerGetByKycWorkflowId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycSettingControllerGetByKycWorkflowIdQueryKey(options)
});

/**
 * Update KYC settings for a specific KYC workflow
 */
export const kycSettingControllerUpdateByKycWorkflowIdMutation = (options?: Partial<Options<KycSettingControllerUpdateByKycWorkflowIdData>>): UseMutationOptions<unknown, DefaultError, Options<KycSettingControllerUpdateByKycWorkflowIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycSettingControllerUpdateByKycWorkflowIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycSettingControllerUpdateByKycWorkflowId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycControllerGetKycWorkflowsDataQueryKey = (options?: Options<KycControllerGetKycWorkflowsDataData>) => createQueryKey('kycControllerGetKycWorkflowsData', options);

/**
 * Get KYC workflows data for a MIP
 */
export const kycControllerGetKycWorkflowsDataOptions = (options?: Options<KycControllerGetKycWorkflowsDataData>) => queryOptions<KycControllerGetKycWorkflowsDataResponse, DefaultError, KycControllerGetKycWorkflowsDataResponse, ReturnType<typeof kycControllerGetKycWorkflowsDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycControllerGetKycWorkflowsData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycControllerGetKycWorkflowsDataQueryKey(options)
});

export const kycControllerGetKycInvestorsDataQueryKey = (options?: Options<KycControllerGetKycInvestorsDataData>) => createQueryKey('kycControllerGetKycInvestorsData', options);

/**
 * Get investors kyc data
 */
export const kycControllerGetKycInvestorsDataOptions = (options?: Options<KycControllerGetKycInvestorsDataData>) => queryOptions<KycControllerGetKycInvestorsDataResponse, DefaultError, KycControllerGetKycInvestorsDataResponse, ReturnType<typeof kycControllerGetKycInvestorsDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycControllerGetKycInvestorsData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycControllerGetKycInvestorsDataQueryKey(options)
});

export const kycControllerGetKycInvestorsDataInfiniteQueryKey = (options?: Options<KycControllerGetKycInvestorsDataData>): QueryKey<Options<KycControllerGetKycInvestorsDataData>> => createQueryKey('kycControllerGetKycInvestorsData', options, true);

/**
 * Get investors kyc data
 */
export const kycControllerGetKycInvestorsDataInfiniteOptions = (options?: Options<KycControllerGetKycInvestorsDataData>) => infiniteQueryOptions<KycControllerGetKycInvestorsDataResponse, DefaultError, InfiniteData<KycControllerGetKycInvestorsDataResponse>, QueryKey<Options<KycControllerGetKycInvestorsDataData>>, string | Pick<QueryKey<Options<KycControllerGetKycInvestorsDataData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<KycControllerGetKycInvestorsDataData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await kycControllerGetKycInvestorsData({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycControllerGetKycInvestorsDataInfiniteQueryKey(options)
});

export const kycControllerGetKycInvestorDataQueryKey = (options: Options<KycControllerGetKycInvestorDataData>) => createQueryKey('kycControllerGetKycInvestorData', options);

/**
 * Get kyc data for a specific investor
 */
export const kycControllerGetKycInvestorDataOptions = (options: Options<KycControllerGetKycInvestorDataData>) => queryOptions<KycControllerGetKycInvestorDataResponse, DefaultError, KycControllerGetKycInvestorDataResponse, ReturnType<typeof kycControllerGetKycInvestorDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycControllerGetKycInvestorData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycControllerGetKycInvestorDataQueryKey(options)
});

/**
 * Set flag for more PIV documents
 */
export const kycControllerMorePivDocumentsMutation = (options?: Partial<Options<KycControllerMorePivDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerMorePivDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerMorePivDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerMorePivDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const kycControllerGetInvestorsStatisticsQueryKey = (options?: Options<KycControllerGetInvestorsStatisticsData>) => createQueryKey('kycControllerGetInvestorsStatistics', options);

/**
 * Get investors statistics
 */
export const kycControllerGetInvestorsStatisticsOptions = (options?: Options<KycControllerGetInvestorsStatisticsData>) => queryOptions<KycControllerGetInvestorsStatisticsResponse, DefaultError, KycControllerGetInvestorsStatisticsResponse, ReturnType<typeof kycControllerGetInvestorsStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kycControllerGetInvestorsStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kycControllerGetInvestorsStatisticsQueryKey(options)
});

/**
 * Update kyc file status
 */
export const kycControllerUpdateKycStatusMutation = (options?: Partial<Options<KycControllerUpdateKycStatusData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateKycStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateKycStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerUpdateKycStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Override kyc file and approve kyc
 */
export const kycControllerUpdateKycFileMutation = (options?: Partial<Options<KycControllerUpdateKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerUpdateKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend the certifier's invitation for a KYC file
 */
export const kycControllerResendKycFileCertifierInvitationMutation = (options?: Partial<Options<KycControllerResendKycFileCertifierInvitationData>>): UseMutationOptions<KycControllerResendKycFileCertifierInvitationResponse, DefaultError, Options<KycControllerResendKycFileCertifierInvitationData>> => {
    const mutationOptions: UseMutationOptions<KycControllerResendKycFileCertifierInvitationResponse, DefaultError, Options<KycControllerResendKycFileCertifierInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerResendKycFileCertifierInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept/reject all investor declarations
 */
export const kycControllerUpdateDeclarationsStatusMutation = (options?: Partial<Options<KycControllerUpdateDeclarationsStatusData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateDeclarationsStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerUpdateDeclarationsStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerUpdateDeclarationsStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KYC admin edits an investor's declarations on their behalf
 */
export const kycControllerSetInvestorDeclarationsMutation = (options?: Partial<Options<KycControllerSetInvestorDeclarationsData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerSetInvestorDeclarationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerSetInvestorDeclarationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerSetInvestorDeclarations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start an async KYC bulk export for the selected (or all-matching) workflows; the zip is delivered via the Exports page
 */
export const kycControllerDownloadInvestorsFilesMutation = (options?: Partial<Options<KycControllerDownloadInvestorsFilesData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerDownloadInvestorsFilesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerDownloadInvestorsFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerDownloadInvestorsFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associates kyc file to an investor
 */
export const kycControllerPutAssociateKycFileMutation = (options?: Partial<Options<KycControllerPutAssociateKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerPutAssociateKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerPutAssociateKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerPutAssociateKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft deletes kyc file from an investor
 */
export const kycControllerDeleteKycFileMutation = (options?: Partial<Options<KycControllerDeleteKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerDeleteKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerDeleteKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerDeleteKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw a standalone KYC workflow
 */
export const kycControllerWithdrawStandaloneKycWorkflowMutation = (options?: Partial<Options<KycControllerWithdrawStandaloneKycWorkflowData>>): UseMutationOptions<unknown, DefaultError, Options<KycControllerWithdrawStandaloneKycWorkflowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<KycControllerWithdrawStandaloneKycWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await kycControllerWithdrawStandaloneKycWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authControllerStartHostedAuthKitQueryKey = (options: Options<AuthControllerStartHostedAuthKitData>) => createQueryKey('authControllerStartHostedAuthKit', options);

/**
 * redirect to the hosted AuthKit sign-in page, or into the app when already signed in
 */
export const authControllerStartHostedAuthKitOptions = (options: Options<AuthControllerStartHostedAuthKitData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof authControllerStartHostedAuthKitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authControllerStartHostedAuthKit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authControllerStartHostedAuthKitQueryKey(options)
});

/**
 * can user change credentials - email or password
 */
export const authControllerCanChangeCredentialsMutation = (options?: Partial<Options<AuthControllerCanChangeCredentialsData>>): UseMutationOptions<AuthControllerCanChangeCredentialsResponse, DefaultError, Options<AuthControllerCanChangeCredentialsData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerCanChangeCredentialsResponse, DefaultError, Options<AuthControllerCanChangeCredentialsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerCanChangeCredentials({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * delete change email request
 */
export const authControllerDeleteChangeEmailRequestMutation = (options?: Partial<Options<AuthControllerDeleteChangeEmailRequestData>>): UseMutationOptions<unknown, DefaultError, Options<AuthControllerDeleteChangeEmailRequestData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthControllerDeleteChangeEmailRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerDeleteChangeEmailRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * user changes email
 */
export const authControllerUpdateEmailMutation = (options?: Partial<Options<AuthControllerUpdateEmailData>>): UseMutationOptions<unknown, DefaultError, Options<AuthControllerUpdateEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthControllerUpdateEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerUpdateEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * change email request
 */
export const authControllerChangeEmailRequestMutation = (options?: Partial<Options<AuthControllerChangeEmailRequestData>>): UseMutationOptions<unknown, DefaultError, Options<AuthControllerChangeEmailRequestData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthControllerChangeEmailRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerChangeEmailRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * cancel a pending email change from the link sent to the old address
 */
export const authControllerCancelChangeEmailRequestMutation = (options?: Partial<Options<AuthControllerCancelChangeEmailRequestData>>): UseMutationOptions<unknown, DefaultError, Options<AuthControllerCancelChangeEmailRequestData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthControllerCancelChangeEmailRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerCancelChangeEmailRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * send a fresh invitation for an expired invitation link
 *
 * The recipient is always the address the original invitation was sent to, read from WorkOS; nothing in the request names one. Sends only when the link is expired and the invitee can still be invited, and never while a renewed invitation to that address is still pending.
 */
export const authControllerRenewInvitationMutation = (options?: Partial<Options<AuthControllerRenewInvitationData>>): UseMutationOptions<AuthControllerRenewInvitationResponse, DefaultError, Options<AuthControllerRenewInvitationData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerRenewInvitationResponse, DefaultError, Options<AuthControllerRenewInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerRenewInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * setup 2FA
 */
export const twoFaControllerSetup2FaMutation = (options?: Partial<Options<TwoFaControllerSetup2FaData>>): UseMutationOptions<TwoFaControllerSetup2FaResponse, DefaultError, Options<TwoFaControllerSetup2FaData>> => {
    const mutationOptions: UseMutationOptions<TwoFaControllerSetup2FaResponse, DefaultError, Options<TwoFaControllerSetup2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await twoFaControllerSetup2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify challenge of 2FA
 */
export const twoFaControllerVerifyChallenge2FaMutation = (options?: Partial<Options<TwoFaControllerVerifyChallenge2FaData>>): UseMutationOptions<TwoFaControllerVerifyChallenge2FaResponse, DefaultError, Options<TwoFaControllerVerifyChallenge2FaData>> => {
    const mutationOptions: UseMutationOptions<TwoFaControllerVerifyChallenge2FaResponse, DefaultError, Options<TwoFaControllerVerifyChallenge2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await twoFaControllerVerifyChallenge2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete auth factor
 */
export const twoFaControllerDeleteAuthFactorMutation = (options?: Partial<Options<TwoFaControllerDeleteAuthFactorData>>): UseMutationOptions<unknown, DefaultError, Options<TwoFaControllerDeleteAuthFactorData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TwoFaControllerDeleteAuthFactorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await twoFaControllerDeleteAuthFactor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * user changes password
 */
export const passwordControllerUpdatePasswordMutation = (options?: Partial<Options<PasswordControllerUpdatePasswordData>>): UseMutationOptions<unknown, DefaultError, Options<PasswordControllerUpdatePasswordData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PasswordControllerUpdatePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passwordControllerUpdatePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * refresh access token
 */
export const sessionManagementControllerRefreshTokenMutation = (options?: Partial<Options<SessionManagementControllerRefreshTokenData>>): UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerRefreshTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerRefreshTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerRefreshToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionManagementControllerGetSessionStatusQueryKey = (options?: Options<SessionManagementControllerGetSessionStatusData>) => createQueryKey('sessionManagementControllerGetSessionStatus', options);

/**
 * read the current session deadlines
 *
 * Lets the client warn the user before the idle window closes. Reading status never counts as activity, so polling it cannot keep a session alive.
 */
export const sessionManagementControllerGetSessionStatusOptions = (options?: Options<SessionManagementControllerGetSessionStatusData>) => queryOptions<SessionManagementControllerGetSessionStatusResponse, DefaultError, SessionManagementControllerGetSessionStatusResponse, ReturnType<typeof sessionManagementControllerGetSessionStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionManagementControllerGetSessionStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionManagementControllerGetSessionStatusQueryKey(options)
});

/**
 * slide the idle window forward
 *
 * Backs the "stay signed in" action on the idle warning. Subject to the absolute session lifetime, which this cannot extend.
 */
export const sessionManagementControllerKeepSessionAliveMutation = (options?: Partial<Options<SessionManagementControllerKeepSessionAliveData>>): UseMutationOptions<SessionManagementControllerKeepSessionAliveResponse, DefaultError, Options<SessionManagementControllerKeepSessionAliveData>> => {
    const mutationOptions: UseMutationOptions<SessionManagementControllerKeepSessionAliveResponse, DefaultError, Options<SessionManagementControllerKeepSessionAliveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerKeepSessionAlive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * user logout method
 */
export const sessionManagementControllerLogoutMutation = (options?: Partial<Options<SessionManagementControllerLogoutData>>): UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerLogoutData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * sign out from anywhere, including with no active session
 */
export const sessionManagementControllerSignOutMutation = (options?: Partial<Options<SessionManagementControllerSignOutData>>): UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerSignOutData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerSignOutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerSignOut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionManagementControllerRedirectCallbackFromWorkOsQueryKey = (options: Options<SessionManagementControllerRedirectCallbackFromWorkOsData>) => createQueryKey('sessionManagementControllerRedirectCallbackFromWorkOs', options);

/**
 * redirect from workos and sso providers
 */
export const sessionManagementControllerRedirectCallbackFromWorkOsOptions = (options: Options<SessionManagementControllerRedirectCallbackFromWorkOsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof sessionManagementControllerRedirectCallbackFromWorkOsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionManagementControllerRedirectCallbackFromWorkOs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionManagementControllerRedirectCallbackFromWorkOsQueryKey(options)
});

/**
 * Send email verification
 */
export const sessionManagementControllerSendMagicAuthVerificationCodeMutation = (options?: Partial<Options<SessionManagementControllerSendMagicAuthVerificationCodeData>>): UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerSendMagicAuthVerificationCodeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SessionManagementControllerSendMagicAuthVerificationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerSendMagicAuthVerificationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * validate user with magic code
 */
export const sessionManagementControllerValidateMagicCodeMutation = (options?: Partial<Options<SessionManagementControllerValidateMagicCodeData>>): UseMutationOptions<SessionManagementControllerValidateMagicCodeResponse, DefaultError, Options<SessionManagementControllerValidateMagicCodeData>> => {
    const mutationOptions: UseMutationOptions<SessionManagementControllerValidateMagicCodeResponse, DefaultError, Options<SessionManagementControllerValidateMagicCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionManagementControllerValidateMagicCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set the phone number hosted AuthKit cannot collect
 */
export const profileControllerUpdatePhoneMutation = (options?: Partial<Options<ProfileControllerUpdatePhoneData>>): UseMutationOptions<unknown, DefaultError, Options<ProfileControllerUpdatePhoneData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ProfileControllerUpdatePhoneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await profileControllerUpdatePhone({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete deal by id
 */
export const dealControllerSoftDeleteDealMutation = (options?: Partial<Options<DealControllerSoftDeleteDealData>>): UseMutationOptions<unknown, DefaultError, Options<DealControllerSoftDeleteDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealControllerSoftDeleteDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerSoftDeleteDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealControllerGetListQueryKey = (options?: Options<DealControllerGetListData>) => createQueryKey('dealControllerGetList', options);

/**
 * Fetch list of deals available for user
 */
export const dealControllerGetListOptions = (options?: Options<DealControllerGetListData>) => queryOptions<DealControllerGetListResponse, DefaultError, DealControllerGetListResponse, ReturnType<typeof dealControllerGetListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerGetList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerGetListQueryKey(options)
});

/**
 * Update deal
 */
export const dealControllerUpdateDealMutation = (options?: Partial<Options<DealControllerUpdateDealData>>): UseMutationOptions<unknown, DefaultError, Options<DealControllerUpdateDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealControllerUpdateDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerUpdateDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create deal
 */
export const dealControllerCreateDealMutation = (options?: Partial<Options<DealControllerCreateDealData>>): UseMutationOptions<DealControllerCreateDealResponse, DefaultError, Options<DealControllerCreateDealData>> => {
    const mutationOptions: UseMutationOptions<DealControllerCreateDealResponse, DefaultError, Options<DealControllerCreateDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerCreateDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealControllerGetDealQueryKey = (options?: Options<DealControllerGetDealData>) => createQueryKey('dealControllerGetDeal', options);

/**
 * Returns the full deal with related data populated.
 */
export const dealControllerGetDealOptions = (options?: Options<DealControllerGetDealData>) => queryOptions<DealControllerGetDealResponse, DefaultError, DealControllerGetDealResponse, ReturnType<typeof dealControllerGetDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerGetDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerGetDealQueryKey(options)
});

export const dealControllerGetDealBasicDataQueryKey = (options?: Options<DealControllerGetDealBasicDataData>) => createQueryKey('dealControllerGetDealBasicData', options);

/**
 * Returns the deal raw database entry
 */
export const dealControllerGetDealBasicDataOptions = (options?: Options<DealControllerGetDealBasicDataData>) => queryOptions<DealControllerGetDealBasicDataResponse, DefaultError, DealControllerGetDealBasicDataResponse, ReturnType<typeof dealControllerGetDealBasicDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerGetDealBasicData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerGetDealBasicDataQueryKey(options)
});

export const dealControllerGetDealDetailsQueryKey = (options: Options<DealControllerGetDealDetailsData>) => createQueryKey('dealControllerGetDealDetails', options);

/**
 * Returns the full deal with related data populated.
 */
export const dealControllerGetDealDetailsOptions = (options: Options<DealControllerGetDealDetailsData>) => queryOptions<DealControllerGetDealDetailsResponse, DefaultError, DealControllerGetDealDetailsResponse, ReturnType<typeof dealControllerGetDealDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerGetDealDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerGetDealDetailsQueryKey(options)
});

/**
 * Mark a deal/fund as Restricted (or clear it). Restricted deals deny inherited DealStack Support access.
 */
export const dealControllerSetDealRestrictionMutation = (options?: Partial<Options<DealControllerSetDealRestrictionData>>): UseMutationOptions<unknown, DefaultError, Options<DealControllerSetDealRestrictionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealControllerSetDealRestrictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerSetDealRestriction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealControllerGetDealClassifiersQueryKey = (options: Options<DealControllerGetDealClassifiersData>) => createQueryKey('dealControllerGetDealClassifiers', options);

/**
 * Fetch deal classifiers
 */
export const dealControllerGetDealClassifiersOptions = (options: Options<DealControllerGetDealClassifiersData>) => queryOptions<DealControllerGetDealClassifiersResponse, DefaultError, DealControllerGetDealClassifiersResponse, ReturnType<typeof dealControllerGetDealClassifiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerGetDealClassifiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerGetDealClassifiersQueryKey(options)
});

/**
 * Create deal classifier
 */
export const dealControllerCreateDealClassifiersMutation = (options?: Partial<Options<DealControllerCreateDealClassifiersData>>): UseMutationOptions<DealControllerCreateDealClassifiersResponse, DefaultError, Options<DealControllerCreateDealClassifiersData>> => {
    const mutationOptions: UseMutationOptions<DealControllerCreateDealClassifiersResponse, DefaultError, Options<DealControllerCreateDealClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerCreateDealClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update deal classifier
 */
export const dealControllerUpdateDealClassifiersMutation = (options?: Partial<Options<DealControllerUpdateDealClassifiersData>>): UseMutationOptions<DealControllerUpdateDealClassifiersResponse, DefaultError, Options<DealControllerUpdateDealClassifiersData>> => {
    const mutationOptions: UseMutationOptions<DealControllerUpdateDealClassifiersResponse, DefaultError, Options<DealControllerUpdateDealClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerUpdateDealClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update deal company representative
 */
export const dealControllerUpdateProjectRepresentativeMutation = (options?: Partial<Options<DealControllerUpdateProjectRepresentativeData>>): UseMutationOptions<unknown, DefaultError, Options<DealControllerUpdateProjectRepresentativeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealControllerUpdateProjectRepresentativeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealControllerUpdateProjectRepresentative({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealControllerUpdateCompanyRepresentativeQueryKey = (options: Options<DealControllerUpdateCompanyRepresentativeData>) => createQueryKey('dealControllerUpdateCompanyRepresentative', options);

/**
 * Get deal company representative
 */
export const dealControllerUpdateCompanyRepresentativeOptions = (options: Options<DealControllerUpdateCompanyRepresentativeData>) => queryOptions<DealControllerUpdateCompanyRepresentativeResponse, DefaultError, DealControllerUpdateCompanyRepresentativeResponse, ReturnType<typeof dealControllerUpdateCompanyRepresentativeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealControllerUpdateCompanyRepresentative({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealControllerUpdateCompanyRepresentativeQueryKey(options)
});

export const dealUsersControllerGetDealUsersQueryKey = (options: Options<DealUsersControllerGetDealUsersData>) => createQueryKey('dealUsersControllerGetDealUsers', options);

/**
 * Fetch deal users
 */
export const dealUsersControllerGetDealUsersOptions = (options: Options<DealUsersControllerGetDealUsersData>) => queryOptions<DealUsersControllerGetDealUsersResponse, DefaultError, DealUsersControllerGetDealUsersResponse, ReturnType<typeof dealUsersControllerGetDealUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealUsersControllerGetDealUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealUsersControllerGetDealUsersQueryKey(options)
});

/**
 * Invite a user to a deal
 */
export const dealUsersControllerInviteUserToDealMutation = (options?: Partial<Options<DealUsersControllerInviteUserToDealData>>): UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerInviteUserToDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerInviteUserToDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealUsersControllerInviteUserToDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync users permission with the db records
 */
export const dealUsersControllerSyncUserInDealToAllProgrammesMutation = (options?: Partial<Options<DealUsersControllerSyncUserInDealToAllProgrammesData>>): UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerSyncUserInDealToAllProgrammesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerSyncUserInDealToAllProgrammesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealUsersControllerSyncUserInDealToAllProgrammes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove user from deal
 */
export const dealUsersControllerDeleteUserFromDealMutation = (options?: Partial<Options<DealUsersControllerDeleteUserFromDealData>>): UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerDeleteUserFromDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DealUsersControllerDeleteUserFromDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealUsersControllerDeleteUserFromDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealUsersControllerGetDealUserQueryKey = (options: Options<DealUsersControllerGetDealUserData>) => createQueryKey('dealUsersControllerGetDealUser', options);

/**
 * Get user information for a specific deal
 */
export const dealUsersControllerGetDealUserOptions = (options: Options<DealUsersControllerGetDealUserData>) => queryOptions<DealUsersControllerGetDealUserResponse, DefaultError, DealUsersControllerGetDealUserResponse, ReturnType<typeof dealUsersControllerGetDealUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealUsersControllerGetDealUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealUsersControllerGetDealUserQueryKey(options)
});

export const programmeUsersControllerGetProgrammeUsersQueryKey = (options: Options<ProgrammeUsersControllerGetProgrammeUsersData>) => createQueryKey('programmeUsersControllerGetProgrammeUsers', options);

/**
 * Get users for specific programme
 */
export const programmeUsersControllerGetProgrammeUsersOptions = (options: Options<ProgrammeUsersControllerGetProgrammeUsersData>) => queryOptions<ProgrammeUsersControllerGetProgrammeUsersResponse, DefaultError, ProgrammeUsersControllerGetProgrammeUsersResponse, ReturnType<typeof programmeUsersControllerGetProgrammeUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeUsersControllerGetProgrammeUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeUsersControllerGetProgrammeUsersQueryKey(options)
});

/**
 * Invite a user to a programme
 */
export const programmeUsersControllerInviteUserToProgrammeMutation = (options?: Partial<Options<ProgrammeUsersControllerInviteUserToProgrammeData>>): UseMutationOptions<unknown, DefaultError, Options<ProgrammeUsersControllerInviteUserToProgrammeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ProgrammeUsersControllerInviteUserToProgrammeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeUsersControllerInviteUserToProgramme({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete user from programme
 */
export const programmeUsersControllerDeleteUserFromProgrammeMutation = (options?: Partial<Options<ProgrammeUsersControllerDeleteUserFromProgrammeData>>): UseMutationOptions<unknown, DefaultError, Options<ProgrammeUsersControllerDeleteUserFromProgrammeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ProgrammeUsersControllerDeleteUserFromProgrammeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeUsersControllerDeleteUserFromProgramme({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const programmeUsersControllerGetProgrammeUserQueryKey = (options: Options<ProgrammeUsersControllerGetProgrammeUserData>) => createQueryKey('programmeUsersControllerGetProgrammeUser', options);

/**
 * Get user data for a programme
 */
export const programmeUsersControllerGetProgrammeUserOptions = (options: Options<ProgrammeUsersControllerGetProgrammeUserData>) => queryOptions<ProgrammeUsersControllerGetProgrammeUserResponse, DefaultError, ProgrammeUsersControllerGetProgrammeUserResponse, ReturnType<typeof programmeUsersControllerGetProgrammeUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeUsersControllerGetProgrammeUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeUsersControllerGetProgrammeUserQueryKey(options)
});

/**
 * Update user first name and last name or isContactPerson for a specific Programme
 */
export const programmeUsersControllerUpdateUserAndUserProgrammeMutation = (options?: Partial<Options<ProgrammeUsersControllerUpdateUserAndUserProgrammeData>>): UseMutationOptions<ProgrammeUsersControllerUpdateUserAndUserProgrammeResponse, DefaultError, Options<ProgrammeUsersControllerUpdateUserAndUserProgrammeData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeUsersControllerUpdateUserAndUserProgrammeResponse, DefaultError, Options<ProgrammeUsersControllerUpdateUserAndUserProgrammeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeUsersControllerUpdateUserAndUserProgramme({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const capTableControllerDownloadExcelQueryKey = (options: Options<CapTableControllerDownloadExcelData>) => createQueryKey('capTableControllerDownloadExcel', options);

/**
 * Download excel file with cap table data
 */
export const capTableControllerDownloadExcelOptions = (options: Options<CapTableControllerDownloadExcelData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof capTableControllerDownloadExcelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capTableControllerDownloadExcel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capTableControllerDownloadExcelQueryKey(options)
});

/**
 * Gets Cap Table Data
 */
export const capTableControllerPostCapTableDataMutation = (options?: Partial<Options<CapTableControllerPostCapTableDataData>>): UseMutationOptions<CapTableControllerPostCapTableDataResponse, DefaultError, Options<CapTableControllerPostCapTableDataData>> => {
    const mutationOptions: UseMutationOptions<CapTableControllerPostCapTableDataResponse, DefaultError, Options<CapTableControllerPostCapTableDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capTableControllerPostCapTableData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Gets Group Structure chart Data
 */
export const capTableControllerPostGroupStructureDataMutation = (options?: Partial<Options<CapTableControllerPostGroupStructureDataData>>): UseMutationOptions<CapTableControllerPostGroupStructureDataResponse, DefaultError, Options<CapTableControllerPostGroupStructureDataData>> => {
    const mutationOptions: UseMutationOptions<CapTableControllerPostGroupStructureDataResponse, DefaultError, Options<CapTableControllerPostGroupStructureDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capTableControllerPostGroupStructureData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Gets all securities for group structure chart
 */
export const capTableControllerPostSecuritiesForGroupStructureDataMutation = (options?: Partial<Options<CapTableControllerPostSecuritiesForGroupStructureDataData>>): UseMutationOptions<CapTableControllerPostSecuritiesForGroupStructureDataResponse, DefaultError, Options<CapTableControllerPostSecuritiesForGroupStructureDataData>> => {
    const mutationOptions: UseMutationOptions<CapTableControllerPostSecuritiesForGroupStructureDataResponse, DefaultError, Options<CapTableControllerPostSecuritiesForGroupStructureDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capTableControllerPostSecuritiesForGroupStructureData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get group structure chart positions
 */
export const capTableControllerPostGroupStructurePositionsMutation = (options?: Partial<Options<CapTableControllerPostGroupStructurePositionsData>>): UseMutationOptions<CapTableControllerPostGroupStructurePositionsResponse, DefaultError, Options<CapTableControllerPostGroupStructurePositionsData>> => {
    const mutationOptions: UseMutationOptions<CapTableControllerPostGroupStructurePositionsResponse, DefaultError, Options<CapTableControllerPostGroupStructurePositionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capTableControllerPostGroupStructurePositions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates group structure chart positions
 */
export const capTableControllerUpdateGroupStructurePositionsMutation = (options?: Partial<Options<CapTableControllerUpdateGroupStructurePositionsData>>): UseMutationOptions<CapTableControllerUpdateGroupStructurePositionsResponse, DefaultError, Options<CapTableControllerUpdateGroupStructurePositionsData>> => {
    const mutationOptions: UseMutationOptions<CapTableControllerUpdateGroupStructurePositionsResponse, DefaultError, Options<CapTableControllerUpdateGroupStructurePositionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capTableControllerUpdateGroupStructurePositions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const capTableControllerGetCapDetailsQueryKey = (options: Options<CapTableControllerGetCapDetailsData>) => createQueryKey('capTableControllerGetCapDetails', options);

/**
 * Get Cap Details
 */
export const capTableControllerGetCapDetailsOptions = (options: Options<CapTableControllerGetCapDetailsData>) => queryOptions<CapTableControllerGetCapDetailsResponse, DefaultError, CapTableControllerGetCapDetailsResponse, ReturnType<typeof capTableControllerGetCapDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capTableControllerGetCapDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capTableControllerGetCapDetailsQueryKey(options)
});

export const capTableControllerGetCapTransactionsValidationDetailsQueryKey = (options: Options<CapTableControllerGetCapTransactionsValidationDetailsData>) => createQueryKey('capTableControllerGetCapTransactionsValidationDetails', options);

/**
 * Get Cap Details
 */
export const capTableControllerGetCapTransactionsValidationDetailsOptions = (options: Options<CapTableControllerGetCapTransactionsValidationDetailsData>) => queryOptions<CapTableControllerGetCapTransactionsValidationDetailsResponse, DefaultError, CapTableControllerGetCapTransactionsValidationDetailsResponse, ReturnType<typeof capTableControllerGetCapTransactionsValidationDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capTableControllerGetCapTransactionsValidationDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capTableControllerGetCapTransactionsValidationDetailsQueryKey(options)
});

export const capTableControllerExportDealHoldingsJsonQueryKey = (options: Options<CapTableControllerExportDealHoldingsJsonData>) => createQueryKey('capTableControllerExportDealHoldingsJson', options);

/**
 * Export deal holdings json
 */
export const capTableControllerExportDealHoldingsJsonOptions = (options: Options<CapTableControllerExportDealHoldingsJsonData>) => queryOptions<CapTableControllerExportDealHoldingsJsonResponse, DefaultError, CapTableControllerExportDealHoldingsJsonResponse, ReturnType<typeof capTableControllerExportDealHoldingsJsonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capTableControllerExportDealHoldingsJson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capTableControllerExportDealHoldingsJsonQueryKey(options)
});

export const dealEmailTemplateControllerListQueryKey = (options?: Options<DealEmailTemplateControllerListData>) => createQueryKey('dealEmailTemplateControllerList', options);

/**
 * List the editable email templates for the current Deal
 */
export const dealEmailTemplateControllerListOptions = (options?: Options<DealEmailTemplateControllerListData>) => queryOptions<DealEmailTemplateControllerListResponse, DefaultError, DealEmailTemplateControllerListResponse, ReturnType<typeof dealEmailTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEmailTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEmailTemplateControllerListQueryKey(options)
});

export const dealEmailTemplateControllerGetOneQueryKey = (options: Options<DealEmailTemplateControllerGetOneData>) => createQueryKey('dealEmailTemplateControllerGetOne', options);

/**
 * Get one email template (default + current override) for editing
 */
export const dealEmailTemplateControllerGetOneOptions = (options: Options<DealEmailTemplateControllerGetOneData>) => queryOptions<DealEmailTemplateControllerGetOneResponse, DefaultError, DealEmailTemplateControllerGetOneResponse, ReturnType<typeof dealEmailTemplateControllerGetOneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEmailTemplateControllerGetOne({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEmailTemplateControllerGetOneQueryKey(options)
});

/**
 * Update the subject, body, or send toggle of a Deal template
 */
export const dealEmailTemplateControllerUpdateMutation = (options?: Partial<Options<DealEmailTemplateControllerUpdateData>>): UseMutationOptions<DealEmailTemplateControllerUpdateResponse, DefaultError, Options<DealEmailTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<DealEmailTemplateControllerUpdateResponse, DefaultError, Options<DealEmailTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealEmailTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Render a live preview (send-parity) of the saved or draft template
 */
export const dealEmailTemplateControllerPreviewMutation = (options?: Partial<Options<DealEmailTemplateControllerPreviewData>>): UseMutationOptions<DealEmailTemplateControllerPreviewResponse, DefaultError, Options<DealEmailTemplateControllerPreviewData>> => {
    const mutationOptions: UseMutationOptions<DealEmailTemplateControllerPreviewResponse, DefaultError, Options<DealEmailTemplateControllerPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealEmailTemplateControllerPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send this template to the caller's own address to verify live delivery
 */
export const dealEmailTemplateControllerTestSendMutation = (options?: Partial<Options<DealEmailTemplateControllerTestSendData>>): UseMutationOptions<DealEmailTemplateControllerTestSendResponse, DefaultError, Options<DealEmailTemplateControllerTestSendData>> => {
    const mutationOptions: UseMutationOptions<DealEmailTemplateControllerTestSendResponse, DefaultError, Options<DealEmailTemplateControllerTestSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealEmailTemplateControllerTestSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset a Deal template back to the Dealstack default
 */
export const dealEmailTemplateControllerResetMutation = (options?: Partial<Options<DealEmailTemplateControllerResetData>>): UseMutationOptions<DealEmailTemplateControllerResetResponse, DefaultError, Options<DealEmailTemplateControllerResetData>> => {
    const mutationOptions: UseMutationOptions<DealEmailTemplateControllerResetResponse, DefaultError, Options<DealEmailTemplateControllerResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealEmailTemplateControllerReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationDealEmailTemplateControllerListQueryKey = (options: Options<OrganizationDealEmailTemplateControllerListData>) => createQueryKey('organizationDealEmailTemplateControllerList', options);

/**
 * List an organisation's default deal email templates
 */
export const organizationDealEmailTemplateControllerListOptions = (options: Options<OrganizationDealEmailTemplateControllerListData>) => queryOptions<OrganizationDealEmailTemplateControllerListResponse, DefaultError, OrganizationDealEmailTemplateControllerListResponse, ReturnType<typeof organizationDealEmailTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDealEmailTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDealEmailTemplateControllerListQueryKey(options)
});

export const organizationDealEmailTemplateControllerGetOneQueryKey = (options: Options<OrganizationDealEmailTemplateControllerGetOneData>) => createQueryKey('organizationDealEmailTemplateControllerGetOne', options);

/**
 * Get one default template (Dealstack default + current override)
 */
export const organizationDealEmailTemplateControllerGetOneOptions = (options: Options<OrganizationDealEmailTemplateControllerGetOneData>) => queryOptions<OrganizationDealEmailTemplateControllerGetOneResponse, DefaultError, OrganizationDealEmailTemplateControllerGetOneResponse, ReturnType<typeof organizationDealEmailTemplateControllerGetOneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDealEmailTemplateControllerGetOne({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDealEmailTemplateControllerGetOneQueryKey(options)
});

/**
 * Update the subject, body or send toggle of a default template
 */
export const organizationDealEmailTemplateControllerUpdateMutation = (options?: Partial<Options<OrganizationDealEmailTemplateControllerUpdateData>>): UseMutationOptions<OrganizationDealEmailTemplateControllerUpdateResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<OrganizationDealEmailTemplateControllerUpdateResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDealEmailTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Render a live preview of the saved or draft default template
 */
export const organizationDealEmailTemplateControllerPreviewMutation = (options?: Partial<Options<OrganizationDealEmailTemplateControllerPreviewData>>): UseMutationOptions<OrganizationDealEmailTemplateControllerPreviewResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerPreviewData>> => {
    const mutationOptions: UseMutationOptions<OrganizationDealEmailTemplateControllerPreviewResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDealEmailTemplateControllerPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset a default template back to the Dealstack default
 */
export const organizationDealEmailTemplateControllerResetMutation = (options?: Partial<Options<OrganizationDealEmailTemplateControllerResetData>>): UseMutationOptions<OrganizationDealEmailTemplateControllerResetResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerResetData>> => {
    const mutationOptions: UseMutationOptions<OrganizationDealEmailTemplateControllerResetResponse, DefaultError, Options<OrganizationDealEmailTemplateControllerResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDealEmailTemplateControllerReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationDealClassifierControllerListClassifiersQueryKey = (options: Options<OrganizationDealClassifierControllerListClassifiersData>) => createQueryKey('organizationDealClassifierControllerListClassifiers', options);

/**
 * List the document classifiers seeded onto every new deal
 */
export const organizationDealClassifierControllerListClassifiersOptions = (options: Options<OrganizationDealClassifierControllerListClassifiersData>) => queryOptions<OrganizationDealClassifierControllerListClassifiersResponse, DefaultError, OrganizationDealClassifierControllerListClassifiersResponse, ReturnType<typeof organizationDealClassifierControllerListClassifiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDealClassifierControllerListClassifiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDealClassifierControllerListClassifiersQueryKey(options)
});

/**
 * Replace the whole default classifier list
 */
export const organizationDealClassifierControllerSetClassifiersMutation = (options?: Partial<Options<OrganizationDealClassifierControllerSetClassifiersData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDealClassifierControllerSetClassifiersData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDealClassifierControllerSetClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDealClassifierControllerSetClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundControllerGetAllFundsQueryKey = (options: Options<FundControllerGetAllFundsData>) => createQueryKey('fundControllerGetAllFunds', options);

/**
 * Get all Funds the user has access to, optionally scoped to an organization
 */
export const fundControllerGetAllFundsOptions = (options: Options<FundControllerGetAllFundsData>) => queryOptions<FundControllerGetAllFundsResponse, DefaultError, FundControllerGetAllFundsResponse, ReturnType<typeof fundControllerGetAllFundsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetAllFunds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetAllFundsQueryKey(options)
});

/**
 * Create a new Fund (creates both Deal and Fund)
 */
export const fundControllerCreateFundMutation = (options?: Partial<Options<FundControllerCreateFundData>>): UseMutationOptions<FundControllerCreateFundResponse, DefaultError, Options<FundControllerCreateFundData>> => {
    const mutationOptions: UseMutationOptions<FundControllerCreateFundResponse, DefaultError, Options<FundControllerCreateFundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerCreateFund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundControllerGetFundQueryKey = (options: Options<FundControllerGetFundData>) => createQueryKey('fundControllerGetFund', options);

/**
 * Get a Fund by ID
 */
export const fundControllerGetFundOptions = (options: Options<FundControllerGetFundData>) => queryOptions<FundControllerGetFundResponse, DefaultError, FundControllerGetFundResponse, ReturnType<typeof fundControllerGetFundQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetFund({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetFundQueryKey(options)
});

/**
 * Update a Fund and its underlying Deal
 */
export const fundControllerUpdateFundMutation = (options?: Partial<Options<FundControllerUpdateFundData>>): UseMutationOptions<FundControllerUpdateFundResponse, DefaultError, Options<FundControllerUpdateFundData>> => {
    const mutationOptions: UseMutationOptions<FundControllerUpdateFundResponse, DefaultError, Options<FundControllerUpdateFundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerUpdateFund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundControllerGetFundLinkedDealsQueryKey = (options: Options<FundControllerGetFundLinkedDealsData>) => createQueryKey('fundControllerGetFundLinkedDeals', options);

/**
 * Get linked deals for Fund by fund ID
 */
export const fundControllerGetFundLinkedDealsOptions = (options: Options<FundControllerGetFundLinkedDealsData>) => queryOptions<FundControllerGetFundLinkedDealsResponse, DefaultError, FundControllerGetFundLinkedDealsResponse, ReturnType<typeof fundControllerGetFundLinkedDealsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetFundLinkedDeals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetFundLinkedDealsQueryKey(options)
});

export const fundControllerGetAvailableDealsForFundQueryKey = (options: Options<FundControllerGetAvailableDealsForFundData>) => createQueryKey('fundControllerGetAvailableDealsForFund', options);

/**
 * Get deals available to link to a Fund
 */
export const fundControllerGetAvailableDealsForFundOptions = (options: Options<FundControllerGetAvailableDealsForFundData>) => queryOptions<FundControllerGetAvailableDealsForFundResponse, DefaultError, FundControllerGetAvailableDealsForFundResponse, ReturnType<typeof fundControllerGetAvailableDealsForFundQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetAvailableDealsForFund({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetAvailableDealsForFundQueryKey(options)
});

export const fundControllerGetAvailableDealsForPersonFundLinkQueryKey = (options: Options<FundControllerGetAvailableDealsForPersonFundLinkData>) => createQueryKey('fundControllerGetAvailableDealsForPersonFundLink', options);

/**
 * Get deals available for linking for fund's person
 */
export const fundControllerGetAvailableDealsForPersonFundLinkOptions = (options: Options<FundControllerGetAvailableDealsForPersonFundLinkData>) => queryOptions<FundControllerGetAvailableDealsForPersonFundLinkResponse, DefaultError, FundControllerGetAvailableDealsForPersonFundLinkResponse, ReturnType<typeof fundControllerGetAvailableDealsForPersonFundLinkQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetAvailableDealsForPersonFundLink({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetAvailableDealsForPersonFundLinkQueryKey(options)
});

export const fundControllerGetFundByDealQueryKey = (options: Options<FundControllerGetFundByDealData>) => createQueryKey('fundControllerGetFundByDeal', options);

/**
 * Get the Fund associated with a Deal (if the Deal is a Fund)
 */
export const fundControllerGetFundByDealOptions = (options: Options<FundControllerGetFundByDealData>) => queryOptions<FundControllerGetFundByDealResponse, DefaultError, FundControllerGetFundByDealResponse, ReturnType<typeof fundControllerGetFundByDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetFundByDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetFundByDealQueryKey(options)
});

/**
 * Link a Fund to a Deal (Fund invests in Deal)
 */
export const fundControllerLinkFundToDealMutation = (options?: Partial<Options<FundControllerLinkFundToDealData>>): UseMutationOptions<FundControllerLinkFundToDealResponse, DefaultError, Options<FundControllerLinkFundToDealData>> => {
    const mutationOptions: UseMutationOptions<FundControllerLinkFundToDealResponse, DefaultError, Options<FundControllerLinkFundToDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerLinkFundToDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink a Fund from a Deal
 */
export const fundControllerUnlinkFundFromDealMutation = (options?: Partial<Options<FundControllerUnlinkFundFromDealData>>): UseMutationOptions<unknown, DefaultError, Options<FundControllerUnlinkFundFromDealData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<FundControllerUnlinkFundFromDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerUnlinkFundFromDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink a Person from a Fund-Deal
 */
export const fundControllerUnlinkPersonFromFundMutation = (options?: Partial<Options<FundControllerUnlinkPersonFromFundData>>): UseMutationOptions<unknown, DefaultError, Options<FundControllerUnlinkPersonFromFundData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<FundControllerUnlinkPersonFromFundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerUnlinkPersonFromFund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link a Person from a Fund to a Deal
 */
export const fundControllerLinkPersonToFundMutation = (options?: Partial<Options<FundControllerLinkPersonToFundData>>): UseMutationOptions<FundControllerLinkPersonToFundResponse, DefaultError, Options<FundControllerLinkPersonToFundData>> => {
    const mutationOptions: UseMutationOptions<FundControllerLinkPersonToFundResponse, DefaultError, Options<FundControllerLinkPersonToFundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundControllerLinkPersonToFund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundControllerGetFundLinksForPersonQueryKey = (options: Options<FundControllerGetFundLinksForPersonData>) => createQueryKey('fundControllerGetFundLinksForPerson', options);

/**
 * Get Fund links for a Person
 */
export const fundControllerGetFundLinksForPersonOptions = (options: Options<FundControllerGetFundLinksForPersonData>) => queryOptions<FundControllerGetFundLinksForPersonResponse, DefaultError, FundControllerGetFundLinksForPersonResponse, ReturnType<typeof fundControllerGetFundLinksForPersonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundControllerGetFundLinksForPerson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundControllerGetFundLinksForPersonQueryKey(options)
});

export const mipControllerGetEmailWorkflowStatusQueryKey = (options: Options<MipControllerGetEmailWorkflowStatusData>) => createQueryKey('mipControllerGetEmailWorkflowStatus', options);

/**
 * Email workflow progress updates
 */
export const mipControllerGetEmailWorkflowStatusOptions = (options: Options<MipControllerGetEmailWorkflowStatusData>) => queryOptions<MipControllerGetEmailWorkflowStatusResponse, DefaultError, MipControllerGetEmailWorkflowStatusResponse, ReturnType<typeof mipControllerGetEmailWorkflowStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetEmailWorkflowStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetEmailWorkflowStatusQueryKey(options)
});

export const mipControllerListProgrammesQueryKey = (options?: Options<MipControllerListProgrammesData>) => createQueryKey('mipControllerListProgrammes', options);

/**
 * Get Programmes by deal Id with fallback option
 */
export const mipControllerListProgrammesOptions = (options?: Options<MipControllerListProgrammesData>) => queryOptions<MipControllerListProgrammesResponse, DefaultError, MipControllerListProgrammesResponse, ReturnType<typeof mipControllerListProgrammesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerListProgrammes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerListProgrammesQueryKey(options)
});

/**
 * Update
 */
export const mipControllerUpdateMipDataMutation = (options?: Partial<Options<MipControllerUpdateMipDataData>>): UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateMipDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateMipDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerUpdateMipData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipControllerGetMipProgrammeEntitiesQueryKey = (options?: Options<MipControllerGetMipProgrammeEntitiesData>) => createQueryKey('mipControllerGetMipProgrammeEntities', options);

/**
 * Get MIP programme entities
 */
export const mipControllerGetMipProgrammeEntitiesOptions = (options?: Options<MipControllerGetMipProgrammeEntitiesData>) => queryOptions<MipControllerGetMipProgrammeEntitiesResponse, DefaultError, MipControllerGetMipProgrammeEntitiesResponse, ReturnType<typeof mipControllerGetMipProgrammeEntitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetMipProgrammeEntities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetMipProgrammeEntitiesQueryKey(options)
});

/**
 * Add entity to MIP programme
 */
export const mipControllerAddMipProgrammeEntityMutation = (options?: Partial<Options<MipControllerAddMipProgrammeEntityData>>): UseMutationOptions<unknown, DefaultError, Options<MipControllerAddMipProgrammeEntityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MipControllerAddMipProgrammeEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerAddMipProgrammeEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete entity from MIP programme
 */
export const mipControllerDeleteMipProgrammeEntityMutation = (options?: Partial<Options<MipControllerDeleteMipProgrammeEntityData>>): UseMutationOptions<unknown, DefaultError, Options<MipControllerDeleteMipProgrammeEntityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MipControllerDeleteMipProgrammeEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerDeleteMipProgrammeEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipControllerGetMipDetailsForJoinerQueryKey = (options?: Options<MipControllerGetMipDetailsForJoinerData>) => createQueryKey('mipControllerGetMipDetailsForJoiner', options);

/**
 * Get MIP Details
 */
export const mipControllerGetMipDetailsForJoinerOptions = (options?: Options<MipControllerGetMipDetailsForJoinerData>) => queryOptions<MipControllerGetMipDetailsForJoinerResponse, DefaultError, MipControllerGetMipDetailsForJoinerResponse, ReturnType<typeof mipControllerGetMipDetailsForJoinerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetMipDetailsForJoiner({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetMipDetailsForJoinerQueryKey(options)
});

/**
 * Joiner/Additional allocations
 */
export const mipControllerPostJoinerAdditionalAllocationsMutation = (options?: Partial<Options<MipControllerPostJoinerAdditionalAllocationsData>>): UseMutationOptions<MipControllerPostJoinerAdditionalAllocationsResponse, DefaultError, Options<MipControllerPostJoinerAdditionalAllocationsData>> => {
    const mutationOptions: UseMutationOptions<MipControllerPostJoinerAdditionalAllocationsResponse, DefaultError, Options<MipControllerPostJoinerAdditionalAllocationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerPostJoinerAdditionalAllocations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipControllerGetMipDetailsForLeaverQueryKey = (options?: Options<MipControllerGetMipDetailsForLeaverData>) => createQueryKey('mipControllerGetMipDetailsForLeaver', options);

/**
 * Get MIP Details
 */
export const mipControllerGetMipDetailsForLeaverOptions = (options?: Options<MipControllerGetMipDetailsForLeaverData>) => queryOptions<MipControllerGetMipDetailsForLeaverResponse, DefaultError, MipControllerGetMipDetailsForLeaverResponse, ReturnType<typeof mipControllerGetMipDetailsForLeaverQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetMipDetailsForLeaver({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetMipDetailsForLeaverQueryKey(options)
});

/**
 * Leaver/Negative allocations
 */
export const mipControllerPostLeaverNegativeAllocationsMutation = (options?: Partial<Options<MipControllerPostLeaverNegativeAllocationsData>>): UseMutationOptions<MipControllerPostLeaverNegativeAllocationsResponse, DefaultError, Options<MipControllerPostLeaverNegativeAllocationsData>> => {
    const mutationOptions: UseMutationOptions<MipControllerPostLeaverNegativeAllocationsResponse, DefaultError, Options<MipControllerPostLeaverNegativeAllocationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerPostLeaverNegativeAllocations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipControllerGetWorkflowSettingsQueryKey = (options?: Options<MipControllerGetWorkflowSettingsData>) => createQueryKey('mipControllerGetWorkflowSettings', options);

/**
 * Get MIP Workflow Settings
 */
export const mipControllerGetWorkflowSettingsOptions = (options?: Options<MipControllerGetWorkflowSettingsData>) => queryOptions<MipControllerGetWorkflowSettingsResponse, DefaultError, MipControllerGetWorkflowSettingsResponse, ReturnType<typeof mipControllerGetWorkflowSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetWorkflowSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetWorkflowSettingsQueryKey(options)
});

/**
 * Update MIP Workflow Settings
 */
export const mipControllerUpdateWorkflowSettingsMutation = (options?: Partial<Options<MipControllerUpdateWorkflowSettingsData>>): UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateWorkflowSettingsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateWorkflowSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerUpdateWorkflowSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update isKycRequired status
 */
export const mipControllerUpdateMipKycRequiredMutation = (options?: Partial<Options<MipControllerUpdateMipKycRequiredData>>): UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateMipKycRequiredData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MipControllerUpdateMipKycRequiredData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerUpdateMipKycRequired({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get MIPS By Person
 */
export const mipControllerGetMipsForPersonMutation = (options?: Partial<Options<MipControllerGetMipsForPersonData>>): UseMutationOptions<MipControllerGetMipsForPersonResponse, DefaultError, Options<MipControllerGetMipsForPersonData>> => {
    const mutationOptions: UseMutationOptions<MipControllerGetMipsForPersonResponse, DefaultError, Options<MipControllerGetMipsForPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipControllerGetMipsForPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipControllerGetPivDetailsForInvestorsQueryKey = (options?: Options<MipControllerGetPivDetailsForInvestorsData>) => createQueryKey('mipControllerGetPivDetailsForInvestors', options);

/**
 * Get representatives for investors
 */
export const mipControllerGetPivDetailsForInvestorsOptions = (options?: Options<MipControllerGetPivDetailsForInvestorsData>) => queryOptions<MipControllerGetPivDetailsForInvestorsResponse, DefaultError, MipControllerGetPivDetailsForInvestorsResponse, ReturnType<typeof mipControllerGetPivDetailsForInvestorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipControllerGetPivDetailsForInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipControllerGetPivDetailsForInvestorsQueryKey(options)
});

/**
 * Soft delete MIP Draft
 */
export const mipDraftControllerSoftDeleteMipDraftMutation = (options?: Partial<Options<MipDraftControllerSoftDeleteMipDraftData>>): UseMutationOptions<MipDraftControllerSoftDeleteMipDraftResponse, DefaultError, Options<MipDraftControllerSoftDeleteMipDraftData>> => {
    const mutationOptions: UseMutationOptions<MipDraftControllerSoftDeleteMipDraftResponse, DefaultError, Options<MipDraftControllerSoftDeleteMipDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipDraftControllerSoftDeleteMipDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create mip draft
 */
export const mipDraftControllerCreateMipMutation = (options?: Partial<Options<MipDraftControllerCreateMipData>>): UseMutationOptions<MipDraftControllerCreateMipResponse, DefaultError, Options<MipDraftControllerCreateMipData>> => {
    const mutationOptions: UseMutationOptions<MipDraftControllerCreateMipResponse, DefaultError, Options<MipDraftControllerCreateMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipDraftControllerCreateMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP Draft General Deal Inputs
 */
export const mipDraftControllerUpdateDraftGeneralDealInputsMutation = (options?: Partial<Options<MipDraftControllerUpdateDraftGeneralDealInputsData>>): UseMutationOptions<MipDraftControllerUpdateDraftGeneralDealInputsResponse, DefaultError, Options<MipDraftControllerUpdateDraftGeneralDealInputsData>> => {
    const mutationOptions: UseMutationOptions<MipDraftControllerUpdateDraftGeneralDealInputsResponse, DefaultError, Options<MipDraftControllerUpdateDraftGeneralDealInputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipDraftControllerUpdateDraftGeneralDealInputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create an active programme without the wizard
 */
export const mipDraftControllerCreateActiveProgrammeMutation = (options?: Partial<Options<MipDraftControllerCreateActiveProgrammeData>>): UseMutationOptions<MipDraftControllerCreateActiveProgrammeResponse, DefaultError, Options<MipDraftControllerCreateActiveProgrammeData>> => {
    const mutationOptions: UseMutationOptions<MipDraftControllerCreateActiveProgrammeResponse, DefaultError, Options<MipDraftControllerCreateActiveProgrammeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipDraftControllerCreateActiveProgramme({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipDraftControllerCompleteQueryKey = (options?: Options<MipDraftControllerCompleteData>) => createQueryKey('mipDraftControllerComplete', options);

/**
 * Complete mip creation -> Draft -> active MIP project
 */
export const mipDraftControllerCompleteOptions = (options?: Options<MipDraftControllerCompleteData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof mipDraftControllerCompleteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipDraftControllerComplete({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipDraftControllerCompleteQueryKey(options)
});

export const mipDraftControllerGetDraftStepsStatusesQueryKey = (options?: Options<MipDraftControllerGetDraftStepsStatusesData>) => createQueryKey('mipDraftControllerGetDraftStepsStatuses', options);

/**
 * Return draft step errors/warnings
 */
export const mipDraftControllerGetDraftStepsStatusesOptions = (options?: Options<MipDraftControllerGetDraftStepsStatusesData>) => queryOptions<MipDraftControllerGetDraftStepsStatusesResponse, DefaultError, MipDraftControllerGetDraftStepsStatusesResponse, ReturnType<typeof mipDraftControllerGetDraftStepsStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipDraftControllerGetDraftStepsStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipDraftControllerGetDraftStepsStatusesQueryKey(options)
});

export const investorMessageControllerGetMessagesForInvestorQueryKey = (options: Options<InvestorMessageControllerGetMessagesForInvestorData>) => createQueryKey('investorMessageControllerGetMessagesForInvestor', options);

/**
 * Get messages for an investor
 */
export const investorMessageControllerGetMessagesForInvestorOptions = (options: Options<InvestorMessageControllerGetMessagesForInvestorData>) => queryOptions<InvestorMessageControllerGetMessagesForInvestorResponse, DefaultError, InvestorMessageControllerGetMessagesForInvestorResponse, ReturnType<typeof investorMessageControllerGetMessagesForInvestorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorMessageControllerGetMessagesForInvestor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorMessageControllerGetMessagesForInvestorQueryKey(options)
});

export const investorMessageControllerGetMessageForInvestorQueryKey = (options: Options<InvestorMessageControllerGetMessageForInvestorData>) => createQueryKey('investorMessageControllerGetMessageForInvestor', options);

/**
 * Get message for investor
 */
export const investorMessageControllerGetMessageForInvestorOptions = (options: Options<InvestorMessageControllerGetMessageForInvestorData>) => queryOptions<InvestorMessageControllerGetMessageForInvestorResponse, DefaultError, InvestorMessageControllerGetMessageForInvestorResponse, ReturnType<typeof investorMessageControllerGetMessageForInvestorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorMessageControllerGetMessageForInvestor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorMessageControllerGetMessageForInvestorQueryKey(options)
});

export const bankAccountControllerGetMipBankAccountQueryKey = (options?: Options<BankAccountControllerGetMipBankAccountData>) => createQueryKey('bankAccountControllerGetMipBankAccount', options);

/**
 * Get MIP Bank Account
 */
export const bankAccountControllerGetMipBankAccountOptions = (options?: Options<BankAccountControllerGetMipBankAccountData>) => queryOptions<BankAccountControllerGetMipBankAccountResponse, DefaultError, BankAccountControllerGetMipBankAccountResponse, ReturnType<typeof bankAccountControllerGetMipBankAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankAccountControllerGetMipBankAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankAccountControllerGetMipBankAccountQueryKey(options)
});

/**
 * Create MIP Bank Account
 */
export const bankAccountControllerCreateMipBankAccountMutation = (options?: Partial<Options<BankAccountControllerCreateMipBankAccountData>>): UseMutationOptions<BankAccountControllerCreateMipBankAccountResponse, DefaultError, Options<BankAccountControllerCreateMipBankAccountData>> => {
    const mutationOptions: UseMutationOptions<BankAccountControllerCreateMipBankAccountResponse, DefaultError, Options<BankAccountControllerCreateMipBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bankAccountControllerCreateMipBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete MIP Bank Account by its id
 */
export const bankAccountControllerDeleteMipBankAccountMutation = (options?: Partial<Options<BankAccountControllerDeleteMipBankAccountData>>): UseMutationOptions<unknown, DefaultError, Options<BankAccountControllerDeleteMipBankAccountData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<BankAccountControllerDeleteMipBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bankAccountControllerDeleteMipBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP Bank Account by its id
 */
export const bankAccountControllerUpdateMipBankAccountMutation = (options?: Partial<Options<BankAccountControllerUpdateMipBankAccountData>>): UseMutationOptions<BankAccountControllerUpdateMipBankAccountResponse, DefaultError, Options<BankAccountControllerUpdateMipBankAccountData>> => {
    const mutationOptions: UseMutationOptions<BankAccountControllerUpdateMipBankAccountResponse, DefaultError, Options<BankAccountControllerUpdateMipBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bankAccountControllerUpdateMipBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify the MIP bank account's identifiers per format rule and log the lookup
 */
export const bankAccountControllerValidateBankAccountMutation = (options?: Partial<Options<BankAccountControllerValidateBankAccountData>>): UseMutationOptions<BankAccountControllerValidateBankAccountResponse, DefaultError, Options<BankAccountControllerValidateBankAccountData>> => {
    const mutationOptions: UseMutationOptions<BankAccountControllerValidateBankAccountResponse, DefaultError, Options<BankAccountControllerValidateBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bankAccountControllerValidateBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplates', options);

/**
 * Get all document workflow templates for MIP with pagination, filtering, and sorting (Master Documents)
 */
export const documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesQueryKey(options)
});

/**
 * Soft delete a document workflow template
 */
export const documentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerSoftDeleteMasterDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerGetByIdQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetByIdData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetById', options);

/**
 * Get document workflow template by ID (Master Documents)
 */
export const documentWorkflowMasterDocumentsControllerGetByIdOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetByIdData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetByIdResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetByIdResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetByIdQueryKey(options)
});

/**
 * Update document workflow template properties (visibleIn, classifiers, signature type)
 */
export const documentWorkflowMasterDocumentsControllerUpdateMasterDocumentMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerUpdateMasterDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerGetSignatureSlotsQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetSignatureSlots', options);

/**
 * Get signature placement slots for a template
 */
export const documentWorkflowMasterDocumentsControllerGetSignatureSlotsOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetSignatureSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetSignatureSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetSignatureSlotsQueryKey(options)
});

export const documentWorkflowMasterDocumentsControllerGetFieldBindingsQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetFieldBindings', options);

/**
 * Get field bindings for a template
 */
export const documentWorkflowMasterDocumentsControllerGetFieldBindingsOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetFieldBindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetFieldBindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetFieldBindingsQueryKey(options)
});

/**
 * Replace field bindings for a template
 */
export const documentWorkflowMasterDocumentsControllerUpdateFieldBindingsMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerUpdateFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a field-bound PDF preview for an investor
 */
export const documentWorkflowMasterDocumentsControllerPreviewFieldBindingsMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerPreviewFieldBindings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerGetDocxFlowDocumentQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetDocxFlowDocument', options);

/**
 * Get the editable document for a Word master document
 */
export const documentWorkflowMasterDocumentsControllerGetDocxFlowDocumentOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetDocxFlowDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetDocxFlowDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetDocxFlowDocumentQueryKey(options)
});

/**
 * Save an edited Word master document
 */
export const documentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerSaveDocxFlowDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData>) => createQueryKey('documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsView', options);

/**
 * Render a converted Word template with its field names in place
 */
export const documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewQueryKey(options)
});

/**
 * Render a converted Word template — field names in place, or a recipient’s real values
 */
export const documentWorkflowMasterDocumentsControllerRenderDocxTemplateMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerRenderDocxTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueQueryKey = (options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData>) => createQueryKey('documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogue', options);

/**
 * Get the field-binding catalogue with resolved sample values
 */
export const documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueOptions = (options: Options<DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData>) => queryOptions<DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponse, DefaultError, DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponse, ReturnType<typeof documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueQueryKey(options)
});

/**
 * Create a document workflow template (master document)
 */
export const documentWorkflowMasterDocumentsControllerCreateMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerCreateData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerCreateResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerCreateResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive a document workflow template
 */
export const documentWorkflowMasterDocumentsControllerUpdateArchivedMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerUpdateArchivedData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateArchivedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerUpdateArchivedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerUpdateArchived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk archive or unarchive document workflow templates
 */
export const documentWorkflowMasterDocumentsControllerBulkArchiveMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerBulkArchiveData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerBulkArchiveResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerBulkArchiveData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerBulkArchiveResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerBulkArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerBulkArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk soft delete document workflow templates
 */
export const documentWorkflowMasterDocumentsControllerBulkDeleteMutation = (options?: Partial<Options<DocumentWorkflowMasterDocumentsControllerBulkDeleteData>>): UseMutationOptions<DocumentWorkflowMasterDocumentsControllerBulkDeleteResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<DocumentWorkflowMasterDocumentsControllerBulkDeleteResponse, DefaultError, Options<DocumentWorkflowMasterDocumentsControllerBulkDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentWorkflowMasterDocumentsControllerBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get a filtered, sorted page of the bank accounts of a programme's investors
 */
export const investorBankAccountControllerGetInvestorBankAccountsMutation = (options?: Partial<Options<InvestorBankAccountControllerGetInvestorBankAccountsData>>): UseMutationOptions<InvestorBankAccountControllerGetInvestorBankAccountsResponse, DefaultError, Options<InvestorBankAccountControllerGetInvestorBankAccountsData>> => {
    const mutationOptions: UseMutationOptions<InvestorBankAccountControllerGetInvestorBankAccountsResponse, DefaultError, Options<InvestorBankAccountControllerGetInvestorBankAccountsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorBankAccountControllerGetInvestorBankAccounts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const investorBankAccountControllerGetBankAccountDetailQueryKey = (options: Options<InvestorBankAccountControllerGetBankAccountDetailData>) => createQueryKey('investorBankAccountControllerGetBankAccountDetail', options);

/**
 * Get one investor bank account with its standing review
 */
export const investorBankAccountControllerGetBankAccountDetailOptions = (options: Options<InvestorBankAccountControllerGetBankAccountDetailData>) => queryOptions<InvestorBankAccountControllerGetBankAccountDetailResponse, DefaultError, InvestorBankAccountControllerGetBankAccountDetailResponse, ReturnType<typeof investorBankAccountControllerGetBankAccountDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorBankAccountControllerGetBankAccountDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorBankAccountControllerGetBankAccountDetailQueryKey(options)
});

export const investorBankAccountControllerGetBankAccountHistoryQueryKey = (options: Options<InvestorBankAccountControllerGetBankAccountHistoryData>) => createQueryKey('investorBankAccountControllerGetBankAccountHistory', options);

/**
 * Get a bank account's audit trail
 */
export const investorBankAccountControllerGetBankAccountHistoryOptions = (options: Options<InvestorBankAccountControllerGetBankAccountHistoryData>) => queryOptions<InvestorBankAccountControllerGetBankAccountHistoryResponse, DefaultError, InvestorBankAccountControllerGetBankAccountHistoryResponse, ReturnType<typeof investorBankAccountControllerGetBankAccountHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investorBankAccountControllerGetBankAccountHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investorBankAccountControllerGetBankAccountHistoryQueryKey(options)
});

/**
 * Approve, decline or revoke a decision on an investor bank account
 */
export const investorBankAccountControllerReviewMutation = (options?: Partial<Options<InvestorBankAccountControllerReviewData>>): UseMutationOptions<InvestorBankAccountControllerReviewResponse, DefaultError, Options<InvestorBankAccountControllerReviewData>> => {
    const mutationOptions: UseMutationOptions<InvestorBankAccountControllerReviewResponse, DefaultError, Options<InvestorBankAccountControllerReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorBankAccountControllerReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const auditControllerGetEntityAuditsQueryKey = (options: Options<AuditControllerGetEntityAuditsData>) => createQueryKey('auditControllerGetEntityAudits', options);

/**
 * Get audit history for entity
 */
export const auditControllerGetEntityAuditsOptions = (options: Options<AuditControllerGetEntityAuditsData>) => queryOptions<AuditControllerGetEntityAuditsResponse, DefaultError, AuditControllerGetEntityAuditsResponse, ReturnType<typeof auditControllerGetEntityAuditsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditControllerGetEntityAudits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditControllerGetEntityAuditsQueryKey(options)
});

export const auditControllerGetInvestmentAuditsQueryKey = (options: Options<AuditControllerGetInvestmentAuditsData>) => createQueryKey('auditControllerGetInvestmentAudits', options);

/**
 * Get audit history for an investment (workflow + allocations + loans)
 */
export const auditControllerGetInvestmentAuditsOptions = (options: Options<AuditControllerGetInvestmentAuditsData>) => queryOptions<AuditControllerGetInvestmentAuditsResponse, DefaultError, AuditControllerGetInvestmentAuditsResponse, ReturnType<typeof auditControllerGetInvestmentAuditsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditControllerGetInvestmentAudits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditControllerGetInvestmentAuditsQueryKey(options)
});

export const auditControllerGetPersonAuditsQueryKey = (options: Options<AuditControllerGetPersonAuditsData>) => createQueryKey('auditControllerGetPersonAudits', options);

/**
 * Get audit history for a person across all of the person's deals
 */
export const auditControllerGetPersonAuditsOptions = (options: Options<AuditControllerGetPersonAuditsData>) => queryOptions<AuditControllerGetPersonAuditsResponse, DefaultError, AuditControllerGetPersonAuditsResponse, ReturnType<typeof auditControllerGetPersonAuditsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditControllerGetPersonAudits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditControllerGetPersonAuditsQueryKey(options)
});

export const programmeSettingControllerGetByMipIdQueryKey = (options?: Options<ProgrammeSettingControllerGetByMipIdData>) => createQueryKey('programmeSettingControllerGetByMipId', options);

/**
 * Get MIP-level programme settings
 */
export const programmeSettingControllerGetByMipIdOptions = (options?: Options<ProgrammeSettingControllerGetByMipIdData>) => queryOptions<ProgrammeSettingControllerGetByMipIdResponse, DefaultError, ProgrammeSettingControllerGetByMipIdResponse, ReturnType<typeof programmeSettingControllerGetByMipIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeSettingControllerGetByMipId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeSettingControllerGetByMipIdQueryKey(options)
});

/**
 * Update MIP-level programme settings
 */
export const programmeSettingControllerUpdateByMipIdMutation = (options?: Partial<Options<ProgrammeSettingControllerUpdateByMipIdData>>): UseMutationOptions<unknown, DefaultError, Options<ProgrammeSettingControllerUpdateByMipIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ProgrammeSettingControllerUpdateByMipIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeSettingControllerUpdateByMipId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationKycSettingControllerGetRequirementsQueryKey = (options: Options<OrganizationKycSettingControllerGetRequirementsData>) => createQueryKey('organizationKycSettingControllerGetRequirements', options);

/**
 * Get organisation-level KYC/AML and Investor Data requirements
 */
export const organizationKycSettingControllerGetRequirementsOptions = (options: Options<OrganizationKycSettingControllerGetRequirementsData>) => queryOptions<OrganizationKycSettingControllerGetRequirementsResponse, DefaultError, OrganizationKycSettingControllerGetRequirementsResponse, ReturnType<typeof organizationKycSettingControllerGetRequirementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationKycSettingControllerGetRequirements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationKycSettingControllerGetRequirementsQueryKey(options)
});

/**
 * Update organisation-level KYC/AML and Investor Data requirements
 */
export const organizationKycSettingControllerUpdateRequirementsMutation = (options?: Partial<Options<OrganizationKycSettingControllerUpdateRequirementsData>>): UseMutationOptions<OrganizationKycSettingControllerUpdateRequirementsResponse, DefaultError, Options<OrganizationKycSettingControllerUpdateRequirementsData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycSettingControllerUpdateRequirementsResponse, DefaultError, Options<OrganizationKycSettingControllerUpdateRequirementsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycSettingControllerUpdateRequirements({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationCustomFieldControllerGetCustomFieldsQueryKey = (options: Options<OrganizationCustomFieldControllerGetCustomFieldsData>) => createQueryKey('organizationCustomFieldControllerGetCustomFields', options);

/**
 * List organisation-level Investor Data custom fields
 */
export const organizationCustomFieldControllerGetCustomFieldsOptions = (options: Options<OrganizationCustomFieldControllerGetCustomFieldsData>) => queryOptions<OrganizationCustomFieldControllerGetCustomFieldsResponse, DefaultError, OrganizationCustomFieldControllerGetCustomFieldsResponse, ReturnType<typeof organizationCustomFieldControllerGetCustomFieldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationCustomFieldControllerGetCustomFields({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationCustomFieldControllerGetCustomFieldsQueryKey(options)
});

/**
 * Add an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerCreateCustomFieldMutation = (options?: Partial<Options<OrganizationCustomFieldControllerCreateCustomFieldData>>): UseMutationOptions<OrganizationCustomFieldControllerCreateCustomFieldResponse, DefaultError, Options<OrganizationCustomFieldControllerCreateCustomFieldData>> => {
    const mutationOptions: UseMutationOptions<OrganizationCustomFieldControllerCreateCustomFieldResponse, DefaultError, Options<OrganizationCustomFieldControllerCreateCustomFieldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationCustomFieldControllerCreateCustomField({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerDeleteCustomFieldMutation = (options?: Partial<Options<OrganizationCustomFieldControllerDeleteCustomFieldData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationCustomFieldControllerDeleteCustomFieldData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationCustomFieldControllerDeleteCustomFieldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationCustomFieldControllerDeleteCustomField({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an organisation-level Investor Data custom field
 */
export const organizationCustomFieldControllerUpdateCustomFieldMutation = (options?: Partial<Options<OrganizationCustomFieldControllerUpdateCustomFieldData>>): UseMutationOptions<OrganizationCustomFieldControllerUpdateCustomFieldResponse, DefaultError, Options<OrganizationCustomFieldControllerUpdateCustomFieldData>> => {
    const mutationOptions: UseMutationOptions<OrganizationCustomFieldControllerUpdateCustomFieldResponse, DefaultError, Options<OrganizationCustomFieldControllerUpdateCustomFieldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationCustomFieldControllerUpdateCustomField({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationVestingTermControllerGetVestingTermsQueryKey = (options: Options<OrganizationVestingTermControllerGetVestingTermsData>) => createQueryKey('organizationVestingTermControllerGetVestingTerms', options);

/**
 * List organisation-level vesting terms
 */
export const organizationVestingTermControllerGetVestingTermsOptions = (options: Options<OrganizationVestingTermControllerGetVestingTermsData>) => queryOptions<OrganizationVestingTermControllerGetVestingTermsResponse, DefaultError, OrganizationVestingTermControllerGetVestingTermsResponse, ReturnType<typeof organizationVestingTermControllerGetVestingTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationVestingTermControllerGetVestingTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationVestingTermControllerGetVestingTermsQueryKey(options)
});

/**
 * Create an organisation-level vesting term
 */
export const organizationVestingTermControllerCreateVestingTermMutation = (options?: Partial<Options<OrganizationVestingTermControllerCreateVestingTermData>>): UseMutationOptions<OrganizationVestingTermControllerCreateVestingTermResponse, DefaultError, Options<OrganizationVestingTermControllerCreateVestingTermData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerCreateVestingTermResponse, DefaultError, Options<OrganizationVestingTermControllerCreateVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerCreateVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an organisation-level vesting term
 */
export const organizationVestingTermControllerDeleteVestingTermMutation = (options?: Partial<Options<OrganizationVestingTermControllerDeleteVestingTermData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteVestingTermData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerDeleteVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an organisation-level vesting term
 */
export const organizationVestingTermControllerUpdateVestingTermMutation = (options?: Partial<Options<OrganizationVestingTermControllerUpdateVestingTermData>>): UseMutationOptions<OrganizationVestingTermControllerUpdateVestingTermResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateVestingTermData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerUpdateVestingTermResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateVestingTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerUpdateVestingTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add the straight-line schedule to an organisation vesting term
 */
export const organizationVestingTermControllerCreateStraightLineMutation = (options?: Partial<Options<OrganizationVestingTermControllerCreateStraightLineData>>): UseMutationOptions<OrganizationVestingTermControllerCreateStraightLineResponse, DefaultError, Options<OrganizationVestingTermControllerCreateStraightLineData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerCreateStraightLineResponse, DefaultError, Options<OrganizationVestingTermControllerCreateStraightLineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerCreateStraightLine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the straight-line schedule of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateStraightLineMutation = (options?: Partial<Options<OrganizationVestingTermControllerUpdateStraightLineData>>): UseMutationOptions<OrganizationVestingTermControllerUpdateStraightLineResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateStraightLineData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerUpdateStraightLineResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateStraightLineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerUpdateStraightLine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a graded tranche to an organisation vesting term
 */
export const organizationVestingTermControllerCreateGradedMutation = (options?: Partial<Options<OrganizationVestingTermControllerCreateGradedData>>): UseMutationOptions<OrganizationVestingTermControllerCreateGradedResponse, DefaultError, Options<OrganizationVestingTermControllerCreateGradedData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerCreateGradedResponse, DefaultError, Options<OrganizationVestingTermControllerCreateGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerCreateGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a graded tranche from an organisation vesting term
 */
export const organizationVestingTermControllerDeleteGradedMutation = (options?: Partial<Options<OrganizationVestingTermControllerDeleteGradedData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteGradedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerDeleteGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a graded tranche of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateGradedMutation = (options?: Partial<Options<OrganizationVestingTermControllerUpdateGradedData>>): UseMutationOptions<OrganizationVestingTermControllerUpdateGradedResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateGradedData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerUpdateGradedResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateGradedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerUpdateGraded({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a leaver provision to an organisation vesting term
 */
export const organizationVestingTermControllerCreateLeaverProvisionMutation = (options?: Partial<Options<OrganizationVestingTermControllerCreateLeaverProvisionData>>): UseMutationOptions<OrganizationVestingTermControllerCreateLeaverProvisionResponse, DefaultError, Options<OrganizationVestingTermControllerCreateLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerCreateLeaverProvisionResponse, DefaultError, Options<OrganizationVestingTermControllerCreateLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerCreateLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a leaver provision from an organisation vesting term
 */
export const organizationVestingTermControllerDeleteLeaverProvisionMutation = (options?: Partial<Options<OrganizationVestingTermControllerDeleteLeaverProvisionData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationVestingTermControllerDeleteLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerDeleteLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a leaver provision of an organisation vesting term
 */
export const organizationVestingTermControllerUpdateLeaverProvisionMutation = (options?: Partial<Options<OrganizationVestingTermControllerUpdateLeaverProvisionData>>): UseMutationOptions<OrganizationVestingTermControllerUpdateLeaverProvisionResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateLeaverProvisionData>> => {
    const mutationOptions: UseMutationOptions<OrganizationVestingTermControllerUpdateLeaverProvisionResponse, DefaultError, Options<OrganizationVestingTermControllerUpdateLeaverProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationVestingTermControllerUpdateLeaverProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationDocumentTemplateControllerListQueryKey = (options: Options<OrganizationDocumentTemplateControllerListData>) => createQueryKey('organizationDocumentTemplateControllerList', options);

/**
 * List organisation-level master documents with pagination, filtering and sorting
 */
export const organizationDocumentTemplateControllerListOptions = (options: Options<OrganizationDocumentTemplateControllerListData>) => queryOptions<OrganizationDocumentTemplateControllerListResponse, DefaultError, OrganizationDocumentTemplateControllerListResponse, ReturnType<typeof organizationDocumentTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDocumentTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDocumentTemplateControllerListQueryKey(options)
});

/**
 * Remove an organisation-level master document
 */
export const organizationDocumentTemplateControllerRemoveMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerRemoveData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationDocumentTemplateControllerGetByIdQueryKey = (options: Options<OrganizationDocumentTemplateControllerGetByIdData>) => createQueryKey('organizationDocumentTemplateControllerGetById', options);

/**
 * Get an organisation-level master document
 */
export const organizationDocumentTemplateControllerGetByIdOptions = (options: Options<OrganizationDocumentTemplateControllerGetByIdData>) => queryOptions<OrganizationDocumentTemplateControllerGetByIdResponse, DefaultError, OrganizationDocumentTemplateControllerGetByIdResponse, ReturnType<typeof organizationDocumentTemplateControllerGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDocumentTemplateControllerGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDocumentTemplateControllerGetByIdQueryKey(options)
});

/**
 * Update an organisation-level master document
 */
export const organizationDocumentTemplateControllerUpdateMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerUpdateData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add an organisation-level master document
 */
export const organizationDocumentTemplateControllerCreateMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerCreateData>>): UseMutationOptions<OrganizationDocumentTemplateControllerCreateResponse, DefaultError, Options<OrganizationDocumentTemplateControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<OrganizationDocumentTemplateControllerCreateResponse, DefaultError, Options<OrganizationDocumentTemplateControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive an organisation-level master document
 */
export const organizationDocumentTemplateControllerUpdateArchivedMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerUpdateArchivedData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerUpdateArchivedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerUpdateArchivedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerUpdateArchived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive organisation-level master documents in bulk
 */
export const organizationDocumentTemplateControllerBulkArchiveMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerBulkArchiveData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerBulkArchiveData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerBulkArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerBulkArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove organisation-level master documents in bulk
 */
export const organizationDocumentTemplateControllerBulkDeleteMutation = (options?: Partial<Options<OrganizationDocumentTemplateControllerBulkDeleteData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDocumentTemplateControllerBulkDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDocumentTemplateControllerBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Tax & Compliance forms from an organisation's defaults
 */
export const organizationKycFormTemplateControllerRemoveMutation = (options?: Partial<Options<OrganizationKycFormTemplateControllerRemoveData>>): UseMutationOptions<OrganizationKycFormTemplateControllerRemoveResponse, DefaultError, Options<OrganizationKycFormTemplateControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycFormTemplateControllerRemoveResponse, DefaultError, Options<OrganizationKycFormTemplateControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycFormTemplateControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationKycFormTemplateControllerListQueryKey = (options: Options<OrganizationKycFormTemplateControllerListData>) => createQueryKey('organizationKycFormTemplateControllerList', options);

/**
 * List an organisation's default Tax & Compliance forms
 */
export const organizationKycFormTemplateControllerListOptions = (options: Options<OrganizationKycFormTemplateControllerListData>) => queryOptions<OrganizationKycFormTemplateControllerListResponse, DefaultError, OrganizationKycFormTemplateControllerListResponse, ReturnType<typeof organizationKycFormTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationKycFormTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationKycFormTemplateControllerListQueryKey(options)
});

/**
 * Add a Tax & Compliance form to an organisation's defaults
 */
export const organizationKycFormTemplateControllerCreateMutation = (options?: Partial<Options<OrganizationKycFormTemplateControllerCreateData>>): UseMutationOptions<OrganizationKycFormTemplateControllerCreateResponse, DefaultError, Options<OrganizationKycFormTemplateControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycFormTemplateControllerCreateResponse, DefaultError, Options<OrganizationKycFormTemplateControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycFormTemplateControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a Tax & Compliance form in an organisation's defaults
 */
export const organizationKycFormTemplateControllerUpdateMutation = (options?: Partial<Options<OrganizationKycFormTemplateControllerUpdateData>>): UseMutationOptions<OrganizationKycFormTemplateControllerUpdateResponse, DefaultError, Options<OrganizationKycFormTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycFormTemplateControllerUpdateResponse, DefaultError, Options<OrganizationKycFormTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycFormTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive or unarchive an organisation Tax & Compliance form
 */
export const organizationKycFormTemplateControllerArchiveMutation = (options?: Partial<Options<OrganizationKycFormTemplateControllerArchiveData>>): UseMutationOptions<OrganizationKycFormTemplateControllerArchiveResponse, DefaultError, Options<OrganizationKycFormTemplateControllerArchiveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycFormTemplateControllerArchiveResponse, DefaultError, Options<OrganizationKycFormTemplateControllerArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycFormTemplateControllerArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationKycFormTemplateControllerSignatureSlotsQueryKey = (options: Options<OrganizationKycFormTemplateControllerSignatureSlotsData>) => createQueryKey('organizationKycFormTemplateControllerSignatureSlots', options);

/**
 * The signature box an admin must place on an organisation default (always one)
 */
export const organizationKycFormTemplateControllerSignatureSlotsOptions = (options: Options<OrganizationKycFormTemplateControllerSignatureSlotsData>) => queryOptions<OrganizationKycFormTemplateControllerSignatureSlotsResponse, DefaultError, OrganizationKycFormTemplateControllerSignatureSlotsResponse, ReturnType<typeof organizationKycFormTemplateControllerSignatureSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationKycFormTemplateControllerSignatureSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationKycFormTemplateControllerSignatureSlotsQueryKey(options)
});

/**
 * Save the manual signature placement for an organisation default
 */
export const organizationKycFormTemplateControllerUpdateSignaturePlacementMutation = (options?: Partial<Options<OrganizationKycFormTemplateControllerUpdateSignaturePlacementData>>): UseMutationOptions<OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponse, DefaultError, Options<OrganizationKycFormTemplateControllerUpdateSignaturePlacementData>> => {
    const mutationOptions: UseMutationOptions<OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponse, DefaultError, Options<OrganizationKycFormTemplateControllerUpdateSignaturePlacementData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationKycFormTemplateControllerUpdateSignaturePlacement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pre-signed download for one of an organisation's default files
 */
export const organizationFileControllerDownloadPreSignedUrlMutation = (options?: Partial<Options<OrganizationFileControllerDownloadPreSignedUrlData>>): UseMutationOptions<OrganizationFileControllerDownloadPreSignedUrlResponse, DefaultError, Options<OrganizationFileControllerDownloadPreSignedUrlData>> => {
    const mutationOptions: UseMutationOptions<OrganizationFileControllerDownloadPreSignedUrlResponse, DefaultError, Options<OrganizationFileControllerDownloadPreSignedUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationFileControllerDownloadPreSignedUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationEmailTemplateControllerListQueryKey = (options: Options<OrganizationEmailTemplateControllerListData>) => createQueryKey('organizationEmailTemplateControllerList', options);

/**
 * List an organisation's default email templates
 */
export const organizationEmailTemplateControllerListOptions = (options: Options<OrganizationEmailTemplateControllerListData>) => queryOptions<OrganizationEmailTemplateControllerListResponse, DefaultError, OrganizationEmailTemplateControllerListResponse, ReturnType<typeof organizationEmailTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationEmailTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationEmailTemplateControllerListQueryKey(options)
});

export const organizationEmailTemplateControllerGetOneQueryKey = (options: Options<OrganizationEmailTemplateControllerGetOneData>) => createQueryKey('organizationEmailTemplateControllerGetOne', options);

/**
 * Get one default template (Dealstack default + current override)
 */
export const organizationEmailTemplateControllerGetOneOptions = (options: Options<OrganizationEmailTemplateControllerGetOneData>) => queryOptions<OrganizationEmailTemplateControllerGetOneResponse, DefaultError, OrganizationEmailTemplateControllerGetOneResponse, ReturnType<typeof organizationEmailTemplateControllerGetOneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationEmailTemplateControllerGetOne({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationEmailTemplateControllerGetOneQueryKey(options)
});

/**
 * Update the subject, body or send toggle of a default template
 */
export const organizationEmailTemplateControllerUpdateMutation = (options?: Partial<Options<OrganizationEmailTemplateControllerUpdateData>>): UseMutationOptions<OrganizationEmailTemplateControllerUpdateResponse, DefaultError, Options<OrganizationEmailTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<OrganizationEmailTemplateControllerUpdateResponse, DefaultError, Options<OrganizationEmailTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationEmailTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Render a live preview of the saved or draft default template
 */
export const organizationEmailTemplateControllerPreviewMutation = (options?: Partial<Options<OrganizationEmailTemplateControllerPreviewData>>): UseMutationOptions<OrganizationEmailTemplateControllerPreviewResponse, DefaultError, Options<OrganizationEmailTemplateControllerPreviewData>> => {
    const mutationOptions: UseMutationOptions<OrganizationEmailTemplateControllerPreviewResponse, DefaultError, Options<OrganizationEmailTemplateControllerPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationEmailTemplateControllerPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset a default template back to the Dealstack default
 */
export const organizationEmailTemplateControllerResetMutation = (options?: Partial<Options<OrganizationEmailTemplateControllerResetData>>): UseMutationOptions<OrganizationEmailTemplateControllerResetResponse, DefaultError, Options<OrganizationEmailTemplateControllerResetData>> => {
    const mutationOptions: UseMutationOptions<OrganizationEmailTemplateControllerResetResponse, DefaultError, Options<OrganizationEmailTemplateControllerResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationEmailTemplateControllerReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationEmailScheduleControllerListConfigsQueryKey = (options: Options<OrganizationEmailScheduleControllerListConfigsData>) => createQueryKey('organizationEmailScheduleControllerListConfigs', options);

/**
 * List organisation-level reminder cadences (one per handler type)
 */
export const organizationEmailScheduleControllerListConfigsOptions = (options: Options<OrganizationEmailScheduleControllerListConfigsData>) => queryOptions<OrganizationEmailScheduleControllerListConfigsResponse, DefaultError, OrganizationEmailScheduleControllerListConfigsResponse, ReturnType<typeof organizationEmailScheduleControllerListConfigsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationEmailScheduleControllerListConfigs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationEmailScheduleControllerListConfigsQueryKey(options)
});

/**
 * Create or update an organisation-level reminder cadence
 */
export const organizationEmailScheduleControllerUpsertConfigMutation = (options?: Partial<Options<OrganizationEmailScheduleControllerUpsertConfigData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationEmailScheduleControllerUpsertConfigData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationEmailScheduleControllerUpsertConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationEmailScheduleControllerUpsertConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const programmeDefaultsSummaryControllerGetMySummaryQueryKey = (options?: Options<ProgrammeDefaultsSummaryControllerGetMySummaryData>) => createQueryKey('programmeDefaultsSummaryControllerGetMySummary', options);

/**
 * The caller's own Programme Defaults, for the confirm step
 */
export const programmeDefaultsSummaryControllerGetMySummaryOptions = (options?: Options<ProgrammeDefaultsSummaryControllerGetMySummaryData>) => queryOptions<ProgrammeDefaultsSummaryControllerGetMySummaryResponse, DefaultError, ProgrammeDefaultsSummaryControllerGetMySummaryResponse, ReturnType<typeof programmeDefaultsSummaryControllerGetMySummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeDefaultsSummaryControllerGetMySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeDefaultsSummaryControllerGetMySummaryQueryKey(options)
});

export const programmeDefaultsSummaryControllerGetSummaryForDealQueryKey = (options?: Options<ProgrammeDefaultsSummaryControllerGetSummaryForDealData>) => createQueryKey('programmeDefaultsSummaryControllerGetSummaryForDeal', options);

/**
 * The Programme Defaults of a deal's lead Sponsor
 */
export const programmeDefaultsSummaryControllerGetSummaryForDealOptions = (options?: Options<ProgrammeDefaultsSummaryControllerGetSummaryForDealData>) => queryOptions<ProgrammeDefaultsSummaryControllerGetSummaryForDealResponse, DefaultError, ProgrammeDefaultsSummaryControllerGetSummaryForDealResponse, ReturnType<typeof programmeDefaultsSummaryControllerGetSummaryForDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeDefaultsSummaryControllerGetSummaryForDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeDefaultsSummaryControllerGetSummaryForDealQueryKey(options)
});

export const programmeDefaultsSummaryControllerGetSummaryQueryKey = (options: Options<ProgrammeDefaultsSummaryControllerGetSummaryData>) => createQueryKey('programmeDefaultsSummaryControllerGetSummary', options);

/**
 * What a Sponsor organisation has configured, for the confirm step
 */
export const programmeDefaultsSummaryControllerGetSummaryOptions = (options: Options<ProgrammeDefaultsSummaryControllerGetSummaryData>) => queryOptions<ProgrammeDefaultsSummaryControllerGetSummaryResponse, DefaultError, ProgrammeDefaultsSummaryControllerGetSummaryResponse, ReturnType<typeof programmeDefaultsSummaryControllerGetSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeDefaultsSummaryControllerGetSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeDefaultsSummaryControllerGetSummaryQueryKey(options)
});

/**
 * Copy an organisation's Programme Defaults into a programme
 */
export const programmeDefaultsSummaryControllerApplyMutation = (options?: Partial<Options<ProgrammeDefaultsSummaryControllerApplyData>>): UseMutationOptions<ProgrammeDefaultsSummaryControllerApplyResponse, DefaultError, Options<ProgrammeDefaultsSummaryControllerApplyData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeDefaultsSummaryControllerApplyResponse, DefaultError, Options<ProgrammeDefaultsSummaryControllerApplyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeDefaultsSummaryControllerApply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipClassifierControllerListQueryKey = (options?: Options<MipClassifierControllerListData>) => createQueryKey('mipClassifierControllerList', options);

/**
 * List classifiers for the current MIP
 */
export const mipClassifierControllerListOptions = (options?: Options<MipClassifierControllerListData>) => queryOptions<MipClassifierControllerListResponse, DefaultError, MipClassifierControllerListResponse, ReturnType<typeof mipClassifierControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipClassifierControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipClassifierControllerListQueryKey(options)
});

/**
 * Create a classifier scoped to the current MIP
 */
export const mipClassifierControllerCreateMutation = (options?: Partial<Options<MipClassifierControllerCreateData>>): UseMutationOptions<MipClassifierControllerCreateResponse, DefaultError, Options<MipClassifierControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<MipClassifierControllerCreateResponse, DefaultError, Options<MipClassifierControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipClassifierControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename and/or archive a MIP-scoped classifier
 */
export const mipClassifierControllerUpdateMutation = (options?: Partial<Options<MipClassifierControllerUpdateData>>): UseMutationOptions<MipClassifierControllerUpdateResponse, DefaultError, Options<MipClassifierControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<MipClassifierControllerUpdateResponse, DefaultError, Options<MipClassifierControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipClassifierControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mipClassifierControllerListByInvestorQueryKey = (options: Options<MipClassifierControllerListByInvestorData>) => createQueryKey('mipClassifierControllerListByInvestor', options);

/**
 * List active cohort classifiers attached to an investor
 */
export const mipClassifierControllerListByInvestorOptions = (options: Options<MipClassifierControllerListByInvestorData>) => queryOptions<MipClassifierControllerListByInvestorResponse, DefaultError, MipClassifierControllerListByInvestorResponse, ReturnType<typeof mipClassifierControllerListByInvestorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mipClassifierControllerListByInvestor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mipClassifierControllerListByInvestorQueryKey(options)
});

/**
 * Attach investors to a cohort classifier. Idempotent — existing active links are skipped.
 */
export const mipClassifierControllerAttachInvestorsMutation = (options?: Partial<Options<MipClassifierControllerAttachInvestorsData>>): UseMutationOptions<MipClassifierControllerAttachInvestorsResponse, DefaultError, Options<MipClassifierControllerAttachInvestorsData>> => {
    const mutationOptions: UseMutationOptions<MipClassifierControllerAttachInvestorsResponse, DefaultError, Options<MipClassifierControllerAttachInvestorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipClassifierControllerAttachInvestors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Detach investors from a cohort classifier. Investors without an active link are skipped.
 */
export const mipClassifierControllerDetachInvestorsMutation = (options?: Partial<Options<MipClassifierControllerDetachInvestorsData>>): UseMutationOptions<MipClassifierControllerDetachInvestorsResponse, DefaultError, Options<MipClassifierControllerDetachInvestorsData>> => {
    const mutationOptions: UseMutationOptions<MipClassifierControllerDetachInvestorsResponse, DefaultError, Options<MipClassifierControllerDetachInvestorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mipClassifierControllerDetachInvestors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const programmeEmailTemplateControllerListQueryKey = (options?: Options<ProgrammeEmailTemplateControllerListData>) => createQueryKey('programmeEmailTemplateControllerList', options);

/**
 * List the editable email templates for the current Programme
 */
export const programmeEmailTemplateControllerListOptions = (options?: Options<ProgrammeEmailTemplateControllerListData>) => queryOptions<ProgrammeEmailTemplateControllerListResponse, DefaultError, ProgrammeEmailTemplateControllerListResponse, ReturnType<typeof programmeEmailTemplateControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeEmailTemplateControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeEmailTemplateControllerListQueryKey(options)
});

export const programmeEmailTemplateControllerGetOneQueryKey = (options: Options<ProgrammeEmailTemplateControllerGetOneData>) => createQueryKey('programmeEmailTemplateControllerGetOne', options);

/**
 * Get one email template (default + current override) for editing
 */
export const programmeEmailTemplateControllerGetOneOptions = (options: Options<ProgrammeEmailTemplateControllerGetOneData>) => queryOptions<ProgrammeEmailTemplateControllerGetOneResponse, DefaultError, ProgrammeEmailTemplateControllerGetOneResponse, ReturnType<typeof programmeEmailTemplateControllerGetOneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeEmailTemplateControllerGetOne({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeEmailTemplateControllerGetOneQueryKey(options)
});

/**
 * Update the subject, body, or send toggle of a Programme template
 */
export const programmeEmailTemplateControllerUpdateMutation = (options?: Partial<Options<ProgrammeEmailTemplateControllerUpdateData>>): UseMutationOptions<ProgrammeEmailTemplateControllerUpdateResponse, DefaultError, Options<ProgrammeEmailTemplateControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeEmailTemplateControllerUpdateResponse, DefaultError, Options<ProgrammeEmailTemplateControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeEmailTemplateControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Render a live preview (send-parity) of the saved or draft template
 */
export const programmeEmailTemplateControllerPreviewMutation = (options?: Partial<Options<ProgrammeEmailTemplateControllerPreviewData>>): UseMutationOptions<ProgrammeEmailTemplateControllerPreviewResponse, DefaultError, Options<ProgrammeEmailTemplateControllerPreviewData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeEmailTemplateControllerPreviewResponse, DefaultError, Options<ProgrammeEmailTemplateControllerPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeEmailTemplateControllerPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send this template to the caller's own address to verify live delivery
 */
export const programmeEmailTemplateControllerTestSendMutation = (options?: Partial<Options<ProgrammeEmailTemplateControllerTestSendData>>): UseMutationOptions<ProgrammeEmailTemplateControllerTestSendResponse, DefaultError, Options<ProgrammeEmailTemplateControllerTestSendData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeEmailTemplateControllerTestSendResponse, DefaultError, Options<ProgrammeEmailTemplateControllerTestSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeEmailTemplateControllerTestSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset a Programme template back to the Dealstack default
 */
export const programmeEmailTemplateControllerResetMutation = (options?: Partial<Options<ProgrammeEmailTemplateControllerResetData>>): UseMutationOptions<ProgrammeEmailTemplateControllerResetResponse, DefaultError, Options<ProgrammeEmailTemplateControllerResetData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeEmailTemplateControllerResetResponse, DefaultError, Options<ProgrammeEmailTemplateControllerResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeEmailTemplateControllerReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tagControllerListQueryKey = (options?: Options<TagControllerListData>) => createQueryKey('tagControllerList', options);

/**
 * List classifier tags for the current MIP
 */
export const tagControllerListOptions = (options?: Options<TagControllerListData>) => queryOptions<TagControllerListResponse, DefaultError, TagControllerListResponse, ReturnType<typeof tagControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tagControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tagControllerListQueryKey(options)
});

/**
 * Create a classifier tag scoped to the current MIP
 */
export const tagControllerCreateMutation = (options?: Partial<Options<TagControllerCreateData>>): UseMutationOptions<TagControllerCreateResponse, DefaultError, Options<TagControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<TagControllerCreateResponse, DefaultError, Options<TagControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tagControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a MIP-scoped classifier tag and remove it from all its cohorts
 */
export const tagControllerRemoveMutation = (options?: Partial<Options<TagControllerRemoveData>>): UseMutationOptions<TagControllerRemoveResponse, DefaultError, Options<TagControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<TagControllerRemoveResponse, DefaultError, Options<TagControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tagControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename and/or archive a MIP-scoped classifier tag
 */
export const tagControllerUpdateMutation = (options?: Partial<Options<TagControllerUpdateData>>): UseMutationOptions<TagControllerUpdateResponse, DefaultError, Options<TagControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<TagControllerUpdateResponse, DefaultError, Options<TagControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tagControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach cohorts to a classifier tag. Idempotent — existing active links are skipped.
 */
export const tagControllerAttachClassifiersMutation = (options?: Partial<Options<TagControllerAttachClassifiersData>>): UseMutationOptions<TagControllerAttachClassifiersResponse, DefaultError, Options<TagControllerAttachClassifiersData>> => {
    const mutationOptions: UseMutationOptions<TagControllerAttachClassifiersResponse, DefaultError, Options<TagControllerAttachClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tagControllerAttachClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Detach cohorts from a classifier tag. Cohorts without an active link are skipped.
 */
export const tagControllerDetachClassifiersMutation = (options?: Partial<Options<TagControllerDetachClassifiersData>>): UseMutationOptions<TagControllerDetachClassifiersResponse, DefaultError, Options<TagControllerDetachClassifiersData>> => {
    const mutationOptions: UseMutationOptions<TagControllerDetachClassifiersResponse, DefaultError, Options<TagControllerDetachClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tagControllerDetachClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const translationsControllerTranslationsQueryKey = (options: Options<TranslationsControllerTranslationsData>) => createQueryKey('translationsControllerTranslations', options);

/**
 * Download translation for given language and given namespace
 */
export const translationsControllerTranslationsOptions = (options: Options<TranslationsControllerTranslationsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof translationsControllerTranslationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await translationsControllerTranslations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: translationsControllerTranslationsQueryKey(options)
});

/**
 * Get the tasks list
 */
export const taskControllerGetMutation = (options?: Partial<Options<TaskControllerGetData>>): UseMutationOptions<TaskControllerGetResponse, DefaultError, Options<TaskControllerGetData>> => {
    const mutationOptions: UseMutationOptions<TaskControllerGetResponse, DefaultError, Options<TaskControllerGetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await taskControllerGet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const configProviderControllerGetConfigQueryKey = (options?: Options<ConfigProviderControllerGetConfigData>) => createQueryKey('configProviderControllerGetConfig', options);

export const configProviderControllerGetConfigOptions = (options?: Options<ConfigProviderControllerGetConfigData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof configProviderControllerGetConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await configProviderControllerGetConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: configProviderControllerGetConfigQueryKey(options)
});

/**
 * Get transaction data
 */
export const transactionControllerGetTransactionsMutation = (options?: Partial<Options<TransactionControllerGetTransactionsData>>): UseMutationOptions<TransactionControllerGetTransactionsResponse, DefaultError, Options<TransactionControllerGetTransactionsData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerGetTransactionsResponse, DefaultError, Options<TransactionControllerGetTransactionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerGetTransactions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get transaction details
 */
export const transactionControllerGetTransactionDetailsMutation = (options?: Partial<Options<TransactionControllerGetTransactionDetailsData>>): UseMutationOptions<TransactionControllerGetTransactionDetailsResponse, DefaultError, Options<TransactionControllerGetTransactionDetailsData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerGetTransactionDetailsResponse, DefaultError, Options<TransactionControllerGetTransactionDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerGetTransactionDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download excel file with transactions
 */
export const transactionControllerDownloadExcelMutation = (options?: Partial<Options<TransactionControllerDownloadExcelData>>): UseMutationOptions<TransactionControllerDownloadExcelResponse, DefaultError, Options<TransactionControllerDownloadExcelData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerDownloadExcelResponse, DefaultError, Options<TransactionControllerDownloadExcelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerDownloadExcel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create transaction
 */
export const transactionControllerCreateTransactionMutation = (options?: Partial<Options<TransactionControllerCreateTransactionData>>): UseMutationOptions<TransactionControllerCreateTransactionResponse, DefaultError, Options<TransactionControllerCreateTransactionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerCreateTransactionResponse, DefaultError, Options<TransactionControllerCreateTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerCreateTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview the linked counterpart leg a single-title transfer would write
 */
export const transactionControllerPreviewTransferCounterpartMutation = (options?: Partial<Options<TransactionControllerPreviewTransferCounterpartData>>): UseMutationOptions<TransactionControllerPreviewTransferCounterpartResponse, DefaultError, Options<TransactionControllerPreviewTransferCounterpartData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerPreviewTransferCounterpartResponse, DefaultError, Options<TransactionControllerPreviewTransferCounterpartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerPreviewTransferCounterpart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a nominee paired issue (mint BOTH title to the nominee, then transfer the beneficial rail to the buyer) atomically
 */
export const transactionControllerCreatePairedIssueMutation = (options?: Partial<Options<TransactionControllerCreatePairedIssueData>>): UseMutationOptions<TransactionControllerCreatePairedIssueResponse, DefaultError, Options<TransactionControllerCreatePairedIssueData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerCreatePairedIssueResponse, DefaultError, Options<TransactionControllerCreatePairedIssueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerCreatePairedIssue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview the counterpart legs a nominee inseparable redemption would write
 */
export const transactionControllerPreviewInseparableRedemptionMutation = (options?: Partial<Options<TransactionControllerPreviewInseparableRedemptionData>>): UseMutationOptions<TransactionControllerPreviewInseparableRedemptionResponse, DefaultError, Options<TransactionControllerPreviewInseparableRedemptionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerPreviewInseparableRedemptionResponse, DefaultError, Options<TransactionControllerPreviewInseparableRedemptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerPreviewInseparableRedemption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restate an inseparable redemption from new intent, reconciling its legs
 */
export const transactionControllerUpdateInseparableRedemptionMutation = (options?: Partial<Options<TransactionControllerUpdateInseparableRedemptionData>>): UseMutationOptions<TransactionControllerUpdateInseparableRedemptionResponse, DefaultError, Options<TransactionControllerUpdateInseparableRedemptionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerUpdateInseparableRedemptionResponse, DefaultError, Options<TransactionControllerUpdateInseparableRedemptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerUpdateInseparableRedemption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redeem one interest and retire the paired counterpart title over the same serials, atomically
 */
export const transactionControllerCreateInseparableRedemptionMutation = (options?: Partial<Options<TransactionControllerCreateInseparableRedemptionData>>): UseMutationOptions<TransactionControllerCreateInseparableRedemptionResponse, DefaultError, Options<TransactionControllerCreateInseparableRedemptionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerCreateInseparableRedemptionResponse, DefaultError, Options<TransactionControllerCreateInseparableRedemptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerCreateInseparableRedemption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transactionControllerGetInseparableRedemptionGroupQueryKey = (options: Options<TransactionControllerGetInseparableRedemptionGroupData>) => createQueryKey('transactionControllerGetInseparableRedemptionGroup', options);

/**
 * Read an inseparable redemption back as the operation entered
 */
export const transactionControllerGetInseparableRedemptionGroupOptions = (options: Options<TransactionControllerGetInseparableRedemptionGroupData>) => queryOptions<TransactionControllerGetInseparableRedemptionGroupResponse, DefaultError, TransactionControllerGetInseparableRedemptionGroupResponse, ReturnType<typeof transactionControllerGetInseparableRedemptionGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await transactionControllerGetInseparableRedemptionGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: transactionControllerGetInseparableRedemptionGroupQueryKey(options)
});

/**
 * Split transaction
 */
export const transactionControllerSplitTransactionMutation = (options?: Partial<Options<TransactionControllerSplitTransactionData>>): UseMutationOptions<TransactionControllerSplitTransactionResponse, DefaultError, Options<TransactionControllerSplitTransactionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerSplitTransactionResponse, DefaultError, Options<TransactionControllerSplitTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerSplitTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Split a transaction into beneficial and legal interest legs
 */
export const transactionControllerSplitTransactionInterestMutation = (options?: Partial<Options<TransactionControllerSplitTransactionInterestData>>): UseMutationOptions<TransactionControllerSplitTransactionInterestResponse, DefaultError, Options<TransactionControllerSplitTransactionInterestData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerSplitTransactionInterestResponse, DefaultError, Options<TransactionControllerSplitTransactionInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerSplitTransactionInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get pair transactions
 */
export const transactionControllerGetPairTransactionMutation = (options?: Partial<Options<TransactionControllerGetPairTransactionData>>): UseMutationOptions<TransactionControllerGetPairTransactionResponse, DefaultError, Options<TransactionControllerGetPairTransactionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerGetPairTransactionResponse, DefaultError, Options<TransactionControllerGetPairTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerGetPairTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pair transaction
 */
export const transactionControllerPairTransactionMutation = (options?: Partial<Options<TransactionControllerPairTransactionData>>): UseMutationOptions<TransactionControllerPairTransactionResponse, DefaultError, Options<TransactionControllerPairTransactionData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerPairTransactionResponse, DefaultError, Options<TransactionControllerPairTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerPairTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update transaction
 */
export const transactionControllerUpdateMutation = (options?: Partial<Options<TransactionControllerUpdateData>>): UseMutationOptions<TransactionControllerUpdateResponse, DefaultError, Options<TransactionControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerUpdateResponse, DefaultError, Options<TransactionControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore transaction
 */
export const transactionControllerRestoreMutation = (options?: Partial<Options<TransactionControllerRestoreData>>): UseMutationOptions<TransactionControllerRestoreResponse, DefaultError, Options<TransactionControllerRestoreData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerRestoreResponse, DefaultError, Options<TransactionControllerRestoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerRestore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Swap transaction order
 */
export const transactionControllerUpdateOrderMutation = (options?: Partial<Options<TransactionControllerUpdateOrderData>>): UseMutationOptions<TransactionControllerUpdateOrderResponse, DefaultError, Options<TransactionControllerUpdateOrderData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerUpdateOrderResponse, DefaultError, Options<TransactionControllerUpdateOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerUpdateOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auto reorder a group of transactions
 */
export const transactionControllerAutoReorderMutation = (options?: Partial<Options<TransactionControllerAutoReorderData>>): UseMutationOptions<TransactionControllerAutoReorderResponse, DefaultError, Options<TransactionControllerAutoReorderData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerAutoReorderResponse, DefaultError, Options<TransactionControllerAutoReorderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerAutoReorder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Upload transaction
 */
export const transactionControllerBulkUploadMutation = (options?: Partial<Options<TransactionControllerBulkUploadData>>): UseMutationOptions<unknown, DefaultError, Options<TransactionControllerBulkUploadData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TransactionControllerBulkUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerBulkUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk upload management loans transactions
 */
export const transactionControllerBulkUploadManagementLoansMutation = (options?: Partial<Options<TransactionControllerBulkUploadManagementLoansData>>): UseMutationOptions<unknown, DefaultError, Options<TransactionControllerBulkUploadManagementLoansData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TransactionControllerBulkUploadManagementLoansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerBulkUploadManagementLoans({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transactionControllerGetBulkUploadTaskStatusQueryKey = (options: Options<TransactionControllerGetBulkUploadTaskStatusData>) => createQueryKey('transactionControllerGetBulkUploadTaskStatus', options);

/**
 * Release InvestmentWorkflow status
 */
export const transactionControllerGetBulkUploadTaskStatusOptions = (options: Options<TransactionControllerGetBulkUploadTaskStatusData>) => queryOptions<TransactionControllerGetBulkUploadTaskStatusResponse, DefaultError, TransactionControllerGetBulkUploadTaskStatusResponse, ReturnType<typeof transactionControllerGetBulkUploadTaskStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await transactionControllerGetBulkUploadTaskStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: transactionControllerGetBulkUploadTaskStatusQueryKey(options)
});

/**
 * Bulk Update transaction
 */
export const transactionControllerBulkUpdateMutation = (options?: Partial<Options<TransactionControllerBulkUpdateData>>): UseMutationOptions<TransactionControllerBulkUpdateResponse, DefaultError, Options<TransactionControllerBulkUpdateData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerBulkUpdateResponse, DefaultError, Options<TransactionControllerBulkUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerBulkUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk restore transaction
 */
export const transactionControllerBulkRestoreMutation = (options?: Partial<Options<TransactionControllerBulkRestoreData>>): UseMutationOptions<TransactionControllerBulkRestoreResponse, DefaultError, Options<TransactionControllerBulkRestoreData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerBulkRestoreResponse, DefaultError, Options<TransactionControllerBulkRestoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerBulkRestore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete transaction
 */
export const transactionControllerDeleteTransactionMutation = (options?: Partial<Options<TransactionControllerDeleteTransactionData>>): UseMutationOptions<unknown, DefaultError, Options<TransactionControllerDeleteTransactionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TransactionControllerDeleteTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerDeleteTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Delete transaction
 */
export const transactionControllerBulkDeleteTransactionsMutation = (options?: Partial<Options<TransactionControllerBulkDeleteTransactionsData>>): UseMutationOptions<TransactionControllerBulkDeleteTransactionsResponse, DefaultError, Options<TransactionControllerBulkDeleteTransactionsData>> => {
    const mutationOptions: UseMutationOptions<TransactionControllerBulkDeleteTransactionsResponse, DefaultError, Options<TransactionControllerBulkDeleteTransactionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transactionControllerBulkDeleteTransactions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * This will create and return upload pre signed urls
 */
export const documentControllerCreateUploadPreSignedUrlsMutation = (options?: Partial<Options<DocumentControllerCreateUploadPreSignedUrlsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerCreateUploadPreSignedUrlsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerCreateUploadPreSignedUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerCreateUploadPreSignedUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * create documents
 */
export const documentControllerCreateDocumentsMutation = (options?: Partial<Options<DocumentControllerCreateDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerCreateDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerCreateDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerCreateDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removing a document from a person, by removing the documentLink to that person
 */
export const documentControllerRemoveDocumentPersonLinkMutation = (options?: Partial<Options<DocumentControllerRemoveDocumentPersonLinkData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentPersonLinkData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentPersonLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerRemoveDocumentPersonLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removing a document from a transaction, by removing the documentLink to that transaction
 */
export const documentControllerRemoveDocumentTransactionLinkMutation = (options?: Partial<Options<DocumentControllerRemoveDocumentTransactionLinkData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentTransactionLinkData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentTransactionLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerRemoveDocumentTransactionLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removing a document by soft deleting it
 */
export const documentControllerRemoveDocumentMutation = (options?: Partial<Options<DocumentControllerRemoveDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerRemoveDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerRemoveDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentControllerGetDocumentQueryKey = (options: Options<DocumentControllerGetDocumentData>) => createQueryKey('documentControllerGetDocument', options);

/**
 * Get document with some related records
 */
export const documentControllerGetDocumentOptions = (options: Options<DocumentControllerGetDocumentData>) => queryOptions<DocumentControllerGetDocumentResponse, DefaultError, DocumentControllerGetDocumentResponse, ReturnType<typeof documentControllerGetDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentControllerGetDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentControllerGetDocumentQueryKey(options)
});

/**
 * update document and related fields, like classifiers, open for extension
 */
export const documentControllerUpdateMutation = (options?: Partial<Options<DocumentControllerUpdateData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentControllerGetDocumentsQueryKey = (options: Options<DocumentControllerGetDocumentsData>) => createQueryKey('documentControllerGetDocuments', options);

/**
 * Get documents for a specific deal
 */
export const documentControllerGetDocumentsOptions = (options: Options<DocumentControllerGetDocumentsData>) => queryOptions<DocumentControllerGetDocumentsResponse, DefaultError, DocumentControllerGetDocumentsResponse, ReturnType<typeof documentControllerGetDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentControllerGetDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentControllerGetDocumentsQueryKey(options)
});

/**
 * Find related files based on a transaction and md5s
 */
export const documentControllerFindRelatedFilesInDealMutation = (options?: Partial<Options<DocumentControllerFindRelatedFilesInDealData>>): UseMutationOptions<DocumentControllerFindRelatedFilesInDealResponse, DefaultError, Options<DocumentControllerFindRelatedFilesInDealData>> => {
    const mutationOptions: UseMutationOptions<DocumentControllerFindRelatedFilesInDealResponse, DefaultError, Options<DocumentControllerFindRelatedFilesInDealData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerFindRelatedFilesInDeal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentControllerFindRelatedDocumentsQueryKey = (options: Options<DocumentControllerFindRelatedDocumentsData>) => createQueryKey('documentControllerFindRelatedDocuments', options);

/**
 * Find related documents
 */
export const documentControllerFindRelatedDocumentsOptions = (options: Options<DocumentControllerFindRelatedDocumentsData>) => queryOptions<DocumentControllerFindRelatedDocumentsResponse, DefaultError, DocumentControllerFindRelatedDocumentsResponse, ReturnType<typeof documentControllerFindRelatedDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentControllerFindRelatedDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentControllerFindRelatedDocumentsQueryKey(options)
});

/**
 * Create or update document links
 */
export const documentControllerUpdateRelatedDocumentsMutation = (options?: Partial<Options<DocumentControllerUpdateRelatedDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentControllerUpdateRelatedDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentControllerUpdateRelatedDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentControllerUpdateRelatedDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentLibraryControllerGetDocumentsWithFilteringQueryKey = (options: Options<DocumentLibraryControllerGetDocumentsWithFilteringData>) => createQueryKey('documentLibraryControllerGetDocumentsWithFiltering', options);

/**
 * Get all documents related to a deal with filtering
 */
export const documentLibraryControllerGetDocumentsWithFilteringOptions = (options: Options<DocumentLibraryControllerGetDocumentsWithFilteringData>) => queryOptions<DocumentLibraryControllerGetDocumentsWithFilteringResponse, DefaultError, DocumentLibraryControllerGetDocumentsWithFilteringResponse, ReturnType<typeof documentLibraryControllerGetDocumentsWithFilteringQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentLibraryControllerGetDocumentsWithFiltering({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentLibraryControllerGetDocumentsWithFilteringQueryKey(options)
});

/**
 * Bulk add/remove document classifiers
 */
export const documentLibraryControllerBulkClassifyDocumentsMutation = (options?: Partial<Options<DocumentLibraryControllerBulkClassifyDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerBulkClassifyDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerBulkClassifyDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerBulkClassifyDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentLibraryControllerGetDocumentDetailsQueryKey = (options: Options<DocumentLibraryControllerGetDocumentDetailsData>) => createQueryKey('documentLibraryControllerGetDocumentDetails', options);

/**
 * Get document and related document details
 */
export const documentLibraryControllerGetDocumentDetailsOptions = (options: Options<DocumentLibraryControllerGetDocumentDetailsData>) => queryOptions<DocumentLibraryControllerGetDocumentDetailsResponse, DefaultError, DocumentLibraryControllerGetDocumentDetailsResponse, ReturnType<typeof documentLibraryControllerGetDocumentDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentLibraryControllerGetDocumentDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentLibraryControllerGetDocumentDetailsQueryKey(options)
});

/**
 * update document and related fields, like classifiers, person/transaction assignment
 */
export const documentLibraryControllerUpdateDocumentMutation = (options?: Partial<Options<DocumentLibraryControllerUpdateDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerUpdateDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerUpdateDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerUpdateDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentLibraryControllerGetDealClassifiersByGroupsQueryKey = (options: Options<DocumentLibraryControllerGetDealClassifiersByGroupsData>) => createQueryKey('documentLibraryControllerGetDealClassifiersByGroups', options);

/**
 * Get all deal classifiers by their groupings
 */
export const documentLibraryControllerGetDealClassifiersByGroupsOptions = (options: Options<DocumentLibraryControllerGetDealClassifiersByGroupsData>) => queryOptions<DocumentLibraryControllerGetDealClassifiersByGroupsResponse, DefaultError, DocumentLibraryControllerGetDealClassifiersByGroupsResponse, ReturnType<typeof documentLibraryControllerGetDealClassifiersByGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentLibraryControllerGetDealClassifiersByGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentLibraryControllerGetDealClassifiersByGroupsQueryKey(options)
});

/**
 * download more than one document
 */
export const documentLibraryControllerBulkDownloadDocumentFilesMutation = (options?: Partial<Options<DocumentLibraryControllerBulkDownloadDocumentFilesData>>): UseMutationOptions<DocumentLibraryControllerBulkDownloadDocumentFilesResponse, DefaultError, Options<DocumentLibraryControllerBulkDownloadDocumentFilesData>> => {
    const mutationOptions: UseMutationOptions<DocumentLibraryControllerBulkDownloadDocumentFilesResponse, DefaultError, Options<DocumentLibraryControllerBulkDownloadDocumentFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerBulkDownloadDocumentFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk soft-delete library-uploaded documents. Workflow-generated documents are skipped server-side as defense in depth.
 */
export const documentLibraryControllerBulkDeleteDocumentsMutation = (options?: Partial<Options<DocumentLibraryControllerBulkDeleteDocumentsData>>): UseMutationOptions<DocumentLibraryControllerBulkDeleteDocumentsResponse, DefaultError, Options<DocumentLibraryControllerBulkDeleteDocumentsData>> => {
    const mutationOptions: UseMutationOptions<DocumentLibraryControllerBulkDeleteDocumentsResponse, DefaultError, Options<DocumentLibraryControllerBulkDeleteDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerBulkDeleteDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentLibraryControllerGetPersonsInDealQueryKey = (options: Options<DocumentLibraryControllerGetPersonsInDealData>) => createQueryKey('documentLibraryControllerGetPersonsInDeal', options);

/**
 * Get all persons within a deal (natural or legal)
 */
export const documentLibraryControllerGetPersonsInDealOptions = (options: Options<DocumentLibraryControllerGetPersonsInDealData>) => queryOptions<DocumentLibraryControllerGetPersonsInDealResponse, DefaultError, DocumentLibraryControllerGetPersonsInDealResponse, ReturnType<typeof documentLibraryControllerGetPersonsInDealQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentLibraryControllerGetPersonsInDeal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentLibraryControllerGetPersonsInDealQueryKey(options)
});

/**
 * Remove persons from a document
 */
export const documentLibraryControllerRemovePersonsFromDocumentMutation = (options?: Partial<Options<DocumentLibraryControllerRemovePersonsFromDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerRemovePersonsFromDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerRemovePersonsFromDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerRemovePersonsFromDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add persons to a document
 */
export const documentLibraryControllerAddPersonsToDocumentMutation = (options?: Partial<Options<DocumentLibraryControllerAddPersonsToDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerAddPersonsToDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerAddPersonsToDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerAddPersonsToDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Show or hide a document in the investor portal for specific linked persons
 *
 * Flips investor-portal visibility per person link without removing the link itself. Requires deal admin; Dealstack Support passes via the guard-level support bypass.
 */
export const documentLibraryControllerSetPersonDocumentVisibilityMutation = (options?: Partial<Options<DocumentLibraryControllerSetPersonDocumentVisibilityData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerSetPersonDocumentVisibilityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerSetPersonDocumentVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerSetPersonDocumentVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add multiple persons to multiple documents
 */
export const documentLibraryControllerAddPersonsToDocumentsMutation = (options?: Partial<Options<DocumentLibraryControllerAddPersonsToDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerAddPersonsToDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerAddPersonsToDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerAddPersonsToDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove multiple persons from multiple documents
 */
export const documentLibraryControllerRemovePersonsFromDocumentsMutation = (options?: Partial<Options<DocumentLibraryControllerRemovePersonsFromDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerRemovePersonsFromDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentLibraryControllerRemovePersonsFromDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentLibraryControllerRemovePersonsFromDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload a document for extraction, bound to the deal
 */
export const documentParsingControllerUploadExtractionDocumentMutation = (options?: Partial<Options<DocumentParsingControllerUploadExtractionDocumentData>>): UseMutationOptions<DocumentParsingControllerUploadExtractionDocumentResponse, DefaultError, Options<DocumentParsingControllerUploadExtractionDocumentData>> => {
    const mutationOptions: UseMutationOptions<DocumentParsingControllerUploadExtractionDocumentResponse, DefaultError, Options<DocumentParsingControllerUploadExtractionDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerUploadExtractionDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start document extraction for one or more documents
 */
export const documentParsingControllerStartExtractionMutation = (options?: Partial<Options<DocumentParsingControllerStartExtractionData>>): UseMutationOptions<DocumentParsingControllerStartExtractionResponse, DefaultError, Options<DocumentParsingControllerStartExtractionData>> => {
    const mutationOptions: UseMutationOptions<DocumentParsingControllerStartExtractionResponse, DefaultError, Options<DocumentParsingControllerStartExtractionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerStartExtraction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentParsingControllerGetExtractionStatusQueryKey = (options: Options<DocumentParsingControllerGetExtractionStatusData>) => createQueryKey('documentParsingControllerGetExtractionStatus', options);

/**
 * Get the status of a document extraction task
 */
export const documentParsingControllerGetExtractionStatusOptions = (options: Options<DocumentParsingControllerGetExtractionStatusData>) => queryOptions<DocumentParsingControllerGetExtractionStatusResponse, DefaultError, DocumentParsingControllerGetExtractionStatusResponse, ReturnType<typeof documentParsingControllerGetExtractionStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetExtractionStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetExtractionStatusQueryKey(options)
});

export const documentParsingControllerGetExtractionResultQueryKey = (options: Options<DocumentParsingControllerGetExtractionResultData>) => createQueryKey('documentParsingControllerGetExtractionResult', options);

/**
 * Get the results of a completed document extraction task
 */
export const documentParsingControllerGetExtractionResultOptions = (options: Options<DocumentParsingControllerGetExtractionResultData>) => queryOptions<DocumentParsingControllerGetExtractionResultResponse, DefaultError, DocumentParsingControllerGetExtractionResultResponse, ReturnType<typeof documentParsingControllerGetExtractionResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetExtractionResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetExtractionResultQueryKey(options)
});

export const documentParsingControllerListBatchesQueryKey = (options: Options<DocumentParsingControllerListBatchesData>) => createQueryKey('documentParsingControllerListBatches', options);

/**
 * List document extraction batches for a deal and person
 */
export const documentParsingControllerListBatchesOptions = (options: Options<DocumentParsingControllerListBatchesData>) => queryOptions<DocumentParsingControllerListBatchesResponse, DefaultError, DocumentParsingControllerListBatchesResponse, ReturnType<typeof documentParsingControllerListBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerListBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerListBatchesQueryKey(options)
});

export const documentParsingControllerListDealBatchesQueryKey = (options?: Options<DocumentParsingControllerListDealBatchesData>) => createQueryKey('documentParsingControllerListDealBatches', options);

/**
 * List all document extraction batches for a deal
 */
export const documentParsingControllerListDealBatchesOptions = (options?: Options<DocumentParsingControllerListDealBatchesData>) => queryOptions<DocumentParsingControllerListDealBatchesResponse, DefaultError, DocumentParsingControllerListDealBatchesResponse, ReturnType<typeof documentParsingControllerListDealBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerListDealBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerListDealBatchesQueryKey(options)
});

/**
 * Update the title of a document extraction batch
 */
export const documentParsingControllerUpdateBatchTitleMutation = (options?: Partial<Options<DocumentParsingControllerUpdateBatchTitleData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerUpdateBatchTitleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerUpdateBatchTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerUpdateBatchTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentParsingControllerGetDocumentTransactionsQueryKey = (options: Options<DocumentParsingControllerGetDocumentTransactionsData>) => createQueryKey('documentParsingControllerGetDocumentTransactions', options);

/**
 * Get extracted transactions for a document from the external extraction service
 */
export const documentParsingControllerGetDocumentTransactionsOptions = (options: Options<DocumentParsingControllerGetDocumentTransactionsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof documentParsingControllerGetDocumentTransactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetDocumentTransactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetDocumentTransactionsQueryKey(options)
});

export const documentParsingControllerGetBatchTransactionsQueryKey = (options: Options<DocumentParsingControllerGetBatchTransactionsData>) => createQueryKey('documentParsingControllerGetBatchTransactions', options);

/**
 * Get all transactions for a completed batch
 */
export const documentParsingControllerGetBatchTransactionsOptions = (options: Options<DocumentParsingControllerGetBatchTransactionsData>) => queryOptions<DocumentParsingControllerGetBatchTransactionsResponse, DefaultError, DocumentParsingControllerGetBatchTransactionsResponse, ReturnType<typeof documentParsingControllerGetBatchTransactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetBatchTransactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetBatchTransactionsQueryKey(options)
});

export const documentParsingControllerGetBatchOverviewQueryKey = (options: Options<DocumentParsingControllerGetBatchOverviewData>) => createQueryKey('documentParsingControllerGetBatchOverview', options);

/**
 * Get aggregated overview stats for a batch analysis
 */
export const documentParsingControllerGetBatchOverviewOptions = (options: Options<DocumentParsingControllerGetBatchOverviewData>) => queryOptions<DocumentParsingControllerGetBatchOverviewResponse, DefaultError, DocumentParsingControllerGetBatchOverviewResponse, ReturnType<typeof documentParsingControllerGetBatchOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetBatchOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetBatchOverviewQueryKey(options)
});

export const documentParsingControllerGetBatchDocumentsQueryKey = (options: Options<DocumentParsingControllerGetBatchDocumentsData>) => createQueryKey('documentParsingControllerGetBatchDocuments', options);

/**
 * Get paginated list of documents in a batch with enriched data
 */
export const documentParsingControllerGetBatchDocumentsOptions = (options: Options<DocumentParsingControllerGetBatchDocumentsData>) => queryOptions<DocumentParsingControllerGetBatchDocumentsResponse, DefaultError, DocumentParsingControllerGetBatchDocumentsResponse, ReturnType<typeof documentParsingControllerGetBatchDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetBatchDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetBatchDocumentsQueryKey(options)
});

/**
 * Persist per-extracted-transaction user overrides (e.g. the date the user typed in the missing-fields modal). The endpoint name is historical — the actual merge into the cap table still goes through /cap/transaction/bulk-upload.
 */
export const documentParsingControllerSaveBatchExtractionOverridesMutation = (options?: Partial<Options<DocumentParsingControllerSaveBatchExtractionOverridesData>>): UseMutationOptions<DocumentParsingControllerSaveBatchExtractionOverridesResponse, DefaultError, Options<DocumentParsingControllerSaveBatchExtractionOverridesData>> => {
    const mutationOptions: UseMutationOptions<DocumentParsingControllerSaveBatchExtractionOverridesResponse, DefaultError, Options<DocumentParsingControllerSaveBatchExtractionOverridesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerSaveBatchExtractionOverrides({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentParsingControllerGetBatchSecuritiesQueryKey = (options: Options<DocumentParsingControllerGetBatchSecuritiesData>) => createQueryKey('documentParsingControllerGetBatchSecurities', options);

/**
 * Get securities found in batch with match statuses
 */
export const documentParsingControllerGetBatchSecuritiesOptions = (options: Options<DocumentParsingControllerGetBatchSecuritiesData>) => queryOptions<DocumentParsingControllerGetBatchSecuritiesResponse, DefaultError, DocumentParsingControllerGetBatchSecuritiesResponse, ReturnType<typeof documentParsingControllerGetBatchSecuritiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetBatchSecurities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetBatchSecuritiesQueryKey(options)
});

export const documentParsingControllerGetBatchPeopleQueryKey = (options: Options<DocumentParsingControllerGetBatchPeopleData>) => createQueryKey('documentParsingControllerGetBatchPeople', options);

/**
 * Get people found in batch with match statuses
 */
export const documentParsingControllerGetBatchPeopleOptions = (options: Options<DocumentParsingControllerGetBatchPeopleData>) => queryOptions<DocumentParsingControllerGetBatchPeopleResponse, DefaultError, DocumentParsingControllerGetBatchPeopleResponse, ReturnType<typeof documentParsingControllerGetBatchPeopleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentParsingControllerGetBatchPeople({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentParsingControllerGetBatchPeopleQueryKey(options)
});

/**
 * Link an extracted person to an existing deal Person
 */
export const documentParsingControllerMatchBatchPersonMutation = (options?: Partial<Options<DocumentParsingControllerMatchBatchPersonData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerMatchBatchPersonData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerMatchBatchPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerMatchBatchPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link an extracted security to an existing deal Security
 */
export const documentParsingControllerMatchBatchSecurityMutation = (options?: Partial<Options<DocumentParsingControllerMatchBatchSecurityData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerMatchBatchSecurityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerMatchBatchSecurityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerMatchBatchSecurity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-run extraction pipeline for a batch using a user-supplied system prompt.
 */
export const documentParsingControllerReextractBatchMutation = (options?: Partial<Options<DocumentParsingControllerReextractBatchData>>): UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerReextractBatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DocumentParsingControllerReextractBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentParsingControllerReextractBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const classifierControllerGetAllClassifiersQueryKey = (options?: Options<ClassifierControllerGetAllClassifiersData>) => createQueryKey('classifierControllerGetAllClassifiers', options);

/**
 * Get all classifiers
 */
export const classifierControllerGetAllClassifiersOptions = (options?: Options<ClassifierControllerGetAllClassifiersData>) => queryOptions<ClassifierControllerGetAllClassifiersResponse, DefaultError, ClassifierControllerGetAllClassifiersResponse, ReturnType<typeof classifierControllerGetAllClassifiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await classifierControllerGetAllClassifiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: classifierControllerGetAllClassifiersQueryKey(options)
});

export const classifierControllerGetDealClassifiersQueryKey = (options: Options<ClassifierControllerGetDealClassifiersData>) => createQueryKey('classifierControllerGetDealClassifiers', options);

/**
 * Get all deal classifiers
 */
export const classifierControllerGetDealClassifiersOptions = (options: Options<ClassifierControllerGetDealClassifiersData>) => queryOptions<ClassifierControllerGetDealClassifiersResponse, DefaultError, ClassifierControllerGetDealClassifiersResponse, ReturnType<typeof classifierControllerGetDealClassifiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await classifierControllerGetDealClassifiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: classifierControllerGetDealClassifiersQueryKey(options)
});

/**
 * create a deal classifiers
 */
export const classifierControllerPostDealClassifiersMutation = (options?: Partial<Options<ClassifierControllerPostDealClassifiersData>>): UseMutationOptions<ClassifierControllerPostDealClassifiersResponse, DefaultError, Options<ClassifierControllerPostDealClassifiersData>> => {
    const mutationOptions: UseMutationOptions<ClassifierControllerPostDealClassifiersResponse, DefaultError, Options<ClassifierControllerPostDealClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await classifierControllerPostDealClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dealEventLogControllerGetDealEventsQueryKey = (options?: Options<DealEventLogControllerGetDealEventsData>) => createQueryKey('dealEventLogControllerGetDealEvents', options);

/**
 * Get the consolidated event feed for a deal
 */
export const dealEventLogControllerGetDealEventsOptions = (options?: Options<DealEventLogControllerGetDealEventsData>) => queryOptions<DealEventLogControllerGetDealEventsResponse, DefaultError, DealEventLogControllerGetDealEventsResponse, ReturnType<typeof dealEventLogControllerGetDealEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventsQueryKey(options)
});

export const dealEventLogControllerGetDealEventsInfiniteQueryKey = (options?: Options<DealEventLogControllerGetDealEventsData>): QueryKey<Options<DealEventLogControllerGetDealEventsData>> => createQueryKey('dealEventLogControllerGetDealEvents', options, true);

/**
 * Get the consolidated event feed for a deal
 */
export const dealEventLogControllerGetDealEventsInfiniteOptions = (options?: Options<DealEventLogControllerGetDealEventsData>) => infiniteQueryOptions<DealEventLogControllerGetDealEventsResponse, DefaultError, InfiniteData<DealEventLogControllerGetDealEventsResponse>, QueryKey<Options<DealEventLogControllerGetDealEventsData>>, string | Pick<QueryKey<Options<DealEventLogControllerGetDealEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<DealEventLogControllerGetDealEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await dealEventLogControllerGetDealEvents({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventsInfiniteQueryKey(options)
});

export const dealEventLogControllerGetDealEventDailyCountsQueryKey = (options?: Options<DealEventLogControllerGetDealEventDailyCountsData>) => createQueryKey('dealEventLogControllerGetDealEventDailyCounts', options);

/**
 * Count the events of a deal per day, under the same filters as the feed
 */
export const dealEventLogControllerGetDealEventDailyCountsOptions = (options?: Options<DealEventLogControllerGetDealEventDailyCountsData>) => queryOptions<DealEventLogControllerGetDealEventDailyCountsResponse, DefaultError, DealEventLogControllerGetDealEventDailyCountsResponse, ReturnType<typeof dealEventLogControllerGetDealEventDailyCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEventDailyCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventDailyCountsQueryKey(options)
});

export const dealEventLogControllerExportDealEventsQueryKey = (options?: Options<DealEventLogControllerExportDealEventsData>) => createQueryKey('dealEventLogControllerExportDealEvents', options);

/**
 * Export the filtered feed of a deal as CSV, newest first, capped at 10000 rows
 */
export const dealEventLogControllerExportDealEventsOptions = (options?: Options<DealEventLogControllerExportDealEventsData>) => queryOptions<DealEventLogControllerExportDealEventsResponse, DefaultError, DealEventLogControllerExportDealEventsResponse, ReturnType<typeof dealEventLogControllerExportDealEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerExportDealEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerExportDealEventsQueryKey(options)
});

export const dealEventLogControllerGetDealEventRecipientsQueryKey = (options?: Options<DealEventLogControllerGetDealEventRecipientsData>) => createQueryKey('dealEventLogControllerGetDealEventRecipients', options);

/**
 * List the distinct recipients of a deal's emails, for the filter
 */
export const dealEventLogControllerGetDealEventRecipientsOptions = (options?: Options<DealEventLogControllerGetDealEventRecipientsData>) => queryOptions<DealEventLogControllerGetDealEventRecipientsResponse, DefaultError, DealEventLogControllerGetDealEventRecipientsResponse, ReturnType<typeof dealEventLogControllerGetDealEventRecipientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEventRecipients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventRecipientsQueryKey(options)
});

export const dealEventLogControllerGetDealEventMessageQueryKey = (options: Options<DealEventLogControllerGetDealEventMessageData>) => createQueryKey('dealEventLogControllerGetDealEventMessage', options);

/**
 * Read one of the deal's messages, for the feed's drill-down
 */
export const dealEventLogControllerGetDealEventMessageOptions = (options: Options<DealEventLogControllerGetDealEventMessageData>) => queryOptions<DealEventLogControllerGetDealEventMessageResponse, DefaultError, DealEventLogControllerGetDealEventMessageResponse, ReturnType<typeof dealEventLogControllerGetDealEventMessageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEventMessage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventMessageQueryKey(options)
});

export const dealEventLogControllerGetDealEventSendersQueryKey = (options?: Options<DealEventLogControllerGetDealEventSendersData>) => createQueryKey('dealEventLogControllerGetDealEventSenders', options);

/**
 * List the senders of a deal's messages, for the filter
 */
export const dealEventLogControllerGetDealEventSendersOptions = (options?: Options<DealEventLogControllerGetDealEventSendersData>) => queryOptions<DealEventLogControllerGetDealEventSendersResponse, DefaultError, DealEventLogControllerGetDealEventSendersResponse, ReturnType<typeof dealEventLogControllerGetDealEventSendersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEventSenders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventSendersQueryKey(options)
});

export const dealEventLogControllerGetDealEventSubjectsQueryKey = (options?: Options<DealEventLogControllerGetDealEventSubjectsData>) => createQueryKey('dealEventLogControllerGetDealEventSubjects', options);

/**
 * List the users a deal's team and access events are about, for the filter
 */
export const dealEventLogControllerGetDealEventSubjectsOptions = (options?: Options<DealEventLogControllerGetDealEventSubjectsData>) => queryOptions<DealEventLogControllerGetDealEventSubjectsResponse, DefaultError, DealEventLogControllerGetDealEventSubjectsResponse, ReturnType<typeof dealEventLogControllerGetDealEventSubjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetDealEventSubjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetDealEventSubjectsQueryKey(options)
});

export const dealEventLogControllerGetUnreadQueryKey = (options?: Options<DealEventLogControllerGetUnreadData>) => createQueryKey('dealEventLogControllerGetUnread', options);

/**
 * Count deal events since the user last opened the event log
 */
export const dealEventLogControllerGetUnreadOptions = (options?: Options<DealEventLogControllerGetUnreadData>) => queryOptions<DealEventLogControllerGetUnreadResponse, DefaultError, DealEventLogControllerGetUnreadResponse, ReturnType<typeof dealEventLogControllerGetUnreadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dealEventLogControllerGetUnread({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dealEventLogControllerGetUnreadQueryKey(options)
});

/**
 * Mark the deal event log as viewed by the user
 */
export const dealEventLogControllerMarkViewedMutation = (options?: Partial<Options<DealEventLogControllerMarkViewedData>>): UseMutationOptions<DealEventLogControllerMarkViewedResponse, DefaultError, Options<DealEventLogControllerMarkViewedData>> => {
    const mutationOptions: UseMutationOptions<DealEventLogControllerMarkViewedResponse, DefaultError, Options<DealEventLogControllerMarkViewedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dealEventLogControllerMarkViewed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get security events data
 */
export const securityEventControllerGetSecurityEventsMutation = (options?: Partial<Options<SecurityEventControllerGetSecurityEventsData>>): UseMutationOptions<SecurityEventControllerGetSecurityEventsResponse, DefaultError, Options<SecurityEventControllerGetSecurityEventsData>> => {
    const mutationOptions: UseMutationOptions<SecurityEventControllerGetSecurityEventsResponse, DefaultError, Options<SecurityEventControllerGetSecurityEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityEventControllerGetSecurityEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create security event
 */
export const securityEventControllerCreateSecurityEventMutation = (options?: Partial<Options<SecurityEventControllerCreateSecurityEventData>>): UseMutationOptions<SecurityEventControllerCreateSecurityEventResponse, DefaultError, Options<SecurityEventControllerCreateSecurityEventData>> => {
    const mutationOptions: UseMutationOptions<SecurityEventControllerCreateSecurityEventResponse, DefaultError, Options<SecurityEventControllerCreateSecurityEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityEventControllerCreateSecurityEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update security event
 */
export const securityEventControllerUpdateSecurityEventMutation = (options?: Partial<Options<SecurityEventControllerUpdateSecurityEventData>>): UseMutationOptions<SecurityEventControllerUpdateSecurityEventResponse, DefaultError, Options<SecurityEventControllerUpdateSecurityEventData>> => {
    const mutationOptions: UseMutationOptions<SecurityEventControllerUpdateSecurityEventResponse, DefaultError, Options<SecurityEventControllerUpdateSecurityEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityEventControllerUpdateSecurityEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete security event
 */
export const securityEventControllerSoftDeleteSecurityEventMutation = (options?: Partial<Options<SecurityEventControllerSoftDeleteSecurityEventData>>): UseMutationOptions<SecurityEventControllerSoftDeleteSecurityEventResponse, DefaultError, Options<SecurityEventControllerSoftDeleteSecurityEventData>> => {
    const mutationOptions: UseMutationOptions<SecurityEventControllerSoftDeleteSecurityEventResponse, DefaultError, Options<SecurityEventControllerSoftDeleteSecurityEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityEventControllerSoftDeleteSecurityEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const valuationControllerGetValuationsAndJoinWithClassifiersQueryKey = (options: Options<ValuationControllerGetValuationsAndJoinWithClassifiersData>) => createQueryKey('valuationControllerGetValuationsAndJoinWithClassifiers', options);

/**
 * Get all valuations with classifiers
 */
export const valuationControllerGetValuationsAndJoinWithClassifiersOptions = (options: Options<ValuationControllerGetValuationsAndJoinWithClassifiersData>) => queryOptions<ValuationControllerGetValuationsAndJoinWithClassifiersResponse, DefaultError, ValuationControllerGetValuationsAndJoinWithClassifiersResponse, ReturnType<typeof valuationControllerGetValuationsAndJoinWithClassifiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationControllerGetValuationsAndJoinWithClassifiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationControllerGetValuationsAndJoinWithClassifiersQueryKey(options)
});

/**
 * Create valuation
 */
export const valuationControllerCreateValuationMutation = (options?: Partial<Options<ValuationControllerCreateValuationData>>): UseMutationOptions<ValuationControllerCreateValuationResponse, DefaultError, Options<ValuationControllerCreateValuationData>> => {
    const mutationOptions: UseMutationOptions<ValuationControllerCreateValuationResponse, DefaultError, Options<ValuationControllerCreateValuationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationControllerCreateValuation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete valuation
 */
export const valuationControllerDeleteValuationMutation = (options?: Partial<Options<ValuationControllerDeleteValuationData>>): UseMutationOptions<unknown, DefaultError, Options<ValuationControllerDeleteValuationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ValuationControllerDeleteValuationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationControllerDeleteValuation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update valuation with classifiers
 */
export const valuationControllerUpdateValuationWithClassifiersMutation = (options?: Partial<Options<ValuationControllerUpdateValuationWithClassifiersData>>): UseMutationOptions<ValuationControllerUpdateValuationWithClassifiersResponse, DefaultError, Options<ValuationControllerUpdateValuationWithClassifiersData>> => {
    const mutationOptions: UseMutationOptions<ValuationControllerUpdateValuationWithClassifiersResponse, DefaultError, Options<ValuationControllerUpdateValuationWithClassifiersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationControllerUpdateValuationWithClassifiers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert valuation by client-supplied id. Creates if missing, updates if present. Used by the autosave so the valuation id is stable from the form mount.
 */
export const valuationControllerUpsertValuationMutation = (options?: Partial<Options<ValuationControllerUpsertValuationData>>): UseMutationOptions<ValuationControllerUpsertValuationResponse, DefaultError, Options<ValuationControllerUpsertValuationData>> => {
    const mutationOptions: UseMutationOptions<ValuationControllerUpsertValuationResponse, DefaultError, Options<ValuationControllerUpsertValuationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationControllerUpsertValuation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Duplicate valuation
 */
export const valuationControllerDuplicateValuationMutation = (options?: Partial<Options<ValuationControllerDuplicateValuationData>>): UseMutationOptions<ValuationControllerDuplicateValuationResponse, DefaultError, Options<ValuationControllerDuplicateValuationData>> => {
    const mutationOptions: UseMutationOptions<ValuationControllerDuplicateValuationResponse, DefaultError, Options<ValuationControllerDuplicateValuationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationControllerDuplicateValuation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const valuationInputControllerGetValuationInputsQueryKey = (options: Options<ValuationInputControllerGetValuationInputsData>) => createQueryKey('valuationInputControllerGetValuationInputs', options);

/**
 * Get all valuation inputs for a given valuation
 */
export const valuationInputControllerGetValuationInputsOptions = (options: Options<ValuationInputControllerGetValuationInputsData>) => queryOptions<ValuationInputControllerGetValuationInputsResponse, DefaultError, ValuationInputControllerGetValuationInputsResponse, ReturnType<typeof valuationInputControllerGetValuationInputsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationInputControllerGetValuationInputs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationInputControllerGetValuationInputsQueryKey(options)
});

/**
 * Upsert valuation inputs and adjustments. Adjustments with id are updated; without id are created.
 */
export const valuationInputControllerUpsertMutation = (options?: Partial<Options<ValuationInputControllerUpsertData>>): UseMutationOptions<ValuationInputControllerUpsertResponse, DefaultError, Options<ValuationInputControllerUpsertData>> => {
    const mutationOptions: UseMutationOptions<ValuationInputControllerUpsertResponse, DefaultError, Options<ValuationInputControllerUpsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationInputControllerUpsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update valuation input
 */
export const valuationInputControllerUpdateValuationInputMutation = (options?: Partial<Options<ValuationInputControllerUpdateValuationInputData>>): UseMutationOptions<ValuationInputControllerUpdateValuationInputResponse, DefaultError, Options<ValuationInputControllerUpdateValuationInputData>> => {
    const mutationOptions: UseMutationOptions<ValuationInputControllerUpdateValuationInputResponse, DefaultError, Options<ValuationInputControllerUpdateValuationInputData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationInputControllerUpdateValuationInput({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create valuation input adjustment
 */
export const valuationInputControllerCreateValuationInputAdjustmentMutation = (options?: Partial<Options<ValuationInputControllerCreateValuationInputAdjustmentData>>): UseMutationOptions<ValuationInputControllerCreateValuationInputAdjustmentResponse, DefaultError, Options<ValuationInputControllerCreateValuationInputAdjustmentData>> => {
    const mutationOptions: UseMutationOptions<ValuationInputControllerCreateValuationInputAdjustmentResponse, DefaultError, Options<ValuationInputControllerCreateValuationInputAdjustmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationInputControllerCreateValuationInputAdjustment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete valuation input adjustment
 */
export const valuationInputControllerDeleteValuationInputAdjustmentMutation = (options?: Partial<Options<ValuationInputControllerDeleteValuationInputAdjustmentData>>): UseMutationOptions<unknown, DefaultError, Options<ValuationInputControllerDeleteValuationInputAdjustmentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ValuationInputControllerDeleteValuationInputAdjustmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationInputControllerDeleteValuationInputAdjustment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update valuation input adjustment
 */
export const valuationInputControllerUpdateValuationInputAdjustmentMutation = (options?: Partial<Options<ValuationInputControllerUpdateValuationInputAdjustmentData>>): UseMutationOptions<ValuationInputControllerUpdateValuationInputAdjustmentResponse, DefaultError, Options<ValuationInputControllerUpdateValuationInputAdjustmentData>> => {
    const mutationOptions: UseMutationOptions<ValuationInputControllerUpdateValuationInputAdjustmentResponse, DefaultError, Options<ValuationInputControllerUpdateValuationInputAdjustmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationInputControllerUpdateValuationInputAdjustment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const foreignExchangeControllerGetLatestExchangeRateQueryKey = (options: Options<ForeignExchangeControllerGetLatestExchangeRateData>) => createQueryKey('foreignExchangeControllerGetLatestExchangeRate', options);

/**
 * Get latest exchange rate
 */
export const foreignExchangeControllerGetLatestExchangeRateOptions = (options: Options<ForeignExchangeControllerGetLatestExchangeRateData>) => queryOptions<ForeignExchangeControllerGetLatestExchangeRateResponse, DefaultError, ForeignExchangeControllerGetLatestExchangeRateResponse, ReturnType<typeof foreignExchangeControllerGetLatestExchangeRateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await foreignExchangeControllerGetLatestExchangeRate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: foreignExchangeControllerGetLatestExchangeRateQueryKey(options)
});

export const foreignExchangeControllerGetHistoricalAndCustomExchangeRateQueryKey = (options: Options<ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData>) => createQueryKey('foreignExchangeControllerGetHistoricalAndCustomExchangeRate', options);

/**
 * Get historical and custom exchange rate
 */
export const foreignExchangeControllerGetHistoricalAndCustomExchangeRateOptions = (options: Options<ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData>) => queryOptions<ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponse, DefaultError, ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponse, ReturnType<typeof foreignExchangeControllerGetHistoricalAndCustomExchangeRateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await foreignExchangeControllerGetHistoricalAndCustomExchangeRate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: foreignExchangeControllerGetHistoricalAndCustomExchangeRateQueryKey(options)
});

/**
 * Put custom foreign exchange rate
 */
export const foreignExchangeControllerPutCustomExchangeRateMutation = (options?: Partial<Options<ForeignExchangeControllerPutCustomExchangeRateData>>): UseMutationOptions<ForeignExchangeControllerPutCustomExchangeRateResponse, DefaultError, Options<ForeignExchangeControllerPutCustomExchangeRateData>> => {
    const mutationOptions: UseMutationOptions<ForeignExchangeControllerPutCustomExchangeRateResponse, DefaultError, Options<ForeignExchangeControllerPutCustomExchangeRateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await foreignExchangeControllerPutCustomExchangeRate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const foreignExchangeControllerGetCurrenciesUsedInValuationQueryKey = (options: Options<ForeignExchangeControllerGetCurrenciesUsedInValuationData>) => createQueryKey('foreignExchangeControllerGetCurrenciesUsedInValuation', options);

/**
 * Get currencies used in a valuation
 */
export const foreignExchangeControllerGetCurrenciesUsedInValuationOptions = (options: Options<ForeignExchangeControllerGetCurrenciesUsedInValuationData>) => queryOptions<ForeignExchangeControllerGetCurrenciesUsedInValuationResponse, DefaultError, ForeignExchangeControllerGetCurrenciesUsedInValuationResponse, ReturnType<typeof foreignExchangeControllerGetCurrenciesUsedInValuationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await foreignExchangeControllerGetCurrenciesUsedInValuation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: foreignExchangeControllerGetCurrenciesUsedInValuationQueryKey(options)
});

export const valuationPersonInputControllerGetValuationPersonInputsQueryKey = (options: Options<ValuationPersonInputControllerGetValuationPersonInputsData>) => createQueryKey('valuationPersonInputControllerGetValuationPersonInputs', options);

/**
 * Get valuation person inputs
 */
export const valuationPersonInputControllerGetValuationPersonInputsOptions = (options: Options<ValuationPersonInputControllerGetValuationPersonInputsData>) => queryOptions<ValuationPersonInputControllerGetValuationPersonInputsResponse, DefaultError, ValuationPersonInputControllerGetValuationPersonInputsResponse, ReturnType<typeof valuationPersonInputControllerGetValuationPersonInputsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationPersonInputControllerGetValuationPersonInputs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationPersonInputControllerGetValuationPersonInputsQueryKey(options)
});

/**
 * Create valuation person input
 */
export const valuationPersonInputControllerCreateValuationPersonInputMutation = (options?: Partial<Options<ValuationPersonInputControllerCreateValuationPersonInputData>>): UseMutationOptions<ValuationPersonInputControllerCreateValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerCreateValuationPersonInputData>> => {
    const mutationOptions: UseMutationOptions<ValuationPersonInputControllerCreateValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerCreateValuationPersonInputData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationPersonInputControllerCreateValuationPersonInput({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert valuation person inputs. Items with id are updated; items without id are created.
 */
export const valuationPersonInputControllerUpsertValuationPersonInputsMutation = (options?: Partial<Options<ValuationPersonInputControllerUpsertValuationPersonInputsData>>): UseMutationOptions<ValuationPersonInputControllerUpsertValuationPersonInputsResponse, DefaultError, Options<ValuationPersonInputControllerUpsertValuationPersonInputsData>> => {
    const mutationOptions: UseMutationOptions<ValuationPersonInputControllerUpsertValuationPersonInputsResponse, DefaultError, Options<ValuationPersonInputControllerUpsertValuationPersonInputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationPersonInputControllerUpsertValuationPersonInputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete valuation person input
 */
export const valuationPersonInputControllerDeleteValuationPersonInputMutation = (options?: Partial<Options<ValuationPersonInputControllerDeleteValuationPersonInputData>>): UseMutationOptions<ValuationPersonInputControllerDeleteValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerDeleteValuationPersonInputData>> => {
    const mutationOptions: UseMutationOptions<ValuationPersonInputControllerDeleteValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerDeleteValuationPersonInputData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationPersonInputControllerDeleteValuationPersonInput({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update valuation person input
 */
export const valuationPersonInputControllerUpdateValuationPersonInputMutation = (options?: Partial<Options<ValuationPersonInputControllerUpdateValuationPersonInputData>>): UseMutationOptions<ValuationPersonInputControllerUpdateValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerUpdateValuationPersonInputData>> => {
    const mutationOptions: UseMutationOptions<ValuationPersonInputControllerUpdateValuationPersonInputResponse, DefaultError, Options<ValuationPersonInputControllerUpdateValuationPersonInputData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationPersonInputControllerUpdateValuationPersonInput({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a valuation compute (Temporal workflow) and return its workflowId; open calculate-valuation/stream with that id to receive live progress + the result reference
 */
export const valuationSummaryControllerStartCalculateValuationMutation = (options?: Partial<Options<ValuationSummaryControllerStartCalculateValuationData>>): UseMutationOptions<ValuationSummaryControllerStartCalculateValuationResponse, DefaultError, Options<ValuationSummaryControllerStartCalculateValuationData>> => {
    const mutationOptions: UseMutationOptions<ValuationSummaryControllerStartCalculateValuationResponse, DefaultError, Options<ValuationSummaryControllerStartCalculateValuationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await valuationSummaryControllerStartCalculateValuation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const valuationSummaryControllerStreamCalculateValuationQueryKey = (options: Options<ValuationSummaryControllerStreamCalculateValuationData>) => createQueryKey('valuationSummaryControllerStreamCalculateValuation', options);

/**
 * Stream a running valuation compute as SSE (progress relayed from Redis); the terminal `result` event carries the compute result reference ({ resultId }), `error` a failure
 */
export const valuationSummaryControllerStreamCalculateValuationOptions = (options: Options<ValuationSummaryControllerStreamCalculateValuationData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof valuationSummaryControllerStreamCalculateValuationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationSummaryControllerStreamCalculateValuation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationSummaryControllerStreamCalculateValuationQueryKey(options)
});

export const valuationSummaryControllerGetValuationSummaryResultQueryKey = (options: Options<ValuationSummaryControllerGetValuationSummaryResultData>) => createQueryKey('valuationSummaryControllerGetValuationSummaryResult', options);

/**
 * Get a calculated valuation summary by its compute result reference
 */
export const valuationSummaryControllerGetValuationSummaryResultOptions = (options: Options<ValuationSummaryControllerGetValuationSummaryResultData>) => queryOptions<ValuationSummaryControllerGetValuationSummaryResultResponse, DefaultError, ValuationSummaryControllerGetValuationSummaryResultResponse, ReturnType<typeof valuationSummaryControllerGetValuationSummaryResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationSummaryControllerGetValuationSummaryResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationSummaryControllerGetValuationSummaryResultQueryKey(options)
});

export const valuationSummaryControllerGetValuationBreakpointSummaryQueryKey = (options: Options<ValuationSummaryControllerGetValuationBreakpointSummaryData>) => createQueryKey('valuationSummaryControllerGetValuationBreakpointSummary', options);

/**
 * Get valuation breakpoint summary
 */
export const valuationSummaryControllerGetValuationBreakpointSummaryOptions = (options: Options<ValuationSummaryControllerGetValuationBreakpointSummaryData>) => queryOptions<ValuationSummaryControllerGetValuationBreakpointSummaryResponse, DefaultError, ValuationSummaryControllerGetValuationBreakpointSummaryResponse, ReturnType<typeof valuationSummaryControllerGetValuationBreakpointSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationSummaryControllerGetValuationBreakpointSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationSummaryControllerGetValuationBreakpointSummaryQueryKey(options)
});

export const valuationSummaryControllerDownloadInterestEventsExcelQueryKey = (options: Options<ValuationSummaryControllerDownloadInterestEventsExcelData>) => createQueryKey('valuationSummaryControllerDownloadInterestEventsExcel', options);

/**
 * Download the per-tranche interest ledger as xlsx
 */
export const valuationSummaryControllerDownloadInterestEventsExcelOptions = (options: Options<ValuationSummaryControllerDownloadInterestEventsExcelData>) => queryOptions<ValuationSummaryControllerDownloadInterestEventsExcelResponse, DefaultError, ValuationSummaryControllerDownloadInterestEventsExcelResponse, ReturnType<typeof valuationSummaryControllerDownloadInterestEventsExcelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationSummaryControllerDownloadInterestEventsExcel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationSummaryControllerDownloadInterestEventsExcelQueryKey(options)
});

export const valuationSummaryControllerDownloadExcelQueryKey = (options: Options<ValuationSummaryControllerDownloadExcelData>) => createQueryKey('valuationSummaryControllerDownloadExcel', options);

/**
 * Download valuation summary excel
 */
export const valuationSummaryControllerDownloadExcelOptions = (options: Options<ValuationSummaryControllerDownloadExcelData>) => queryOptions<ValuationSummaryControllerDownloadExcelResponse, DefaultError, ValuationSummaryControllerDownloadExcelResponse, ReturnType<typeof valuationSummaryControllerDownloadExcelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await valuationSummaryControllerDownloadExcel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: valuationSummaryControllerDownloadExcelQueryKey(options)
});

/**
 * Create security value override
 */
export const securityValueOverrideControllerCreateSecurityValueOverrideMutation = (options?: Partial<Options<SecurityValueOverrideControllerCreateSecurityValueOverrideData>>): UseMutationOptions<SecurityValueOverrideControllerCreateSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerCreateSecurityValueOverrideData>> => {
    const mutationOptions: UseMutationOptions<SecurityValueOverrideControllerCreateSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerCreateSecurityValueOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityValueOverrideControllerCreateSecurityValueOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete security value override
 */
export const securityValueOverrideControllerDeleteSecurityValueOverrideMutation = (options?: Partial<Options<SecurityValueOverrideControllerDeleteSecurityValueOverrideData>>): UseMutationOptions<SecurityValueOverrideControllerDeleteSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerDeleteSecurityValueOverrideData>> => {
    const mutationOptions: UseMutationOptions<SecurityValueOverrideControllerDeleteSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerDeleteSecurityValueOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityValueOverrideControllerDeleteSecurityValueOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update security value override
 */
export const securityValueOverrideControllerUpdateSecurityValueOverrideMutation = (options?: Partial<Options<SecurityValueOverrideControllerUpdateSecurityValueOverrideData>>): UseMutationOptions<SecurityValueOverrideControllerUpdateSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerUpdateSecurityValueOverrideData>> => {
    const mutationOptions: UseMutationOptions<SecurityValueOverrideControllerUpdateSecurityValueOverrideResponse, DefaultError, Options<SecurityValueOverrideControllerUpdateSecurityValueOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityValueOverrideControllerUpdateSecurityValueOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const holdingsControllerGenerateShareRegisterPdfQueryKey = (options: Options<HoldingsControllerGenerateShareRegisterPdfData>) => createQueryKey('holdingsControllerGenerateShareRegisterPdf', options);

/**
 * Generate PDF share register for an issuer, upload to S3, and return presigned download URL
 */
export const holdingsControllerGenerateShareRegisterPdfOptions = (options: Options<HoldingsControllerGenerateShareRegisterPdfData>) => queryOptions<HoldingsControllerGenerateShareRegisterPdfResponse, DefaultError, HoldingsControllerGenerateShareRegisterPdfResponse, ReturnType<typeof holdingsControllerGenerateShareRegisterPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerGenerateShareRegisterPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerGenerateShareRegisterPdfQueryKey(options)
});

export const holdingsControllerGenerateShareRegisterPdfInlineQueryKey = (options: Options<HoldingsControllerGenerateShareRegisterPdfInlineData>) => createQueryKey('holdingsControllerGenerateShareRegisterPdfInline', options);

/**
 * Render the share-register PDF and stream the bytes inline (application/pdf). Does NOT persist to S3 or create a File row — intended for perf testing.
 */
export const holdingsControllerGenerateShareRegisterPdfInlineOptions = (options: Options<HoldingsControllerGenerateShareRegisterPdfInlineData>) => queryOptions<HoldingsControllerGenerateShareRegisterPdfInlineResponse, DefaultError, HoldingsControllerGenerateShareRegisterPdfInlineResponse, ReturnType<typeof holdingsControllerGenerateShareRegisterPdfInlineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerGenerateShareRegisterPdfInline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerGenerateShareRegisterPdfInlineQueryKey(options)
});

/**
 * Start async share-register PDF generation; returns a task id to poll via the status endpoint
 */
export const holdingsControllerStartShareRegisterPdfGenerationMutation = (options?: Partial<Options<HoldingsControllerStartShareRegisterPdfGenerationData>>): UseMutationOptions<HoldingsControllerStartShareRegisterPdfGenerationResponse, DefaultError, Options<HoldingsControllerStartShareRegisterPdfGenerationData>> => {
    const mutationOptions: UseMutationOptions<HoldingsControllerStartShareRegisterPdfGenerationResponse, DefaultError, Options<HoldingsControllerStartShareRegisterPdfGenerationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingsControllerStartShareRegisterPdfGeneration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const holdingsControllerGetShareRegisterPdfTaskStatusQueryKey = (options: Options<HoldingsControllerGetShareRegisterPdfTaskStatusData>) => createQueryKey('holdingsControllerGetShareRegisterPdfTaskStatus', options);

/**
 * Get share-register PDF generation task status; returns downloadUrl when status is DONE
 */
export const holdingsControllerGetShareRegisterPdfTaskStatusOptions = (options: Options<HoldingsControllerGetShareRegisterPdfTaskStatusData>) => queryOptions<HoldingsControllerGetShareRegisterPdfTaskStatusResponse, DefaultError, HoldingsControllerGetShareRegisterPdfTaskStatusResponse, ReturnType<typeof holdingsControllerGetShareRegisterPdfTaskStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerGetShareRegisterPdfTaskStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerGetShareRegisterPdfTaskStatusQueryKey(options)
});

/**
 * Get Holdings List for Person
 */
export const holdingsControllerPostHoldingsListForPersonMutation = (options?: Partial<Options<HoldingsControllerPostHoldingsListForPersonData>>): UseMutationOptions<HoldingsControllerPostHoldingsListForPersonResponse, DefaultError, Options<HoldingsControllerPostHoldingsListForPersonData>> => {
    const mutationOptions: UseMutationOptions<HoldingsControllerPostHoldingsListForPersonResponse, DefaultError, Options<HoldingsControllerPostHoldingsListForPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingsControllerPostHoldingsListForPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const holdingsControllerGetHoldingByPersonAndSecurityQueryKey = (options: Options<HoldingsControllerGetHoldingByPersonAndSecurityData>) => createQueryKey('holdingsControllerGetHoldingByPersonAndSecurity', options);

/**
 * Get Holding Details
 */
export const holdingsControllerGetHoldingByPersonAndSecurityOptions = (options: Options<HoldingsControllerGetHoldingByPersonAndSecurityData>) => queryOptions<HoldingsControllerGetHoldingByPersonAndSecurityResponse, DefaultError, HoldingsControllerGetHoldingByPersonAndSecurityResponse, ReturnType<typeof holdingsControllerGetHoldingByPersonAndSecurityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerGetHoldingByPersonAndSecurity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerGetHoldingByPersonAndSecurityQueryKey(options)
});

export const holdingsControllerGetHoldingEventsListByPersonAndSecurityQueryKey = (options: Options<HoldingsControllerGetHoldingEventsListByPersonAndSecurityData>) => createQueryKey('holdingsControllerGetHoldingEventsListByPersonAndSecurity', options);

/**
 * Get Holding Events List
 */
export const holdingsControllerGetHoldingEventsListByPersonAndSecurityOptions = (options: Options<HoldingsControllerGetHoldingEventsListByPersonAndSecurityData>) => queryOptions<HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponse, DefaultError, HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponse, ReturnType<typeof holdingsControllerGetHoldingEventsListByPersonAndSecurityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerGetHoldingEventsListByPersonAndSecurity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerGetHoldingEventsListByPersonAndSecurityQueryKey(options)
});

/**
 * Get Wide View Holdings CSV
 */
export const holdingsControllerPostWideViewHoldingsCsvMutation = (options?: Partial<Options<HoldingsControllerPostWideViewHoldingsCsvData>>): UseMutationOptions<unknown, DefaultError, Options<HoldingsControllerPostWideViewHoldingsCsvData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<HoldingsControllerPostWideViewHoldingsCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingsControllerPostWideViewHoldingsCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Regular View Holdings CSV
 */
export const holdingsControllerPostRegularViewHoldingsCsvMutation = (options?: Partial<Options<HoldingsControllerPostRegularViewHoldingsCsvData>>): UseMutationOptions<unknown, DefaultError, Options<HoldingsControllerPostRegularViewHoldingsCsvData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<HoldingsControllerPostRegularViewHoldingsCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingsControllerPostRegularViewHoldingsCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const holdingsControllerDownloadHoldingsExcelQueryKey = (options: Options<HoldingsControllerDownloadHoldingsExcelData>) => createQueryKey('holdingsControllerDownloadHoldingsExcel', options);

/**
 * Download excel file with holdings table data
 */
export const holdingsControllerDownloadHoldingsExcelOptions = (options: Options<HoldingsControllerDownloadHoldingsExcelData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof holdingsControllerDownloadHoldingsExcelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerDownloadHoldingsExcel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerDownloadHoldingsExcelQueryKey(options)
});

export const holdingsControllerDownloadVestingEventsReportQueryKey = (options: Options<HoldingsControllerDownloadVestingEventsReportData>) => createQueryKey('holdingsControllerDownloadVestingEventsReport', options);

/**
 * Download xlsx with vesting events report
 */
export const holdingsControllerDownloadVestingEventsReportOptions = (options: Options<HoldingsControllerDownloadVestingEventsReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof holdingsControllerDownloadVestingEventsReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await holdingsControllerDownloadVestingEventsReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: holdingsControllerDownloadVestingEventsReportQueryKey(options)
});

/**
 * Create holding event
 */
export const holdingEventControllerCreateHoldingEventMutation = (options?: Partial<Options<HoldingEventControllerCreateHoldingEventData>>): UseMutationOptions<HoldingEventControllerCreateHoldingEventResponse, DefaultError, Options<HoldingEventControllerCreateHoldingEventData>> => {
    const mutationOptions: UseMutationOptions<HoldingEventControllerCreateHoldingEventResponse, DefaultError, Options<HoldingEventControllerCreateHoldingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingEventControllerCreateHoldingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create multiple holding events
 */
export const holdingEventControllerCreateBulkHoldingEventsMutation = (options?: Partial<Options<HoldingEventControllerCreateBulkHoldingEventsData>>): UseMutationOptions<HoldingEventControllerCreateBulkHoldingEventsResponse, DefaultError, Options<HoldingEventControllerCreateBulkHoldingEventsData>> => {
    const mutationOptions: UseMutationOptions<HoldingEventControllerCreateBulkHoldingEventsResponse, DefaultError, Options<HoldingEventControllerCreateBulkHoldingEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingEventControllerCreateBulkHoldingEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update holding event
 */
export const holdingEventControllerUpdateHoldingEventMutation = (options?: Partial<Options<HoldingEventControllerUpdateHoldingEventData>>): UseMutationOptions<HoldingEventControllerUpdateHoldingEventResponse, DefaultError, Options<HoldingEventControllerUpdateHoldingEventData>> => {
    const mutationOptions: UseMutationOptions<HoldingEventControllerUpdateHoldingEventResponse, DefaultError, Options<HoldingEventControllerUpdateHoldingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingEventControllerUpdateHoldingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete holding event
 */
export const holdingEventControllerSoftDeleteHoldingEventMutation = (options?: Partial<Options<HoldingEventControllerSoftDeleteHoldingEventData>>): UseMutationOptions<HoldingEventControllerSoftDeleteHoldingEventResponse, DefaultError, Options<HoldingEventControllerSoftDeleteHoldingEventData>> => {
    const mutationOptions: UseMutationOptions<HoldingEventControllerSoftDeleteHoldingEventResponse, DefaultError, Options<HoldingEventControllerSoftDeleteHoldingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdingEventControllerSoftDeleteHoldingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * pre-initialize the e2e user pool before tests run
 */
export const e2eControllerWarmupPoolMutation = (options?: Partial<Options<E2eControllerWarmupPoolData>>): UseMutationOptions<unknown, DefaultError, Options<E2eControllerWarmupPoolData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<E2eControllerWarmupPoolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerWarmupPool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * create test user
 */
export const e2eControllerCreateUserMutation = (options?: Partial<Options<E2eControllerCreateUserData>>): UseMutationOptions<E2eControllerCreateUserResponse, DefaultError, Options<E2eControllerCreateUserData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerCreateUserResponse, DefaultError, Options<E2eControllerCreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * authenticate a user against workos and return cookies
 */
export const e2eControllerAuthenticateUserMutation = (options?: Partial<Options<E2eControllerAuthenticateUserData>>): UseMutationOptions<E2eControllerAuthenticateUserResponse, DefaultError, Options<E2eControllerAuthenticateUserData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerAuthenticateUserResponse, DefaultError, Options<E2eControllerAuthenticateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerAuthenticateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * get the captured WorkOS change-email verification code
 */
export const e2eControllerGetChangeEmailVerificationCodeMutation = (options?: Partial<Options<E2eControllerGetChangeEmailVerificationCodeData>>): UseMutationOptions<E2eControllerGetChangeEmailVerificationCodeResponse, DefaultError, Options<E2eControllerGetChangeEmailVerificationCodeData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerGetChangeEmailVerificationCodeResponse, DefaultError, Options<E2eControllerGetChangeEmailVerificationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerGetChangeEmailVerificationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * read the newest WorkOS email verification code for an address from WorkOS events
 */
export const e2eControllerGetWorkOsEmailVerificationCodeMutation = (options?: Partial<Options<E2eControllerGetWorkOsEmailVerificationCodeData>>): UseMutationOptions<E2eControllerGetWorkOsEmailVerificationCodeResponse, DefaultError, Options<E2eControllerGetWorkOsEmailVerificationCodeData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerGetWorkOsEmailVerificationCodeResponse, DefaultError, Options<E2eControllerGetWorkOsEmailVerificationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerGetWorkOsEmailVerificationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * read the newest WorkOS magic auth code for an address from WorkOS events
 */
export const e2eControllerGetWorkOsMagicAuthCodeMutation = (options?: Partial<Options<E2eControllerGetWorkOsMagicAuthCodeData>>): UseMutationOptions<E2eControllerGetWorkOsMagicAuthCodeResponse, DefaultError, Options<E2eControllerGetWorkOsMagicAuthCodeData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerGetWorkOsMagicAuthCodeResponse, DefaultError, Options<E2eControllerGetWorkOsMagicAuthCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerGetWorkOsMagicAuthCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * read the newest WorkOS password reset link for an address from WorkOS events
 */
export const e2eControllerGetWorkOsPasswordResetLinkMutation = (options?: Partial<Options<E2eControllerGetWorkOsPasswordResetLinkData>>): UseMutationOptions<E2eControllerGetWorkOsPasswordResetLinkResponse, DefaultError, Options<E2eControllerGetWorkOsPasswordResetLinkData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerGetWorkOsPasswordResetLinkResponse, DefaultError, Options<E2eControllerGetWorkOsPasswordResetLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerGetWorkOsPasswordResetLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const e2eControllerGetSsoFixtureQueryKey = (options?: Options<E2eControllerGetSsoFixtureData>) => createQueryKey('e2eControllerGetSsoFixture', options);

/**
 * ensure and report this environment’s SSO fixture organisations and canonical user
 */
export const e2eControllerGetSsoFixtureOptions = (options?: Options<E2eControllerGetSsoFixtureData>) => queryOptions<E2eControllerGetSsoFixtureResponse, DefaultError, E2eControllerGetSsoFixtureResponse, ReturnType<typeof e2eControllerGetSsoFixtureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await e2eControllerGetSsoFixture({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: e2eControllerGetSsoFixtureQueryKey(options)
});

/**
 * reset a MUTABLE SSO fixture organisation (B or C) to a known state
 */
export const e2eControllerResetSsoOrganizationMutation = (options?: Partial<Options<E2eControllerResetSsoOrganizationData>>): UseMutationOptions<E2eControllerResetSsoOrganizationResponse, DefaultError, Options<E2eControllerResetSsoOrganizationData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerResetSsoOrganizationResponse, DefaultError, Options<E2eControllerResetSsoOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerResetSsoOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const e2eControllerGetSentEmailsQueryKey = (options: Options<E2eControllerGetSentEmailsData>) => createQueryKey('e2eControllerGetSentEmails', options);

/**
 * report the emails the app recorded sending to an address, newest last
 */
export const e2eControllerGetSentEmailsOptions = (options: Options<E2eControllerGetSentEmailsData>) => queryOptions<E2eControllerGetSentEmailsResponse, DefaultError, E2eControllerGetSentEmailsResponse, ReturnType<typeof e2eControllerGetSentEmailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await e2eControllerGetSentEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: e2eControllerGetSentEmailsQueryKey(options)
});

export const e2eControllerGetWorkOsUserQueryKey = (options: Options<E2eControllerGetWorkOsUserData>) => createQueryKey('e2eControllerGetWorkOsUser', options);

/**
 * report the WorkOS identity behind an address and the organisations it belongs to
 */
export const e2eControllerGetWorkOsUserOptions = (options: Options<E2eControllerGetWorkOsUserData>) => queryOptions<E2eControllerGetWorkOsUserResponse, DefaultError, E2eControllerGetWorkOsUserResponse, ReturnType<typeof e2eControllerGetWorkOsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await e2eControllerGetWorkOsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: e2eControllerGetWorkOsUserQueryKey(options)
});

/**
 * create a WorkOS identity for an address without touching the local database
 */
export const e2eControllerCreateWorkOsUserMutation = (options?: Partial<Options<E2eControllerCreateWorkOsUserData>>): UseMutationOptions<E2eControllerCreateWorkOsUserResponse, DefaultError, Options<E2eControllerCreateWorkOsUserData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerCreateWorkOsUserResponse, DefaultError, Options<E2eControllerCreateWorkOsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerCreateWorkOsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * move a WorkOS identity onto another address, as a customer’s IdP would
 */
export const e2eControllerChangeWorkOsUserEmailMutation = (options?: Partial<Options<E2eControllerChangeWorkOsUserEmailData>>): UseMutationOptions<E2eControllerChangeWorkOsUserEmailResponse, DefaultError, Options<E2eControllerChangeWorkOsUserEmailData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerChangeWorkOsUserEmailResponse, DefaultError, Options<E2eControllerChangeWorkOsUserEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerChangeWorkOsUserEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * accept a WorkOS invitation outside sign-in, so no DealStack user gets linked
 */
export const e2eControllerAcceptWorkOsInvitationMutation = (options?: Partial<Options<E2eControllerAcceptWorkOsInvitationData>>): UseMutationOptions<E2eControllerAcceptWorkOsInvitationResponse, DefaultError, Options<E2eControllerAcceptWorkOsInvitationData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerAcceptWorkOsInvitationResponse, DefaultError, Options<E2eControllerAcceptWorkOsInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerAcceptWorkOsInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * run one WorkOS event ingest+sweep pass synchronously
 */
export const e2eControllerPollWorkOsEventsMutation = (options?: Partial<Options<E2eControllerPollWorkOsEventsData>>): UseMutationOptions<E2eControllerPollWorkOsEventsResponse, DefaultError, Options<E2eControllerPollWorkOsEventsData>> => {
    const mutationOptions: UseMutationOptions<E2eControllerPollWorkOsEventsResponse, DefaultError, Options<E2eControllerPollWorkOsEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerPollWorkOsEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable KYC requirement for a MIP
 */
export const e2eControllerDisableMipKycMutation = (options?: Partial<Options<E2eControllerDisableMipKycData>>): UseMutationOptions<unknown, DefaultError, Options<E2eControllerDisableMipKycData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<E2eControllerDisableMipKycData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await e2eControllerDisableMipKyc({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * collect Content-Security-Policy violation reports
 */
export const cspReportControllerCollectReportMutation = (options?: Partial<Options<CspReportControllerCollectReportData>>): UseMutationOptions<CspReportControllerCollectReportResponse, DefaultError, Options<CspReportControllerCollectReportData>> => {
    const mutationOptions: UseMutationOptions<CspReportControllerCollectReportResponse, DefaultError, Options<CspReportControllerCollectReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cspReportControllerCollectReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eidEasyWebhookControllerDocumentSignedMutation = (options?: Partial<Options<EidEasyWebhookControllerDocumentSignedData>>): UseMutationOptions<unknown, DefaultError, Options<EidEasyWebhookControllerDocumentSignedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EidEasyWebhookControllerDocumentSignedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eidEasyWebhookControllerDocumentSigned({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eidEasyWebhookControllerCustomSignatureImageMutation = (options?: Partial<Options<EidEasyWebhookControllerCustomSignatureImageData>>): UseMutationOptions<unknown, DefaultError, Options<EidEasyWebhookControllerCustomSignatureImageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EidEasyWebhookControllerCustomSignatureImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eidEasyWebhookControllerCustomSignatureImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * WorkOS webhook - drains the events queue, payload unused
 */
export const workOsWebhookControllerWebhookMutation = (options?: Partial<Options<WorkOsWebhookControllerWebhookData>>): UseMutationOptions<unknown, DefaultError, Options<WorkOsWebhookControllerWebhookData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<WorkOsWebhookControllerWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workOsWebhookControllerWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eidEasyMockControllerSignPageQueryKey = (options: Options<EidEasyMockControllerSignPageData>) => createQueryKey('eidEasyMockControllerSignPage', options);

export const eidEasyMockControllerSignPageOptions = (options: Options<EidEasyMockControllerSignPageData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof eidEasyMockControllerSignPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await eidEasyMockControllerSignPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: eidEasyMockControllerSignPageQueryKey(options)
});

export const eidEasyMockControllerVerifyOtpMutation = (options?: Partial<Options<EidEasyMockControllerVerifyOtpData>>): UseMutationOptions<unknown, DefaultError, Options<EidEasyMockControllerVerifyOtpData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EidEasyMockControllerVerifyOtpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eidEasyMockControllerVerifyOtp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eidEasyMockControllerCompleteMutation = (options?: Partial<Options<EidEasyMockControllerCompleteData>>): UseMutationOptions<unknown, DefaultError, Options<EidEasyMockControllerCompleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EidEasyMockControllerCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await eidEasyMockControllerComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthControllerHealthCheckQueryKey = (options?: Options<HealthControllerHealthCheckData>) => createQueryKey('healthControllerHealthCheck', options);

export const healthControllerHealthCheckOptions = (options?: Options<HealthControllerHealthCheckData>) => queryOptions<HealthControllerHealthCheckResponse, HealthControllerHealthCheckError, HealthControllerHealthCheckResponse, ReturnType<typeof healthControllerHealthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthControllerHealthCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthControllerHealthCheckQueryKey(options)
});

export const organizationDefaultMemberControllerListMembersQueryKey = (options: Options<OrganizationDefaultMemberControllerListMembersData>) => createQueryKey('organizationDefaultMemberControllerListMembers', options);

/**
 * List the people seeded onto every new deal or programme
 */
export const organizationDefaultMemberControllerListMembersOptions = (options: Options<OrganizationDefaultMemberControllerListMembersData>) => queryOptions<OrganizationDefaultMemberControllerListMembersResponse, DefaultError, OrganizationDefaultMemberControllerListMembersResponse, ReturnType<typeof organizationDefaultMemberControllerListMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationDefaultMemberControllerListMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationDefaultMemberControllerListMembersQueryKey(options)
});

/**
 * Add a default member. Sends no invitation.
 */
export const organizationDefaultMemberControllerAddMemberMutation = (options?: Partial<Options<OrganizationDefaultMemberControllerAddMemberData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDefaultMemberControllerAddMemberData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDefaultMemberControllerAddMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDefaultMemberControllerAddMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a default member
 */
export const organizationDefaultMemberControllerRemoveMemberMutation = (options?: Partial<Options<OrganizationDefaultMemberControllerRemoveMemberData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationDefaultMemberControllerRemoveMemberData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationDefaultMemberControllerRemoveMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationDefaultMemberControllerRemoveMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationUsersControllerGetOrganizationUsersQueryKey = (options: Options<OrganizationUsersControllerGetOrganizationUsersData>) => createQueryKey('organizationUsersControllerGetOrganizationUsers', options);

/**
 * get user organization
 */
export const organizationUsersControllerGetOrganizationUsersOptions = (options: Options<OrganizationUsersControllerGetOrganizationUsersData>) => queryOptions<OrganizationUsersControllerGetOrganizationUsersResponse, DefaultError, OrganizationUsersControllerGetOrganizationUsersResponse, ReturnType<typeof organizationUsersControllerGetOrganizationUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationUsersControllerGetOrganizationUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationUsersControllerGetOrganizationUsersQueryKey(options)
});

/**
 * Invite a user to an organization
 */
export const organizationUsersControllerInviteUserToOrganizationMutation = (options?: Partial<Options<OrganizationUsersControllerInviteUserToOrganizationData>>): UseMutationOptions<unknown, DefaultError, Options<OrganizationUsersControllerInviteUserToOrganizationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<OrganizationUsersControllerInviteUserToOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationUsersControllerInviteUserToOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removes a user from the organization by revoking their roles on it. The account is deactivated only when that leaves the user no access anywhere else
 */
export const organizationUsersControllerDeleteUserFromOrganizationsMutation = (options?: Partial<Options<OrganizationUsersControllerDeleteUserFromOrganizationsData>>): UseMutationOptions<OrganizationUsersControllerDeleteUserFromOrganizationsResponse, DefaultError, Options<OrganizationUsersControllerDeleteUserFromOrganizationsData>> => {
    const mutationOptions: UseMutationOptions<OrganizationUsersControllerDeleteUserFromOrganizationsResponse, DefaultError, Options<OrganizationUsersControllerDeleteUserFromOrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationUsersControllerDeleteUserFromOrganizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationUsersControllerGetOrganizationUserWithPermissionsQueryKey = (options: Options<OrganizationUsersControllerGetOrganizationUserWithPermissionsData>) => createQueryKey('organizationUsersControllerGetOrganizationUserWithPermissions', options);

/**
 * Get user information for a specific organization
 */
export const organizationUsersControllerGetOrganizationUserWithPermissionsOptions = (options: Options<OrganizationUsersControllerGetOrganizationUserWithPermissionsData>) => queryOptions<OrganizationUsersControllerGetOrganizationUserWithPermissionsResponse, DefaultError, OrganizationUsersControllerGetOrganizationUserWithPermissionsResponse, ReturnType<typeof organizationUsersControllerGetOrganizationUserWithPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationUsersControllerGetOrganizationUserWithPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationUsersControllerGetOrganizationUserWithPermissionsQueryKey(options)
});

export const infoControllerDeploymentInfoQueryKey = (options?: Options<InfoControllerDeploymentInfoData>) => createQueryKey('infoControllerDeploymentInfo', options);

/**
 * Gets info about the current deployment
 */
export const infoControllerDeploymentInfoOptions = (options?: Options<InfoControllerDeploymentInfoData>) => queryOptions<InfoControllerDeploymentInfoResponse, DefaultError, InfoControllerDeploymentInfoResponse, ReturnType<typeof infoControllerDeploymentInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await infoControllerDeploymentInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: infoControllerDeploymentInfoQueryKey(options)
});

/**
 * Delete KYCFile
 */
export const shareholderKycControllerDeleteKycFileMutation = (options?: Partial<Options<ShareholderKycControllerDeleteKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerDeleteKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerDeleteKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerDeleteKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetProofOfIdentityQueryKey = (options: Options<ShareholderKycControllerGetProofOfIdentityData>) => createQueryKey('shareholderKycControllerGetProofOfIdentity', options);

/**
 * Get shareholder proof of identity data
 */
export const shareholderKycControllerGetProofOfIdentityOptions = (options: Options<ShareholderKycControllerGetProofOfIdentityData>) => queryOptions<ShareholderKycControllerGetProofOfIdentityResponse, DefaultError, ShareholderKycControllerGetProofOfIdentityResponse, ReturnType<typeof shareholderKycControllerGetProofOfIdentityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetProofOfIdentity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetProofOfIdentityQueryKey(options)
});

/**
 * Post new shareholder proof of identity file
 */
export const shareholderKycControllerPutProofOfIdentityMutation = (options?: Partial<Options<ShareholderKycControllerPutProofOfIdentityData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPutProofOfIdentityData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPutProofOfIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerPutProofOfIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetProofOfAddressQueryKey = (options: Options<ShareholderKycControllerGetProofOfAddressData>) => createQueryKey('shareholderKycControllerGetProofOfAddress', options);

/**
 * Get shareholder proof of address data
 */
export const shareholderKycControllerGetProofOfAddressOptions = (options: Options<ShareholderKycControllerGetProofOfAddressData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shareholderKycControllerGetProofOfAddressQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetProofOfAddress({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetProofOfAddressQueryKey(options)
});

/**
 * Post new shareholder proof of address file
 */
export const shareholderKycControllerPutProofOfAddressMutation = (options?: Partial<Options<ShareholderKycControllerPutProofOfAddressData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPutProofOfAddressData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPutProofOfAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerPutProofOfAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetInvestmentVehicleKycFilesQueryKey = (options: Options<ShareholderKycControllerGetInvestmentVehicleKycFilesData>) => createQueryKey('shareholderKycControllerGetInvestmentVehicleKycFiles', options);

/**
 * Get shareholder investment vehicle data kyc files
 */
export const shareholderKycControllerGetInvestmentVehicleKycFilesOptions = (options: Options<ShareholderKycControllerGetInvestmentVehicleKycFilesData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shareholderKycControllerGetInvestmentVehicleKycFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetInvestmentVehicleKycFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetInvestmentVehicleKycFilesQueryKey(options)
});

/**
 * Post new shareholder proof of identity file
 */
export const shareholderKycControllerPostInvestmentVehicleMutation = (options?: Partial<Options<ShareholderKycControllerPostInvestmentVehicleData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPostInvestmentVehicleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPostInvestmentVehicleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerPostInvestmentVehicle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetInvestorKycFormsQueryKey = (options: Options<ShareholderKycControllerGetInvestorKycFormsData>) => createQueryKey('shareholderKycControllerGetInvestorKycForms', options);

/**
 * Get investor KYC forms for a workflow from DocumentWorkflow (flag-gated)
 */
export const shareholderKycControllerGetInvestorKycFormsOptions = (options: Options<ShareholderKycControllerGetInvestorKycFormsData>) => queryOptions<ShareholderKycControllerGetInvestorKycFormsResponse, DefaultError, ShareholderKycControllerGetInvestorKycFormsResponse, ReturnType<typeof shareholderKycControllerGetInvestorKycFormsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetInvestorKycForms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetInvestorKycFormsQueryKey(options)
});

/**
 * Pre-fill a KYC form with the investor data before they complete it
 */
export const shareholderKycControllerPreFillInvestorKycFormMutation = (options?: Partial<Options<ShareholderKycControllerPreFillInvestorKycFormData>>): UseMutationOptions<ShareholderKycControllerPreFillInvestorKycFormResponse, DefaultError, Options<ShareholderKycControllerPreFillInvestorKycFormData>> => {
    const mutationOptions: UseMutationOptions<ShareholderKycControllerPreFillInvestorKycFormResponse, DefaultError, Options<ShareholderKycControllerPreFillInvestorKycFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerPreFillInvestorKycForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a new shareholder filled kyc form to kyc forms
 */
export const shareholderKycControllerAddFilledKycFormMutation = (options?: Partial<Options<ShareholderKycControllerAddFilledKycFormData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerAddFilledKycFormData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerAddFilledKycFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerAddFilledKycForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an uploaded KYC form
 */
export const shareholderKycControllerRemoveInvestorFormMutation = (options?: Partial<Options<ShareholderKycControllerRemoveInvestorFormData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerRemoveInvestorFormData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerRemoveInvestorFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerRemoveInvestorForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm inherited KYC form unchanged
 */
export const shareholderKycControllerConfirmInvestorFormMutation = (options?: Partial<Options<ShareholderKycControllerConfirmInvestorFormData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmInvestorFormData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmInvestorFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerConfirmInvestorForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetDeclarationsQueryKey = (options: Options<ShareholderKycControllerGetDeclarationsData>) => createQueryKey('shareholderKycControllerGetDeclarations', options);

/**
 * Get shareholder declarations data
 */
export const shareholderKycControllerGetDeclarationsOptions = (options: Options<ShareholderKycControllerGetDeclarationsData>) => queryOptions<ShareholderKycControllerGetDeclarationsResponse, DefaultError, ShareholderKycControllerGetDeclarationsResponse, ReturnType<typeof shareholderKycControllerGetDeclarationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetDeclarations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetDeclarationsQueryKey(options)
});

/**
 * Update shareholder declarations data
 */
export const shareholderKycControllerPatchDeclarationsMutation = (options?: Partial<Options<ShareholderKycControllerPatchDeclarationsData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPatchDeclarationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerPatchDeclarationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerPatchDeclarations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm inherited KYC file unchanged
 */
export const shareholderKycControllerConfirmKycFileMutation = (options?: Partial<Options<ShareholderKycControllerConfirmKycFileData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmKycFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmKycFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerConfirmKycFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change how an uploaded KYC file is certified, or nominate a different certifier
 */
export const shareholderKycControllerChangeKycFileCertificationMutation = (options?: Partial<Options<ShareholderKycControllerChangeKycFileCertificationData>>): UseMutationOptions<ShareholderKycControllerChangeKycFileCertificationResponse, DefaultError, Options<ShareholderKycControllerChangeKycFileCertificationData>> => {
    const mutationOptions: UseMutationOptions<ShareholderKycControllerChangeKycFileCertificationResponse, DefaultError, Options<ShareholderKycControllerChangeKycFileCertificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerChangeKycFileCertification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend the certifier's invitation for a KYC file
 */
export const shareholderKycControllerResendKycFileCertifierInvitationMutation = (options?: Partial<Options<ShareholderKycControllerResendKycFileCertifierInvitationData>>): UseMutationOptions<ShareholderKycControllerResendKycFileCertifierInvitationResponse, DefaultError, Options<ShareholderKycControllerResendKycFileCertifierInvitationData>> => {
    const mutationOptions: UseMutationOptions<ShareholderKycControllerResendKycFileCertifierInvitationResponse, DefaultError, Options<ShareholderKycControllerResendKycFileCertifierInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerResendKycFileCertifierInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm inherited declaration unchanged
 */
export const shareholderKycControllerConfirmDeclarationMutation = (options?: Partial<Options<ShareholderKycControllerConfirmDeclarationData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmDeclarationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerConfirmDeclarationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerConfirmDeclaration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set flag for more PIV documents
 */
export const shareholderKycControllerSetOffMorePivDocumentsMutation = (options?: Partial<Options<ShareholderKycControllerSetOffMorePivDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerSetOffMorePivDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerSetOffMorePivDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerSetOffMorePivDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore soft-deleted inherited KYC items back to pending confirmation
 */
export const shareholderKycControllerResetInheritedMutation = (options?: Partial<Options<ShareholderKycControllerResetInheritedData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerResetInheritedData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderKycControllerResetInheritedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderKycControllerResetInherited({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderKycControllerGetStandaloneKycMetadataQueryKey = (options: Options<ShareholderKycControllerGetStandaloneKycMetadataData>) => createQueryKey('shareholderKycControllerGetStandaloneKycMetadata', options);

/**
 * Get standalone KYC workflow metadata for investor
 */
export const shareholderKycControllerGetStandaloneKycMetadataOptions = (options: Options<ShareholderKycControllerGetStandaloneKycMetadataData>) => queryOptions<ShareholderKycControllerGetStandaloneKycMetadataResponse, DefaultError, ShareholderKycControllerGetStandaloneKycMetadataResponse, ReturnType<typeof shareholderKycControllerGetStandaloneKycMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerGetStandaloneKycMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerGetStandaloneKycMetadataQueryKey(options)
});

export const shareholderKycControllerDownloadPreFilledKycFormFileQueryKey = (options: Options<ShareholderKycControllerDownloadPreFilledKycFormFileData>) => createQueryKey('shareholderKycControllerDownloadPreFilledKycFormFile', options);

/**
 * Download pre-filled kyc form file
 */
export const shareholderKycControllerDownloadPreFilledKycFormFileOptions = (options: Options<ShareholderKycControllerDownloadPreFilledKycFormFileData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shareholderKycControllerDownloadPreFilledKycFormFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderKycControllerDownloadPreFilledKycFormFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderKycControllerDownloadPreFilledKycFormFileQueryKey(options)
});

export const shareholderBankAccountControllerGetUserBankAccountQueryKey = (options: Options<ShareholderBankAccountControllerGetUserBankAccountData>) => createQueryKey('shareholderBankAccountControllerGetUserBankAccount', options);

/**
 * Get user persons bank accounts
 */
export const shareholderBankAccountControllerGetUserBankAccountOptions = (options: Options<ShareholderBankAccountControllerGetUserBankAccountData>) => queryOptions<ShareholderBankAccountControllerGetUserBankAccountResponse, DefaultError, ShareholderBankAccountControllerGetUserBankAccountResponse, ReturnType<typeof shareholderBankAccountControllerGetUserBankAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderBankAccountControllerGetUserBankAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderBankAccountControllerGetUserBankAccountQueryKey(options)
});

/**
 * Create or update bank account data
 */
export const shareholderBankAccountControllerUpsertBankAccountMutation = (options?: Partial<Options<ShareholderBankAccountControllerUpsertBankAccountData>>): UseMutationOptions<ShareholderBankAccountControllerUpsertBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerUpsertBankAccountData>> => {
    const mutationOptions: UseMutationOptions<ShareholderBankAccountControllerUpsertBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerUpsertBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderBankAccountControllerUpsertBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete one of the user's own bank accounts
 */
export const shareholderBankAccountControllerDeleteBankAccountMutation = (options?: Partial<Options<ShareholderBankAccountControllerDeleteBankAccountData>>): UseMutationOptions<ShareholderBankAccountControllerDeleteBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerDeleteBankAccountData>> => {
    const mutationOptions: UseMutationOptions<ShareholderBankAccountControllerDeleteBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerDeleteBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderBankAccountControllerDeleteBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Email a confirmation code for an own bank account
 */
export const shareholderBankAccountControllerRequestBankAccountCodeMutation = (options?: Partial<Options<ShareholderBankAccountControllerRequestBankAccountCodeData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderBankAccountControllerRequestBankAccountCodeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderBankAccountControllerRequestBankAccountCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderBankAccountControllerRequestBankAccountCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm an own bank account with the emailed code
 */
export const shareholderBankAccountControllerConfirmBankAccountMutation = (options?: Partial<Options<ShareholderBankAccountControllerConfirmBankAccountData>>): UseMutationOptions<ShareholderBankAccountControllerConfirmBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerConfirmBankAccountData>> => {
    const mutationOptions: UseMutationOptions<ShareholderBankAccountControllerConfirmBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerConfirmBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderBankAccountControllerConfirmBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify an own bank account's identifiers per format rule and log the lookup
 */
export const shareholderBankAccountControllerValidateBankAccountMutation = (options?: Partial<Options<ShareholderBankAccountControllerValidateBankAccountData>>): UseMutationOptions<ShareholderBankAccountControllerValidateBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerValidateBankAccountData>> => {
    const mutationOptions: UseMutationOptions<ShareholderBankAccountControllerValidateBankAccountResponse, DefaultError, Options<ShareholderBankAccountControllerValidateBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderBankAccountControllerValidateBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderCustomDetailControllerGetShareholderCustomDetailDataQueryKey = (options?: Options<ShareholderCustomDetailControllerGetShareholderCustomDetailDataData>) => createQueryKey('shareholderCustomDetailControllerGetShareholderCustomDetailData', options);

/**
 * Get mip custom details
 */
export const shareholderCustomDetailControllerGetShareholderCustomDetailDataOptions = (options?: Options<ShareholderCustomDetailControllerGetShareholderCustomDetailDataData>) => queryOptions<ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponse, DefaultError, ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponse, ReturnType<typeof shareholderCustomDetailControllerGetShareholderCustomDetailDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderCustomDetailControllerGetShareholderCustomDetailData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderCustomDetailControllerGetShareholderCustomDetailDataQueryKey(options)
});

/**
 * Update investor bank account data
 */
export const shareholderCustomDetailControllerUpdateShareholderInvestorDataMutation = (options?: Partial<Options<ShareholderCustomDetailControllerUpdateShareholderInvestorDataData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderCustomDetailControllerUpdateShareholderInvestorDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderCustomDetailControllerUpdateShareholderInvestorDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderCustomDetailControllerUpdateShareholderInvestorData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderContractControllerGetListOfActionableDocumentsQueryKey = (options: Options<ShareholderContractControllerGetListOfActionableDocumentsData>) => createQueryKey('shareholderContractControllerGetListOfActionableDocuments', options);

/**
 * Get list of actionable contracts for investor
 */
export const shareholderContractControllerGetListOfActionableDocumentsOptions = (options: Options<ShareholderContractControllerGetListOfActionableDocumentsData>) => queryOptions<ShareholderContractControllerGetListOfActionableDocumentsResponse, DefaultError, ShareholderContractControllerGetListOfActionableDocumentsResponse, ReturnType<typeof shareholderContractControllerGetListOfActionableDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderContractControllerGetListOfActionableDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderContractControllerGetListOfActionableDocumentsQueryKey(options)
});

export const shareholderContractControllerStreamSignableDocumentsQueryKey = (options: Options<ShareholderContractControllerStreamSignableDocumentsData>) => createQueryKey('shareholderContractControllerStreamSignableDocuments', options);

/**
 * Stream signable-documents change signals for an investor
 */
export const shareholderContractControllerStreamSignableDocumentsOptions = (options: Options<ShareholderContractControllerStreamSignableDocumentsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shareholderContractControllerStreamSignableDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderContractControllerStreamSignableDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderContractControllerStreamSignableDocumentsQueryKey(options)
});

/**
 * Marks a document workflow instance as reviewed
 */
export const shareholderContractControllerReviewDocumentMutation = (options?: Partial<Options<ShareholderContractControllerReviewDocumentData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderContractControllerReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderContractControllerReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderContractControllerReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate signable documents for investor
 */
export const shareholderContractControllerGenerateSignableDocumentsMutation = (options?: Partial<Options<ShareholderContractControllerGenerateSignableDocumentsData>>): UseMutationOptions<unknown, DefaultError, Options<ShareholderContractControllerGenerateSignableDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ShareholderContractControllerGenerateSignableDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareholderContractControllerGenerateSignableDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareholderContractControllerGeneratePrefillableFormFileQueryKey = (options: Options<ShareholderContractControllerGeneratePrefillableFormFileData>) => createQueryKey('shareholderContractControllerGeneratePrefillableFormFile', options);

/**
 * Download prefillable form file
 */
export const shareholderContractControllerGeneratePrefillableFormFileOptions = (options: Options<ShareholderContractControllerGeneratePrefillableFormFileData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shareholderContractControllerGeneratePrefillableFormFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareholderContractControllerGeneratePrefillableFormFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareholderContractControllerGeneratePrefillableFormFileQueryKey(options)
});

export const investmentControllerGetInvestmentDetailsQueryKey = (options: Options<InvestmentControllerGetInvestmentDetailsData>) => createQueryKey('investmentControllerGetInvestmentDetails', options);

/**
 * Get detailed user investment by mip id
 */
export const investmentControllerGetInvestmentDetailsOptions = (options: Options<InvestmentControllerGetInvestmentDetailsData>) => queryOptions<InvestmentControllerGetInvestmentDetailsResponse, DefaultError, InvestmentControllerGetInvestmentDetailsResponse, ReturnType<typeof investmentControllerGetInvestmentDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetInvestmentDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetInvestmentDetailsQueryKey(options)
});

export const investmentControllerGetInvestmentsAndSdwDocumentsQueryKey = (options?: Options<InvestmentControllerGetInvestmentsAndSdwDocumentsData>) => createQueryKey('investmentControllerGetInvestmentsAndSdwDocuments', options);

/**
 * Get user investments with SDW documents
 */
export const investmentControllerGetInvestmentsAndSdwDocumentsOptions = (options?: Options<InvestmentControllerGetInvestmentsAndSdwDocumentsData>) => queryOptions<InvestmentControllerGetInvestmentsAndSdwDocumentsResponse, DefaultError, InvestmentControllerGetInvestmentsAndSdwDocumentsResponse, ReturnType<typeof investmentControllerGetInvestmentsAndSdwDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetInvestmentsAndSdwDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetInvestmentsAndSdwDocumentsQueryKey(options)
});

export const investmentControllerGetInvestmentV2QueryKey = (options: Options<InvestmentControllerGetInvestmentV2Data>) => createQueryKey('investmentControllerGetInvestmentV2', options);

/**
 * Get specific investor investment with sdw documents
 */
export const investmentControllerGetInvestmentV2Options = (options: Options<InvestmentControllerGetInvestmentV2Data>) => queryOptions<InvestmentControllerGetInvestmentV2Response, DefaultError, InvestmentControllerGetInvestmentV2Response, ReturnType<typeof investmentControllerGetInvestmentV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetInvestmentV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetInvestmentV2QueryKey(options)
});

export const investmentControllerGetAllInvestmentValuationsQueryKey = (options?: Options<InvestmentControllerGetAllInvestmentValuationsData>) => createQueryKey('investmentControllerGetAllInvestmentValuations', options);

/**
 * Get list of investor valuations
 */
export const investmentControllerGetAllInvestmentValuationsOptions = (options?: Options<InvestmentControllerGetAllInvestmentValuationsData>) => queryOptions<InvestmentControllerGetAllInvestmentValuationsResponse, DefaultError, InvestmentControllerGetAllInvestmentValuationsResponse, ReturnType<typeof investmentControllerGetAllInvestmentValuationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetAllInvestmentValuations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetAllInvestmentValuationsQueryKey(options)
});

export const investmentControllerGetSecurityVestingDataQueryKey = (options: Options<InvestmentControllerGetSecurityVestingDataData>) => createQueryKey('investmentControllerGetSecurityVestingData', options);

/**
 * Get vesting data for a specific security of an investor
 */
export const investmentControllerGetSecurityVestingDataOptions = (options: Options<InvestmentControllerGetSecurityVestingDataData>) => queryOptions<InvestmentControllerGetSecurityVestingDataResponse, DefaultError, InvestmentControllerGetSecurityVestingDataResponse, ReturnType<typeof investmentControllerGetSecurityVestingDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetSecurityVestingData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetSecurityVestingDataQueryKey(options)
});

export const investmentControllerGetInvestmentValuationsQueryKey = (options: Options<InvestmentControllerGetInvestmentValuationsData>) => createQueryKey('investmentControllerGetInvestmentValuations', options);

/**
 * Get specific investor valuations
 */
export const investmentControllerGetInvestmentValuationsOptions = (options: Options<InvestmentControllerGetInvestmentValuationsData>) => queryOptions<InvestmentControllerGetInvestmentValuationsResponse, DefaultError, InvestmentControllerGetInvestmentValuationsResponse, ReturnType<typeof investmentControllerGetInvestmentValuationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetInvestmentValuations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetInvestmentValuationsQueryKey(options)
});

export const investmentControllerGetInvestmentPaymentInstructionQueryKey = (options?: Options<InvestmentControllerGetInvestmentPaymentInstructionData>) => createQueryKey('investmentControllerGetInvestmentPaymentInstruction', options);

/**
 * Get payment instruction file
 */
export const investmentControllerGetInvestmentPaymentInstructionOptions = (options?: Options<InvestmentControllerGetInvestmentPaymentInstructionData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof investmentControllerGetInvestmentPaymentInstructionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetInvestmentPaymentInstruction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetInvestmentPaymentInstructionQueryKey(options)
});

export const investmentControllerGetUserInvestmentsListQueryKey = (options?: Options<InvestmentControllerGetUserInvestmentsListData>) => createQueryKey('investmentControllerGetUserInvestmentsList', options);

/**
 * Get simple list of user investments
 */
export const investmentControllerGetUserInvestmentsListOptions = (options?: Options<InvestmentControllerGetUserInvestmentsListData>) => queryOptions<InvestmentControllerGetUserInvestmentsListResponse, DefaultError, InvestmentControllerGetUserInvestmentsListResponse, ReturnType<typeof investmentControllerGetUserInvestmentsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await investmentControllerGetUserInvestmentsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: investmentControllerGetUserInvestmentsListQueryKey(options)
});

/**
 * Link the bank account entered by the investor to their investment
 */
export const investmentControllerSetSelectedBankAccountMutation = (options?: Partial<Options<InvestmentControllerSetSelectedBankAccountData>>): UseMutationOptions<unknown, DefaultError, Options<InvestmentControllerSetSelectedBankAccountData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InvestmentControllerSetSelectedBankAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await investmentControllerSetSelectedBankAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add user OpenFGA relations to OpenFGA
 */
export const permissionControllerAddResourcePermissionsForUserMutation = (options?: Partial<Options<PermissionControllerAddResourcePermissionsForUserData>>): UseMutationOptions<unknown, DefaultError, Options<PermissionControllerAddResourcePermissionsForUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PermissionControllerAddResourcePermissionsForUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await permissionControllerAddResourcePermissionsForUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove user OpenFGA relations to OpenFGA
 */
export const permissionControllerRemoveResourcePermissionForUserMutation = (options?: Partial<Options<PermissionControllerRemoveResourcePermissionForUserData>>): UseMutationOptions<unknown, DefaultError, Options<PermissionControllerRemoveResourcePermissionForUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PermissionControllerRemoveResourcePermissionForUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await permissionControllerRemoveResourcePermissionForUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove all user explicit permissions and sets the new permission roles
 */
export const permissionControllerSetResourcePermissionsForUserMutation = (options?: Partial<Options<PermissionControllerSetResourcePermissionsForUserData>>): UseMutationOptions<unknown, DefaultError, Options<PermissionControllerSetResourcePermissionsForUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PermissionControllerSetResourcePermissionsForUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await permissionControllerSetResourcePermissionsForUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const programmeSecurityAllocationsControllerGetAllocationsBySecurityIdQueryKey = (options: Options<ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData>) => createQueryKey('programmeSecurityAllocationsControllerGetAllocationsBySecurityId', options);

/**
 * Get MIP security allocations by security id
 */
export const programmeSecurityAllocationsControllerGetAllocationsBySecurityIdOptions = (options: Options<ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData>) => queryOptions<ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponse, DefaultError, ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponse, ReturnType<typeof programmeSecurityAllocationsControllerGetAllocationsBySecurityIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeSecurityAllocationsControllerGetAllocationsBySecurityId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeSecurityAllocationsControllerGetAllocationsBySecurityIdQueryKey(options)
});

export const programmeSecurityAllocationsControllerGetAllocationMipListBySecurityIdQueryKey = (options: Options<ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData>) => createQueryKey('programmeSecurityAllocationsControllerGetAllocationMipListBySecurityId', options);

/**
 * Get allocations available IP for security
 */
export const programmeSecurityAllocationsControllerGetAllocationMipListBySecurityIdOptions = (options: Options<ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData>) => queryOptions<ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponse, DefaultError, ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponse, ReturnType<typeof programmeSecurityAllocationsControllerGetAllocationMipListBySecurityIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await programmeSecurityAllocationsControllerGetAllocationMipListBySecurityId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: programmeSecurityAllocationsControllerGetAllocationMipListBySecurityIdQueryKey(options)
});

/**
 * Create MIP security allocation
 */
export const programmeSecurityAllocationsControllerCreateAllocationMutation = (options?: Partial<Options<ProgrammeSecurityAllocationsControllerCreateAllocationData>>): UseMutationOptions<ProgrammeSecurityAllocationsControllerCreateAllocationResponse, DefaultError, Options<ProgrammeSecurityAllocationsControllerCreateAllocationData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeSecurityAllocationsControllerCreateAllocationResponse, DefaultError, Options<ProgrammeSecurityAllocationsControllerCreateAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeSecurityAllocationsControllerCreateAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete MIP security allocation
 */
export const programmeSecurityAllocationsControllerDeleteAllocationMutation = (options?: Partial<Options<ProgrammeSecurityAllocationsControllerDeleteAllocationData>>): UseMutationOptions<unknown, DefaultError, Options<ProgrammeSecurityAllocationsControllerDeleteAllocationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ProgrammeSecurityAllocationsControllerDeleteAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeSecurityAllocationsControllerDeleteAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update MIP security allocation
 */
export const programmeSecurityAllocationsControllerUpdateAllocationMutation = (options?: Partial<Options<ProgrammeSecurityAllocationsControllerUpdateAllocationData>>): UseMutationOptions<ProgrammeSecurityAllocationsControllerUpdateAllocationResponse, DefaultError, Options<ProgrammeSecurityAllocationsControllerUpdateAllocationData>> => {
    const mutationOptions: UseMutationOptions<ProgrammeSecurityAllocationsControllerUpdateAllocationResponse, DefaultError, Options<ProgrammeSecurityAllocationsControllerUpdateAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await programmeSecurityAllocationsControllerUpdateAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend email delivery event
 */
export const resendControllerEmailEventMutation = (options?: Partial<Options<ResendControllerEmailEventData>>): UseMutationOptions<unknown, DefaultError, Options<ResendControllerEmailEventData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ResendControllerEmailEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendControllerEmailEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const helpBlogControllerGetArticlesQueryKey = (options: Options<HelpBlogControllerGetArticlesData>) => createQueryKey('helpBlogControllerGetArticles', options);

/**
 * Get all articles
 */
export const helpBlogControllerGetArticlesOptions = (options: Options<HelpBlogControllerGetArticlesData>) => queryOptions<HelpBlogControllerGetArticlesResponse, DefaultError, HelpBlogControllerGetArticlesResponse, ReturnType<typeof helpBlogControllerGetArticlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetArticles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetArticlesQueryKey(options)
});

export const helpBlogControllerGetEntrypointArticlesQueryKey = (options: Options<HelpBlogControllerGetEntrypointArticlesData>) => createQueryKey('helpBlogControllerGetEntrypointArticles', options);

/**
 * Get all articles with entrypoint data
 */
export const helpBlogControllerGetEntrypointArticlesOptions = (options: Options<HelpBlogControllerGetEntrypointArticlesData>) => queryOptions<HelpBlogControllerGetEntrypointArticlesResponse, DefaultError, HelpBlogControllerGetEntrypointArticlesResponse, ReturnType<typeof helpBlogControllerGetEntrypointArticlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetEntrypointArticles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetEntrypointArticlesQueryKey(options)
});

export const helpBlogControllerGetSlugArticleQueryKey = (options: Options<HelpBlogControllerGetSlugArticleData>) => createQueryKey('helpBlogControllerGetSlugArticle', options);

/**
 * Get article by slug
 */
export const helpBlogControllerGetSlugArticleOptions = (options: Options<HelpBlogControllerGetSlugArticleData>) => queryOptions<HelpBlogControllerGetSlugArticleResponse, DefaultError, HelpBlogControllerGetSlugArticleResponse, ReturnType<typeof helpBlogControllerGetSlugArticleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetSlugArticle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetSlugArticleQueryKey(options)
});

export const helpBlogControllerGetCategoriesQueryKey = (options: Options<HelpBlogControllerGetCategoriesData>) => createQueryKey('helpBlogControllerGetCategories', options);

/**
 * Get all categories
 */
export const helpBlogControllerGetCategoriesOptions = (options: Options<HelpBlogControllerGetCategoriesData>) => queryOptions<HelpBlogControllerGetCategoriesResponse, DefaultError, HelpBlogControllerGetCategoriesResponse, ReturnType<typeof helpBlogControllerGetCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetCategoriesQueryKey(options)
});

export const helpBlogControllerGetAuthorsQueryKey = (options: Options<HelpBlogControllerGetAuthorsData>) => createQueryKey('helpBlogControllerGetAuthors', options);

/**
 * Get all authors
 */
export const helpBlogControllerGetAuthorsOptions = (options: Options<HelpBlogControllerGetAuthorsData>) => queryOptions<HelpBlogControllerGetAuthorsResponse, DefaultError, HelpBlogControllerGetAuthorsResponse, ReturnType<typeof helpBlogControllerGetAuthorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetAuthors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetAuthorsQueryKey(options)
});

export const helpBlogControllerGetSlugCategoryQueryKey = (options: Options<HelpBlogControllerGetSlugCategoryData>) => createQueryKey('helpBlogControllerGetSlugCategory', options);

/**
 * Get category by slug
 */
export const helpBlogControllerGetSlugCategoryOptions = (options: Options<HelpBlogControllerGetSlugCategoryData>) => queryOptions<HelpBlogControllerGetSlugCategoryResponse, DefaultError, HelpBlogControllerGetSlugCategoryResponse, ReturnType<typeof helpBlogControllerGetSlugCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetSlugCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetSlugCategoryQueryKey(options)
});

export const helpBlogControllerGetSlugAuthorQueryKey = (options: Options<HelpBlogControllerGetSlugAuthorData>) => createQueryKey('helpBlogControllerGetSlugAuthor', options);

/**
 * Get author by slug
 */
export const helpBlogControllerGetSlugAuthorOptions = (options: Options<HelpBlogControllerGetSlugAuthorData>) => queryOptions<HelpBlogControllerGetSlugAuthorResponse, DefaultError, HelpBlogControllerGetSlugAuthorResponse, ReturnType<typeof helpBlogControllerGetSlugAuthorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpBlogControllerGetSlugAuthor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpBlogControllerGetSlugAuthorQueryKey(options)
});

export const simpleDocumentWorkflowControllerGetInvestorsFilteringDataQueryKey = (options?: Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>) => createQueryKey('simpleDocumentWorkflowControllerGetInvestorsFilteringData', options);

/**
 * Get investors data for filter
 */
export const simpleDocumentWorkflowControllerGetInvestorsFilteringDataOptions = (options?: Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>) => queryOptions<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse, DefaultError, SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse, ReturnType<typeof simpleDocumentWorkflowControllerGetInvestorsFilteringDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await simpleDocumentWorkflowControllerGetInvestorsFilteringData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: simpleDocumentWorkflowControllerGetInvestorsFilteringDataQueryKey(options)
});

export const simpleDocumentWorkflowControllerGetInvestorsFilteringDataInfiniteQueryKey = (options?: Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>): QueryKey<Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>> => createQueryKey('simpleDocumentWorkflowControllerGetInvestorsFilteringData', options, true);

/**
 * Get investors data for filter
 */
export const simpleDocumentWorkflowControllerGetInvestorsFilteringDataInfiniteOptions = (options?: Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>) => infiniteQueryOptions<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse, DefaultError, InfiniteData<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse>, QueryKey<Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>>, string | Pick<QueryKey<Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await simpleDocumentWorkflowControllerGetInvestorsFilteringData({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: simpleDocumentWorkflowControllerGetInvestorsFilteringDataInfiniteQueryKey(options)
});

/**
 * Add document file to MIP
 */
export const simpleDocumentWorkflowControllerAddFileToMipMutation = (options?: Partial<Options<SimpleDocumentWorkflowControllerAddFileToMipData>>): UseMutationOptions<SimpleDocumentWorkflowControllerAddFileToMipResponse, DefaultError, Options<SimpleDocumentWorkflowControllerAddFileToMipData>> => {
    const mutationOptions: UseMutationOptions<SimpleDocumentWorkflowControllerAddFileToMipResponse, DefaultError, Options<SimpleDocumentWorkflowControllerAddFileToMipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await simpleDocumentWorkflowControllerAddFileToMip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create documents and initiate submission generation
 */
export const simpleDocumentWorkflowControllerCreateDocumentsMutation = (options?: Partial<Options<SimpleDocumentWorkflowControllerCreateDocumentsData>>): UseMutationOptions<SimpleDocumentWorkflowControllerCreateDocumentsResponse, DefaultError, Options<SimpleDocumentWorkflowControllerCreateDocumentsData>> => {
    const mutationOptions: UseMutationOptions<SimpleDocumentWorkflowControllerCreateDocumentsResponse, DefaultError, Options<SimpleDocumentWorkflowControllerCreateDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await simpleDocumentWorkflowControllerCreateDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send master documents to investors
 */
export const simpleDocumentWorkflowControllerSendMasterDocumentsMutation = (options?: Partial<Options<SimpleDocumentWorkflowControllerSendMasterDocumentsData>>): UseMutationOptions<SimpleDocumentWorkflowControllerSendMasterDocumentsResponse, DefaultError, Options<SimpleDocumentWorkflowControllerSendMasterDocumentsData>> => {
    const mutationOptions: UseMutationOptions<SimpleDocumentWorkflowControllerSendMasterDocumentsResponse, DefaultError, Options<SimpleDocumentWorkflowControllerSendMasterDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await simpleDocumentWorkflowControllerSendMasterDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove document file
 */
export const simpleDocumentWorkflowControllerRemoveDocumentFileMutation = (options?: Partial<Options<SimpleDocumentWorkflowControllerRemoveDocumentFileData>>): UseMutationOptions<unknown, DefaultError, Options<SimpleDocumentWorkflowControllerRemoveDocumentFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SimpleDocumentWorkflowControllerRemoveDocumentFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await simpleDocumentWorkflowControllerRemoveDocumentFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const securityRankDefinitionControllerGetPersonRanksQueryKey = (options: Options<SecurityRankDefinitionControllerGetPersonRanksData>) => createQueryKey('securityRankDefinitionControllerGetPersonRanks', options);

/**
 * Get person ranks
 */
export const securityRankDefinitionControllerGetPersonRanksOptions = (options: Options<SecurityRankDefinitionControllerGetPersonRanksData>) => queryOptions<SecurityRankDefinitionControllerGetPersonRanksResponse, DefaultError, SecurityRankDefinitionControllerGetPersonRanksResponse, ReturnType<typeof securityRankDefinitionControllerGetPersonRanksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityRankDefinitionControllerGetPersonRanks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityRankDefinitionControllerGetPersonRanksQueryKey(options)
});

/**
 * Create rank
 */
export const securityRankDefinitionControllerCreateRankMutation = (options?: Partial<Options<SecurityRankDefinitionControllerCreateRankData>>): UseMutationOptions<SecurityRankDefinitionControllerCreateRankResponse, DefaultError, Options<SecurityRankDefinitionControllerCreateRankData>> => {
    const mutationOptions: UseMutationOptions<SecurityRankDefinitionControllerCreateRankResponse, DefaultError, Options<SecurityRankDefinitionControllerCreateRankData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankDefinitionControllerCreateRank({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft delete rank
 */
export const securityRankDefinitionControllerSoftDeleteRankMutation = (options?: Partial<Options<SecurityRankDefinitionControllerSoftDeleteRankData>>): UseMutationOptions<SecurityRankDefinitionControllerSoftDeleteRankResponse, DefaultError, Options<SecurityRankDefinitionControllerSoftDeleteRankData>> => {
    const mutationOptions: UseMutationOptions<SecurityRankDefinitionControllerSoftDeleteRankResponse, DefaultError, Options<SecurityRankDefinitionControllerSoftDeleteRankData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankDefinitionControllerSoftDeleteRank({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update rank
 */
export const securityRankDefinitionControllerUpdateRankMutation = (options?: Partial<Options<SecurityRankDefinitionControllerUpdateRankData>>): UseMutationOptions<SecurityRankDefinitionControllerUpdateRankResponse, DefaultError, Options<SecurityRankDefinitionControllerUpdateRankData>> => {
    const mutationOptions: UseMutationOptions<SecurityRankDefinitionControllerUpdateRankResponse, DefaultError, Options<SecurityRankDefinitionControllerUpdateRankData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankDefinitionControllerUpdateRank({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert security rank
 */
export const securityRankControllerUpsertSecurityRankMutation = (options?: Partial<Options<SecurityRankControllerUpsertSecurityRankData>>): UseMutationOptions<SecurityRankControllerUpsertSecurityRankResponse, DefaultError, Options<SecurityRankControllerUpsertSecurityRankData>> => {
    const mutationOptions: UseMutationOptions<SecurityRankControllerUpsertSecurityRankResponse, DefaultError, Options<SecurityRankControllerUpsertSecurityRankData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankControllerUpsertSecurityRank({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert security income ranks
 */
export const securityRankControllerUpsertSecurityIncomeRanksMutation = (options?: Partial<Options<SecurityRankControllerUpsertSecurityIncomeRanksData>>): UseMutationOptions<SecurityRankControllerUpsertSecurityIncomeRanksResponse, DefaultError, Options<SecurityRankControllerUpsertSecurityIncomeRanksData>> => {
    const mutationOptions: UseMutationOptions<SecurityRankControllerUpsertSecurityIncomeRanksResponse, DefaultError, Options<SecurityRankControllerUpsertSecurityIncomeRanksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankControllerUpsertSecurityIncomeRanks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete security rank
 */
export const securityRankControllerDeleteSecurityRankMutation = (options?: Partial<Options<SecurityRankControllerDeleteSecurityRankData>>): UseMutationOptions<unknown, DefaultError, Options<SecurityRankControllerDeleteSecurityRankData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SecurityRankControllerDeleteSecurityRankData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankControllerDeleteSecurityRank({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete security income ranks
 */
export const securityRankControllerDeleteSecurityIncomeRanksMutation = (options?: Partial<Options<SecurityRankControllerDeleteSecurityIncomeRanksData>>): UseMutationOptions<unknown, DefaultError, Options<SecurityRankControllerDeleteSecurityIncomeRanksData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SecurityRankControllerDeleteSecurityIncomeRanksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRankControllerDeleteSecurityIncomeRanks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete ratchet schedule for a security
 */
export const securityRatchetControllerDeleteScheduleMutation = (options?: Partial<Options<SecurityRatchetControllerDeleteScheduleData>>): UseMutationOptions<unknown, DefaultError, Options<SecurityRatchetControllerDeleteScheduleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SecurityRatchetControllerDeleteScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRatchetControllerDeleteSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const securityRatchetControllerGetScheduleQueryKey = (options: Options<SecurityRatchetControllerGetScheduleData>) => createQueryKey('securityRatchetControllerGetSchedule', options);

/**
 * Get ratchet schedule for a security
 */
export const securityRatchetControllerGetScheduleOptions = (options: Options<SecurityRatchetControllerGetScheduleData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof securityRatchetControllerGetScheduleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await securityRatchetControllerGetSchedule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: securityRatchetControllerGetScheduleQueryKey(options)
});

/**
 * Create or update ratchet schedule for a security
 */
export const securityRatchetControllerUpsertScheduleMutation = (options?: Partial<Options<SecurityRatchetControllerUpsertScheduleData>>): UseMutationOptions<unknown, DefaultError, Options<SecurityRatchetControllerUpsertScheduleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SecurityRatchetControllerUpsertScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await securityRatchetControllerUpsertSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailSchedulerControllerListConfigsQueryKey = (options: Options<EmailSchedulerControllerListConfigsData>) => createQueryKey('emailSchedulerControllerListConfigs', options);

/**
 * List email schedule configs for a programme (one per handler type)
 */
export const emailSchedulerControllerListConfigsOptions = (options: Options<EmailSchedulerControllerListConfigsData>) => queryOptions<EmailSchedulerControllerListConfigsResponse, DefaultError, EmailSchedulerControllerListConfigsResponse, ReturnType<typeof emailSchedulerControllerListConfigsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await emailSchedulerControllerListConfigs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: emailSchedulerControllerListConfigsQueryKey(options)
});

/**
 * Create or update an email schedule config for a programme
 */
export const emailSchedulerControllerUpsertConfigMutation = (options?: Partial<Options<EmailSchedulerControllerUpsertConfigData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerUpsertConfigData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerUpsertConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerUpsertConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailSchedulerControllerListSchedulesQueryKey = (options: Options<EmailSchedulerControllerListSchedulesData>) => createQueryKey('emailSchedulerControllerListSchedules', options);

/**
 * List scheduled emails for a programme, optionally filtered by status and/or documentWorkflowInstanceId
 */
export const emailSchedulerControllerListSchedulesOptions = (options: Options<EmailSchedulerControllerListSchedulesData>) => queryOptions<EmailSchedulerControllerListSchedulesResponse, DefaultError, EmailSchedulerControllerListSchedulesResponse, ReturnType<typeof emailSchedulerControllerListSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await emailSchedulerControllerListSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: emailSchedulerControllerListSchedulesQueryKey(options)
});

/**
 * Create (start) a signing-reminder schedule for a document workflow instance
 */
export const emailSchedulerControllerCreateScheduleMutation = (options?: Partial<Options<EmailSchedulerControllerCreateScheduleData>>): UseMutationOptions<EmailSchedulerControllerCreateScheduleResponse, DefaultError, Options<EmailSchedulerControllerCreateScheduleData>> => {
    const mutationOptions: UseMutationOptions<EmailSchedulerControllerCreateScheduleResponse, DefaultError, Options<EmailSchedulerControllerCreateScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerCreateSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel a scheduled email
 */
export const emailSchedulerControllerCancelMutation = (options?: Partial<Options<EmailSchedulerControllerCancelData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerCancelData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reschedule a scheduled email to a new fire time
 */
export const emailSchedulerControllerRescheduleMutation = (options?: Partial<Options<EmailSchedulerControllerRescheduleData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerRescheduleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerRescheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerReschedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-activate a terminated scheduled email
 */
export const emailSchedulerControllerRestartMutation = (options?: Partial<Options<EmailSchedulerControllerRestartData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerRestartData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerRestartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerRestart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Fire a scheduled email immediately, out of band
 */
export const emailSchedulerControllerSendNowMutation = (options?: Partial<Options<EmailSchedulerControllerSendNowData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerSendNowData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerSendNowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerSendNow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set or clear a scheduled email's end date
 */
export const emailSchedulerControllerSetEndDateMutation = (options?: Partial<Options<EmailSchedulerControllerSetEndDateData>>): UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerSetEndDateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EmailSchedulerControllerSetEndDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSchedulerControllerSetEndDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
